"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[617,529],{

/***/ 7894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Ads_Slot; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Ads/Ads.Slot.Engine.tsx





var DEBUG_FLAG = "ojcdebugads";
var LOADED_SLOT_EVENT = "gaLoadSlot";
var CUSTOM_LOADED_EVENT = "gaCustomLoadSlot";
var DESKTOP_WIDTH_LIMIT = 980;
var nthElementsCache = {};

var Slot = function Slot(_ref) {
  var _slotSizeMap$slotId$p, _slotSizeMap$slotId, _slotSizeMap$slotId$p2, _slotSizeMap$slotId$, _slotSizeMap$slotId2, _slotSizeMap$slotId$p3, _slotSizeMap$slotId3, _slotSizeMap$slotId3$, _slotSizeMap$slotId$2, _slotSizeMap$slotId4;

  var id = _ref.id,
      className = _ref.className,
      slotId = _ref.slotId,
      isDebug = _ref.isDebug,
      _ref$debugType = _ref.debugType,
      debugType = _ref$debugType === void 0 ? 'with_event' : _ref$debugType,
      _ref$isDebugNthSlot = _ref.isDebugNthSlot,
      isDebugNthSlot = _ref$isDebugNthSlot === void 0 ? false : _ref$isDebugNthSlot,
      type = _ref.type,
      componentReference = _ref.componentReference,
      position = _ref.position,
      customHtml = _ref.customHtml,
      customEventName = _ref.customEventName,
      slotSizeMap = _ref.slotSizeMap,
      targetName = _ref.targetName;
  var isMobile = className.indexOf("isMobile") >= 0; // Alright slots

  var isHtmlAds = position === 'HTML';

  if (isHtmlAds) {
    var debugClassName = isDebug ? "alright-debug-slot ".concat(isDebugNthSlot ? 'not-used ' : '').concat(slotId, "-").concat(targetName, "-").concat(type, "-").concat(position, "-").concat(componentReference) : undefined;
    var debugText = isDebug ? "Alright AdSlot - #\"".concat(targetName, "\"-").concat(slotId, "-").concat(type, "-").concat(position, "-").concat(componentReference, " - notUsed: ").concat(isDebugNthSlot) : undefined;
    var html = customHtml || '';
    var htmlAds = isDebug ? "<p>".concat(debugText, "</p>") + html : html;

    if (!!customEventName && !!window && debugType === 'with_event') {
      window.dispatchEvent(new CustomEvent(CUSTOM_LOADED_EVENT, {
        detail: {
          slotId: slotId,
          isMobile: isMobile,
          id: id,
          position: position,
          customEventName: customEventName
        }
      }));
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: 'alright-adslot',
      className: debugClassName,
      dangerouslySetInnerHTML: {
        __html: htmlAds
      }
    });
  }

  if (window && debugType === 'with_event') {
    window.dispatchEvent(new CustomEvent(LOADED_SLOT_EVENT, {
      detail: {
        slotId: slotId,
        isMobile: isMobile,
        id: id,
        position: position
      }
    }));
  }

  var backgroundColor = "yellow";

  switch (type) {
    case "article":
      backgroundColor = "purple";
      break;

    case "block":
      backgroundColor = "blue";
      break;

    case "mega":
      backgroundColor = "green";
      break;

    case "side":
      backgroundColor = "red";
      break;
  }

  var minWidth = !Array.isArray(slotSizeMap[slotId]) ? (_slotSizeMap$slotId$p = (_slotSizeMap$slotId = slotSizeMap[slotId]) === null || _slotSizeMap$slotId === void 0 ? void 0 : (_slotSizeMap$slotId$p2 = _slotSizeMap$slotId[position]) === null || _slotSizeMap$slotId$p2 === void 0 ? void 0 : _slotSizeMap$slotId$p2[0]) !== null && _slotSizeMap$slotId$p !== void 0 ? _slotSizeMap$slotId$p : 300 : (_slotSizeMap$slotId$ = (_slotSizeMap$slotId2 = slotSizeMap[slotId]) === null || _slotSizeMap$slotId2 === void 0 ? void 0 : _slotSizeMap$slotId2[0]) !== null && _slotSizeMap$slotId$ !== void 0 ? _slotSizeMap$slotId$ : 300;
  var minHeight = !Array.isArray(slotSizeMap[slotId]) ? (_slotSizeMap$slotId$p3 = (_slotSizeMap$slotId3 = slotSizeMap[slotId]) === null || _slotSizeMap$slotId3 === void 0 ? void 0 : (_slotSizeMap$slotId3$ = _slotSizeMap$slotId3[position]) === null || _slotSizeMap$slotId3$ === void 0 ? void 0 : _slotSizeMap$slotId3$[1]) !== null && _slotSizeMap$slotId$p3 !== void 0 ? _slotSizeMap$slotId$p3 : 250 : (_slotSizeMap$slotId$2 = (_slotSizeMap$slotId4 = slotSizeMap[slotId]) === null || _slotSizeMap$slotId4 === void 0 ? void 0 : _slotSizeMap$slotId4[1]) !== null && _slotSizeMap$slotId$2 !== void 0 ? _slotSizeMap$slotId$2 : 250;
  var style = {
    width: "100%",
    minWidth: isDebug ? "".concat(minWidth || 300, "px") : "".concat(minWidth, "px"),
    minHeight: isDebug ? "".concat(minHeight || 250, "px") : "".concat(minHeight, "px"),
    backgroundColor: isDebug ? backgroundColor : "transparent"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: id,
    className: "".concat(className).concat(isDebug ? " debugAds ".concat(slotId, "-").concat(targetName, "-").concat(type, "-").concat(position, "-").concat(componentReference) : "", " ads-slot skeleton"),
    style: style,
    children: isDebug && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\"".concat(targetName, "\" | ").concat(type, " | ").concat(slotId, " | ").concat(position, " | ").concat(componentReference)
    })
  });
};

var AdsSlotEngine = function AdsSlotEngine(_ref2) {
  var _window, _window$location, _window$location$sear, _window2, _window2$location, _window2$location$sea, _currentSlotSettings, _currentSlotSettings$, _currentSlotSettings2, _currentSlotSettings3, _currentSlotSettings4, _currentSlotSettings5, _currentSlotSettings6, _currentSlotSettings7, _currentSlotSettings8, _currentSlotSettings9;

  var type = _ref2.type,
      _ref2$componentRefere = _ref2.componentReference,
      componentReference = _ref2$componentRefere === void 0 ? "bottom" : _ref2$componentRefere,
      data = _ref2.data,
      settings = _ref2.settings,
      urlMapRegex = _ref2.urlMapRegex,
      slotSizeMap = _ref2.slotSizeMap;
  // URL params DEBUG_FLAG will enable the debug mode
  // if the query param is 2, the debug mode will show the slot without the event that triggers the slot load
  var isDebugMode = ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : (_window$location$sear = _window$location.search) === null || _window$location$sear === void 0 ? void 0 : _window$location$sear.indexOf("".concat(DEBUG_FLAG))) >= 0;
  var debugType = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : (_window2$location$sea = _window2$location.search) === null || _window2$location$sea === void 0 ? void 0 : _window2$location$sea.indexOf("".concat(DEBUG_FLAG, "=2"))) >= 0 ? 'without_event' : 'with_event';
  var isMobileView = window.innerWidth < DESKTOP_WIDTH_LIMIT;
  var targetName = data === null || data === void 0 ? void 0 : data.name;
  var articleIndex = 0; // Type "mega", special case where the first element with rules will be used

  if (type === "mega") {
    var contentBlock = data === null || data === void 0 ? void 0 : data.contentBlock;
    var contentSide = data === null || data === void 0 ? void 0 : data.contentSide;

    if (contentBlock) {
      var blockItens = contentBlock.map(function (item) {
        return item.name;
      });

      for (var i = 0; i < blockItens.length; i++) {
        targetName = blockItens[i];
        break;
      }
    } else if (contentSide) {
      var sideItens = contentSide.map(function (item) {
        return item.name;
      });

      for (var _i = 0; _i < sideItens.length; _i++) {
        targetName = sideItens[_i];
        break;
      }
    }
  } else if (type === "article") {
    targetName = "Article Slot";
    articleIndex = data !== null && data !== void 0 && data.key ? data.key < 3 ? data.key + 1 : 3 : 1;
  } else if (type === "search") {
    targetName = "Search Slot";
  }

  if (isDebugMode) {
    console.log("[DEBUG] ads target slot: \"".concat(targetName, "\""));
  }

  var showSlot = !!settings[targetName];
  var currentSlotSettings = showSlot ? settings[targetName] : settings.generic; // Get current slot settings by url

  var pathname = window.location.pathname;
  var keys = Object.keys(urlMapRegex);
  var urlKey = "*";

  for (var _i2 = 0; _i2 < keys.length; _i2++) {
    var regex = new RegExp(keys[_i2]);

    if (regex.test(pathname)) {
      urlKey = urlMapRegex[keys[_i2]];
      break;
    }
  }

  currentSlotSettings = !!currentSlotSettings[urlKey] ? currentSlotSettings[urlKey] : !!currentSlotSettings["*"] ? currentSlotSettings['*'] : undefined;

  if (!currentSlotSettings) {
    showSlot = false;

    if (isDebugMode) {
      console.log("[DEBUG] No slot settings found for url key: \"".concat(urlKey, "\""));
    }

    currentSlotSettings = settings.generic['*'];
  }

  currentSlotSettings = (_currentSlotSettings = currentSlotSettings) === null || _currentSlotSettings === void 0 ? void 0 : (_currentSlotSettings$ = _currentSlotSettings[type]) === null || _currentSlotSettings$ === void 0 ? void 0 : _currentSlotSettings$[componentReference];

  if (!currentSlotSettings) {
    showSlot = false;

    if (isDebugMode) {
      console.log("[DEBUG] No slot settings found for type: \"".concat(type, "\" and component reference: \"").concat(componentReference, "\""));
    }
  }

  if (isDebugMode && !showSlot) {
    var _settings$generic$, _settings$generic$$ty;

    currentSlotSettings = (_settings$generic$ = settings.generic['*']) === null || _settings$generic$ === void 0 ? void 0 : (_settings$generic$$ty = _settings$generic$[type]) === null || _settings$generic$$ty === void 0 ? void 0 : _settings$generic$$ty[componentReference];

    if (currentSlotSettings) {
      console.log("[DEBUG] Using generic settings for type: \"".concat(type, "\" and component reference: \"").concat(componentReference, "\""));
      showSlot = true;
    }
  }

  var idDesktop, classDesktop, slotNameDesktop, positionDesktop, nthPostionDesktop, customHtmlDesktop, customEventNameDesktop, currentDesktopSlotEnabled;

  if ((_currentSlotSettings2 = currentSlotSettings) !== null && _currentSlotSettings2 !== void 0 && (_currentSlotSettings3 = _currentSlotSettings2.desktopSlot) !== null && _currentSlotSettings3 !== void 0 && _currentSlotSettings3.id) {
    var _currentSlotSettings$2, _currentSlotSettings$3, _currentSlotSettings$4;

    var randomIdDsk = (0,lodash.random)(1000000, 9999999);
    var isArticle = type === "article";
    var position = isArticle ? currentSlotSettings.desktopSlot.position.replace('?', articleIndex) : currentSlotSettings.desktopSlot.position;
    var desktopSlotName = isArticle ? "".concat(currentSlotSettings.desktopSlot.id, " ").concat(position) : "".concat(currentSlotSettings.desktopSlot.id);
    idDesktop = "".concat(desktopSlotName, "-").concat(randomIdDsk);
    classDesktop = "isDesktop ".concat(desktopSlotName.toLowerCase());
    slotNameDesktop = currentSlotSettings.desktopSlot.id;
    positionDesktop = position;
    nthPostionDesktop = (_currentSlotSettings$2 = currentSlotSettings.desktopSlot) === null || _currentSlotSettings$2 === void 0 ? void 0 : _currentSlotSettings$2.nthPosition;
    customHtmlDesktop = (_currentSlotSettings$3 = currentSlotSettings.desktopSlot) === null || _currentSlotSettings$3 === void 0 ? void 0 : _currentSlotSettings$3.customHtml;
    customEventNameDesktop = (_currentSlotSettings$4 = currentSlotSettings.desktopSlot) === null || _currentSlotSettings$4 === void 0 ? void 0 : _currentSlotSettings$4.customEventName;
    currentDesktopSlotEnabled = true;
  }

  var idMobile, classMobile, slotNameMobile, positionMobile, nthPositionMobile, customHtmlMobile, customEventNameMobile, currentMobileSlotEnabled;

  if ((_currentSlotSettings4 = currentSlotSettings) !== null && _currentSlotSettings4 !== void 0 && (_currentSlotSettings5 = _currentSlotSettings4.mobileSlot) !== null && _currentSlotSettings5 !== void 0 && _currentSlotSettings5.id) {
    var _currentSlotSettings$5, _currentSlotSettings$6, _currentSlotSettings$7;

    var randomIdSmt = (0,lodash.random)(1000000, 9999999);

    var _isArticle = type === "article";

    var _position = _isArticle ? currentSlotSettings.mobileSlot.position.replace('?', articleIndex) : currentSlotSettings.mobileSlot.position;

    var mobileSlotName = type === "article" ? "".concat(currentSlotSettings.mobileSlot.id, " ").concat(_position) : "".concat(currentSlotSettings.mobileSlot.id);
    idMobile = "".concat(mobileSlotName, "-").concat(randomIdSmt);
    classMobile = "isMobile ".concat(mobileSlotName.toLowerCase());
    slotNameMobile = currentSlotSettings.mobileSlot.id;
    positionMobile = _position;
    nthPositionMobile = (_currentSlotSettings$5 = currentSlotSettings.mobileSlot) === null || _currentSlotSettings$5 === void 0 ? void 0 : _currentSlotSettings$5.nthPosition;
    customHtmlMobile = (_currentSlotSettings$6 = currentSlotSettings.mobileSlot) === null || _currentSlotSettings$6 === void 0 ? void 0 : _currentSlotSettings$6.customHtml;
    customEventNameMobile = (_currentSlotSettings$7 = currentSlotSettings.mobileSlot) === null || _currentSlotSettings$7 === void 0 ? void 0 : _currentSlotSettings$7.customEventName;
    currentMobileSlotEnabled = true;
  }

  var debugCurrentNthDesktopSlot = false;
  var debugCurrentNthMobileSlot = false;

  if (!!nthPostionDesktop || !!nthPositionMobile) {
    if (!nthElementsCache[targetName]) {
      nthElementsCache[targetName] = {};
    }

    if (!nthElementsCache[targetName][urlKey]) {
      nthElementsCache[targetName][urlKey] = {};
    }

    nthElementsCache[targetName][urlKey]["ocurrences"] = nthElementsCache[targetName][urlKey]["ocurrences"] ? nthElementsCache[targetName][urlKey]["ocurrences"] + 1 : 1; // TODO: Fix temporary because the screen is rendering twice

    if (nthElementsCache[targetName][urlKey]["ocurrences"] > 5) {
      nthElementsCache[targetName][urlKey]["ocurrences"] = 1;
    }

    currentDesktopSlotEnabled = nthPostionDesktop.includes(nthElementsCache[targetName][urlKey]["ocurrences"]);
    currentMobileSlotEnabled = nthPositionMobile.includes(nthElementsCache[targetName][urlKey]["ocurrences"]);

    if (isDebugMode) {
      debugCurrentNthDesktopSlot = !currentDesktopSlotEnabled;
      debugCurrentNthMobileSlot = !currentMobileSlotEnabled;
      currentDesktopSlotEnabled = true;
      currentMobileSlotEnabled = true;
    }
  }

  if (isDebugMode) {
    var desktopSettings = {
      idDesktop: idDesktop,
      classDesktop: classDesktop,
      slotNameDesktop: slotNameDesktop,
      positionDesktop: positionDesktop,
      nthPostionDesktop: nthPostionDesktop,
      customHtmlDesktop: customHtmlDesktop,
      customEventNameDesktop: customEventNameDesktop
    };
    console.log("Current desktop settings:", desktopSettings);
    var mobileSettings = {
      idMobile: idMobile,
      classMobile: classMobile,
      slotNameMobile: slotNameMobile,
      positionMobile: positionMobile,
      nthPositionMobile: nthPositionMobile,
      customHtmlMobile: customHtmlMobile,
      customEventNameMobile: customEventNameMobile
    };
    console.log("Current mobile settings:", mobileSettings);
    console.log('Is Mobile View? ', isMobileView);
  }

  return !showSlot ? null : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!!((_currentSlotSettings6 = currentSlotSettings) !== null && _currentSlotSettings6 !== void 0 && (_currentSlotSettings7 = _currentSlotSettings6.desktopSlot) !== null && _currentSlotSettings7 !== void 0 && _currentSlotSettings7.id) && currentDesktopSlotEnabled && !isMobileView && /*#__PURE__*/(0,jsx_runtime.jsx)(Slot, {
      id: idDesktop,
      className: classDesktop,
      slotId: slotNameDesktop,
      type: type,
      isDebug: isDebugMode,
      debugType: debugType,
      isDebugNthSlot: debugCurrentNthDesktopSlot,
      customHtml: customHtmlDesktop,
      customEventName: customEventNameDesktop,
      componentReference: componentReference,
      position: positionDesktop,
      slotSizeMap: slotSizeMap,
      targetName: targetName
    }), !!((_currentSlotSettings8 = currentSlotSettings) !== null && _currentSlotSettings8 !== void 0 && (_currentSlotSettings9 = _currentSlotSettings8.mobileSlot) !== null && _currentSlotSettings9 !== void 0 && _currentSlotSettings9.id) && currentMobileSlotEnabled && isMobileView && /*#__PURE__*/(0,jsx_runtime.jsx)(Slot, {
      id: idMobile,
      className: classMobile,
      slotId: slotNameMobile,
      type: type,
      isDebug: isDebugMode,
      debugType: debugType,
      isDebugNthSlot: debugCurrentNthMobileSlot,
      customHtml: customHtmlMobile,
      customEventName: customEventNameMobile,
      componentReference: componentReference,
      position: positionMobile,
      slotSizeMap: slotSizeMap,
      targetName: targetName
    })]
  });
};

/* harmony default export */ var Ads_Slot_Engine = (AdsSlotEngine);
;// CONCATENATED MODULE: ./components/Ads/Ads.Slot.Opopular.tsx



var urlMapRegex = {
  "/$": "home",
  "^/cidades.*": "cidades",
  "^/comprova.*": "comprova",
  "^/economia/empresas-produtos.*": "empresasprodutos",
  "^/economia/loterias.*": "empresasprodutos",
  "^/economia/sobre-rodas.*": "sobrerodas",
  "^/economia.*": "economia",
  "^/eleicoes.*": "eleicoes",
  "^/goiania-90-anos.*": "goiania90anos",
  "^/esporte/atletico.*": "atletico",
  "^/esporte/goianao.*": "goianao",
  "^/esporte/goias.*": "goias",
  "^/esporte/vila-nova.*": "vilanova",
  "^/esporte.*": "esporte",
  "^/arte-e-pop.*": "arteepop",
  "^/-85-anos.*": "85anos",
  "^/o-popular-85-anos.*": "85anos",
  "^/caminhada-ecologica.*": "caminhadaecologica",
  "^/mulher-de-negócios.*": "infomercial",
  "^/infomercial.*": "infomercial",
  "^/inteligencia-artificial.*": "inteligenciaartificial",
  "^/magazine/bbb.*": "bbb",
  "^/magazine/cinema.*": "cinema",
  "^/magazine/cronicas.*": "cronicas",
  "^/magazine/famosos.*": "famosos",
  "^/magazine/gastronomia.*": "gastronomia",
  "^/magazine/horoscopo.*": "horoscopo",
  "^/magazine/opratododia.*": "opratododia",
  "^/magazine/português-expresso.*": "portuguesexpresso",
  "^/magazine/resumo-novelas.*": "resumonovelas",
  "^/magazine/saude-a-mesa.*": "saudeamesa",
  "^/magazine/saude-mental.*": "saudemental",
  "^/magazine.*": "magazine",
  "^/opiniao/artigos.*": "artigos",
  "^/opiniao/blog-fabiana-pulcineli.*": "blogfabianapulcineli",
  "^/opiniao/carta-dos-leitores.*": "cartadosleitores",
  "^/opiniao/charges.*": "charges",
  "^/opiniao/coluna-da-cileide.*": "colunadacileide",
  "^/opiniao/coluna-giro.*": "colunagiro",
  "^/opiniao/editorial.*": "editorial",
  "^/opiniao.*": "opiniao",
  "^/podcasts.*": "podcasts",
  "^/politica.*": "politica",
  "^/mundo.*": "mundo",
  "^/publicidade-legal.*": "publicidadelegal",
  "^/videos/jackson-abrao.*": "jacksonabrao",
  "^/videos/jackson-abr.*": "jacksonabrao",
  "^/videos.*": "videos",
  "^/ultimas.*": "ultimas"
};
var settings = {
  "Colunistas - destaques": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Manchete / Colunistas": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Infomercial - destaques": {
    "home": {
      "block": {
        "top": {
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM1_M"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Grid 6 > Layout Grid3": {
    "home": {
      "block": {
        "top": {
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM1_M"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Vídeos - CAPA": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Vídeos - CAPA ": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Cidades - Capa 1": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "cidades": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Cidades - últimas": {
    "cidades": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Cidades": {
    "cidades": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Comprova": {
    "comprova": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Comprova Últimas": {
    "comprova": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Economia - CAPA 1": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "economia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Capa - Super manchete com correlatas": {
    "arteepop": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "goiania90anos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Capa - fotão, secundárias e rodapé": {
    "eleicoes": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    } // TODO: Check if this is correct
    // "block": {
    //     "top": {
    //         "mobileSlot": {
    //             "id": "gjc_OPopular",
    //             "position": "RM1_M"
    //         }
    //     },
    //     "bottom": {
    //         "desktopSlot": {
    //             "id": "gjc_OPopular",
    //             "position": "LEADBRD1"
    //         },
    //         "mobileSlot": {
    //             "id": "gjc_OPopular",
    //             "position": "RM1_M"
    //         }
    //     }
    // }

  },
  "Economia - últimas (auto-9)": {
    "economia": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Economia": {
    "economia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Empresas": {
    "empresasprodutos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Sobre Rodas": {
    "sobrerodas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria": {
    "economia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    // TODO: Check if this is correct
    // "loterias": {
    //     "mega": {
    //         "top": {
    //             "desktopSlot": {
    //                 "id": "gjc_OPopular",
    //                 "position": "BILL_MAXI1"
    //             },
    //             "mobileSlot": {
    //                 "id": "gjc_OPopular",
    //                 "position": "BILL_MAXI1_M"
    //             }
    //         }
    //     }
    // },
    "atletico": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "goianao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "goias": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "vilanova": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "jacksonabrao": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Esporte - CAPA": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "esporte": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Esporte - últimas (auto-9)": {
    "esporte": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Esporte": {
    "esporte": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "O Popular 85 anos": {
    "85anos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "O Popular 85 anos - últimas": {
    "85anos": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Editoria Especial": {
    "85anos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "infomercial - últimas": {
    "infomercial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Infomercial": {
    "infomercial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Magazine - CAPA 1": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "magazine": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Magazine - últimas (auto-9)": {
    "magazine": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Magazine": {
    "magazine": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "bbb": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "cinema": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "famosos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "horoscopo": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "portuguesexpresso": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "resumonovelas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "saudeamesa": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "saudemental": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Últimas BBB": {
    "bbb": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Crônicas - últimas": {
    "cronicas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Matéria - Crônicas": {
    "cronicas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Gastronomia": {
    "gastronomia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Matéria - Gastronomia": {
    "gastronomia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Pratododia": {
    "opratododia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Política": {
    "politica": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Português Expresso": {
    "bbb": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Resumo das Novelas": {
    "resumonovelas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Saúde Mental": {
    "saudemental": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Mundo - CAPA ": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "mundo": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Mundo - últimas (auto-9)": {
    "mundo": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Mundo": {
    "mundo": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Opinião - CAPA": {
    "opiniao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Artigos - Últimas": {
    "artigos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Artigos": {
    "opiniao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "artigos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Opinião": {
    "opiniao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Opinião - Fabiana": {
    "blogfabianapulcineli": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Opinião - Carta dos Leitores": {
    "cartadosleitores": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Charge": {
    "charges": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Opinião - Cileide": {
    "colunadacileide": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Coluna Giro": {
    "colunagiro": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas Editorial": {
    "editorial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Opinião - Editorial": {
    "editorial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Jackson Abrão Entrevista": {
    "jacksonabrao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Editais - Lista": {
    "publicidadelegal": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Podcasts - últimos": {
    "podcasts": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Política - CAPA": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "politica": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Política - últimas (auto-9)": {
    "politica": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas (auto-9)": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "ultimas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Vídeos - destaques": {
    "videos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Vídeos - últimas da tag": {
    "videos": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Vídeos - últimas [auto-9]": {
    "videos": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Matéria - vídeo": {
    "videos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MBOX1"
          },
          "mobileSlot": {
            "id": " gjc_OPopular/Videos",
            "position": "RM1_M"
          }
        }
      }
    },
    "jacksonabrao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MBOX1"
          },
          "mobileSlot": {
            "id": " gjc_OPopular/Videos",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas notícias": {
    "atletico": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM1_M"
          }
        }
      }
    },
    "goianao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM1_M"
          }
        }
      }
    },
    "goias": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM1_M"
          }
        }
      }
    },
    "vilanova": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM1_M"
          }
        }
      }
    },
    "cinema": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "famosos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "horoscopo": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "opratododia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "saudeamesa": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "blogfabianapulcineli": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    },
    "cartadosleitores": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    },
    "charges": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    },
    "colunadacileide": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    },
    "colunagiro": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    },
    "jacksonabrao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - genérica": {
    "comprova": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    },
    "ultimas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Inteligência Artificial - Capa": {
    "inteligenciaartificial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Edição Digital": {
    "home": {
      "side": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "*": {
      "side": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas - Concursos e Empregos - Manual": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Saúde à Mesa - Manual": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Lateral - Últimas": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2_M"
          }
        }
      }
    },
    "comprova": {
      "side": {
        "top": {
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "RM2_M"
          }
        }
      }
    },
    "caminhadaecologica": {
      "side": {
        "top": {
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        }
      }
    },
    "cidades": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "RM2_M"
          }
        }
      }
    },
    "economia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "RM2_M"
          }
        }
      }
    },
    "esporte": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    },
    "atletico": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    },
    "goianao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    },
    "goias": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    },
    "vilanova": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "RM2_M"
          }
        }
      }
    },
    "85anos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        }
      }
    },
    "infomercial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "RM2_M"
          }
        }
      }
    },
    "inteligenciaartificial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Inteligencia_Artificial",
            "position": "RM2_M"
          }
        }
      }
    },
    "magazine": {
      "side": {
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM3_M"
          }
        }
      }
    },
    "bbb": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "cinema": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "cronicas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "famosos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "gastronomia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "horoscopo": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "opratododia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "portuguesexpresso": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "resumonovelas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "saudeamesa": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "saudemental": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "mundo": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "RM2_M"
          }
        }
      }
    },
    "opiniao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "podcasts": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        }
      }
    },
    "politica": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "RM3_M"
          }
        }
      }
    },
    "videos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM2_M"
          }
        }
      }
    },
    "artigos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "blogfabianapulcineli": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "cartadosleitores": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "charges": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "colunadacileide": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "colunagiro": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "editorial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "jacksonabrao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "RM2_M"
          }
        }
      }
    },
    "goiania90anos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Continue lendo / Mais Lidas": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM2_M"
          }
        }
      }
    },
    "comprova": {
      "side": {
        "top": {
          "mobileSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Comprova",
            "position": "RM2"
          }
        }
      }
    },
    "cidades": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Cidades",
            "position": "MPAG1"
          }
        }
      }
    },
    "economia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Economia",
            "position": "MPAG1"
          }
        }
      }
    },
    "esporte": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        }
      }
    },
    "atletico": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        }
      }
    },
    "goianao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        }
      }
    },
    "goias": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        }
      }
    },
    "vilanova": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Esporte",
            "position": "MPAG1"
          }
        }
      }
    },
    "85anos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        }
      }
    },
    "infomercial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Especial_Publicitario",
            "position": "MPAG1"
          }
        }
      }
    },
    "bbb": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "cinema": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "cronicas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "famosos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "gastronomia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "horoscopo": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "opratododia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "portuguesexpresso": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "resumonovelas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "saudeamesa": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "saudemental": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        }
      }
    },
    "mundo": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Mundo",
            "position": "MPAG1"
          }
        }
      }
    },
    "opiniao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "podcasts": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        }
      }
    },
    "politica": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Politica",
            "position": "MPAG1"
          }
        }
      }
    },
    "videos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MPAG1"
          }
        }
      }
    },
    "artigos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "blogfabianapulcineli": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "cartadosleitores": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "charges": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "colunadacileide": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "editorial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Opiniao",
            "position": "MPAG1"
          }
        }
      }
    },
    "jacksonabrao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MPAG1"
          }
        }
      }
    },
    "colunagiro": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Videos",
            "position": "MPAG1"
          }
        }
      }
    },
    "caminhadaecologica": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas - Concursos e Empregos": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "MPAG2"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "ultimas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "MPAG1"
          }
        }
      }
    }
  },
  "Elementos - BBB": {
    "home": {
      "side": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular.Home",
            "position": "MPAG2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "magazine": {
      "side": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Elementos - Radio": {
    "arteepop": {
      "side": {
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "RM1_M"
          }
        }
      }
    },
    "home": {
      "side": {
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular.Home",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Últimas de Caminhada Ecológica": {
    "caminhadaecologica": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Matéria - Caminhada Ecológica": {
    "caminhadaecologica": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Saúde à Mesa": {
    "magazine": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "ultimas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "RM2_M"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_OPopular/Ultimas",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Mais lidas": {
    "arteepop": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "RM2_M"
          }
        }
      }
    },
    "eleicoes": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas do Opopular": {
    "arteepop": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Arte_e_Pop",
            "position": "RM1_M"
          }
        }
      }
    },
    "eleicoes": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular/Eleicoes",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "ClassiSearch": {
    "*": {
      "side": {
        "bottom": {
          "desktopSlot": {
            "id": "Alright",
            "position": "HTML",
            "customHtml": "<div id='div-gpt-ad-1730134033076-0'></div>",
            "customEventName": "div-gpt-ad-1730134033076-0"
          },
          "mobileSlot": {
            "id": "Alright",
            "position": "HTML",
            "customHtml": "<div id='div-gpt-ad-1730134083458-0'></div>",
            "customEventName": "div-gpt-ad-1730134083458-0"
          }
        }
      }
    }
  },
  "generic": {
    "*": {
      "article": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "block": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "side": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "search": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "newsletter": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      }
    }
  },
  "Search Slot": {
    "*": {
      "search": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MBOX1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Search Filter": {
    "*": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Leia também": {
    "*": {
      "block": {
        "top": {
          "desktopSlot": {
            "id": "Alright",
            "position": "HTML",
            "nthPosition": [1],
            "customHtml": "<div id='div-gpt-ad-1730134121511-0'></div>",
            "customEventName": "div-gpt-ad-1730134121511-0"
          },
          "mobileSlot": {
            "id": "Alright",
            "position": "HTML",
            "nthPosition": [1],
            "customHtml": "<div id='div-gpt-ad-1730134154679-0'></div>",
            "customEventName": "div-gpt-ad-1730134154679-0"
          }
        }
      }
    }
  },
  "Article Slot": {
    "*": {
      "article": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_OPopular",
            "position": "MBOX?"
          },
          "mobileSlot": {
            "id": "gjc_OPopular",
            "position": "RM?_M"
          }
        }
      }
    }
  }
}; // Slot sizes to be used a fixed size for the slots

var slotSizeMap = {
  POP_HOME_SMT_BILL1_MAXI1: [300, 250],
  POP_HOME_SMT_RM1: [300, 250],
  POP_HOME_SMT_RM2: [300, 250],
  POP_HOME_SMT_RM3: [300, 250],
  POP_INTERNAS_SMT_BILL1_MAXI1: [300, 250],
  POP_INTERNAS_SMT_RM1: [300, 250],
  POP_INTERNAS_SMT_RM2: [300, 250],
  POP_INTERNAS_SMT_RM3: [300, 250],
  POP_HOME_DSK_BILL1_MAXI1: [970, 250],
  POP_INTERNAS_DSK_BILL1_MAXI1: [970, 250],
  POP_HOME_DSK_RM1: [300, 250],
  POP_HOME_DSK_RM2: [300, 250],
  POP_HOME_DSK_RM3: [300, 250],
  POP_HOME_DSK_LEADBRD1: [728, 90],
  POP_HOME_DSK_LEADBRD2: [728, 90],
  POP_HOME_DSK_LEADBRD3: [728, 90],
  POP_HOME_DSK_MPAG1: [300, 600],
  POP_HOME_DSK_MPAG2: [300, 600],
  POP_HOME_DSK_MPAG3: [300, 600],
  POP_INTERNAS_DSK_MPAG1: [300, 600],
  POP_INTERNAS_DSK_MPAG2: [300, 600],
  POP_INTERNAS_DSK_MPAG3: [300, 600],
  POP_INTERNAS_DSK_MBOX1: [600, 300],
  POP_INTERNAS_DSK_MBOX2: [600, 300],
  POP_INTERNAS_DSK_MBOX3: [600, 300],
  'gjc_OPopular.Home': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Cidades': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Ultimas': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Eleicoes': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Politica': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Esporte': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Economia': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Magazine': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Videos': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Opiniao': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Mundo': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Comprova': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Arte_e_Pop': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Inteligencia_Artificial': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_OPopular/Especial_Publicitario': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  }
};

var AdsSlot = function AdsSlot(_ref) {
  var type = _ref.type,
      _ref$componentReferen = _ref.componentReference,
      componentReference = _ref$componentReferen === void 0 ? "bottom" : _ref$componentReferen,
      data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot_Engine, {
    settings: settings,
    urlMapRegex: urlMapRegex,
    slotSizeMap: slotSizeMap,
    type: type,
    componentReference: componentReference,
    data: data
  });
};

/* harmony default export */ var Ads_Slot_Opopular = (AdsSlot);
;// CONCATENATED MODULE: ./components/Ads/Ads.Slot.Tocantins.tsx



var Ads_Slot_Tocantins_urlMapRegex = {
  "/$": "home",
  "^/economia/concursos-e-empregos.*": "empresasnegocios",
  "^/economia/empresas-e-negocios.*": "empresasnegocios",
  "^/economia/loterias.*": "empresasnegocios",
  "^/economia/sobre-rodas.*": "empresasnegocios",
  "^/economia.*": "economia",
  "^/cidades/judiciario.*": "judiciario",
  "^/cidades.*": "cidades",
  "^/esporte.*": "esporte",
  "^/infomercial.*": "infomercial",
  "^/magazine/bip.*": "bip",
  "^/magazine/cronicas-causos.*": "cronicascausos",
  "^/magazine/cinema.*": "cinema",
  "^/magazine.*": "magazine",
  "^/opiniao/jorge-braga.*": "jorgebraga",
  "^/opiniao/tendencias-e-ideais.*": "opiniao",
  "^/opiniao.*": "opiniao",
  "^/politica/coluna-esplanada*": "colunaeesplanada",
  "^/politica/antena-ligada.*": "antenaligada",
  "^/politica/eleicoes.*": "eleicoes",
  "^/politica.*": "politica",
  "^/mundo.*": "mundo",
  "^/vida-urbana./judiciario*": "judiciario",
  "^/vida-urbana./sustentabilidade.*": "sustentabilidade",
  "^/vida-urbana.*": "vidaurbana",
  "^/videos.*": "videos",
  "^/ultimas.*": "ultimas"
};
var Ads_Slot_Tocantins_settings = {
  "Capa - manchete sem foto": {
    "home": {
      "block": {
        "top": {
          "desktopSlot": {
            "id": "Alright",
            "position": "HTML",
            "customHtml": "<div id='div-gpt-ad-1737052441084-0'></div>",
            "customEventName": "div-gpt-ad-1737052441084-0"
          },
          "mobileSlot": {
            "id": "Alright",
            "position": "HTML_M",
            "customHtml": "<div id='div-gpt-ad-1737052835947-0'></div>",
            "customEventName": "div-gpt-ad-1737052835947-0"
          }
        }
      }
    }
  },
  "Capa - fotão, secundárias e rodapé": {
    "home": {
      "block": {
        "top": {
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM1_M"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Infomercial - destaques": {
    "home": {
      "block": {
        "top": {
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM1_M"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas Capa": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Elementos - Radio": {
    "home": {
      "side": {
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Vídeos - CAPA": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    }
  },
  "Cidades - Capa 1": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "cidades": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Cidades",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Cidades",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Cidades",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Cidades",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Economia - CAPA 1": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "economia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas de Economia": {
    "economia": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas de Cidades": {
    "cidades": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Cidades",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Cidades",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Política - CAPA": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "politica": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas de Política": {
    "politica": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas notícias Eleicoes": {
    "eleicoes": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Eleicoes",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Eleicoes",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas notícias": {
    "empresasnegocios": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "RM1_M"
          }
        }
      }
    },
    "economia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "RM1_M"
          }
        }
      }
    },
    "bip": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "cronicascausos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "RM1_M"
          }
        }
      }
    },
    "cinema": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM1_M"
          }
        }
      }
    },
    "antenaligada": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "RM1_M"
          }
        }
      }
    },
    "colunaeesplanada": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "RM1_M"
          }
        }
      }
    },
    "judiciario": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM1_M"
          }
        }
      }
    },
    "sustentabilidade": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Esporte - CAPA": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "esporte": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Esporte",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Esporte",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas notícias Cinema": {
    "cinema": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas notícias Esplanada": {
    "colunaeesplanada": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas de Esporte": {
    "esporte": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Esporte",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Esporte",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas de Infomercial": {
    "infomercial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Especial_Publicitario",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Especial_Publicitario",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Especial_Publicitario",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Especial_Publicitario",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Magazine - CAPA 1": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "magazine": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Magazine ultimas": {
    "magazine": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas de Magazine": {
    "magazine": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Mundo - CAPA": {
    "home": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "LEADBRD3"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "mundo": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas de Mundo": {
    "mundo": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Opinião - CAPA": {
    "opiniao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Jorge Braga": {
    "jorgebraga": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas notícias Jorge Braga": {
    "jorgebraga": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas Tendências e Ideias": {
    "opiniao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas notícias Tendencias e ideias": {
    "opiniao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Lateral - Últimas": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "empresasnegocios": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "RM2_M"
          }
        }
      }
    },
    "cidades": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Cidades",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Cidades",
            "position": "RM3_M"
          }
        }
      }
    },
    "economia": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "RM3_M"
          }
        }
      }
    },
    "esporte": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Esporte",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Esporte",
            "position": "RM3_M"
          }
        }
      }
    },
    "infomercial": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Especial_Publicitario",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Especial_Publicitario",
            "position": "RM2_M"
          }
        }
      }
    },
    "magazine": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "RM3_M"
          }
        }
      }
    },
    "bip": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "cronicascausos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "RM2_M"
          }
        }
      }
    },
    "cinema": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM2_M"
          }
        }
      }
    },
    "mundo": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "RM2_M"
          }
        }
      }
    },
    "opiniao": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "jorgebraga": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Opiniao",
            "position": "RM2_M"
          }
        }
      }
    },
    "colunaeesplanada": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "RM2_M"
          }
        }
      }
    },
    "antenaligada": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "RM2_M"
          }
        }
      }
    },
    "politica": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "RM3_M"
          }
        }
      }
    },
    "eleicoes": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Eleicoes",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Eleicoes",
            "position": "RM3_M"
          }
        }
      }
    },
    "vidaurbana": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM2_M"
          }
        }
      }
    },
    "judiciario": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM2_M"
          }
        }
      }
    },
    "sustentabilidade": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM2_M"
          }
        }
      }
    },
    "videos": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Videos",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Videos",
            "position": "RM3_M"
          }
        }
      }
    } // "artigos": {
    //    "side": {
    //       "top": {
    //          "desktopSlot": {
    //             "id": "gjc_JTO",
    //             "position": "MPAG1"
    //          }
    //       },
    //       "bottom": {
    //          "mobileSlot": {
    //             "id": "gjc_JTO",
    //             "position": "RM2_M"
    //          }
    //       }
    //    }
    // }

  },
  "Últimas": {
    "ultimas": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Ultimas",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Ultimas",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Ultimas",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Ultimas",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Mais lidas": {
    "home": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM1"
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM2"
          },
          "mobileSlot": {
            "id": "gjc_JTO.Home",
            "position": "RM3_M"
          }
        }
      }
    },
    "ultimas": {
      "side": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Ultimas",
            "position": "MPAG1"
          }
        },
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Ultimas",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Vida Urbana - Capa 1": {
    "vidaurbana": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Últimas de Vida Urbana": {
    "vidaurbana": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas de Opinião": {
    "mundo": {
      "block": {
        "bottom": {
          "mobileSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Vídeos - destaques": {
    "videos": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Videos",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Videos",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Videos",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Videos",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Últimas de Vídeos": {
    "videos": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Videos",
            "position": "LEADBRD2"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Videos",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Matéria - Cidades- JTO": {
    "cidades": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Cidades",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Cidades",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - genérica": {
    "*": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Economia- JTO": {
    "economia": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Economia",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Economia",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria -Esporte- JTO": {
    "esporte": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Esporte",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Esporte",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Magazine - JTO": {
    "magazine": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Magazine",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Mundo - JTO": {
    "mundo": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Opiniao - JTO": {
    "opiniao": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Mundo",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Politica - JTO": {
    "*": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Politica",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Politica",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Infomercial - JTO": {
    "infomercial": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Especial_Publicitario",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Especial_Publicitario",
            "position": "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Eleições - CAPA": {
    "*": {
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "gjc_JTO/Eleicoes",
            "position": "BILL_MAXI1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Eleicoes",
            "position": "BILL_MAXI1_M"
          }
        }
      },
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO/Eleicoes",
            "position": "LEADBRD1"
          },
          "mobileSlot": {
            "id": "gjc_JTO/Eleicoes",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "generic": {
    "*": {
      "article": {
        "top": {
          "desktopSlot": {
            "id": "JTO_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "JTO_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "JTO_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "JTO_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "block": {
        "top": {
          "desktopSlot": {
            "id": "JTO_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "JTO_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "JTO_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "JTO_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "JTO_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "JTO_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "JTO_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "JTO_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "side": {
        "top": {
          "desktopSlot": {
            "id": "JTO_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "JTO_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "JTO_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "JTO_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "search": {
        "top": {
          "desktopSlot": {
            "id": "JTO_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "JTO_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "JTO_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "JTO_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      }
    }
  },
  "Search Slot": {
    "*": {
      "search": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "MBOX1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM1_M"
          }
        }
      }
    }
  },
  "Search Filter": {
    "*": {
      "block": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "RM1"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM2_M"
          }
        }
      }
    }
  },
  "Article Slot": {
    "*": {
      "article": {
        "bottom": {
          "desktopSlot": {
            "id": "gjc_JTO",
            "position": "MBOX?"
          },
          "mobileSlot": {
            "id": "gjc_JTO",
            "position": "RM?_M"
          }
        }
      }
    }
  }
}; // Slot sizes to be used a fixed size for the slots

var Ads_Slot_Tocantins_slotSizeMap = {
  JTO_HOME_SMT_BILL1_MAXI1: [300, 250],
  JTO_HOME_SMT_RM1: [300, 250],
  JTO_HOME_SMT_RM2: [300, 250],
  JTO_HOME_SMT_RM3: [300, 250],
  JTO_INTERNAS_SMT_BILL1_MAXI1: [300, 250],
  JTO_INTERNAS_SMT_RM1: [300, 250],
  JTO_INTERNAS_SMT_RM2: [300, 250],
  JTO_INTERNAS_SMT_RM3: [300, 250],
  JTO_HOME_DSK_BILL1_MAXI1: [970, 250],
  JTO_INTERNAS_DSK_BILL1_MAXI1: [970, 250],
  JTO_HOME_DSK_RM1: [300, 250],
  JTO_HOME_DSK_RM2: [300, 250],
  JTO_HOME_DSK_RM3: [300, 250],
  JTO_HOME_DSK_LEADBRD1: [728, 90],
  JTO_HOME_DSK_LEADBRD2: [728, 90],
  JTO_HOME_DSK_LEADBRD3: [728, 90],
  JTO_HOME_DSK_MPAG1: [300, 600],
  JTO_HOME_DSK_MPAG2: [300, 600],
  JTO_HOME_DSK_MPAG3: [300, 600],
  JTO_INTERNAS_DSK_MPAG1: [300, 600],
  JTO_INTERNAS_DSK_MPAG2: [300, 600],
  JTO_INTERNAS_DSK_MPAG3: [300, 600],
  JTO_INTERNAS_DSK_MBOX1: [600, 300],
  JTO_INTERNAS_DSK_MBOX2: [600, 300],
  JTO_INTERNAS_DSK_MBOX3: [600, 300],
  'gjc_JTO.Home': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Cidades': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Ultimas': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Eleicoes': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Politica': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Esporte': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Economia': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Magazine': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Videos': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Opiniao': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Mundo': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  'gjc_JTO/Especial_Publicitario': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  }
};

var Ads_Slot_Tocantins_AdsSlot = function AdsSlot(_ref) {
  var type = _ref.type,
      _ref$componentReferen = _ref.componentReference,
      componentReference = _ref$componentReferen === void 0 ? "bottom" : _ref$componentReferen,
      data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot_Engine, {
    settings: Ads_Slot_Tocantins_settings,
    urlMapRegex: Ads_Slot_Tocantins_urlMapRegex,
    slotSizeMap: Ads_Slot_Tocantins_slotSizeMap,
    type: type,
    componentReference: componentReference,
    data: data
  });
};

/* harmony default export */ var Ads_Slot_Tocantins = (Ads_Slot_Tocantins_AdsSlot);
;// CONCATENATED MODULE: ./components/Ads/Ads.Slot.Daqui.tsx



var Ads_Slot_Daqui_urlMapRegex = {
  "/$": "home",
  "^/ultimas.*": "ultimas",
  "^/geral.*": "geral",
  "^/emprego.*": "emprego",
  "^/esporte.*": "esporte",
  "^/famosos.*": "famosos",
  "^/meu-bichinho.*": "meu-bichinho",
  "^/loterias.*": "loterias",
  "^/gata-do-daqui.*": "gata-do-daqui",
  "^/promocoes.*": "promocoes",
  "^/infomercial.*": "infomercial",
  "^/novelas.*": "novelas",
  "^/publicidade-legal.*": "publicidade-legal",
  "^/horoscopo.*": "horoscopo",
  "^/pesquisa.*": "pesquisa"
};
var Ads_Slot_Daqui_settings = {
  "Capa - Destaque - Daqui": {
    home: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Capa - fotão, secundárias e rodapé - Daqui": {
    home: {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "LEADBRD2"
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Capa - Destaque 2 - Daqui": {
    home: {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM1_M"
          }
        }
      }
    }
  },
  "Geral - título": {
    geral: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Widget Agendamento": {
    home: {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "MPAG1"
          }
        }
      }
    }
  },
  "Últimas Geral - Daqui": {
    home: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "LEADBRD1"
          }
        }
      }
    },
    geral: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          id: "gjc_DAQUI/Geral",
          position: "LEADBRD1"
        }
      }
    }
  },
  "Capa de Últimas - Daqui": {
    ultimas: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Continue lendo / Mais Lidas": {
    home: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "MPAG1"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM2"
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM2_M"
          }
        }
      }
    },
    ultimas: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "MPAG1"
          }
        }
      }
    },
    famosos: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "MPAG1"
          }
        }
      }
    },
    geral: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "MPAG1"
          }
        }
      }
    },
    emprego: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "MPAG1"
          }
        }
      }
    },
    esporte: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "MPAG1"
          }
        }
      }
    },
    "meu-bichinho": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "MPAG1"
          }
        }
      }
    },
    loterias: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "MPAG1"
          }
        }
      }
    },
    promocoes: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "MPAG1"
          }
        }
      }
    },
    infomercial: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "MPAG1"
          }
        }
      }
    }
  },
  "Editais - Lista - DAQUI": {
    "publicidade-legal": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "RM1_M"
          }
        }
      }
    }
  },
  "Elementos - Radio Daqui": {
    home: {
      side: {
        bottom: {
          desktopSlot: {
            id: 'gjc_DAQUI.Home',
            position: 'RM3'
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM3_M"
          }
        }
      }
    }
  },
  "Emprego - título": {
    emprego: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Esporte - título": {
    esporte: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Loterias - título": {
    loterias: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Promoções - título": {
    promocoes: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Pesquisa - Lista": {
    pesquisa: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Pesquisa",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Pesquisa",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Pesquisa",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Gata do Daqui - título": {
    "gata-do-daqui": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Famosos - título": {
    famosos: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Publicidade Legal Daqui- Lateral": {
    "publicidade-legal": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "MPAG1"
          }
        }
      }
    }
  },
  "Publicidade Legal - Template Interna Daqui": {
    "publicidade-legal": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Publicidade_Legal",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Infomercial - título": {
    infomercial: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Meu bichinho - título": {
    "meu-bichinho": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Widget Kit GO": {
    ultimas: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "MPAG1"
          },
          mobileSlot: {
            id: 'gjc_DAQUI/Ultimas',
            position: 'RM1_M'
          }
        }
      }
    },
    geral: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "RM1_M"
          }
        }
      }
    },
    emprego: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "RM1_M"
          }
        }
      }
    },
    esporte: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "RM1_M"
          }
        }
      }
    },
    famosos: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "RM1_M"
          }
        }
      }
    },
    "meu-bichinho": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "RM1_M"
          }
        }
      }
    },
    loterias: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "RM1_M"
          }
        }
      }
    },
    "gata-do-daqui": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "RM1_M"
          }
        }
      }
    },
    promocoes: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "RM1_M"
          }
        }
      }
    },
    "*": {
      side: {
        top: {
          desktopSlot: {
            id: "Alright",
            position: "HTML",
            customHtml: "<div id='div-gpt-ad-1737038557423-0'></div>",
            customEventName: "div-gpt-ad-1737038557423-0"
          }
        }
      }
    }
  },
  "Widget Kit TO": {
    home: {
      side: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM3_M"
          }
        }
      }
    }
  },
  "Widget - Lista Gata do Daqui": {
    home: {
      side: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM2"
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "WhatsApp": {
    ultimas: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "RM1"
          }
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Ultimas",
            position: "RM2_M"
          }
        }
      }
    },
    geral: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "RM1"
          }
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "RM2_M"
          }
        }
      }
    },
    emprego: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "RM1"
          }
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "RM2_M"
          }
        }
      }
    },
    esporte: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "RM1"
          }
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "RM2_M"
          }
        }
      }
    },
    famosos: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "RM1"
          }
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "RM2_M"
          }
        }
      }
    },
    "meu-bichinho": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "RM1"
          }
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "RM2_M"
          }
        }
      }
    },
    loterias: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "RM1"
          }
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "RM2_M"
          }
        }
      }
    },
    "gata-do-daqui": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "RM1"
          }
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "RM2_M"
          }
        }
      }
    },
    promocoes: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "RM1"
          }
        },
        bottom: {
          mobileSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Lateral - Últimas Daqui": {
    emprego: {
      side: {
        bottom: {
          id: "gjc_DAQUI/Emprego",
          position: "RM2"
        }
      }
    }
  },
  "Últimas Promocoes - Daqui": {
    promocoes: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Últimas Gata do Daqui": {
    "gata-do-daqui": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Gata_Do_Daqui",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Últimas Loteria - Daqui": {
    loterias: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Últimas Meu Bichinho - Daqui": {
    "meu-bichinho": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Meu_Bichinho",
            position: "BILL_MAXI1_M"
          }
        },
        block: {
          bottom: {
            desktopSlot: {
              id: "gjc_DAQUI/Meu_Bichinho",
              position: "LEADBRD1"
            }
          }
        }
      }
    }
  },
  "Últimas Esporte - Daqui": {
    esporte: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Últimas Emprego - Daqui": {
    emprego: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Últimas Famosos - Daqui": {
    famosos: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Últimas Capa - Daqui": {
    home: {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI.Home",
            position: "LEADBRD3"
          },
          mobileSlot: {
            id: "gjc_DAQUI.Home",
            position: "RM3_M"
          }
        }
      }
    }
  },
  "Últimas infomercial - Daqui": {
    infomercial: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Infomercial",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Search Filter": {
    "*": {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_DAQUI",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Search Slot": {
    "*": {
      search: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI",
            position: "MBOX1"
          },
          mobileSlot: {
            id: "gjc_DAQUI",
            position: "RM1_M"
          }
        }
      }
    }
  },
  "Últimas Horoscopo": {
    horoscopo: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "BILL_MAXI1"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Horóscopo - título": {
    horoscopo: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Emprego Daqui": {
    "emprego": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Esporte Daqui": {
    "esporte": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Esporte",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Famosos Daqui": {
    "famosos": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Famosos",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Gata do Daqui": {
    "gata-do-daqui": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/GataDoDaqui",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/GataDoDaqui",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Horóscopo Daqui": {
    "horoscopo": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Horoscopo",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Loterias Daqui": {
    "loterias": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Loterias",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Novelas Daqui": {
    "novelas": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Novelas",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Novelas",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Geral Daqui": {
    "geral": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Geral",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Meu Bichinho Daqui": {
    "meu-bichinho": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/MeuBichinho",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/MeuBichinho",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Minha dica e Daqui": {
    "*": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/MeuBichinho",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/MeuBichinho",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Promoções Daqui": {
    "promocoes": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Promocoes",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - Informecial Daqui": {
    "infomercial": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Especial_Publicitario",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Especial_Publicitario",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Matéria - genérica": {
    "geral": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_DAQUI/Emprego",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Article Slot": {
    "*": {
      article: {
        bottom: {
          desktopSlot: {
            id: "gjc_DAQUI",
            position: "MBOX?"
          },
          mobileSlot: {
            id: "gjc_DAQUI",
            position: "RM?_M"
          }
        }
      }
    }
  },
  "generic": {
    "*": {
      "article": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "block": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "side": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "search": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "newsletter": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      }
    }
  }
};
var Ads_Slot_Daqui_slotSizeMap = {
  "gjc_DAQUI.Home": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Emprego": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Esporte": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Famosos": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Gata_Do_Daqui": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Geral": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Horoscopo": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Infomercial": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Loterias": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Meu_Bichinho": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Pesquisa": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Promocoes": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Publicidade_Legal": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_DAQUI/Ultimas": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  }
};

var Ads_Slot_Daqui_AdsSlot = function AdsSlot(_ref) {
  var type = _ref.type,
      _ref$componentReferen = _ref.componentReference,
      componentReference = _ref$componentReferen === void 0 ? "bottom" : _ref$componentReferen,
      data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot_Engine, {
    settings: Ads_Slot_Daqui_settings,
    urlMapRegex: Ads_Slot_Daqui_urlMapRegex,
    slotSizeMap: Ads_Slot_Daqui_slotSizeMap,
    type: type,
    componentReference: componentReference,
    data: data
  });
};

/* harmony default export */ var Ads_Slot_Daqui = (Ads_Slot_Daqui_AdsSlot);
;// CONCATENATED MODULE: ./components/Ads/Ads.Slot.Cbngo.tsx



var Ads_Slot_Cbngo_urlMapRegex = {
  "/$": "home",
  "^/cbn-goiania/boca-baco.*": "boca-baco",
  "^/cbn-goiania/cafe-com-cbn.*": "cafe-com-cbn",
  "^/cbn-goiania/cbn-talk.*": "cbn-talk",
  "^/cbn-goiania/cenario-economico.*": "cenario-economico",
  "^/cbn-goiania/empreender.*": "empreender",
  "^/cbn-goiania/guia-saude.*": "guia-saude",
  "^/cbn-goiania/napontadalingua.*": "napontadalingua",
  "^/cbn-goiania/papo-politico.*": "papo-politico",
  "^/cbn-goiania/plural.*": "plural",
  "^/cbn-goiania/proseando.*": "proseando",
  "^/cbn-goiania/radio-pet.*": "radio-pet",
  "^/tarde-cbn/diva-na-cbn.*": "diva-na-cbn",
  "^/tarde-cbn/extra-campo.*": "extra-campo",
  "^/tarde-cbn/na-trilha-da-politica.*": "na-trilha-da-politica",
  "^/tarde-cbn/onda-cultural.*": "onda-cultural",
  "^/tarde-cbn/precisamos-falar-sobre.*": "precisamos-falar-sobre",
  "^/tarde-cbn/voce-investe.*": "voce-investe",
  "^/cbn-esportes.*": "cbn-esportes",
  "^/podcasts.*": "podcasts",
  "^/ultimas.*": "ultimas",
  "^/cbn-goiania.*": "cbn-goiania",
  "^/tarde-cbn.*": "tarde-cbn"
};
var Ads_Slot_Cbngo_settings = {
  "Manchete sem foto CBN": {
    home: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Capa - fotão, secundárias e rodapé - CBNGO": {
    home: {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "RM1_M"
          }
        }
      }
    }
  },
  "Elemento - Jogos": {
    home: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Mais lidas": {
    home: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "RM2"
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "RM1_M"
          }
        }
      }
    }
  },
  "Últimas - Papo Político - Auto": {
    home: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "RM3"
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "RM2_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "RM3_M"
          }
        }
      }
    },
    'cbn-goiania': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Capa - CBNGO": {
    home: {
      mega: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "LEADBRD2"
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "BILL_MAXI1_M"
          }
        }
      }
    },
    ultimas: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Ultimas",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN.Ultimas",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN.Ultimas",
            position: "LEADBRD2"
          },
          mobileSlot: {
            id: "gjc_CBN.Ultimas",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  //ELEMENTO RÁDIO
  "Elementos - Radio CBNGO": {
    //EDITORIAS
    'cbn-goiania': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM2_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM3_M"
          }
        }
      }
    },
    'tarde-cbn': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "RM2_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "RM3_M"
          }
        }
      }
    },
    //SUB EDITORIAS
    'cafe-com-cbn': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cafe_com_CBN",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Cafe_com_CBN",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Cafe_com_CBN",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Cafe_com_CBN",
            position: "RM3_M"
          }
        }
      }
    },
    'cbn-talk': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "RM3_M"
          }
        }
      }
    },
    'boca-baco': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM3_M"
          }
        }
      }
    },
    'cenario-economico': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM3_M"
          }
        }
      }
    },
    'empreender': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Empreender",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Empreender",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Empreender",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Empreender",
            position: "RM3_M"
          }
        }
      }
    },
    'podcasts': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Podcasts",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Podcasts",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Podcasts",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Podcasts",
            position: "RM3_M"
          }
        }
      }
    },
    'guia-saude': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "RM3_M"
          }
        }
      }
    },
    'napontadalingua': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "RM3_M"
          }
        }
      }
    },
    'papo-politico': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "RM3_M"
          }
        }
      }
    },
    'plural': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Plural",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Plural",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Plural",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Plural",
            position: "RM3_M"
          }
        }
      }
    },
    'proseando': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Proseando",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Proseando",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Proseando",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Proseando",
            position: "RM3_M"
          }
        }
      }
    },
    'radio-pet': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "RM3_M"
          }
        }
      }
    },
    'diva-na-cbn': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "RM3_M"
          }
        }
      }
    },
    'extra-campo': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "RM3_M"
          }
        }
      }
    },
    'na-trilha-da-politica': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "RM3_M"
          }
        }
      }
    },
    'onda-cultural': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "RM3_M"
          }
        }
      }
    },
    'precisamos-falar-sobre': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "RM3_M"
          }
        }
      }
    },
    'voce-investe': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "RM3_M"
          }
        }
      }
    },
    'cbn-esportes': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "RM3_M"
          }
        }
      }
    },
    'ultimas': {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Ultimas",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN/Ultimas",
            position: "RM1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Ultimas",
            position: "MPAG1"
          },
          mobileSlot: {
            id: "gjc_CBN/Ultimas",
            position: "RM3_M"
          }
        }
      }
    }
  },
  //DESTAQUE CAPAS EDITORIAS
  "CBN Goiânia - destaques": {
    'cbn-goiania': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Tarde CBN - destaques": {
    'tarde-cbn': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  //DESTAQUES SUB EDITORIAS
  "Café com CBN - destaques": {
    'cbn-goiania': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cafe_com_CBN",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Cafe_com_CBN",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Cenário Econômico com Leandro Resende": {
    'cenario-economico': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Na Ponta da Língua": {
    'napontadalingua': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Papo Político com Fabiana Pulcineli": {
    'papo-politico': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Plural": {
    'plural': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Plural",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Plural",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Proseando com José Bonfim": {
    'proseando': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Proseando",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Proseando",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Rádio Pet": {
    'radio-pet': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Divã na CBN": {
    'diva-na-cbn': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Na Trilha da Política com Cileide Alves": {
    'na-trilha-da-politica': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Onda Cultural": {
    'onda-cultural': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Precisamos falar sobre": {
    'precisamos-falar-sobre': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Você Investe": {
    'voce-investe': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "CBN + Esportes": {
    'cbn-esportes': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Podcasts": {
    'podcasts': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Podcasts",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Podcasts",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  //ULTIMAS CAPAS EDITORIAS
  "Últimas CBN Goiânia - CBNGO": {
    'cbn-goiania': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM3_M"
          }
        }
      }
    }
  },
  "Últimas Tarde CBN - CBNGO": {
    'tarde-cbn': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "RM3_M"
          }
        }
      }
    }
  },
  //SULTIMAS SUB EDITORIAS
  "Últimas Café com CBN - CBNGO": {
    'cbn-goiania': {
      mega: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "RM3_M"
          }
        }
      }
    }
  },
  "Últimas CBN Talk - CBNGO": {
    'cbn-talk': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "BILL_MAXI1_M"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "RM3_M"
          }
        }
      }
    }
  },
  "Últimas Boca e Baco - CBNGO": {
    'boca-baco': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "RM3_M"
          }
        }
      }
    }
  },
  "Últimas Cenário Econômico - CBNGO": {
    'cenario-economico': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Empreender - CBNGO": {
    'empreender': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Empreender",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Empreender",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Empreender",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Empreender",
            position: "RM3_M"
          }
        }
      }
    }
  },
  "Últimas Guia Saúde - CBNGO": {
    'guia-saude': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "RM3_M"
          }
        }
      }
    }
  },
  "Últimas Na Ponta da Língua - CBNGO": {
    'napontadalingua': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Papo Político - CBNGO": {
    'papo-politico': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Plural - CBNGO": {
    'plural': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Plural",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Plural",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Proseando - CBNGO": {
    'proseando': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Proseando",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Proseando",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Rádio Pet - CBNGO": {
    'radio-pet': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Divã na CBN - CBNGO": {
    'diva-na-cbn': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Extra Campo - CBNGO": {
    'extra-campo': {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "RM3_M"
          }
        }
      }
    }
  },
  "Últimas Na Trilha da Política - CBNGO": {
    'na-trilha-da-politica': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Onda Cultural - CBNGO": {
    'onda-cultural': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Precisamos falar Sobre - CBNGO": {
    'precisamos-falar-sobre': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas Você Investe - CBNGO": {
    'voce-investe': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Últimas CBN + Esportes - CBNGO": {
    'cbn-esportes': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Podcasts - CBNGO": {
    'podcasts': {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Podcasts",
            position: "LEADBRD1"
          },
          mobileSlot: {
            id: "gjc_CBN/Podcasts",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Pesquisa - Lista": {
    pesquisa: {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Pesquisa",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN/Pesquisa",
            position: "BILL_MAXI1_M"
          }
        }
      },
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN/Pesquisa",
            position: "LEADBRD1"
          }
        }
      }
    }
  },
  "Search Filter": {
    "*": {
      block: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN",
            position: "RM1"
          },
          mobileSlot: {
            id: "gjc_CBN",
            position: "RM2_M"
          }
        }
      }
    }
  },
  "Search Slot": {
    "*": {
      search: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN",
            position: "MBOX1"
          },
          mobileSlot: {
            id: "gjc_CBN",
            position: "RM1_M"
          }
        }
      }
    }
  },
  //CONTINUE LENDO / MAIS LIDAS MATÉRIAS
  "Continue lendo / Mais Lidas": {
    home: {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "MPAG1"
          }
        },
        bottom: {
          desktopSlot: {
            id: "gjc_CBN.Home",
            position: "RM2"
          },
          mobileSlot: {
            id: "gjc_CBN.Home",
            position: "RM2_M"
          }
        }
      }
    },
    "cbn-goiania": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Goiania",
            position: "MPAG1"
          }
        }
      }
    },
    "tarde-cbn": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Tarde_CBN",
            position: "MPAG1"
          }
        }
      }
    },
    "boca-baco": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Boca_e_Baco",
            position: "MPAG1"
          }
        }
      }
    },
    "cafe-com-cbn": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cafe_com_CBN",
            position: "MPAG1"
          }
        }
      }
    },
    "cbn-talk": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Talk",
            position: "MPAG1"
          }
        }
      }
    },
    "cenario-economico": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Cenario_Economico",
            position: "MPAG1"
          }
        }
      }
    },
    "empreender": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Empreender",
            position: "MPAG1"
          }
        }
      }
    },
    "guia-saude": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Guia_Saude",
            position: "MPAG1"
          }
        }
      }
    },
    "napontadalingua": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Ponta_da_Lingua",
            position: "MPAG1"
          }
        }
      }
    },
    "papo-politico": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Papo_Politico",
            position: "MPAG1"
          }
        }
      }
    },
    "plural": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Plural",
            position: "MPAG1"
          }
        }
      }
    },
    "proseando": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Proseando",
            position: "MPAG1"
          }
        }
      }
    },
    "radio-pet": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Radio_Pet",
            position: "MPAG1"
          }
        }
      }
    },
    "extra-campo": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Extra_Campo",
            position: "MPAG1"
          }
        }
      }
    },
    "diva-na-cbn": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Diva_na_CBN",
            position: "MPAG1"
          }
        }
      }
    },
    "na-trilha-da-politica": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Na_Trilha_da_Politica",
            position: "MPAG1"
          }
        }
      }
    },
    "onda-cultural": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Onda_Cultural",
            position: "MPAG1"
          }
        }
      }
    },
    "precisamos-falar-sobre": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Precisamos_Falar_Sobre",
            position: "MPAG1"
          }
        }
      }
    },
    "voce-investe": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Voce_Investe",
            position: "MPAG1"
          }
        }
      }
    },
    "cbn-esportes": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/CBN_Esportes",
            position: "MPAG1"
          }
        }
      }
    },
    "podcasts": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Podcasts",
            position: "MPAG1"
          }
        }
      }
    },
    "ultimas": {
      side: {
        top: {
          desktopSlot: {
            id: "gjc_CBN/Ultimas",
            position: "MPAG1"
          }
        }
      }
    }
  },
  "Matéria - genérica - CBNGO": {
    "*": {
      mega: {
        top: {
          desktopSlot: {
            id: "gjc_CBN",
            position: "BILL_MAXI1"
          },
          mobileSlot: {
            id: "gjc_CBN",
            position: "BILL_MAXI1_M"
          }
        }
      }
    }
  },
  "Article Slot": {
    "*": {
      article: {
        bottom: {
          desktopSlot: {
            id: "gjc_CBN",
            position: "MBOX?"
          },
          mobileSlot: {
            id: "gjc_CBN",
            position: "RM?_M"
          }
        }
      }
    }
  },
  "generic": {
    "*": {
      "article": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "block": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "mega": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "side": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "search": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      },
      "newsletter": {
        "top": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        },
        "bottom": {
          "desktopSlot": {
            "id": "POP_INTERNAS_DSK_MBOX9999",
            "position": ""
          },
          "mobileSlot": {
            "id": "POP_INTERNAS_SMT_RM9999",
            "position": ""
          }
        }
      }
    }
  }
};
var Ads_Slot_Cbngo_slotSizeMap = {
  "gjc_CBN.Home": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Proseando": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Na_Ponta_da_Lingua": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Tarde_CBN": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Cenario_Economico": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/CBN_Goiania": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Voce_Investe": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/CBN_Esportes": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Plural": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Papo_Politico": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Pesquisa": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Na_Trilha_da_Politica": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Precisamos_Falar_Sobre": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Ultimas": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Extra_Campo": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Guia_Saude": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Especial_Publicitario": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Radio_Pet": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Empreender": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Boca_e_Baco": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Diva_na_CBN": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Onda_Cultural": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Cafe_com_CBN": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/CBN_Talk": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN/Podcasts": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  },
  "gjc_CBN.Ultimas": {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250]
  }
};

var Ads_Slot_Cbngo_AdsSlot = function AdsSlot(_ref) {
  var type = _ref.type,
      _ref$componentReferen = _ref.componentReference,
      componentReference = _ref$componentReferen === void 0 ? "bottom" : _ref$componentReferen,
      data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot_Engine, {
    settings: Ads_Slot_Cbngo_settings,
    urlMapRegex: Ads_Slot_Cbngo_urlMapRegex,
    slotSizeMap: Ads_Slot_Cbngo_slotSizeMap,
    type: type,
    componentReference: componentReference,
    data: data
  });
};

/* harmony default export */ var Ads_Slot_Cbngo = (Ads_Slot_Cbngo_AdsSlot);
;// CONCATENATED MODULE: ./components/Ads/Ads.Slot.tsx


var _excluded = ["type", "componentReference", "data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var slug = "cbngo" || 0;

var Ads_Slot_AdsSlot = function AdsSlot(_ref) {
  var type = _ref.type,
      _ref$componentReferen = _ref.componentReference,
      componentReference = _ref$componentReferen === void 0 ? "bottom" : _ref$componentReferen,
      data = _ref.data,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,react.useMemo)(function () {
    switch (slug) {
      case 'tocantins':
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot_Tocantins, _objectSpread({
          type: type,
          componentReference: componentReference,
          data: data
        }, props));

      case 'daqui':
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot_Daqui, _objectSpread({
          type: type,
          componentReference: componentReference,
          data: data
        }, props));

      case 'cbngo':
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot_Cbngo, _objectSpread({
          type: type,
          componentReference: componentReference,
          data: data
        }, props));

      default:
        // opopular
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot_Opopular, _objectSpread({
          type: type,
          componentReference: componentReference,
          data: data
        }, props));
    }
  }, [type, componentReference, data, props]);
};

/* harmony default export */ var Ads_Slot = (Ads_Slot_AdsSlot);

/***/ }),

/***/ 7617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ComponentSwitch": function() { return /* binding */ ComponentSwitch; },
  "default": function() { return /* binding */ Base_index; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/@xprog/prensa/index.js
var prensa = __webpack_require__(2003);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/lodash/slice.js
var slice = __webpack_require__(2571);
var slice_default = /*#__PURE__*/__webpack_require__.n(slice);
// EXTERNAL MODULE: ./providers/Article/index.tsx
var Article = __webpack_require__(6521);
// EXTERNAL MODULE: ./providers/Assets/index.tsx
var Assets = __webpack_require__(8054);
// EXTERNAL MODULE: ./providers/Pages/index.tsx
var Pages = __webpack_require__(9859);
// EXTERNAL MODULE: ./providers/ServerSideProps/index.tsx + 539 modules
var ServerSideProps = __webpack_require__(7083);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Buttons/IconButton.index.tsx
var IconButton_index = __webpack_require__(4312);
// EXTERNAL MODULE: ./components/Buttons/CallToActionOutlinedButton.index.tsx
var CallToActionOutlinedButton_index = __webpack_require__(8081);
// EXTERNAL MODULE: ./hooks/useIcon.tsx
var useIcon = __webpack_require__(3090);
// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__(3311);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
// EXTERNAL MODULE: ./node_modules/lodash/first.js
var first = __webpack_require__(8804);
var first_default = /*#__PURE__*/__webpack_require__.n(first);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(7361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__(5161);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Article/Caption/Caption.index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Caption = function Caption(props) {
  var _props$customCssWrap, _props$customCssWrap2;

  var blockProps = _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : props.customCssWrap), {}, {
    maxWidth: props !== null && props !== void 0 && props.isFullWidth ? '100%' : props === null || props === void 0 ? void 0 : (_props$customCssWrap = props.customCssWrap) === null || _props$customCssWrap === void 0 ? void 0 : _props$customCssWrap.maxWidth,
    width: props !== null && props !== void 0 && props.isFullWidth ? '100%' : props === null || props === void 0 ? void 0 : (_props$customCssWrap2 = props.customCssWrap) === null || _props$customCssWrap2 === void 0 ? void 0 : _props$customCssWrap2.width
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: blockProps,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: props.as,
      css: props.customCss,
      variant: props.variant,
      children: props.value || props.children
    })
  });
};

Caption.defaultProps = {
  as: 'p',
  customCssWrap: {
    maxWidth: '960px',
    width: '100%',
    mb: '$8',
    mt: '0'
  },
  customCss: {
    fontFamily: '$secondary',
    px: '$2',
    py: '$0',
    width: 'calc(100% - 32px)'
  },
  variant: 'default-heading-1xl'
};
/* harmony default export */ var Caption_index = (Caption);
;// CONCATENATED MODULE: ./components/Article/Byline/Byline.index.tsx


function Byline_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Byline_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Byline_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Byline_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Byline = function Byline(props) {
  var _props$publishedDate, _props$modifiedDate, _props$authorImage, _props$authorImage2, _props$author, _props$author2, _props$author3, _props$author4, _props$publishedDate2, _props$modifiedDate2, _props$rightSlot;

  var RenderImage = props === null || props === void 0 ? void 0 : props.componentImage;
  var authorImgSrc = get_default()(props, 'authorImage.imageProps.src', false);
  var customCssContent = !(props !== null && props !== void 0 && props.showListenButton) ? Byline_index_objectSpread(Byline_index_objectSpread({}, props === null || props === void 0 ? void 0 : props.customCssContent), {}, {
    '@lg': {
      align: ['column', 'left', 'top'],
      '> p': {
        pr: '$2'
      }
    }
  }) : props === null || props === void 0 ? void 0 : props.customCssContent;
  var publishedDate = (_props$publishedDate = props.publishedDate) === null || _props$publishedDate === void 0 ? void 0 : _props$publishedDate.original;
  var modifiedDate = (_props$modifiedDate = props.modifiedDate) === null || _props$modifiedDate === void 0 ? void 0 : _props$modifiedDate.original;
  var isoDatePublished = typeof publishedDate === 'number' ? new Date(publishedDate).toISOString() : '';
  var isoDateModified = typeof modifiedDate === 'number' ? new Date(modifiedDate).toISOString() : '';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: props === null || props === void 0 ? void 0 : props.customCss,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: props === null || props === void 0 ? void 0 : props.customCssLeft,
      children: [((_props$authorImage = props.authorImage) === null || _props$authorImage === void 0 ? void 0 : _props$authorImage.enabled) && authorImgSrc && RenderImage && /*#__PURE__*/(0,jsx_runtime.jsx)(RenderImage, Byline_index_objectSpread({}, (_props$authorImage2 = props.authorImage) === null || _props$authorImage2 === void 0 ? void 0 : _props$authorImage2.imageProps)), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: customCssContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          className: "autor-opopular",
          itemProp: "author",
          as: (_props$author = props.author) === null || _props$author === void 0 ? void 0 : _props$author.as,
          css: (_props$author2 = props.author) === null || _props$author2 === void 0 ? void 0 : _props$author2.customCss,
          variant: (_props$author3 = props.author) === null || _props$author3 === void 0 ? void 0 : _props$author3.variant,
          children: (_props$author4 = props.author) === null || _props$author4 === void 0 ? void 0 : _props$author4.value
        }), (props === null || props === void 0 ? void 0 : (_props$publishedDate2 = props.publishedDate) === null || _props$publishedDate2 === void 0 ? void 0 : _props$publishedDate2.enabled) && /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          as: props.publishedDate.as,
          css: props.publishedDate.customCss,
          variant: props.publishedDate.variant,
          itemProp: "datePublished",
          dateTime: isoDatePublished,
          children: props.publishedDate.value
        }), (props === null || props === void 0 ? void 0 : (_props$modifiedDate2 = props.modifiedDate) === null || _props$modifiedDate2 === void 0 ? void 0 : _props$modifiedDate2.enabled) && /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          as: props.modifiedDate.as,
          css: props.modifiedDate.customCss,
          variant: props.modifiedDate.variant,
          itemProp: "dateModified",
          dateTime: isoDateModified,
          children: props.modifiedDate.value
        })]
      })]
    }), (props === null || props === void 0 ? void 0 : props.showListenButton) && /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: props === null || props === void 0 ? void 0 : props.customCssRight,
      children: (_props$rightSlot = props.rightSlot) === null || _props$rightSlot === void 0 ? void 0 : _props$rightSlot.children
    })]
  });
};

Byline.defaultProps = {
  as: 'p',
  variant: 'default-texts-md'
};
/* harmony default export */ var Byline_index = (Byline);
;// CONCATENATED MODULE: ./components/Article/Image/Image.index.tsx


function Image_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Image_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Image_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Image_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Image = function Image(props) {
  var alt = props.alt,
      byline = props.byline,
      caption = props.caption,
      RenderCaption = props.componentCaption,
      RenderImage = props.componentImage,
      captionProps = props.captionProps,
      imageProps = props.imageProps,
      isFullWidth = props.isFullWidth,
      linkHref = props.linkHref,
      linkTarget = props.linkTarget,
      src = props.src;
  var textValue = [];
  caption && textValue.push(caption);
  byline && textValue.push("(".concat(byline, ")"));

  if (src) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RenderImage, Image_index_objectSpread({
        alt: caption || alt,
        linkHref: linkHref,
        linkTarget: linkTarget,
        isFullWidth: isFullWidth,
        src: src
      }, imageProps)), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderCaption, {
        captionProps: captionProps,
        isFullWidth: isFullWidth,
        value: textValue.join(' ')
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(RenderImage, {});
};

Image.defaultProps = {
  as: 'h3',
  componentCaption: Caption_index,
  variant: 'newstitle-2xl'
};
/* harmony default export */ var Image_index = (Image);
;// CONCATENATED MODULE: ./components/Article/Tag/Tag.styled.tsx


function Tag_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Tag_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Tag_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tag_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Container = function Container(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: Tag_styled_objectSpread(Tag_styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

Container.defaultProps = {
  defaultCss: {
    align: ['row', 'center', 'middle'],
    background: '$transparent'
  }
};

;// CONCATENATED MODULE: ./components/Article/Tag/Tag.index.tsx


function Tag_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Tag_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Tag_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tag_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Tag = function Tag(props) {
  var TagWrap = props.wrapLink;

  var renderTag = function renderTag() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, Tag_index_objectSpread(Tag_index_objectSpread(Tag_index_objectSpread({}, props["default"]), props.customProps), {}, {
      css: Tag_index_objectSpread(Tag_index_objectSpread({}, props.defaultCss), props.customCss),
      children: props.value || props.children
    }));
  };

  if (props.wrapLink) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
      customCss: props.cssContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagWrap, Tag_index_objectSpread(Tag_index_objectSpread({}, props), {}, {
        children: renderTag()
      }))
    });
  } else {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
      customCss: props.cssContainer,
      children: renderTag()
    });
  }
};

Tag.defaultProps = {
  defaultCss: {
    backgroundColor: '#DEDEDE',
    color: '#000000',
    fontFamily: '$primary',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '17px',
    py: '$1',
    px: '$3',
    mt: '$0',
    mr: '$2',
    mb: '$2' // width: 'max-content'

  }
};
/* harmony default export */ var Tag_index = (Tag);
// EXTERNAL MODULE: ./node_modules/react-twitter-widgets/es/index.js + 1 modules
var es = __webpack_require__(9945);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(3913);
// EXTERNAL MODULE: ./node_modules/react-tiktok/dist/index.umd.js
var index_umd = __webpack_require__(936);
;// CONCATENATED MODULE: ./components/Article/Embed/Embed.utils.ts
var getYoutubePlaylistId = function getYoutubePlaylistId(url) {
  if (!url) return null;
  var playlistId = url.replace(/^.*list=/, '').replace(/\\&.*$/, '');
  return playlistId;
};
var getYoutubeVideoId = function getYoutubeVideoId(url) {
  if (!url) return null;
  var regExp = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)(?:\?v=|\/))|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  var match = url.match(regExp);
  return match && match[1].length === 11 ? match[1] : false;
};
/**
 * Prensa | getTweetId
 * @param url Expects an https tweet url
 * @example 
 * https://twitter.com/${user}/status/${tweetId}
 * https://twitter.com/${user}/status/${tweetId}?ref_src=${...}
 * @returns tweetId
 */

function getTweetId(url) {
  if (!url) return null;
  var split_a = url.split('/');
  var split_b = split_a[split_a.length - 1].split('?');
  return split_b[0];
}
function getTiktokId(url) {
  var regex = /cite="([^"]*)"/;
  var match = regex.exec(url);

  if (match) {
    return match[1];
  } else {
    return '';
  }
}
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/Article/Embed/Embed.index.tsx


function Embed_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Embed_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Embed_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Embed_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var StyledDiv = prensa/* PrensaEngine.styled */.u7.styled('div', {
  minHeight: '400px',
  minWidth: '400px'
});

var Embed = function Embed(props) {
  var _props$customCssWrap, _props$customCssWrap2, _props$item, _props$item$bodyParse, _hrefTwitter;

  var blockProps = Embed_index_objectSpread(Embed_index_objectSpread({}, props === null || props === void 0 ? void 0 : props.customCssWrap), {}, {
    maxWidth: props !== null && props !== void 0 && props.isFullWidth ? '100%' : props === null || props === void 0 ? void 0 : (_props$customCssWrap = props.customCssWrap) === null || _props$customCssWrap === void 0 ? void 0 : _props$customCssWrap.maxWidth,
    width: props !== null && props !== void 0 && props.isFullWidth ? '100%' : props === null || props === void 0 ? void 0 : (_props$customCssWrap2 = props.customCssWrap) === null || _props$customCssWrap2 === void 0 ? void 0 : _props$customCssWrap2.width
  });

  var slotTemplateCode = props.item.slotTemplateCode;
  var hrefRegex = /<a.*?href="(.*?)".*?>/g;
  var hrefRegexTwitter = /<a.+href="(.+?)">/gm;
  var hrefMatch = hrefRegex.exec(slotTemplateCode);
  var hrefTwitterMatch = hrefRegexTwitter.exec(slotTemplateCode);
  var href = '';
  var hrefTwitter = '';

  if (hrefTwitterMatch && hrefTwitterMatch.length > 0) {
    hrefTwitter = hrefTwitterMatch[1];
  }

  if (hrefMatch && hrefMatch.length > 0) {
    href = hrefMatch[1];
  }

  var originalUrl = (props === null || props === void 0 ? void 0 : (_props$item = props.item) === null || _props$item === void 0 ? void 0 : (_props$item$bodyParse = _props$item.bodyParsed) === null || _props$item$bodyParse === void 0 ? void 0 : _props$item$bodyParse.value) || href;

  if (hrefTwitter && (_hrefTwitter = hrefTwitter) !== null && _hrefTwitter !== void 0 && _hrefTwitter.includes('twitter.com')) {
    var tweetId = getTweetId(hrefTwitter);

    if (tweetId) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: blockProps,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
          css: {
            align: ['row', 'center', 'middle'],
            width: '100%'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* Tweet */.tP, {
            tweetId: tweetId,
            options: {
              lang: 'pt',
              align: 'center',
              height: 800,
              width: 1000
            }
          })
        })
      });
    }
  }

  if (originalUrl && originalUrl.includes('twitter.com')) {
    var _tweetId = getTweetId(originalUrl);

    if (_tweetId) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: blockProps,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
          css: {
            align: ['row', 'center', 'middle'],
            width: '100%'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* Tweet */.tP, {
            tweetId: _tweetId,
            options: {
              lang: 'pt',
              align: 'center',
              height: 800,
              width: 1000
            }
          })
        })
      });
    }
  }

  if (originalUrl && originalUrl.includes('youtube.com')) {
    var opts = {};
    var videoId = getYoutubeVideoId(originalUrl);

    if (originalUrl.includes('list=')) {
      var playlistId = getYoutubePlaylistId(originalUrl);
      opts = {
        playerVars: {
          listType: 'playlist',
          list: playlistId
        }
      };
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
      className: "article-youtube-embed",
      videoId: videoId,
      opts: opts,
      style: {
        maxWidth: '960px',
        width: '100%'
      }
    });
  }

  if (originalUrl && originalUrl.includes('stories.opopular')) {
    var _props$item2, _props$item2$bodyPars;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDiv, {
        dangerouslySetInnerHTML: {
          __html: "".concat(props === null || props === void 0 ? void 0 : (_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : (_props$item2$bodyPars = _props$item2.bodyParsed) === null || _props$item2$bodyPars === void 0 ? void 0 : _props$item2$bodyPars.value)
        }
      })
    });
  }

  if (originalUrl && originalUrl.includes('instagram-media')) {
    var _props$item3, _props$item3$bodyPars;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
          __html: "".concat(props === null || props === void 0 ? void 0 : (_props$item3 = props.item) === null || _props$item3 === void 0 ? void 0 : (_props$item3$bodyPars = _props$item3.bodyParsed) === null || _props$item3$bodyPars === void 0 ? void 0 : _props$item3$bodyPars.value)
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        async: true,
        src: "https://www.instagram.com/embed.js"
      })]
    });
  }

  if (originalUrl && originalUrl.includes('instagram.com')) {
    var _props$item4;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
          __html: "".concat(props === null || props === void 0 ? void 0 : (_props$item4 = props.item) === null || _props$item4 === void 0 ? void 0 : _props$item4.slotTemplateCode)
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        async: true,
        src: "https://www.instagram.com/embed.js"
      })]
    });
  }

  if (originalUrl && originalUrl.includes('tiktok.com')) {
    var url = getTiktokId(props.item.slotTemplateCode);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(index_umd.TikTok, {
      url: url
    });
  } // Regex para capturar todos os iframes no HTML


  var iframeRegex = /<iframe.*?src="(.*?)".*?<\/iframe>/g;
  var iframes = [];
  var match;

  if (slotTemplateCode && slotTemplateCode.includes('facebook.com')) {
    while ((match = iframeRegex.exec(slotTemplateCode)) !== null) {
      iframes.push(match[0]);
    }

    if (iframes.length > 0) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['column', 'center', 'middle'],
          blockProps: blockProps
        },
        children: iframes.map(function (iframe, index) {
          // Manipula o iframe para ajustar altura e largura
          var modifiedIframe = iframe.replace(/height="\d+"/, 'height="550"');
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
              __html: modifiedIframe
            },
            style: {
              marginBottom: '20px',
              position: 'relative',
              overflow: 'hidden'
            }
          }, index);
        })
      });
    }
  }

  if (originalUrl && originalUrl.includes('<iframe')) {
    while ((match = iframeRegex.exec(originalUrl)) !== null) {
      iframes.push(match[0]);
    }

    if (iframes.length > 0) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: blockProps,
        children: iframes.map(function (iframe, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
              __html: iframe
            },
            style: {
              marginBottom: '20px'
            }
          }, index);
        })
      });
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: blockProps,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: props.as,
      css: props.customCss,
      variant: props.variant,
      children: props.value || props.children
    })
  });
};

Embed.defaultProps = {
  as: 'p',
  customCssWrap: {
    maxWidth: '960px',
    width: '100%',
    mb: '$8',
    px: '$0'
  },
  customCss: {
    fontFamily: '$secondary',
    px: '$0',
    py: '$0',
    width: '100%'
  },
  variant: 'default-heading-1xl'
};
/* harmony default export */ var Embed_index = (Embed);
// EXTERNAL MODULE: ./node_modules/lodash/replace.js
var replace = __webpack_require__(3880);
var replace_default = /*#__PURE__*/__webpack_require__.n(replace);
;// CONCATENATED MODULE: ./components/Article/Horoscope/Horoscope.index.tsx





var Horoscope = function Horoscope(props) {
  var blockProps = {
    fontFamily: '$primary',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '29px',
    px: '$0',
    py: '$0',
    width: '100%',
    '.item-horoscope': {
      align: ['column', 'left', 'top'],
      '@lg': {
        align: ['row', 'left', 'top']
      },
      'h3': {
        fontSize: '21px',
        fontWeight: 700,
        lineHeight: '25px',
        mb: '$2',
        '> span': {
          fontSize: '16px',
          fontWeight: 400
        }
      },
      '> img': {
        width: '190px'
      },
      '> div': {
        width: '100%',
        '@lg': {
          ml: '30px',
          width: 'calc(100% - 220px)'
        }
      },
      'a': {
        color: '#164194 !important',
        fontWeight: 'bold'
      }
    }
  };
  var link1 = 'https://www.personare.com.br/horoscopo?utm_source=Parceiro&utm_medium=Grupo%20Jaime%20C%C3%A2mara&utm_campaign=Horoscopo%20Botao%201&ref=grupo-jaime-camara';
  var link2 = 'https://www.personare.com.br/signos?utm_source=Parceiro&utm_medium=Grupo%20Jaime%20C%C3%A2mara&utm_campaign=Horoscopo%20Botao%202&ref=grupo-jaime-camara';
  var link1Html = "<p>Leia seu <a href='".concat(link1, "' title='Leia seu Hor\xF3scopo Personalizado'>Hor\xF3scopo Personalizado</a>.</p>");
  var link2Html = "<p>Saiba tudo sobre seu <a href='".concat(link2, "' title='Saiba tudo sobre seu signo'>signo</a>.</p>");
  var textParsed = replace_default()(props.content, new RegExp('<div class="link_markup"></div>', 'g'), "".concat(link1Html).concat(link2Html));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: blockProps,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      dangerouslySetInnerHTML: {
        __html: textParsed
      }
    })
  });
};

/* harmony default export */ var Horoscope_index = (Horoscope);
;// CONCATENATED MODULE: ./components/Article/ColunaGiro/index.tsx




var ColunaGiro = function ColunaGiro(props) {
  var blockProps = {
    fontFamily: '$primary',
    fontWeight: 400,
    fontSize: '21px',
    lineHeight: '32px',
    px: '$0',
    py: '$0',
    width: '100%',
    '.colunagiro-container': {
      align: ['column', 'left', 'top'],
      '@lg': {
        align: ['column', 'left', 'top']
      },
      'h2': {
        fontSize: '26px !important',
        fontWeight: 700,
        lineHeight: '43px',
        mb: '25px !important',
        '@lg': {
          mb: '21px !important'
        }
      },
      '.colunagiro-header': {
        align: ['column', 'left', 'top'],
        '.left': {
          fontSize: '21px !important',
          fontWeight: 700,
          lineHeight: '32.5px',
          color: 'black',
          mb: '5px'
        },
        '.right': {
          fontSize: '16px !important',
          fontWeight: 400,
          lineHeight: '21px',
          color: 'black',
          mb: '5px'
        },
        '@lg': {
          width: '100%',
          align: ['row', 'between', 'bottom'],
          borderBottom: '2px solid #BFBFBF'
        }
      },
      '.colunagiro-body': {
        width: '100%',
        'img': {
          width: '100%'
        },
        '@lg': {
          align: ['row', 'left', 'top'],
          'img': {
            width: '296px',
            mr: '33px',
            mb: '48px'
          },
          'h3': {
            fontSize: '28px !important',
            fontWeight: 700,
            lineHeight: '33px',
            color: 'black',
            mb: '5px'
          }
        },
        '.p-smartcaption': {
          display: 'none'
        }
      }
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: blockProps,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      dangerouslySetInnerHTML: {
        __html: props.content
      }
    })
  });
};

/* harmony default export */ var Article_ColunaGiro = (ColunaGiro);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(2004);
;// CONCATENATED MODULE: ./components/Video/index.tsx





var midiaMp4Href = 'https://cdn.ojc.com.br/videos/mp4/';

var VideoComponent = function VideoComponent(_ref) {
  var videoCode = _ref.videoCode,
      thumbnail = _ref.thumbnail,
      alt = _ref.alt;
  var light;
  var maxHeightLg = 'calc(calc(calc(100vw + 4px) / 3) * 2)';

  if (thumbnail) {
    light = /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: thumbnail,
      alt: alt,
      style: {
        width: '100%'
      }
    });
    maxHeightLg = 'calc(50vw + 30px)';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: {
      position: 'relative',
      paddingTop: '-56.25%',
      marginBottom: '16px',
      width: '100%',
      iframe: {
        marginBottom: '0px',
        minHeight: '500px'
      },
      '.react-player': {
        position: 'absolute',
        top: 0,
        left: 0
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
      controls: true,
      light: light,
      url: videoCode,
      height: "100%",
      width: "100%"
    })
  });
};

var VideoWrap = function VideoWrap(props) {
  var videoLink = get_default()(props, 'link', false);
  var videoCode = get_default()(props, 'slotTemplateCode', false);
  var videoLinkUrl = videoLink ? "".concat(midiaMp4Href).concat(videoLink) : videoCode.indexOf('/') > -1 ? videoCode : "".concat(midiaMp4Href).concat(videoCode);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(VideoComponent, {
    alt: props.alt,
    videoCode: videoLinkUrl,
    thumbnail: props.thumbnail
  });
};


;// CONCATENATED MODULE: ./components/ArticleAudio/index.tsx






var ArticleAudioComponent = function ArticleAudioComponent(_ref) {
  var audioLink = _ref.audioLink;

  var _useState = (0,react.useState)(0),
      playerKey = _useState[0],
      setPlayerKey = _useState[1];

  var _useState2 = (0,react.useState)(null),
      isAvailable = _useState2[0],
      setIsAvailable = _useState2[1];

  var _useState3 = (0,react.useState)('none'),
      preloadAttr = _useState3[0],
      setPreloadAttr = _useState3[1];

  (0,react.useEffect)(function () {
    if (!audioLink) {
      setIsAvailable(false);
      return;
    }

    var mounted = true;
    var audio = new Audio(audioLink);
    audio.preload = 'none';
    audio.addEventListener('loadedmetadata', function () {
      if (!mounted) return;
      setIsAvailable(true);
      setPreloadAttr('metadata');
      setPlayerKey(function (k) {
        return k + 1;
      });
    });
    audio.addEventListener('error', function () {
      if (mounted) setIsAvailable(false);
    });
    audio.load();
    return function () {
      mounted = false;
      audio.remove();
    };
  }, [audioLink]); // 2) Key adicional só para resize

  (0,react.useEffect)(function () {
    var onResize = function onResize() {
      return setPlayerKey(function (k) {
        return k + 1;
      });
    };

    window.addEventListener('resize', onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, []); // 3) Enquanto checa ou se deu erro, nada

  if (isAvailable === null) return null;
  if (!isAvailable) return null; // 4) Player com preload de metadados

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      align: ['column', 'left', 'middle'],
      width: '100%',
      flexDirection: 'column',
      mb: '$8',
      pr: '$8',
      pl: '$4'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: "span",
      css: {
        fontFamily: '$primary',
        fontSize: '14px',
        mb: '$3'
      },
      children: "ouvir mat\xE9ria"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
      url: audioLink,
      controls: true,
      playing: false,
      width: "100%",
      height: "50px",
      config: {
        file: {
          attributes: {
            controlsList: 'nodownload',
            preload: preloadAttr
          }
        }
      }
    }, playerKey)]
  });
};

/* harmony default export */ var ArticleAudio = (ArticleAudioComponent);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 130 modules
var react_markdown = __webpack_require__(3599);
;// CONCATENATED MODULE: ./components/Assets/Utils.tsx

var castTokenColors = function castTokenColors(colors) {
  var tokens = {};
  Object.keys(colors).map(function (item) {
    Object.keys(colors[item]).map(function (color) {
      tokens["".concat(item).concat(color)] = colors[item][color];
    });
  });
  return tokens;
};
var parseVariants = function parseVariants(variants) {
  return (0,lodash.isArray)(variants) ? {
    '@initial': (0,lodash.first)(variants),
    '@lg': (0,lodash.last)(variants)
  } : variants;
};
// EXTERNAL MODULE: ./node_modules/rehype-autolink-headings/lib/index.js + 10 modules
var rehype_autolink_headings_lib = __webpack_require__(3662);
;// CONCATENATED MODULE: ./components/Article/Text/Text.index.tsx


function Text_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Text_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Text_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Text = function Text(props) {
  var _props$value, _props$value$replace;

  var THeading = function THeading(childProps) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: childProps.as,
      css: props.customCss,
      variant: parseVariants(props.variants),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: childProps.children
      })
    });
  };

  var TParagraph = function TParagraph(childProps) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: props.as,
      css: props.customCss,
      variant: parseVariants(props.variants),
      children: childProps.children
    });
  };

  var TListItem = function TListItem(childProps) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: "li",
      css: props.customCss,
      variant: parseVariants(props.variants),
      children: childProps.children
    });
  };

  var TCite = function TCite(childProps) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: "cite",
      css: props.customCss,
      variant: parseVariants(props.variants),
      children: childProps.children
    });
  };

  var TLink = function TLink(childProps) {
    try {
      var _childProps$children, _childProps$children$, _childProps$children$2, _childProps$children$3, _childProps$children2;

      var href = childProps.href || '';
      var isCrossOrigin = href.match(childProps.siteDomain) ? false : true;
      var children = childProps !== null && childProps !== void 0 && (_childProps$children = childProps.children) !== null && _childProps$children !== void 0 && (_childProps$children$ = _childProps$children[0]) !== null && _childProps$children$ !== void 0 && (_childProps$children$2 = _childProps$children$.props) !== null && _childProps$children$2 !== void 0 && (_childProps$children$3 = _childProps$children$2.children) !== null && _childProps$children$3 !== void 0 && _childProps$children$3[0] ? childProps.children[0].props.children[0] : (childProps === null || childProps === void 0 ? void 0 : (_childProps$children2 = childProps.children) === null || _childProps$children2 === void 0 ? void 0 : _childProps$children2[0]) || '';
      var targetMatch = children === null || children === void 0 ? void 0 : children.match(/target:_(\w+)/);
      var target = targetMatch ? "_".concat(targetMatch[1]) : '_blank';
      var cleanChildren = (children === null || children === void 0 ? void 0 : children.replace(/ target:_\w+/, '')) || '';
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Link */.rU, {
        component: (link_default()),
        href: href,
        rel: isCrossOrigin ? 'nofollow' : undefined,
        target: target,
        children: cleanChildren
      });
    } catch (error) {
      var _childProps$children3, _childProps$children4, _childProps$children5, _childProps$children6;

      console.error('Erro ao processar link:', error);
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
        as: "span",
        css: props.customCss,
        variant: parseVariants(props.variants),
        children: ((_childProps$children3 = childProps.children) === null || _childProps$children3 === void 0 ? void 0 : (_childProps$children4 = _childProps$children3[0]) === null || _childProps$children4 === void 0 ? void 0 : (_childProps$children5 = _childProps$children4.props) === null || _childProps$children5 === void 0 ? void 0 : (_childProps$children6 = _childProps$children5.children) === null || _childProps$children6 === void 0 ? void 0 : _childProps$children6[0]) || ''
      });
    }
  };

  var TList = function TList(childProps) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: props.as,
      css: Text_index_objectSpread({
        width: '100%'
      }, props.customCss),
      children: childProps.children
    });
  };

  var componentsMap = {
    a: TLink,
    p: TParagraph,
    h2: function h2(props) {
      return THeading(Text_index_objectSpread(Text_index_objectSpread({}, props), {}, {
        as: 'h2'
      }));
    },
    h3: function h3(props) {
      return THeading(Text_index_objectSpread(Text_index_objectSpread({}, props), {}, {
        as: 'h3'
      }));
    },
    h4: function h4(props) {
      return THeading(Text_index_objectSpread(Text_index_objectSpread({}, props), {}, {
        as: 'h4'
      }));
    },
    li: TListItem,
    cite: TCite,
    ul: TList,
    ol: TList
  };
  var preprocessedValue = props === null || props === void 0 ? void 0 : (_props$value = props.value) === null || _props$value === void 0 ? void 0 : (_props$value$replace = _props$value.replace(/\n\n/g, '\n')) === null || _props$value$replace === void 0 ? void 0 : _props$value$replace.replace(/^(\d+)\)\s*/gm, "\u200B$1) ");
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
    components: componentsMap,
    remarkPlugins: [rehype_autolink_headings_lib/* default */.Z],
    children: preprocessedValue || props.children || ''
  });
};

Text.defaultProps = {
  as: 'p',
  variants: ['articleParagraph-default', 'articleParagraph-desktop']
};
/* harmony default export */ var Text_index = (Text);
;// CONCATENATED MODULE: ./components/Article/Embed/InfogramEmbed.tsx



var InfogramEmbed = function InfogramEmbed(_ref) {
  var code = _ref.code;

  function extractDataFromCode(code) {
    var regex = /data-id="([^"]*)"[\s\S]*?data-title="([^"]*)"/;
    var match = code.match(regex);

    if (match) {
      var dataId = match[1];
      var dataTitle = match[2];
      return {
        dataId: dataId,
        dataTitle: dataTitle
      };
    } else {
      return null;
    }
  }

  var extractedData = extractDataFromCode(code);
  (0,react.useEffect)(function () {
    var script = document.createElement('script');
    script.async = true;
    script.id = 'infogram-async';
    script.src = 'https://e.infogram.com/js/dist/embed-loader-min.js';

    if (!document.getElementById('infogram-async')) {
      document.head.appendChild(script);
    }
  }, []);
  var dataId = extractedData ? extractedData.dataId : '';
  var dataTitle = extractedData ? extractedData.dataTitle : '';
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "infogram-embed",
    "data-id": dataId,
    "data-type": "interactive",
    "data-title": dataTitle,
    style: {
      width: '100%'
    }
  });
};

/* harmony default export */ var Embed_InfogramEmbed = (InfogramEmbed);
;// CONCATENATED MODULE: ./components/Article/ReadMore/ReadMore.tsx





var ReadMore = function ReadMore(props) {
  var siteDomain = "cbngo" || 0;
  var readMoreColor = siteDomain.includes('cbn') ? '#D72027' : siteDomain.includes('tocantins') ? ' #164194' : siteDomain.includes('daqui') ? '#FC008F' : siteDomain.includes('opopular') ? '#164194 ' : '#164194';
  var blockProps = {
    fontFamily: '$primary',
    mb: '25px',
    mt: '25px',
    width: '100%',
    '@lg': {
      backgroundColor: '#F7F7F7',
      pb: '8px'
    },
    '.p-readmore-box': {
      align: ['column', 'left', 'top'],
      borderLeft: "5px solid ".concat(readMoreColor),
      'a': {
        color: readMoreColor,
        fontSize: '18px',
        fontWeight: 400,
        lineHeight: '21px',
        ml: '18px',
        mb: '18px',
        textDecoration: 'none'
      },
      '@lg': {
        borderLeft: 'none',
        'a': {
          fontSize: '22px',
          lineHeight: '35px',
          ml: '25px',
          mb: '18px',
          '&:hover': {
            textDecoration: 'underline'
          }
        }
      }
    }
  };
  var sectionTitleProps = {
    display: 'none',
    '@lg': {
      display: 'block',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: '24px',
      ml: '25px',
      mt: '30px'
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: blockProps,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      css: sectionTitleProps,
      children: "Leia Tamb\xE9m"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      dangerouslySetInnerHTML: {
        __html: props.content
      }
    })]
  });
};

/* harmony default export */ var ReadMore_ReadMore = (ReadMore);
;// CONCATENATED MODULE: ./components/Article/Texts/Texts.index.tsx



function Texts_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Texts_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Texts_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Texts_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck
















var EmbedCode = prensa/* PrensaEngine.styled */.u7.styled('div', {
  align: ['column', 'left', 'top'],
  marginBottom: '$12',
  width: '100%'
});
var audioIsActive = "false" === 'true';

var Texts = function Texts(props) {
  var captionProps = props.captionProps,
      componentCaption = props.componentCaption,
      RenderImage = props.componentImage,
      itemsAheadBody = props.itemsAheadBody,
      Image = props.image,
      images = props.images,
      items = props.items,
      imageProps = props.imageProps,
      siteDomain = props.siteDomain,
      textProps = props.textProps,
      isViads = props.isViads,
      sourceSite = props.sourceSite,
      isRestricted = props.isRestricted,
      audioLink = props.audioLink,
      isPosition = props.isPosition; // image

  var updatedItems = items;

  if (isViads && items && items.length > 0) {
    var totalItems = items.length;
    var isEven = totalItems % 2 === 0;
    var halfIndex = isEven ? totalItems / 2 : (totalItems - 1) / 2;
    var adItem = {
      type: 'p-ads-box',
      bodyParsed: {
        value: 'slotAds'
      }
    };
    updatedItems = [].concat((0,toConsumableArray/* default */.Z)(items.slice(0, halfIndex)), [adItem], (0,toConsumableArray/* default */.Z)(items.slice(halfIndex)));
  } else if (!isViads && items && items.length > 0 && isPosition === 0 && !(siteDomain !== null && siteDomain !== void 0 && siteDomain.includes('cbngoiania.com.br'))) {
    var _totalItems = items.length;

    var _isEven = _totalItems % 2 === 0;

    var _halfIndex = _isEven ? _totalItems / 2 : (_totalItems - 1) / 2;

    var _adItem = {
      type: 'p-viads-box'
    };
    updatedItems = [].concat((0,toConsumableArray/* default */.Z)(items.slice(0, _halfIndex)), [_adItem], (0,toConsumableArray/* default */.Z)(items.slice(_halfIndex)));
  }

  var image = get_default()(images, '[0]', false);
  var imageByline = get_default()(image, 'byline', false);
  var imageCaption = get_default()(image, 'caption', false); // const imageName = get(image, 'name', false)
  // const linkHref = get(image, 'linkHref', false)
  // const linkTarget = get(image, 'linkTarget', false)
  // const textValue = textName ? `## ${textName}` : false

  var RenderItemsAheadBody = function RenderItemsAheadBody() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: map_default()(itemsAheadBody, function (item, key) {
        var bodyParsed = get_default()(item, 'bodyParsed.value', '');
        return /*#__PURE__*/(0,react.createElement)(Text_index, Texts_index_objectSpread(Texts_index_objectSpread({}, textProps), {}, {
          value: bodyParsed,
          key: key
        }));
      })
    });
  };

  var RenderImagesAheadBody = function RenderImagesAheadBody() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: image && /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        alt: imageCaption,
        byline: imageByline,
        caption: imageCaption,
        componentImage: RenderImage,
        componentCaption: componentCaption,
        captionProps: captionProps,
        isFullWidth: true,
        imageProps: imageProps,
        src: image === null || image === void 0 ? void 0 : image.url
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RenderItemsAheadBody, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderImagesAheadBody, {}), audioIsActive && (audioLink === null || audioLink === void 0 ? void 0 : audioLink.length) > 0 && !isRestricted && /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleAudio, {
      audioLink: audioLink
    }), map_default()(updatedItems, function (item, key) {
      var imageId = get_default()(item, 'contentData', '');
      var imageURL = get_default()(imageId[0], 'url', '');
      var bodyParsed = get_default()(item, 'bodyParsed.value', '');
      var textName = get_default()(item, 'name', false);
      var bodyCode = get_default()(item, 'code', '');
      var embedCode = get_default()(item, 'code.value', false);
      var galleryList = get_default()(item, 'contentData', []);
      var inputTemplate = get_default()(item, 'inputTemplate', false);
      var slotTemplateCode = get_default()(item, 'slotTemplateCode', false);

      if (inputTemplate === 'br.com.atex.templates.articleText.it' || (item === null || item === void 0 ? void 0 : item.type) === 'text') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Text_index, Texts_index_objectSpread({
          value: bodyParsed,
          siteDomain: siteDomain
        }, textProps), key);
      }

      if (inputTemplate === 'br.com.atex.templates.articleEmbed.it' && slotTemplateCode.includes('twitter.com')) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Embed_index, {
          item: item
        }, key);
      }

      if (inputTemplate === 'br.com.atex.templates.articleEmbed.it' && slotTemplateCode.includes('tiktok.com')) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Embed_index, {
          item: item
        }, key);
      }

      if (inputTemplate === 'br.com.atex.templates.articleEmbed.it' && slotTemplateCode.includes('infogram.com')) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Embed_InfogramEmbed, {
          code: slotTemplateCode
        }, key);
      }

      if (inputTemplate === 'br.com.atex.templates.articleEmbed.it' && slotTemplateCode.includes('instagram.com')) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Embed_index, {
          item: item
        }, key);
      }

      if (inputTemplate === 'br.com.atex.templates.articleEmbed.it' && slotTemplateCode.includes('facebook.com')) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Embed_index, {
          item: item
        }, key);
      }

      if (inputTemplate === 'br.com.atex.templates.articleEmbed.it') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(EmbedCode, {
          dangerouslySetInnerHTML: {
            __html: slotTemplateCode
          }
        }, key);
      }

      if (inputTemplate === 'br.com.atex.templates.articleGallery.it') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* ImageGallery */.hJ, {
          componentCaption: componentCaption,
          captionProps: Texts_index_objectSpread({
            enabled: true
          }, captionProps),
          items: galleryList,
          showThumbs: true,
          css: {
            container: {
              mb: '$4',
              width: '100%'
            },
            sliderThumbsWrapper: {
              margin: '0px',
              width: '100%'
            },
            sliderThumbsAnimated: {
              align: ['row', 'center', 'middle'],
              mt: '0px',
              '.thumb': {
                height: '67px',
                width: '67px !important',
                img: {
                  objectFit: 'cover'
                }
              }
            }
          }
        }, key);
      }

      if ((item === null || item === void 0 ? void 0 : item.inputTemplate) === 'br.com.atex.templates.articleVideo.it') {
        return /*#__PURE__*/(0,react.createElement)(VideoWrap, Texts_index_objectSpread(Texts_index_objectSpread({
          alt: "".concat(item.caption, " / ").concat(item.byline || 'Reprodução')
        }, item), {}, {
          key: key,
          thumbnail: imageURL
        }));
      }

      if ((item === null || item === void 0 ? void 0 : item.type) === 'embed') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Embed_index, {
          item: item
        }, key);
      }

      if ((item === null || item === void 0 ? void 0 : item.type) === 'block-horoscope') {
        var _item$bodyParsed;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(Horoscope_index, {
          content: item === null || item === void 0 ? void 0 : (_item$bodyParsed = item.bodyParsed) === null || _item$bodyParsed === void 0 ? void 0 : _item$bodyParsed.value
        }, key);
      }

      if ((item === null || item === void 0 ? void 0 : item.type) === 'p-readmore-box') {
        var _item$bodyParsed2;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(ReadMore_ReadMore, {
          content: item === null || item === void 0 ? void 0 : (_item$bodyParsed2 = item.bodyParsed) === null || _item$bodyParsed2 === void 0 ? void 0 : _item$bodyParsed2.value,
          siteDomain: siteDomain
        }, key);
      }

      if ((item === null || item === void 0 ? void 0 : item.type) === 'p-ads-box') {
        switch (sourceSite) {
          case 'opopular.d':
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: "v110250"
            });

          case 'tocantins.d':
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: "v110249"
            });

          case 'daqui.d':
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: "v110251"
            });
        }
      }
      /*         if (item?.type === 'p-viads-box') {
                switch (sourceSite) {
                  case 'opopular.d':
                    return <div style={{ marginBottom: '$2' }} id='v110243'></div>
                  case 'tocantins.d':
                    return <div style={{ marginBottom: '$2' }} id='v110242'></div>
                }
              } */


      if ((item === null || item === void 0 ? void 0 : item.type) === 'colunagiro-container') {
        var _item$bodyParsed3;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(Article_ColunaGiro, {
          content: item === null || item === void 0 ? void 0 : (_item$bodyParsed3 = item.bodyParsed) === null || _item$bodyParsed3 === void 0 ? void 0 : _item$bodyParsed3.value
        }, key);
      }

      if ((item === null || item === void 0 ? void 0 : item.type) === 'com.atex.standard.image.ImageContentDataBean') {
        var inlineImageByline = get_default()(item, 'byline', false);
        var inlineImageCaption = get_default()(item, 'caption', false);
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          alt: inlineImageCaption,
          byline: inlineImageByline,
          caption: inlineImageCaption,
          componentImage: RenderImage,
          componentCaption: componentCaption,
          captionProps: captionProps,
          isFullWidth: true,
          imageProps: imageProps,
          src: item === null || item === void 0 ? void 0 : item.url
        }, key);
      }

      if (!(item !== null && item !== void 0 && item.type) && item !== null && item !== void 0 && item.images && (item === null || item === void 0 ? void 0 : item.images.length) > 0) {
        var inlineImage = get_default()(item.images, '[0]', false);

        var _inlineImageByline = get_default()(inlineImage, 'byline', false);

        var _inlineImageCaption = get_default()(inlineImage, 'caption', false);

        return /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          alt: _inlineImageCaption,
          byline: _inlineImageByline,
          caption: _inlineImageCaption,
          componentImage: RenderImage,
          componentCaption: componentCaption,
          captionProps: captionProps,
          isFullWidth: true,
          imageProps: imageProps,
          src: inlineImage === null || inlineImage === void 0 ? void 0 : inlineImage.url
        }, key);
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)(Text_index, Texts_index_objectSpread({
        value: bodyParsed
      }, textProps), key);
    })]
  });
};

Texts.defaultProps = {};
/* harmony default export */ var Texts_index = (Texts);
;// CONCATENATED MODULE: ./components/Article/Title/Title.index.tsx





var Title = function Title(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: {
      width: '100%'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: props.as,
      css: props.customCss,
      variant: parseVariants(props.variants),
      children: props.value || props.children
    })
  });
};

Title.defaultProps = {
  as: 'h1',
  variants: ['newstitle-4xl', 'newstitle-6xl']
};
/* harmony default export */ var Title_index = (Title);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@react-keycloak/ssr/lib/index.js + 14 modules
var ssr_lib = __webpack_require__(5069);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./providers/actions/util.tsx
var util = __webpack_require__(4987);
// EXTERNAL MODULE: ./providers/Session/index.tsx + 2 modules
var Session = __webpack_require__(2236);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./providers/Session/actions/patchTrialCreditsEarned.ts



function patchTrialCreditsEarned(_x, _x2) {
  return _patchTrialCreditsEarned.apply(this, arguments);
}

function _patchTrialCreditsEarned() {
  _patchTrialCreditsEarned = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(idConteudoPolopoly, idSessao) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios_default().put("/paywall/creditos-degustador", null, {
              params: {
                idSessao: idSessao,
                idConteudoPolopoly: idConteudoPolopoly
              }
            }).then(function (res) {
              return res;
            })["catch"](function (e) {
              return {
                status: false,
                erro: e
              };
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _patchTrialCreditsEarned.apply(this, arguments);
}
// EXTERNAL MODULE: ./providers/Session/actions/updateSession.ts
var updateSession = __webpack_require__(9100);
// EXTERNAL MODULE: ./providers/Session/utils.ts
var utils = __webpack_require__(8717);
// EXTERNAL MODULE: ./components/Icon/Icon.index.tsx
var Icon_index = __webpack_require__(3234);
;// CONCATENATED MODULE: ./components/Article/Restricted/Restricted.styled.tsx


function Restricted_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Restricted_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Restricted_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Restricted_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ButtonDefault = function ButtonDefault(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CallToActionOutlinedButton_index/* default */.Z, {
    onClick: onClick,
    css: {
      button: {
        borderColor: "#164194",
        height: "42px",
        width: "210px"
      },
      label: {
        color: "#164194"
      }
    },
    children: children
  });
};

var Restricted_styled_Container = function Container(_ref2) {
  var children = _ref2.children;
  var containerStyles = {
    align: ['column', 'center', 'top'],
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 20%)',
    minHeight: '240px',
    position: 'relative',
    paddingTop: '175px',
    marginTop: '-275px',
    width: '100%'
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: containerStyles,
    children: children
  });
};

var ColumnHolder = function ColumnHolder(_ref3) {
  var children = _ref3.children;
  var columnHolderCSS = {
    align: ["column", "center", "top"],
    width: "100%",
    "div:first-child": {
      mb: "$8"
    },
    "@lg": {
      align: ["row", "center", "top"],
      "div:nth-child(2)": {
        borderLeft: "1px solid #E6E6E6"
      }
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: columnHolderCSS,
    children: children
  });
};

var Column = function Column(_ref4) {
  var children = _ref4.children,
      customCss = _ref4.customCss;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: Restricted_styled_objectSpread({
      align: ["column", "center", "top"],
      px: "$8",
      maxWidth: "306px",
      "@lg": {
        width: "calc(50% - $16)"
      }
    }, customCss),
    children: children
  });
};

var KeyHolder = function KeyHolder(_ref5) {
  var children = _ref5.children;
  var columnHolderCSS = {
    align: ["row", "center", "top"],
    mb: "$4",
    width: "100%"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: columnHolderCSS,
    children: children
  });
};

var KeyIcon = function KeyIcon(_ref6) {
  var used = _ref6.used;
  var iconChave = (0,useIcon/* useIcon */.b)("IcChave");
  var iconChaveAzul = (0,useIcon/* useIcon */.b)("IcChaveAzul");

  var keyIconGray = function keyIconGray() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, Restricted_styled_objectSpread(Restricted_styled_objectSpread({}, iconChave), {}, {
      height: "24px",
      width: "58px"
    }));
  };

  var keyIconBlue = function keyIconBlue() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, Restricted_styled_objectSpread(Restricted_styled_objectSpread({}, iconChaveAzul), {}, {
      height: "24px",
      width: "58px"
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    children: used ? keyIconBlue() : keyIconGray()
  });
};

var MainTitle = function MainTitle(_ref7) {
  var children = _ref7.children,
      customCss = _ref7.customCss;

  var mainTitleCSS = Restricted_styled_objectSpread({
    color: "black",
    fontWeight: 700,
    fontSize: "30px",
    lineHeight: "43px",
    fontFamily: "$primary",
    textAlign: "center"
  }, customCss);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    css: mainTitleCSS,
    children: children
  });
};

var SubTitle = function SubTitle(_ref8) {
  var children = _ref8.children;
  var subTitleCSS = {
    color: "black",
    fontFamily: "$primary",
    fontSize: "22px",
    fontWeight: 500,
    lineHeight: "35px",
    letterSpacing: "0.6px",
    my: "$0",
    textAlign: "center"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    css: subTitleCSS,
    children: children
  });
};

var SubText = function SubText(_ref9) {
  var children = _ref9.children,
      customCss = _ref9.customCss;

  var subTextCSS = Restricted_styled_objectSpread({
    color: "#4D4D4D",
    fontFamily: "$primary",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17px",
    letterSpacing: "0.2px",
    textAlign: "center",
    strong: {
      color: "#164194"
    },
    "@lg": {
      minHeight: "50px"
    }
  }, customCss);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    css: subTextCSS,
    dangerouslySetInnerHTML: {
      __html: children
    }
  });
};


// EXTERNAL MODULE: ./components/Article/Restricted/RestrictedBanner.styled.tsx
var RestrictedBanner_styled = __webpack_require__(4960);
;// CONCATENATED MODULE: ./components/Article/Restricted/RestrictedBanner.index.tsx





var restrictedStrings = {
  mainTitle: 'Assine <strong>O Popular digital</strong>',
  mainPrice: '<span>R$ <strong>4,90</strong></span> <span>mensais</span>',
  buttonText: 'Assine Agora',
  buttonLink: '/assine',
  subText: 'Desconto para assinatura <strong>digital</strong> nos três primeiros meses.'
};

var RestrictedBanner = function RestrictedBanner(_ref) {
  var _serverSideContext$si, _serverSideContext$si2, _bannerData$valor;

  var priceValue = _ref.priceValue,
      bannerData = _ref.bannerData;
  var serverSideContext = react.useContext(ServerSideProps.ServerSidePropsContext);
  var isPaywall = serverSideContext === null || serverSideContext === void 0 ? void 0 : (_serverSideContext$si = serverSideContext.site) === null || _serverSideContext$si === void 0 ? void 0 : (_serverSideContext$si2 = _serverSideContext$si.pageConfig) === null || _serverSideContext$si2 === void 0 ? void 0 : _serverSideContext$si2.featureRadioSelectPaywall;
  var valor = bannerData === null || bannerData === void 0 ? void 0 : (_bannerData$valor = bannerData.valor) === null || _bannerData$valor === void 0 ? void 0 : _bannerData$valor.toString().replace('.', ',');
  var mainPriceString = "<span>R$ <strong>".concat((valor === null || valor === void 0 ? void 0 : valor.length) < 4 ? valor + '0' : valor, "</strong></span> <span>").concat(bannerData.condicaoPagamento, "</span> ") || 0;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RestrictedBanner_styled/* Container */.W2, {
    backGround: bannerData.corBackground,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedBanner_styled/* MainTitle */.U3, {
      color: bannerData.corTexto,
      children: bannerData.chamadaLoja
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedBanner_styled/* MainPrice */.hv, {
      color: bannerData.corTexto,
      children: mainPriceString
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedBanner_styled/* ButtonDefault */.t, {
      color: bannerData.corTexto,
      url: isPaywall === 'PIANO' ? restrictedStrings.buttonLink :  false || '',
      children: restrictedStrings.buttonText
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedBanner_styled/* SubText */.i_, {
      color: bannerData.corTexto,
      children: bannerData.textoCondicao
    })]
  });
};

RestrictedBanner.defaultProps = {
  priceValue: '4,90'
};
/* harmony default export */ var RestrictedBanner_index = (RestrictedBanner);
// EXTERNAL MODULE: ./utils/ecryption.ts
var ecryption = __webpack_require__(3119);
;// CONCATENATED MODULE: ./components/Article/Restricted/RestrictedGuest.index.tsx









var RestrictedGuest = function RestrictedGuest() {
  var _useKeycloak = (0,ssr_lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var handleLogin = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return keycloak === null || keycloak === void 0 ? void 0 : keycloak.login({
                redirectUri: "".concat(window.location.href)
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error("Error during login:", _context.t0);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function handleLogin() {
      return _ref.apply(this, arguments);
    };
  }();

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    var tp = window.tp || [];
    tp.push(["init", function () {
      if (keycloak) {
        tp.pianoId.loginByToken((0,ecryption/* decrypt */.p)(keycloak === null || keycloak === void 0 ? void 0 : keycloak.token));
      }

      tp.experience.execute();
    }]);
    tp.push(["setUseTinypassAccounts", false]);
    tp.push(["setUsePianoIdUserProvider", false]);
    tp.push(["setUsePianoIdLiteUserProvider", true]);
    tp.push(["addHandler", "loginRequired", function (params) {
      handleLogin();
    }]);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        width: "100%"
      },
      id: "locked-content"
    })
  });
};

/* harmony default export */ var RestrictedGuest_index = (RestrictedGuest);
;// CONCATENATED MODULE: ./utils/getStoreId.ts
var getStoreId = function getStoreId() {
  switch ("cbngo.d") {
    case 'opopular.d':
      return 'popstore';

    case 'tocantins.d':
      return 'jstostore';

    case 'daqui.d':
      return 'daquistore';

    default:
      return 'popstore';
  }
};
;// CONCATENATED MODULE: ./components/Article/Restricted/RestrictedPaywall/RestrictedExpiredPaywall.index.tsx





var RestrictedExpiredPaywall_index_restrictedStrings = {
  mainTitle: "Você se interessou por essa matéria?",
  subTitle: "Você atingiu o limite de matérias exclusivas por mês."
};

var RestrictedExpiredPaywall = function RestrictedExpiredPaywall(_ref) {
  var _bannerData$chavesAce;

  var bannerData = _ref.bannerData;
  var trialSize = bannerData.chavesAcesso;
  var trialSizeString = "Voc\xEA atingiu o limite de <strong>".concat((_bannerData$chavesAce = bannerData.chavesAcesso) === null || _bannerData$chavesAce === void 0 ? void 0 : _bannerData$chavesAce.toString(), " mat\xE9rias</strong> exclusivas por m\xEAs.");
  var keysArray = [];

  for (var i = 0; i < trialSize; i++) {
    keysArray.push({
      used: false
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: bannerData && bannerData.chavesAcesso > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MainTitle, {
        customCss: {
          mb: "$2"
        },
        children: RestrictedExpiredPaywall_index_restrictedStrings.mainTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
        customCss: {
          maxWidth: "auto",
          "@lg": {
            width: "100%"
          }
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubText, {
          customCss: {
            fontSize: "18px",
            lineHeight: "23px",
            letterSpacing: "0.2px",
            fontWeight: 400,
            "@lg": {
              minHeight: "auto"
            }
          },
          children: bannerData ? trialSizeString : RestrictedExpiredPaywall_index_restrictedStrings.subTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(KeyHolder, {
          children: keysArray.map(function (item, key) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(KeyIcon, {
              used: item.used
            }, key);
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var RestrictedExpiredPaywall_index = (RestrictedExpiredPaywall);
;// CONCATENATED MODULE: ./components/Article/Restricted/RestrictedPaywall/RestrictedGuestPaywall.index.tsx





var RestrictedGuestPaywall_index_restrictedStrings = {
  mainTitle: "Você se interessou por essa matéria?",
  subTitle1: "Acessar conta",
  subTitle2: "Criar conta gratuita",
  subText1: "É só colocar login e senha e acessar <strong>o melhor jornalismo de Goiás</strong>.",
  subText2: "É só registrar seu e-mail para ter acesso a <strong>5 matérias por mês</strong>, sem pagar nada por isso.",
  button1: "Entrar",
  button2: "Cadastrar"
};

var RestrictedGuestPaywall = function RestrictedGuestPaywall(_ref) {
  var _bannerData$textoCada;

  var bannerData = _ref.bannerData,
      handleButton1Click = _ref.handleButton1Click,
      handleButton2Click = _ref.handleButton2Click;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MainTitle, {
      children: (bannerData === null || bannerData === void 0 ? void 0 : bannerData.chamadaPrincipal) || RestrictedGuestPaywall_index_restrictedStrings.mainTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ColumnHolder, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
          children: RestrictedGuestPaywall_index_restrictedStrings.subTitle1
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubText, {
          children: (bannerData === null || bannerData === void 0 ? void 0 : bannerData.textoLogin) || RestrictedGuestPaywall_index_restrictedStrings.subText1
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonDefault, {
          onClick: handleButton1Click,
          children: RestrictedGuestPaywall_index_restrictedStrings.button1
        })]
      }), bannerData && bannerData.chavesAcesso > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
          children: RestrictedGuestPaywall_index_restrictedStrings.subTitle2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubText, {
          children: ((_bannerData$textoCada = bannerData.textoCadastro) === null || _bannerData$textoCada === void 0 ? void 0 : _bannerData$textoCada.replace("{{QUANTIDADE_DE_CHAVES}}", "".concat(bannerData === null || bannerData === void 0 ? void 0 : bannerData.chavesAcesso))) || RestrictedGuestPaywall_index_restrictedStrings.subText2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonDefault, {
          onClick: handleButton2Click,
          children: RestrictedGuestPaywall_index_restrictedStrings.button2
        })]
      })]
    })]
  });
};

/* harmony default export */ var RestrictedGuestPaywall_index = (RestrictedGuestPaywall);
;// CONCATENATED MODULE: ./components/Article/Restricted/RestrictedPaywall/RestrictedTrialPaywall.index.tsx





var RestrictedTrialPaywall_index_restrictedStrings = {
  mainTitle: "Você se interessou por essa matéria?",
  subTitle: "Deseja utilizar uma chave para abrir o conteúdo?",
  buttonTitle: "Abrir"
};

var RestrictedTrialPaywall = function RestrictedTrialPaywall(_ref) {
  var bannerData = _ref.bannerData,
      handleActionClick = _ref.handleActionClick,
      trialSize = _ref.trialSize;
  var keysArray = [];
  (0,react.useEffect)(function () {}, [trialSize]);
  if (bannerData) for (var i = 0; i < (bannerData === null || bannerData === void 0 ? void 0 : bannerData.chavesAcesso); i++) {
    if (trialSize > i) {
      keysArray.push({
        used: true
      });
      continue;
    }

    keysArray.push({
      used: false
    });
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: bannerData && bannerData.chavesAcesso > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MainTitle, {
        customCss: {
          mb: "$2",
          textAlign: "center"
        },
        children: bannerData.chamadaPrincipal || RestrictedTrialPaywall_index_restrictedStrings.mainTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
        customCss: {
          maxWidth: "auto",
          "@lg": {
            width: "100%"
          }
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubText, {
          customCss: {
            fontSize: "18px",
            lineHeight: "23px",
            letterSpacing: "0.2px",
            fontWeight: 400,
            "@lg": {
              minHeight: "auto"
            }
          },
          children: RestrictedTrialPaywall_index_restrictedStrings.subTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(KeyHolder, {
          children: keysArray.map(function (item, key) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(KeyIcon, {
              used: item.used
            }, key);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonDefault, {
          onClick: handleActionClick,
          children: RestrictedTrialPaywall_index_restrictedStrings.buttonTitle
        })]
      })]
    })
  });
};

/* harmony default export */ var RestrictedTrialPaywall_index = (RestrictedTrialPaywall);
// EXTERNAL MODULE: ./node_modules/query-string/index.js + 4 modules
var query_string = __webpack_require__(4887);
;// CONCATENATED MODULE: ./components/Article/Restricted/Restricted.index.tsx
























var KEY_USAGE = 'key:usage';

var Restricted = function Restricted(_ref) {
  var _serverSideContext$si, _serverSideContext$si2;

  var articleCid = _ref.articleCid,
      trialStage = _ref.trialStage,
      setRestrictedArticle = _ref.setRestrictedArticle,
      handleOpenArticle = _ref.handleOpenArticle,
      author = _ref.author,
      publishedDate = _ref.publishedDate,
      articleType = _ref.articleType;
  var router = (0,next_router.useRouter)();
  var routerRedirectUrl = window.location.href;
  var serverSideContext = react.useContext(ServerSideProps.ServerSidePropsContext);

  var _useKeycloak = (0,ssr_lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var isPaywall = serverSideContext === null || serverSideContext === void 0 ? void 0 : (_serverSideContext$si = serverSideContext.site) === null || _serverSideContext$si === void 0 ? void 0 : (_serverSideContext$si2 = _serverSideContext$si.pageConfig) === null || _serverSideContext$si2 === void 0 ? void 0 : _serverSideContext$si2.featureRadioSelectPaywall;

  var _useState = (0,react.useState)(true),
      hasAccess = _useState[0],
      setHasAccess = _useState[1];

  var sessionData = (0,react.useContext)(Session.SessionDataContext);

  var _useState2 = (0,react.useState)(),
      bannerData = _useState2[0],
      setBannerData = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      lastVisitedURL = _useState3[0],
      setLastVisitedURL = _useState3[1];

  var siteId = "CBNGO" || 0;

  var handleGetPaywallConfig = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var nivelAcesso, url, data;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              nivelAcesso = sessionData !== null && sessionData !== void 0 && sessionData.id && sessionData != null ? 'DEGUSTADOR' : 'VISITANTE';
              url = "/siteApi/paywallConfig/".concat(siteId, "/").concat(nivelAcesso);
              _context.next = 4;
              return (0,util/* fetchApi */.a8)(url).then(function (res) {
                return res;
              });

            case 4:
              data = _context.sent;
              return _context.abrupt("return", data);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleGetPaywallConfig() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    var storedLastURL = sessionStorage.getItem('lastVisitedURL');
    setLastVisitedURL(storedLastURL);
    handleGetPaywallConfig().then(function (res) {
      setBannerData(res);
    });
  }, [sessionData]);

  var redirectTo = function redirectTo(path) {
    window.location.assign(path);
  };

  var unlockContentId = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(cid, sessionData, author, publishedDate) {
      var _sessionData$inscrica;

      var chavesUsadas, storeId, email, customMessage, currentUrl, data, queryStringData, patchTrialCreditsEarnedRes, updatedSession;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              chavesUsadas = 0;

              if (sessionData !== null && sessionData !== void 0 && (_sessionData$inscrica = sessionData.inscricaoDegustador) !== null && _sessionData$inscrica !== void 0 && _sessionData$inscrica.creditosDegustadorList) {
                sessionData.inscricaoDegustador.creditosDegustadorList.forEach(function (credito) {
                  chavesUsadas += 3 - credito.quantidade;
                });
              }

              storeId = getStoreId();
              email = sessionData === null || sessionData === void 0 ? void 0 : sessionData.emailUsuario;
              customMessage = "Usu\xE1rio usou ".concat(chavesUsadas + 1, " chave(s)");
              currentUrl = window.location.href;
              data = {
                storeId: storeId,
                email: email,
                conversionIdentifier: 'Chave Usada',
                customMessage: customMessage,
                autorMateria: author,
                dataMateria: publishedDate,
                origemNavegacao: lastVisitedURL,
                editoria: articleType,
                urlNoticia: currentUrl
              };
              queryStringData = query_string/* default.stringify */.Z.stringify(data);
              _context2.prev = 8;
              _context2.next = 11;
              return axios_default().post("/send-keys-to-rdstation?".concat(queryStringData), {
                params: {
                  storeId: storeId
                }
              });

            case 11:
              console.log('Dados enviados para o RD Station com sucesso');
              _context2.next = 17;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](8);
              console.error('Erro ao enviar dados para o RD Station', _context2.t0);

            case 17:
              if (window) {
                window.dispatchEvent(new CustomEvent(KEY_USAGE, {
                  detail: {
                    email: email,
                    used: chavesUsadas + 1
                  }
                }));
              }

              _context2.next = 20;
              return patchTrialCreditsEarned(cid, sessionData === null || sessionData === void 0 ? void 0 : sessionData.id);

            case 20:
              patchTrialCreditsEarnedRes = _context2.sent;
              _context2.next = 23;
              return (0,updateSession/* updateSession */.C)(sessionData === null || sessionData === void 0 ? void 0 : sessionData.id).then(function (res) {
                if (res.status == 200) {
                  return res.data;
                } else {
                  return sessionData;
                }
              });

            case 23:
              updatedSession = _context2.sent;

              if (patchTrialCreditsEarnedRes.status != 200) {
                console.log('Erro ao abrir a matéria: ', patchTrialCreditsEarnedRes);
              } else {
                (0,utils/* updateSessionCookie */.IU)(updatedSession);
                handleOpenArticle();
                setRestrictedArticle(false);
              }

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 14]]);
    }));

    return function unlockContentId(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleLogin = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return keycloak === null || keycloak === void 0 ? void 0 : keycloak.login({
                redirectUri: "".concat(window.location.href)
              });

            case 3:
              _context3.next = 8;
              break;

            case 5:
              _context3.prev = 5;
              _context3.t0 = _context3["catch"](0);
              console.error('Error during login:', _context3.t0);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 5]]);
    }));

    return function handleLogin() {
      return _ref4.apply(this, arguments);
    };
  }();

  var renderRestrictedView = function renderRestrictedView(stage) {
    var _sessionData$inscrica6, _sessionData$inscrica7;

    switch (stage) {
      case 1:
        if (isPaywall === 'PIANO') {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedGuest_index, {});
        } else {
          var _sessionData$inscrica2, _sessionData$inscrica3;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedGuestPaywall_index, {
            bannerData: bannerData,
            handleButton1Click: handleLogin,
            handleButton2Click: function handleButton2Click() {
              return redirectTo("".concat("https://accounts.opopular.com.br/auth/realms/accounts", "/protocol/openid-connect/registrations?client_id=").concat("cbngo", "&response_type=code&scope=openid email&redirect_uri=").concat(routerRedirectUrl));
            },
            trialSize: (sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$inscrica2 = sessionData.inscricaoDegustador) === null || _sessionData$inscrica2 === void 0 ? void 0 : (_sessionData$inscrica3 = _sessionData$inscrica2.creditosDegustadorList[0]) === null || _sessionData$inscrica3 === void 0 ? void 0 : _sessionData$inscrica3.quantidade) || 0
          });
        }

      case 2:
        if (isPaywall === 'PIANO') {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedGuest_index, {});
        } else {
          var _sessionData$inscrica4, _sessionData$inscrica5;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedTrialPaywall_index, {
            bannerData: bannerData,
            handleActionClick: function handleActionClick() {
              return unlockContentId(articleCid, sessionData, author, publishedDate);
            },
            trialSize: (sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$inscrica4 = sessionData.inscricaoDegustador) === null || _sessionData$inscrica4 === void 0 ? void 0 : (_sessionData$inscrica5 = _sessionData$inscrica4.creditosDegustadorList[0]) === null || _sessionData$inscrica5 === void 0 ? void 0 : _sessionData$inscrica5.quantidade) || 0
          });
        }

      case 0:
      default:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedExpiredPaywall_index, {
          trialSize: (sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$inscrica6 = sessionData.inscricaoDegustador) === null || _sessionData$inscrica6 === void 0 ? void 0 : (_sessionData$inscrica7 = _sessionData$inscrica6.creditosDegustadorList[0]) === null || _sessionData$inscrica7 === void 0 ? void 0 : _sessionData$inscrica7.quantidade) || 0,
          bannerData: bannerData
        });
    }
  };

  if (isPaywall === 'PIANO') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          display: hasAccess ? 'none' : 'block',
          width: '100%'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Restricted_styled_Container, {
          children: renderRestrictedView(trialStage)
        })
      })
    });
  } else {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Restricted_styled_Container, {
      children: [!bannerData && /*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedBanner_styled/* Load */.q5, {}), bannerData && renderRestrictedView(trialStage), bannerData && /*#__PURE__*/(0,jsx_runtime.jsx)(RestrictedBanner_index, {
        priceValue: "4,90",
        bannerData: bannerData
      })]
    });
  }
};

Restricted.defaultProps = {
  trialStage: 1
};
/* harmony default export */ var Restricted_index = (Restricted);
;// CONCATENATED MODULE: ./components/Article/Subtitle/Subtitle.index.tsx




var Subtitle = function Subtitle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    as: props.as,
    css: props.customCss,
    variant: props.variant,
    children: props.value || props.children
  });
};

Subtitle.defaultProps = {
  as: 'h2',
  variant: 'default-heading-2xl'
};
/* harmony default export */ var Subtitle_index = (Subtitle);
;// CONCATENATED MODULE: ./components/Newsletter/styled.tsx


function styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var ContainerButton = function ContainerButton(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: styled_objectSpread(styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

ContainerButton.defaultProps = {
  defaultCss: {
    width: '100%',
    '@lg': {
      align: ['row', 'center', 'middle']
    }
  }
};


var ContainerNewsletter = function ContainerNewsletter(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: styled_objectSpread(styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

ContainerNewsletter.defaultProps = {
  defaultCss: {
    align: ['column', 'center', 'top'],
    border: '1px solid #E6E6E6',
    display: 'flex',
    height: '100%',
    mx: '$4',
    mt: '$4',
    mb: '$6',
    pb: '$2',
    width: 'calc(100% - 32px)',
    '@lg': {
      maxWidth: '952px'
    }
  }
};


var ContainerInputs = function ContainerInputs(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: styled_objectSpread(styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

ContainerInputs.defaultProps = {
  defaultCss: {
    align: ['column', 'left', 'middle'],
    mb: '$2',
    width: 'calc(100% - 16px)',
    '@lg': {
      align: ['row', 'center', 'top'],
      maxWidth: '918px',
      width: 'calc(100% - 48px)'
    }
  }
};


var ContainerSubject = function ContainerSubject(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: styled_objectSpread(styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

ContainerSubject.defaultProps = {
  defaultCss: {
    width: 'calc(100% - 32px)',
    align: ['column', 'left', 'center'],
    '@lg': {
      align: ['row', 'left', 'middle'],
      width: 'calc(100% - 48px)'
    }
  }
};


var ContainerTitle = function ContainerTitle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: styled_objectSpread(styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

ContainerTitle.defaultProps = {
  defaultCss: {
    align: ['row', 'left', 'middle'],
    mb: '$2',
    mt: '$6',
    width: 'calc(100% - 32px)'
  }
};


var styled_Subtitle = function Subtitle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    css: styled_objectSpread(styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

styled_Subtitle.defaultProps = {
  defaultCss: {
    color: 'black',
    fontFamily: '$primary',
    fontSize: '14px',
    fontWeight: 400,
    m: '$0',
    mb: '$4',
    width: '100%',
    '@lg': {
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '25px',
      mb: '$0'
    }
  }
};


var styled_Title = function Title(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    css: styled_objectSpread(styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

styled_Title.defaultProps = {
  defaultCss: {
    alignItems: 'center',
    color: '#164194',
    fontFamily: '$primary',
    fontSize: '22px',
    fontWeight: 700,
    m: '$0',
    width: 'max-content'
  }
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
;// CONCATENATED MODULE: ./components/Newsletter/Input/styled.tsx


function Input_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Input_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Input_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Input_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Label = function Label(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    css: Input_styled_objectSpread(Input_styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

Label.defaultProps = {
  defaultCss: {
    color: 'black',
    fontFamily: '$primary',
    fontSize: '22px',
    fontWeight: 700,
    m: '$0',
    width: '100%'
  }
};

;// CONCATENATED MODULE: ./components/Newsletter/Input/index.tsx



function Input_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Input_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Input_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Input_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck







var InputBox = prensa/* PrensaEngine.styled */.u7.styled('input', {
  border: '1px solid #BFBFBF',
  borderRadius: '$default',
  cursor: 'pointer',
  height: '15px',
  mr: '6px',
  width: '15px'
});


var SelectInput = function SelectInput(_ref) {
  var content = _ref.content,
      setSelectedItems = _ref.setSelectedItems,
      selectedItems = _ref.selectedItems,
      clear = _ref.clear;

  var _useState = (0,react.useState)({}),
      checks = _useState[0],
      setChecks = _useState[1];

  var selectChange = function selectChange(event) {
    var _event$target = event.target,
        value = _event$target.value,
        checked = _event$target.checked;
    setChecks(function (prev) {
      return Input_objectSpread(Input_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, value, checked));
    });
  };

  react.useEffect(function () {
    var checkedItems = Object.entries(checks).filter(function (_ref2) {
      var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      return value;
    });

    if (selectedItems) {
      setSelectedItems(checkedItems);
    }
  }, [checks]);
  react.useEffect(function () {
    if (clear) {
      setChecks({});
      setSelectedItems([]);
    }
  }, [clear]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: {
      align: ['column', 'left', 'top'],
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        width: '100%',
        maxWidth: '1000px'
      }
    },
    children: map_default()(content, function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: {
          align: ['row', 'left', 'center'],
          width: '100%',
          '@lg': {
            width: '30%',
            mr: '$5'
          }
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputBox, {
          type: "checkbox",
          onChange: selectChange,
          value: item.selectContent,
          checked: checks[item.selectContent] || false
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          customCss: {
            fontSize: '15px',
            fontWeight: 400,
            lineHeight: 'normal',
            mb: '$5',
            mt: '2px',
            width: '100%'
          },
          children: item.selectContent
        })]
      }, index);
    })
  });
};

/* harmony default export */ var Input = (SelectInput);
;// CONCATENATED MODULE: ./components/Newsletter/Input/content.json
var content_namespaceObject = JSON.parse('[{"id":1,"selectContent":"Notícias do Atlético"},{"id":2,"selectContent":"Notícias do Goiás E. C."},{"id":3,"selectContent":"Notícias do Vila Nova"},{"id":4,"selectContent":"Destaques do Impresso"},{"id":5,"selectContent":"Podcast Giro 360"},{"id":6,"selectContent":"Economia Goiana"},{"id":7,"selectContent":"Edição de Domingo"},{"id":8,"selectContent":"Crônicas da Semana"}]');
// EXTERNAL MODULE: ./components/Input/Input.styles.tsx
var Input_styles = __webpack_require__(9936);
;// CONCATENATED MODULE: ./components/Input/InputNewsletter.index.tsx





var InputNewsletter = function InputNewsletter(_ref) {
  var placeholder = _ref.placeholder,
      value = _ref.value,
      onChange = _ref.onChange;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: {
      align: ['column', 'left', 'top']
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input_styles/* Input */.I, {
      placeholder: placeholder,
      value: value,
      onChange: onChange,
      css: {
        borderColor: '#BFBFBF',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '$unset',
        color: '#4D4D4D',
        fontFamily: '$primary',
        fontSize: '16px',
        px: '$3',
        height: '40px',
        mb: '$2',
        width: '100%',
        '@lg': {
          width: '380px'
        }
      }
    })
  });
};

/* harmony default export */ var InputNewsletter_index = (InputNewsletter);
;// CONCATENATED MODULE: ./components/Buttons/NewsletterButton.index.tsx


function NewsletterButton_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NewsletterButton_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NewsletterButton_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NewsletterButton_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var NewsletterButton = function NewsletterButton(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Button */.zx, NewsletterButton_index_objectSpread(NewsletterButton_index_objectSpread({}, props), {}, {
    variant: "filled",
    css: {
      button: {
        background: '#164194',
        borderRadius: '$unset',
        height: '40px',
        width: '100%',
        '@lg': {
          width: '120px'
        }
      },
      label: {
        color: '$basicWhite',
        fontFamily: '$primary',
        fontSize: '18px',
        fontWeight: '700'
      }
    },
    children: "Enviar"
  }));
};
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(1444);
;// CONCATENATED MODULE: ./components/Newsletter/index.tsx



function Newsletter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Newsletter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Newsletter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Newsletter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


// @ts-nocheck
















var Newsletter = function Newsletter() {
  var _useState = (0,react.useState)({
    name: "",
    email: ""
  }),
      input = _useState[0],
      setInput = _useState[1];

  var _useState2 = (0,react.useState)([]),
      selectedItems = _useState2[0],
      setSelectedItems = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      shouldClear = _useState3[0],
      setShouldClear = _useState3[1];

  var _useState4 = (0,react.useState)(),
      rdStationList = _useState4[0],
      setRdStationList = _useState4[1];

  var iconNewsletter = (0,useIcon/* useIcon */.b)("IcNewsletter");
  var iconMoreSubjects = (0,useIcon/* useIcon */.b)("icMoreSubjects");
  var storeId = getStoreId();
  (0,react.useEffect)(function () {
    loadRdStationList();
  }, []);
  (0,react.useEffect)(function () {
    if (shouldClear) {
      setShouldClear(false);
    }
  }, [shouldClear]);

  var loadRdStationList = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var url, _rdStationList;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              url = "/siteApi/rdStationList/cf_sobre_o_que_voce_gosta_de_ler_no_jornal?storeId=".concat(storeId);
              _context.next = 4;
              return axios_default().get(url);

            case 4:
              _rdStationList = _context.sent;
              setRdStationList(_rdStationList.data ? _rdStationList.data : content_namespaceObject);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error("Erro ao carregar rdStationList:", _context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function loadRdStationList() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleInputChange = function handleInputChange(fieldName, value) {
    setInput(function (prevState) {
      return Newsletter_objectSpread(Newsletter_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, fieldName, value));
    });
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var emailRegex, data, queryStringData, response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!input.email || !input.name)) {
                _context2.next = 3;
                break;
              }

              react_toastify_esm/* toast.warning */.Am.warning('Preencha todos os campos antes de enviar.');
              return _context2.abrupt("return");

            case 3:
              emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

              if (emailRegex.test(input.email)) {
                _context2.next = 7;
                break;
              }

              react_toastify_esm/* toast.warning */.Am.warning('Insira um email válido.');
              return _context2.abrupt("return");

            case 7:
              data = {
                email: input.email,
                conversionIdentifier: "newsletter-geral-completo",
                name: input.name,
                customField: JSON.stringify(selectedItems.map(function (item) {
                  return item[0];
                })),
                storeId: storeId
              };
              queryStringData = query_string/* default.stringify */.Z.stringify(data);
              _context2.prev = 9;
              _context2.next = 12;
              return axios_default().get("/send-to-rdstation/api/send-to-rdstation?".concat(queryStringData), {
                params: {
                  storeId: storeId
                }
              });

            case 12:
              response = _context2.sent;
              react_toastify_esm/* toast.success */.Am.success('Formulário enviado com sucesso');
              setInput({
                name: "",
                email: ""
              });
              setShouldClear(true);
              _context2.next = 22;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](9);
              react_toastify_esm/* toast.error */.Am.error('Erro no envio do formulário');
              console.log(_context2.t0);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[9, 18]]);
    }));

    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ContainerNewsletter, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ContainerTitle, {
      customCss: {
        align: ['column', 'left', 'middle'],
        '@lg': {
          align: ['row', 'left', 'middle'],
          width: 'calc(100% - 48px)'
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: {
          align: ['row', 'left', 'middle'],
          mb: '$2',
          '@lg': {
            borderRight: '1px solid #E6E6E6',
            mr: '$3'
          }
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
          css: {
            mr: '$3'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
            icon: iconNewsletter
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled_Title, {
          customCss: {
            mr: '$2'
          },
          children: "Newsletter"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(styled_Subtitle, {
        customCss: {
          mb: '$4'
        },
        children: "Escolha seus assuntos favoritos e receba em primeira m\xE3o as not\xEDcias do dia."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContainerSubject, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
        content: rdStationList,
        selectedItems: selectedItems,
        setSelectedItems: setSelectedItems,
        clear: shouldClear
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContainerInputs, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          mr: '10px',
          width: '100%'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(InputNewsletter_index, {
          placeholder: "Seu nome",
          value: input.name,
          onChange: function onChange(e) {
            return handleInputChange('name', e.target.value);
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          mr: '10px',
          width: '100%'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(InputNewsletter_index, {
          placeholder: "Insira seu email",
          value: input.email,
          onChange: function onChange(e) {
            return handleInputChange('email', e.target.value);
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContainerButton, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsletterButton, {
          onClick: handleSubmit
        })
      })]
    })]
  });
};

/* harmony default export */ var components_Newsletter = (Newsletter);
;// CONCATENATED MODULE: ./components/Article/Article.styled.tsx


function Article_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Article_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Article_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Article_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var ArticleContainer = function ArticleContainer(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: Article_styled_objectSpread(Article_styled_objectSpread(Article_styled_objectSpread({}, props.defaultCss), props.customCss), props.hideInDesktop && {
      "@lg": {
        display: "none"
      }
    }),
    children: props.children
  });
};

var ArticleContentLeft = function ArticleContentLeft(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: Article_styled_objectSpread(Article_styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

var ArticleContentRight = function ArticleContentRight(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: Article_styled_objectSpread(Article_styled_objectSpread(Article_styled_objectSpread({}, props.defaultCss), props.customCss), props.hideInDesktop && {
      "@lg": {
        display: "none"
      }
    }),
    children: props.children
  });
};

var ArticleContent = function ArticleContent(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: Article_styled_objectSpread(Article_styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

var ArticleTagContainer = function ArticleTagContainer(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: Article_styled_objectSpread(Article_styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

var ArticleShareSectionContainer = function ArticleShareSectionContainer(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: Article_styled_objectSpread(Article_styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

ArticleContainer.defaultProps = {
  defaultCss: {
    align: ["row", "center", "middle"],
    width: "100%"
  }
};
ArticleContent.defaultProps = {
  defaultCss: {
    align: ["row", "center", "between"],
    width: "calc(100% - $6)",
    maxWidth: "960px",
    "@lg": {
      width: "100%"
    }
  }
};
ArticleContentLeft.defaultProps = {
  defaultCss: {
    width: "100%"
  }
};
ArticleContentRight.defaultProps = {
  defaultCss: {
    display: "none"
  }
};
ArticleTagContainer.defaultProps = {
  defaultCss: {
    align: ["row", "left", "top"],
    flexWrap: "wrap",
    my: "$0",
    mb: "$6",
    width: "calc(100% - calc($4 * 3))",
    maxWidth: "960px"
  }
};
ArticleShareSectionContainer.defaultProps = {
  defaultCss: {
    align: ["row", "left", "middle"],
    mt: "$5",
    mb: "$11"
  }
};

// EXTERNAL MODULE: ./hooks/useImageProxy.tsx
var useImageProxy = __webpack_require__(1332);
// EXTERNAL MODULE: ./components/Ads/Ads.Slot.tsx + 5 modules
var Ads_Slot = __webpack_require__(7894);
;// CONCATENATED MODULE: ./components/Article/Article.index.tsx


function Article_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Article_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Article_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Article_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























 // import ClassiRecomend from '../ClassiRecomend';







var SNIPPET_SIZE_LIMIT = 800;
var ArticleBody = prensa/* PrensaEngine.styled */.u7.styled('div', {
  align: ['column', 'center', 'top'],
  maxWidth: '100vw',
  '@lg': {
    maxWidth: 'none'
  },
  '&.restricted': {
    height: '400px',
    overflow: 'hidden'
  }
});
var Article_index_ArticleContainer = prensa/* PrensaEngine.styled */.u7.styled('article', {
  align: ['column', 'center', 'top']
});
var ArticleImage = prensa/* PrensaEngine.styled */.u7.styled('img', {
  width: '100%',
  maxWidth: '960px'
});
var AuthorImage = prensa/* PrensaEngine.styled */.u7.styled('img', {
  borderRadius: '50%',
  marginRight: '$4',
  width: '100%',
  maxWidth: '52px'
});

var convertLocaleDate = function convertLocaleDate(timestamp, showWeekDay, modificationDateEnabled) {
  var date = new Date(timestamp);

  if (modificationDateEnabled) {
    var _options = {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    };
    return date.toLocaleDateString('pt-BR', _options);
  }

  var options = Article_index_objectSpread({
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }, showWeekDay && {
    weekday: 'long'
  });

  var dateString = date.toLocaleDateString('pt-BR', options);

  if (showWeekDay) {
    return dateString.replace(/^\w/, function (c) {
      return c.toUpperCase();
    });
  }

  return dateString.replace(/(\d{4})(\s+\d{2}:\d{2})/, '$1 |$2');
};

var RenderCaption = function RenderCaption(props) {
  var captionProps = props.captionProps,
      isFullWidth = props.isFullWidth,
      textValue = props.textValue,
      value = props.value;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Caption_index, Article_index_objectSpread(Article_index_objectSpread({}, captionProps), {}, {
    isFullWidth: isFullWidth,
    value: value || textValue
  }));
};

var RenderBylineImage = function RenderBylineImage(_ref) {
  var alt = _ref.alt,
      css = _ref.css,
      linkHref = _ref.linkHref,
      linkTarget = _ref.linkTarget,
      src = _ref.src;
  var imgSrc = (0,useImageProxy/* useImageProxy */.n)("".concat(src, "&f=1x1"), true);

  var imageTag = function imageTag() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(AuthorImage, Article_index_objectSpread(Article_index_objectSpread({}, css), {}, {
      alt: alt,
      src: imgSrc,
      width: "82px"
    }));
  };

  if (linkHref) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: linkHref,
      target: linkTarget || '_self',
      children: imageTag()
    });
  }

  return imageTag();
};

var RenderImage = function RenderImage(_ref2) {
  var alt = _ref2.alt,
      _ref2$derivative = _ref2.derivative,
      derivative = _ref2$derivative === void 0 ? '3x2' : _ref2$derivative,
      isFullWidth = _ref2.isFullWidth,
      linkHref = _ref2.linkHref,
      linkTarget = _ref2.linkTarget,
      src = _ref2.src;
  var imgSrc = (0,useImageProxy/* useImageProxy */.n)("".concat(src, "&f=").concat(derivative), true);

  var imageTag = function imageTag() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleImage, {
      alt: alt,
      src: imgSrc,
      width: isFullWidth ? '100%' : '960px'
    });
  };

  if (linkHref) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: linkHref,
      target: linkTarget || '_self',
      children: imageTag()
    });
  }

  return imageTag();
};

var RenderTag = function RenderTag(_ref3) {
  var children = _ref3.children,
      value = _ref3.value;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Link */.rU, {
    bypass: false,
    component: (link_default()),
    componentProps: {
      href: "/tag?tag=".concat(value),
      legacyBehavior: true
    },
    href: "/tag?tag=".concat(value),
    css: {
      fontSize: 0,
      width: '100%'
    },
    children: children
  });
};

var Article_index_Article = function Article(props) {
  var _props$bylineProps, _props$bylineProps2, _props$author, _props$bylineProps3, _props$bylineProps3$a, _props$author2, _props$bylineProps4, _props$bylineProps5, _sessionData$inscrica, _sessionData$inscrica2;

  var shareSection = get_default()(props, 'shareSection', {
    enabled: false,
    content: []
  });
  var isPosition = get_default()(props, 'itemPosition', 0);
  var sourceSite = get_default()(props, 'siteOrigem[0]', '');
  var isDelete = get_default()(props, 'isDeleted', false);
  var isOnline = get_default()(props, 'isOnline', true);
  var audioLink = get_default()(props, 'audioLink', '');
  var showImageBottom = get_default()(props, 'showImageBottom', false);
  var showImageFull = get_default()(props, 'showImageFull', false);
  var showTopImage = get_default()(props, 'showTopImage', false);
  var showListenButton = false; // get(props, 'showListenButton', true)

  var showMainTitle = get_default()(props, 'showMainTitle', true);
  var tagsList = get_default()(props, 'tags.tags', []);
  var sessionData = (0,react.useContext)(Session.SessionDataContext);

  var _useKeycloak = (0,ssr_lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak; // const topImage: any = get(props, 'images[0]', false)


  var unlockedIds = get_default()(props, 'sessionUnlockedIds', []);
  var isUnlocked = unlockedIds === null || unlockedIds === void 0 ? void 0 : unlockedIds.find(function (i) {
    return i === props.id.replace('policy:', '');
  });
  var serverSideContext = react.useContext(ServerSideProps.ServerSidePropsContext);
  var isInPreviewMode = get_default()(serverSideContext, 'preview.enabled', false);
  var sitSlug = get_default()(serverSideContext, 'siteSlug', '');
  var isViads = isPosition === 0 && sitSlug != 'cbngo';

  var _useState = (0,react.useState)(props.sessionPremium),
      restrictedArticle = _useState[0],
      setRestrictedArticle = _useState[1];

  var router = (0,next_router.useRouter)();

  var goToHomePage = function goToHomePage() {
    window.location.assign('/');
  };

  var topResources = get_default()(props, 'images', []);
  var imageTypeBean = 'com.atex.standard.image.ImageContentDataBean';
  var topImage = find_default()(topResources, {
    type: imageTypeBean
  });
  var topSelected = showTopImage && first_default()(topResources);
  var bodyRaw = get_default()(props, 'bodyRaw', []);
  var bodyItems = get_default()(props, 'bodyItems', []);
  var textsData = get_default()(props, 'textsData', []);

  var handleOpenArticle = function handleOpenArticle() {
    var bodyItems = get_default()(props, 'bodyItems', []);
    var textsData = get_default()(props, 'textsData', []);
  };

  var authorBylineProps = Article_index_objectSpread(Article_index_objectSpread({}, (_props$bylineProps = props.bylineProps) === null || _props$bylineProps === void 0 ? void 0 : _props$bylineProps.author), {}, {
    value: props === null || props === void 0 ? void 0 : props.byline
  });

  var authorImageProps = Article_index_objectSpread(Article_index_objectSpread({}, (_props$bylineProps2 = props.bylineProps) === null || _props$bylineProps2 === void 0 ? void 0 : _props$bylineProps2.authorImage), {}, {
    imageProps: {
      alt: (props === null || props === void 0 ? void 0 : (_props$author = props.author) === null || _props$author === void 0 ? void 0 : _props$author.name) || '',
      css: (_props$bylineProps3 = props.bylineProps) === null || _props$bylineProps3 === void 0 ? void 0 : (_props$bylineProps3$a = _props$bylineProps3.authorImage) === null || _props$bylineProps3$a === void 0 ? void 0 : _props$bylineProps3$a.customCss,
      linkHref: '',
      linkTarget: '',
      src: (props === null || props === void 0 ? void 0 : (_props$author2 = props.author) === null || _props$author2 === void 0 ? void 0 : _props$author2.url) || ''
    }
  });

  var authorEmailProps = {
    customCss: {
      fontFamily: '$tertiary',
      m: '$0',
      mb: '$1'
    },
    enabled: get_default()(props, 'email', '') !== '',
    value: get_default()(props, 'email', '')
  };
  var modificationTime = get_default()(props, 'modificationTime', false);
  modificationTime = modificationTime && Number(modificationTime) > 1677570000000 ? modificationTime : false; // remove migration modification event

  var publishingTime = get_default()(props, 'publishingTime', false);
  var modifiedDateEnabled = false;

  if (modificationTime && publishingTime) {
    modifiedDateEnabled = modificationTime > publishingTime;
  }

  var publishedDateProps = Article_index_objectSpread(Article_index_objectSpread({
    enabled: true
  }, (_props$bylineProps4 = props.bylineProps) === null || _props$bylineProps4 === void 0 ? void 0 : _props$bylineProps4.publishedDate), {}, {
    value: convertLocaleDate(publishingTime, false, false),
    original: publishingTime
  });

  var modifiedDateProps = Article_index_objectSpread(Article_index_objectSpread({
    enabled: modifiedDateEnabled
  }, (_props$bylineProps5 = props.bylineProps) === null || _props$bylineProps5 === void 0 ? void 0 : _props$bylineProps5.publishedDate), {}, {
    value: modifiedDateEnabled ? "Modificado em ".concat(convertLocaleDate(modificationTime, false, modifiedDateEnabled)) : '',
    original: modificationTime
  });

  var topImageProps = showImageFull ? Article_index_objectSpread(Article_index_objectSpread({}, props.imageProps), {}, {
    derivative: 'default'
  }) : props.imageProps;

  var textBodyImageProps = Article_index_objectSpread(Article_index_objectSpread({}, props.imageProps), {}, {
    derivative: 'default'
  });

  var shareSectionIcons = (0,useIcon/* useIcon */.b)(shareSection.content.map(function (i) {
    return i.icon;
  }));
  var shareSectionData = shareSectionIcons.map(function (i) {
    return Article_index_objectSpread(Article_index_objectSpread({}, i), {}, {
      config: shareSection.content.find(function (s) {
        return s.icon === i.name;
      })
    });
  });
  (0,react.useEffect)(function () {
    if ((sessionData === null || sessionData === void 0 ? void 0 : sessionData.nivelAcesso) == 'ASSINANTE' && sessionData !== null && sessionData !== void 0 && sessionData.nivelAcesso) {
      setRestrictedArticle(false);
    }
  }, [sessionData]);

  var renderTopImage = function renderTopImage() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Image_index, {
      alt: props.name,
      byline: get_default()(topImage, 'byline'),
      caption: (props === null || props === void 0 ? void 0 : props.caption) || get_default()(topImage, 'caption'),
      componentImage: RenderImage,
      componentCaption: RenderCaption,
      captionProps: props.captionProps,
      isFullWidth: true,
      imageProps: topImageProps,
      linkHref: get_default()(topImage, 'linkHref'),
      linkTarget: get_default()(topImage, 'linkTarget'),
      src: get_default()(topImage, 'url')
    });
  };

  if (isDelete || !isOnline || !props.id) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: {
        align: ['column', 'center', 'middle'],
        justifyContent: 'flex-end',
        width: 'auto',
        mt: '24px'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
        as: "p",
        css: {
          fontFamily: '$primary',
          fontSize: '22px'
        },
        children: "P\xE1gina 404 - N\xE3o encontrado"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CallToActionOutlinedButton_index/* default */.Z, {
        onClick: goToHomePage,
        children: "P\xE1gina inicial"
      })]
    });
  }

  var isRestrictedContent = !isUnlocked && restrictedArticle === true;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ArticleContainer, {
      customCss: props.articleContainer,
      hideInDesktop: props.hideInDesktop,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "article-text-top"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Article_index_ArticleContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ArticleContent, {
          customCss: props.articleContent,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ArticleContentLeft, {
            customCss: props.articleContentLeft,
            children: [showMainTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(Title_index, Article_index_objectSpread(Article_index_objectSpread({}, props.titleProps), {}, {
              value: props === null || props === void 0 ? void 0 : props.name
            })), /*#__PURE__*/(0,jsx_runtime.jsx)(Subtitle_index, Article_index_objectSpread(Article_index_objectSpread({}, props.subtitleProps), {}, {
              value: props === null || props === void 0 ? void 0 : props.lead
            })), shareSection.enabled && /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleShareSectionContainer, {
              children: shareSectionData.map(function (i, k) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
                  href: "".concat(i.config.href).concat(props.domain).concat(props.path),
                  icon: {
                    src: i.url,
                    alt: i.config.alt
                  },
                  linkProps: {
                    target: '_blank',
                    title: i.config.alt,
                    rel: 'noreferrer'
                  },
                  css: {
                    button: {
                      mr: '$2'
                    }
                  }
                }, i.name);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Byline_index, Article_index_objectSpread(Article_index_objectSpread({}, props.bylineProps), {}, {
              author: authorBylineProps,
              authorEmail: authorEmailProps,
              authorImage: authorImageProps,
              componentImage: RenderBylineImage,
              modifiedDate: modifiedDateProps,
              publishedDate: publishedDateProps,
              showListenButton: showListenButton
            })), !showImageBottom && topImage && topSelected === topImage && renderTopImage(), /*#__PURE__*/(0,jsx_runtime.jsxs)(ArticleBody, {
              className: isRestrictedContent ? 'restricted' : '',
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Texts_index, {
                componentCaption: RenderCaption,
                componentImage: RenderImage,
                captionProps: props.captionProps,
                imageProps: textBodyImageProps,
                image: Image_index,
                items: bodyItems,
                isViads: isViads,
                isPosition: isPosition,
                sourceSite: sourceSite,
                siteDomain: serverSideContext.site.siteDomain,
                textProps: props === null || props === void 0 ? void 0 : props.textProps,
                isRestricted: isRestrictedContent,
                audioLink: audioLink
              }), map_default()(textsData, function (item, key) {
                var itemBodyItems = item === null || item === void 0 ? void 0 : item.bodyItems; // if (!isUnlocked && restrictedArticle) {
                //   debugger
                //   itemBodyItems = itemBodyItems?.slice(0, 2);
                // }

                return /*#__PURE__*/(0,jsx_runtime.jsx)(Texts_index, {
                  componentCaption: RenderCaption,
                  componentImage: RenderImage,
                  captionProps: props.captionProps,
                  itemsAheadBody: (item === null || item === void 0 ? void 0 : item.itemsAheadBody) || [],
                  imageProps: textBodyImageProps,
                  image: Image_index,
                  images: (item === null || item === void 0 ? void 0 : item.images) || [],
                  items: itemBodyItems || [],
                  textProps: props === null || props === void 0 ? void 0 : props.textProps,
                  isRestricted: isRestrictedContent
                }, key);
              }), showImageBottom && topSelected === topImage && topImage && renderTopImage()]
            }), !isUnlocked && restrictedArticle == true && /*#__PURE__*/(0,jsx_runtime.jsx)(Restricted_index, {
              articleCid: props.id,
              trialStage: !sessionData && !(keycloak !== null && keycloak !== void 0 && keycloak.authenticated) ? 1 : sessionData && (sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$inscrica = sessionData.inscricaoDegustador) === null || _sessionData$inscrica === void 0 ? void 0 : (_sessionData$inscrica2 = _sessionData$inscrica.creditosDegustadorList[0]) === null || _sessionData$inscrica2 === void 0 ? void 0 : _sessionData$inscrica2.quantidade) <= 0 || !(sessionData !== null && sessionData !== void 0 && sessionData.inscricaoDegustador) && !(sessionData !== null && sessionData !== void 0 && sessionData.numeroContrato) ? 0 : 2,
              setRestrictedArticle: setRestrictedArticle,
              handleOpenArticle: handleOpenArticle,
              author: authorBylineProps.value,
              publishedDate: publishedDateProps.value,
              articleType: props.articleType
            }), shareSection.enabled && /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleShareSectionContainer, {
              children: shareSectionData.map(function (i, k) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
                  href: "".concat(i.config.href).concat(props.domain).concat(props.path),
                  icon: {
                    src: i.url,
                    alt: i.config.alt
                  },
                  linkProps: {
                    target: '_blank',
                    title: i.config.alt,
                    rel: 'noreferrer'
                  },
                  css: {
                    button: {
                      mr: '$2'
                    }
                  }
                }, i.name);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
              css: {
                align: ['column', 'center', 'middle'],
                width: 'auto',
                mb: '$6'
              },
              children: sitSlug === 'opopular' && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
                  type: "newsletter",
                  componentReference: "top",
                  data: {
                    name: 'Article Newsletter'
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Newsletter, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
                  type: "newsletter",
                  componentReference: "bottom",
                  data: {
                    name: 'Article Newsletter'
                  }
                })]
              })
            }), tagsList.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleTagContainer, {
              customCss: props === null || props === void 0 ? void 0 : props.articleTagsContainer,
              children: map_default()(tagsList, function (tag, key) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag_index, {
                  value: tag,
                  wrapLink: RenderTag
                }, key);
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleContentRight, {
            customCss: props.articleContentRight
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "article-text-bottom"
      })]
    })
  });
};

/* harmony default export */ var Article_index = (Article_index_Article);
;// CONCATENATED MODULE: ./components/Base/Base.Article.tsx



function Base_Article_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Base_Article_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Base_Article_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_Article_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */
















var getItem = function getItem(slotsData, slotList) {
  var items = [];
  (0,lodash.map)(slotList, function (item) {
    var policy = {
      id: item.replace("contentid/", "policy:")
    };
    var found = (0,lodash.find)(slotsData, policy);
    found && items.push(found);
  });
  return items;
};

var getArticleInnerProps = function getArticleInnerProps(article) {
  var articleData = (0,lodash.get)(article, "pageDataArticleElement", false);
  var articleImageTop = (0,lodash.get)(article, "showTopImage", false);
  var articleImageBottom = (0,lodash.get)(article, "showImageBottom", false);
  var showImageBottom = articleImageBottom || (0,lodash.get)(articleData, "showImageBottom", true);
  var showListenButton = (0,lodash.get)(articleData, "showListenButton", true);
  var showMainTitle = (0,lodash.get)(articleData, "showMainTitle", true);
  var showTopImage = articleImageTop && (0,lodash.get)(articleData, "showImageTop", false);
  var showImageFull = (0,lodash.get)(articleData, "showImageFull", false);
  return {
    showImageBottom: showImageBottom,
    showListenButton: showListenButton,
    showMainTitle: showMainTitle,
    showImageFull: showImageFull,
    showTopImage: showTopImage
  };
};

var renderSlotInner = function renderSlotInner(article, relatedList, slotName) {
  var articleData = (0,lodash.get)(article, "pageDataArticleElement", false);
  var slotData;

  if (articleData) {
    var contentData = (0,lodash.get)(articleData, "contentData", []);
    slotData = getItem(contentData, (0,lodash.get)(articleData, slotName, []));
  }

  return (0,lodash.map)(slotData, function (data, key) {
    var _data;

    if (((_data = data) === null || _data === void 0 ? void 0 : _data.name) === "Leia também") {
      var ids = (0,lodash.map)(relatedList, function (i) {
        return i.id;
      });
      data = Base_Article_objectSpread(Base_Article_objectSpread({}, data), {}, {
        items: [].concat((0,toConsumableArray/* default */.Z)(data.items), (0,toConsumableArray/* default */.Z)(relatedList)),
        slotAutoLeftElements: [].concat((0,toConsumableArray/* default */.Z)(data.slotAutoLeftElements), (0,toConsumableArray/* default */.Z)(ids))
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(ComponentSwitch, {
      data: data
    }, key);
  });
};

var ArticleComponent = function ArticleComponent(_ref) {
  var _keycloak$tokenParsed, _serverSideContext$si, _serverSideContext$si2;

  var title = _ref.title;
  var articleContext = (0,react.useContext)(Article.ArticleContext);
  var assetsState = (0,react.useContext)(Assets.AssetsContext);
  var pagesContext = (0,react.useContext)(Pages.PagesContext);
  var serverSideContext = (0,react.useContext)(ServerSideProps.ServerSidePropsContext);

  var _useKeycloak = (0,ssr_lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var articleProps = (0,lodash.get)(assetsState, "assets.article");
  var sessionReadingLimit = keycloak === null || keycloak === void 0 ? void 0 : (_keycloak$tokenParsed = keycloak.tokenParsed) === null || _keycloak$tokenParsed === void 0 ? void 0 : _keycloak$tokenParsed.exp;
  var isPaywall = serverSideContext === null || serverSideContext === void 0 ? void 0 : (_serverSideContext$si = serverSideContext.site) === null || _serverSideContext$si === void 0 ? void 0 : (_serverSideContext$si2 = _serverSideContext$si.pageConfig) === null || _serverSideContext$si2 === void 0 ? void 0 : _serverSideContext$si2.featureRadioSelectPaywall;
  (0,react.useEffect)(function () {
    articleContext.setIsLoaded(true);
    return function () {
      articleContext.clearState();
    };
  }, []);
  var articles = articleContext.articles;
  var firstArticle = articles && articles.length > 0 ? articles[0] : false;
  var articleRelatedList = firstArticle ? firstArticle === null || firstArticle === void 0 ? void 0 : firstArticle.relatedArticleList : [];

  var _useState = (0,react.useState)(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  var sessionData = (0,utils/* getSessionDataFromCookie */.o9)();

  var articleRelatedSlice = function articleRelatedSlice(i) {
    var start = (i + 1) * 3;
    var end = (i + 2) * 3;
    var list = slice_default()(articleRelatedList, start, end);
    return list;
  };

  var handleAutoLogout = function handleAutoLogout() {
    if ((sessionData === null || sessionData === void 0 ? void 0 : sessionData.ativo) === false && !showModal) {
      setShowModal(true);
    }
  };

  var handleCloseModal = function handleCloseModal() {
    setShowModal(false);
  };

  (0,react.useEffect)(function () {
    var interval = setInterval(function () {
      if (!showModal) {
        handleAutoLogout();
      }
    }, 10000);
    return function () {
      return clearInterval(interval);
    };
  }, [sessionData === null || sessionData === void 0 ? void 0 : sessionData.ativo]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: articles.map(function (article, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        "data-article-id": article.id,
        "data-article-url": article.path,
        "data-component-type": "article",
        children: [renderSlotInner(article, [], "slotAutoLeftElements"), /*#__PURE__*/(0,react.createElement)(Article_index, Base_Article_objectSpread(Base_Article_objectSpread(Base_Article_objectSpread(Base_Article_objectSpread({}, articleProps), article), getArticleInnerProps(article)), {}, {
          id: article.id,
          domain: pagesContext.domain,
          key: "article-".concat(article.id),
          itemPosition: key,
          isPaywall: isPaywall,
          sessionReadingLimit: sessionReadingLimit,
          sessionPremium: isPaywall == "DESATIVADO" ? false : article.isLocked,
          articleType: title
        })), renderSlotInner(article, articleRelatedSlice(key), "slotManualLeftElements"), /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
          type: "article",
          componentReference: "bottom",
          data: {
            article: article,
            key: key
          }
        })]
      }, "article-wrapper-".concat(article.id));
    })
  });
};

/* harmony default export */ var Base_Article = (ArticleComponent);
// EXTERNAL MODULE: ./providers/Filter/index.tsx
var Filter = __webpack_require__(1187);
// EXTERNAL MODULE: ./providers/FilterData/index.tsx
var FilterData = __webpack_require__(5341);
;// CONCATENATED MODULE: ./components/SearchEngine/SearchEngine.index.tsx
/* eslint-disable react-hooks/exhaustive-deps */







var SearchEngine = function SearchEngine(props) {
  var filterContext = (0,react.useContext)(Filter.FilterContext);
  var filterDataContext = (0,react.useContext)(FilterData.FilterDataContext);
  var policyId = get_default()(props, 'id', '').replace('policy:', '');
  var pageRows = parseInt(get_default()(props, 'rowsPerPage', 9));
  var pageStart = parseInt(get_default()(props, 'startAtPosition', 0));
  var listOrdenation = get_default()(props, 'listOrdenation', '');
  var listPriority = get_default()(props, 'listPriority', '');
  var loadAtStart = get_default()(props, 'loadAtStart', ''); // const departmentCode = get(props, 'slotTemplateCode', '')

  var loadSearchEngineData = function loadSearchEngineData() {
    var urlParams = new URLSearchParams(window.location.search);
    var searchPageMatcher = new RegExp('\\/pesquisa');
    var tagPageMatcher = new RegExp('\\/tag');
    var urlIsSearchPage = searchPageMatcher.test(window.location.href);
    var urlIsTagPage = tagPageMatcher.test(window.location.href);
    var searchTag = urlIsTagPage && urlParams.get('tag') || '';
    var searchText = urlIsSearchPage && urlParams.get('term') || '';
    filterContext.updateFilter(policyId, {
      date: null,
      departments: [],
      pageRows: pageRows,
      pageStart: pageStart
    });
    filterDataContext.loadSearchEngineData({
      policyId: policyId,
      pageRows: pageRows,
      pageStart: pageStart,
      searchTag: searchTag,
      searchText: searchText
    }, {
      isSearchEngine: true
    });
  };

  (0,react.useEffect)(function () {
    loadSearchEngineData();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

/* harmony default export */ var SearchEngine_index = (SearchEngine);
;// CONCATENATED MODULE: ./components/SectionMore/index.tsx


function SectionMore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SectionMore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SectionMore_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SectionMore_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



 // import MoreButton from 'components/Buttons/MoreButton/MoreButton.index'


var LinkStyled = prensa/* PrensaEngine.styled */.u7.styled('a', {
  align: ['row', 'left', 'middle'],
  cursor: 'pointer',
  width: 'fit-content'
});

var SectionMore = function SectionMore(_ref) {
  var isDesktop = _ref.isDesktop,
      titleColor = _ref.titleColor,
      titleDesktop = _ref.titleDesktop,
      titleMobile = _ref.titleMobile,
      titleTarget = _ref.titleTarget,
      titleLink = _ref.titleLink,
      titleLabel = _ref.titleLabel,
      titleIcon = _ref.titleIcon;
  var responsiveClass = [];
  if (!titleMobile && !isDesktop) return null;

  if (titleMobile && titleDesktop) {
    if (isDesktop) {
      return null;
    }
  } else {
    !isDesktop && titleMobile && responsiveClass.push('mobile');
    isDesktop && titleDesktop && responsiveClass.push('desktop');
  }

  var LinkWrap = function LinkWrap(_ref2) {
    var children = _ref2.children;
    if (!titleLink || titleLink == '') return children;
    var props = titleTarget ? {
      target: '_blank '
    } : {};
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), SectionMore_objectSpread(SectionMore_objectSpread({}, props), {}, {
      href: titleLink,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkStyled, {
        children: children
      })
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    className: "Item ".concat(responsiveClass.join(' ')),
    css: {
      align: ['row', 'right', 'middle'],
      mb: '$4',
      ml: '$4',
      width: '100%',
      'svg path': {
        fill: "$".concat(titleColor)
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWrap, {})
  });
};

/* harmony default export */ var components_SectionMore = (SectionMore);
;// CONCATENATED MODULE: ./components/SectionTitle/index.tsx


function SectionTitle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SectionTitle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SectionTitle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SectionTitle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var SectionTitle_LinkStyled = prensa/* PrensaEngine.styled */.u7.styled('span', {
  align: ['row', 'left', 'middle'],
  cursor: 'pointer',
  width: 'fit-content'
});

var SectionTitle = function SectionTitle(_ref) {
  var isExpanded = _ref.isExpanded,
      isReadMore = _ref.isReadMore,
      isSeeMore = _ref.isSeeMore,
      isVideoBox = _ref.isVideoBox,
      _ref$leftIcon = _ref.leftIcon,
      leftIcon = _ref$leftIcon === void 0 ? true : _ref$leftIcon,
      rightClick = _ref.rightClick,
      _ref$rightIcon = _ref.rightIcon,
      rightIcon = _ref$rightIcon === void 0 ? true : _ref$rightIcon,
      _ref$readMoreLabel = _ref.readMoreLabel,
      readMoreLabel = _ref$readMoreLabel === void 0 ? 'Ver mais' : _ref$readMoreLabel,
      titleColor = _ref.titleColor,
      titleTarget = _ref.titleTarget,
      titleLink = _ref.titleLink,
      titleLabel = _ref.titleLabel,
      titleIcon = _ref.titleIcon;
  var router = (0,next_router.useRouter)();
  var responsiveClass = [];

  var LinkWrap = function LinkWrap(_ref2) {
    var children = _ref2.children;
    if (!titleLink || titleLink == '') return children;
    var props = titleTarget ? {
      target: '_blank '
    } : {};
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), SectionTitle_objectSpread(SectionTitle_objectSpread({}, props), {}, {
      href: titleLink,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_LinkStyled, {
        children: children
      })
    }));
  };

  var iconSetaSeeMore = false;
  var styleColummLeft = {
    align: ['row', 'left', 'middle']
  };
  var styleColummRight = styleColummLeft;
  var styleTitle = {
    color: "$".concat(titleColor),
    fontSize: '18px',
    lineHeight: '25px',
    letterSpacing: '0.4px',
    fontWeight: '500',
    m: '$0'
  };
  var styleExpanded = {};

  if (isExpanded && !isVideoBox && !isSeeMore) {
    styleExpanded = {
      borderTopWidth: '1px',
      borderTopColor: '#e6e6e6',
      borderTopStyle: 'solid',
      paddingTop: '$3'
    };
  }

  if (isSeeMore) {
    leftIcon = false;
    iconSetaSeeMore = true;
    styleExpanded = {
      color: '#000000',
      pt: '$0',
      mb: '$8'
    };
    styleTitle = SectionTitle_objectSpread(SectionTitle_objectSpread({}, styleTitle), {}, {
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400
    });
  }

  if (isVideoBox) {
    leftIcon = false;
    titleIcon = 'IcEsporte';
    styleExpanded = {
      color: '#e6e6e6',
      pt: '$1',
      mb: '$8'
    };
    styleColummLeft = SectionTitle_objectSpread(SectionTitle_objectSpread({}, styleColummLeft), {}, {
      position: 'relative',
      'p::before': {
        content: '_',
        backgroundColor: '#F06C6C',
        color: '#F06C6C',
        position: 'absolute',
        fontSize: '6px',
        lineHeight: '6px',
        left: '0px',
        top: '-20px',
        width: '72px'
      }
    });
    styleTitle = SectionTitle_objectSpread(SectionTitle_objectSpread({}, styleTitle), {}, {
      fontSize: '25px',
      letterSpacing: '0.2px'
    });

    rightClick = function rightClick() {
      return router.push('/videos');
    };
  }

  if (!titleIcon) {
    leftIcon = false;

    if (titleLabel === 'Leia também') {
      styleTitle = SectionTitle_objectSpread(SectionTitle_objectSpread({}, styleTitle), {}, {
        fontSize: '14px',
        fontWeight: 'bold',
        letterSpacing: '0.4px',
        lineHeight: '21px',
        textTransform: 'uppercase'
      });
    }
  }

  var setaName = titleIcon ? titleIcon.replace('Ic', 'IcSeta') : '';

  var iconSeta = SectionTitle_objectSpread({}, (0,useIcon/* useIcon */.b)(titleIcon ? setaName : !setaName ? 'IcSetaEspecial' : ''));

  var titleIconData = (0,useIcon/* useIcon */.b)(titleIcon || '');
  var styleReadMore = {
    align: ['row', 'between', 'middle']
  };
  var departmentPath = get_default()(window, 'location.pathname', '/');
  var isSeeMoreVisible = departmentPath !== titleLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    className: "Item ".concat(responsiveClass.join(' ')),
    css: SectionTitle_objectSpread(SectionTitle_objectSpread({
      align: ['row', 'left', 'bottom'],
      mb: '$4',
      width: '100%'
    }, styleExpanded), styleReadMore),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: styleColummLeft,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWrap, {
        children: [titleIcon && leftIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, SectionTitle_objectSpread({}, titleIconData)), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          as: "h3",
          css: SectionTitle_objectSpread(SectionTitle_objectSpread({}, styleTitle), {}, {
            ml: leftIcon ? '$2' : '$0',
            mr: iconSetaSeeMore ? '$2' : '$0'
          }),
          variant: "sectionTitle-default",
          children: titleLabel
        }), iconSetaSeeMore && /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, SectionTitle_objectSpread({}, titleIconData))]
      })
    }), isExpanded && isReadMore && isSeeMoreVisible && /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: styleColummRight,
      onClick: rightClick,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWrap, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          css: {
            color: "$".concat(titleColor),
            cursor: 'pointer',
            fontSize: '18px',
            lineHeight: '25px',
            letterSpacing: '0.4px',
            fontWeight: '500',
            m: '$0',
            mr: '$2',
            pt: '$0'
          },
          variant: "sectionTitle-default",
          children: readMoreLabel
        }), iconSeta && rightIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, SectionTitle_objectSpread({}, iconSeta))]
      })
    })]
  });
};

SectionTitle.defaultProps = {
  titleColor: 'primary'
};
/* harmony default export */ var components_SectionTitle = (SectionTitle);
;// CONCATENATED MODULE: ./brands/opopular/assets/pageblocks.ts


function pageblocks_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function pageblocks_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? pageblocks_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : pageblocks_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var extractTemplateFromBlock = function extractTemplateFromBlock(props) {
  var object = pageblocks_objectSpread({}, props);

  var blocksTemplates = {
    blockDefault: {
      slotLeftTeaserValue: 'LayoutFeatured',
      slotCenterTeaserValue: 'LayoutDefault',
      slotRightTeaserValue: 'LayoutGrid3',
      slotTemplate: 'Template5050100'
    },
    blockDefaultNoGrid: {
      slotLeftTeaserValue: 'LayoutFeatured',
      slotCenterTeaserValue: 'LayoutDefault',
      slotRightTeaserValue: 'LayoutDefault',
      slotTemplate: 'Template5050'
    },
    blockDefaultFive: {
      slotLeftTeaserValue: 'LayoutDefault',
      slotCenterTeaserValue: 'LayoutDefault',
      slotRightTeaserValue: 'LayoutGrid3',
      slotTemplate: 'Template5050100'
    },
    blockDefaultGrid: {
      slotLeftTeaserValue: 'LayoutGrid3',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'Template100'
    },
    blockInfomercial: {
      slotLeftTeaserValue: 'LayoutGridInfocom',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'Template100'
    },
    blockDefaultSide: {
      slotLeftTeaserValue: 'LayoutGrid4',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'TemplateSideBox'
    },
    blockFeaturedNoImage: {
      slotLeftTeaserValue: 'LayoutFeaturedNoImage',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'Template100'
    },
    blockFeatureImage: {
      slotLeftTeaserValue: 'LayoutFeatured',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'Template100'
    },
    blockSuperFeatureImage: {
      slotLeftTeaserValue: 'LayoutFeatured',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'TemplateSuperManchete'
    },
    blockSuperFeatureRelated: {
      slotLeftTeaserValue: 'LayoutFeaturedImage',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'TemplateSuperManchete'
    },
    blockVideoFeatured: {
      slotLeftTeaserValue: 'LayoutVideoFeatured',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'Template100'
    },
    blockVideoHome: {
      slotLeftTeaserValue: 'LayoutVideoHome',
      slotCenterTeaserValue: 'LayoutVideoHome',
      slotRightTeaserValue: 'LayoutVideoHome',
      slotTemplate: 'TemplateVideos'
    },
    blockVideoLive: {
      slotLeftTeaserValue: 'LayoutVideoLive',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'TemplateVideoLive'
    },
    blockNone: {}
  };
  var selectedTemplate = blocksTemplates[props === null || props === void 0 ? void 0 : props.slotBlockTemplate];

  if (selectedTemplate) {
    object = pageblocks_objectSpread(pageblocks_objectSpread({}, props), selectedTemplate);
  }

  return object;
};


// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__(1469);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
;// CONCATENATED MODULE: ./components/VideoLive/styled.tsx


function VideoLive_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function VideoLive_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VideoLive_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VideoLive_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var CloseProps = {
  color: '#959595',
  cursor: 'pointer',
  fontSize: '14px',
  lineHeight: '20px',
  fontFamily: '$primary',
  my: '$0'
};
var TitleOpenProps = {
  color: '#9A9A9A',
  cursor: 'pointer',
  fontFamily: '$primary',
  fontSize: '18px',
  fontWeight: 400,
  letterSpacing: '0.2px',
  lineHeight: '23px',
  my: '$0',
  display: 'none',
  '@lg': {
    display: 'flex'
  }
};
var SubjectProps = {
  color: '$basicWhite',
  fontSize: '14px',
  fontFamily: '$primary',
  fontWeight: 700,
  letterSpacing: '0.2px',
  lineHeight: '21px',
  pl: '$4',
  ml: '$0',
  mt: '$0',
  mb: '$2',
  '&::before': {
    content: '',
    backgroundColor: '#F06C6C',
    borderRadius: '50%',
    color: '#F06C6C',
    fontSize: '$2',
    lineHeight: '$2',
    height: '$2',
    width: '$2',
    ml: '-$4',
    mt: '6px',
    position: 'absolute'
  },
  '@lg': {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 500,
    textTransform: 'uppercase'
  }
};
var TitleProps = {
  color: '$basicWhite',
  cursor: 'pointer',
  fontSize: '14px',
  fontFamily: '$primary',
  fontWeight: 400,
  letterSpacing: '0.2px',
  lineHeight: '17px',
  ml: '$0',
  mb: '$4',
  my: '$0',
  '@lg': {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 500
  }
};
var TitlePropsExpanded = VideoLive_styled_objectSpread(VideoLive_styled_objectSpread({}, TitleProps), {}, {
  fontSize: '14px',
  lineHeight: '17px',
  '@lg': {
    my: '$4',
    fontSize: '20px',
    fontWeight: 500,
    letterSpacing: '0.2px',
    lineHeight: '24px'
  }
});
var styled_EmbedCode = prensa/* PrensaEngine.styled */.u7.styled('div', {
  align: ['column', 'left', 'top'],
  marginBottom: '$2',
  width: '100%',
  iframe: {
    mb: '$2 !important'
  }
});
var Thumbnail = prensa/* PrensaEngine.styled */.u7.styled('img', {
  align: ['column', 'left', 'top'],
  marginBottom: '$0',
  width: '25%',
  '@lg': {
    height: '100px',
    width: '200px'
  }
});
// EXTERNAL MODULE: ./providers/AutoRefreshProvider/AutoRefreshProvider.tsx
var AutoRefreshProvider = __webpack_require__(1190);
;// CONCATENATED MODULE: ./hooks/useAutoRefresh.ts


function useAutoRefresh() {
  var context = (0,react.useContext)(AutoRefreshProvider/* AutoRefreshContext */.m);

  if (!context) {
    throw new Error("useAutoRefresh must be used within an AutoRefreshProvider");
  }

  return context;
}
;
;// CONCATENATED MODULE: ./components/VideoLive/index.tsx



function VideoLive_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function VideoLive_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VideoLive_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VideoLive_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable @next/next/no-img-element */











var VideoLiveWrap = function VideoLiveWrap(props) {
  var firstEmbedItem = find_default()(props === null || props === void 0 ? void 0 : props.items, {
    inputTemplate: "br.com.atex.templates.articleEmbed.it"
  });
  var firstVideoItem = find_default()(props === null || props === void 0 ? void 0 : props.items, {
    inputTemplate: "br.com.atex.templates.articleVideo.it"
  });
  var embedSelected;

  if (firstVideoItem) {
    embedSelected = firstVideoItem;
  } else if (firstEmbedItem) {
    embedSelected = firstEmbedItem;
  }

  if (!embedSelected) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(VideoLive, VideoLive_objectSpread({}, embedSelected));
};

var VideoLive = function VideoLive(props) {
  var _props$contentData$;

  var _useAutoRefresh = useAutoRefresh(),
      enableAutoRefresh = _useAutoRefresh.enableAutoRefresh,
      disableAutoRefresh = _useAutoRefresh.disableAutoRefresh;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isExpanded = _React$useState2[0],
      setIsExpanded = _React$useState2[1];

  var handleExpand = function handleExpand() {
    setIsExpanded(!isExpanded);
  };

  react.useEffect(function () {
    if (isExpanded) {
      disableAutoRefresh();
    } else {
      enableAutoRefresh();
    }
  }, [isExpanded, disableAutoRefresh, enableAutoRefresh]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      align: ["column", "left", "middle"],
      width: "100%",
      iframe: {
        mb: isExpanded ? "$4" : "$0",
        height: isExpanded ? "320px" : "120px",
        width: isExpanded ? "100%" : "360px"
      },
      "@lg": {
        mt: "$0",
        iframe: {
          height: isExpanded ? "720px" : "120px",
          width: isExpanded ? "100%" : "360px"
        }
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: {
        align: ["row", "left", "top"],
        mb: isExpanded ? "$0" : "$0",
        width: "100%"
      },
      children: [isArray_default()(props === null || props === void 0 ? void 0 : props.contentData) && (props === null || props === void 0 ? void 0 : props.contentData.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Thumbnail, {
        src: "".concat(props === null || props === void 0 ? void 0 : (_props$contentData$ = props.contentData[0]) === null || _props$contentData$ === void 0 ? void 0 : _props$contentData$.url, "?&f=3x2"),
        alt: props === null || props === void 0 ? void 0 : props.contentData.byline,
        onClick: handleExpand,
        style: {
          cursor: "pointer",
          display: isExpanded ? "none" : "block"
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ["column", "left", "top"],
          ml: isExpanded ? "$0" : "$4",
          width: "calc(100% - $4)"
        },
        children: isExpanded ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
            css: {
              display: "none",
              width: "100%",
              "@lg": {
                align: ["column", "between", "top"],
                display: isExpanded ? "flex" : "none"
              }
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionTitle, {
              leftIcon: false,
              isExpanded: isExpanded,
              isVideoBox: true,
              rightIcon: false,
              rightClick: handleExpand,
              titleLabel: "",
              titleIcon: "IcEconomia"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
              as: "p",
              css: VideoLive_objectSpread(VideoLive_objectSpread({}, SubjectProps), {}, {
                mt: "-$8"
              }),
              children: "Ao vivo"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
            css: {
              align: ["row", "between", "top"],
              ml: "$2",
              width: "100%",
              "@lg": {
                display: "none"
              }
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
              as: "p",
              css: SubjectProps,
              children: "Ao vivo"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
              as: "p",
              css: CloseProps,
              onClick: handleExpand,
              children: "X"
            })]
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
          css: {
            width: "100%",
            "@lg": {
              align: ["column", "left", "between"],
              height: "90px"
            }
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
            as: "p",
            css: SubjectProps,
            children: "Ao vivo"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
            as: "h2",
            css: TitleProps,
            onClick: handleExpand,
            children: (props === null || props === void 0 ? void 0 : props.title) || (props === null || props === void 0 ? void 0 : props.name)
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ["column", "left", "middle"],
          display: "none",
          ml: "$2",
          height: "100px",
          width: "260px",
          "@lg": {
            display: isExpanded ? "none" : "flex"
          }
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          as: "h2",
          css: TitleOpenProps,
          onClick: handleExpand,
          id: "expandir-ao-vivo",
          children: "CLIQUE PARA EXPANDIR"
        })
      })]
    }), isExpanded && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VideoWrap, VideoLive_objectSpread({}, props)), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: {
          align: ["row", "between", "middle"],
          width: "100%"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          as: "h2",
          css: TitlePropsExpanded,
          children: (props === null || props === void 0 ? void 0 : props.title) || (props === null || props === void 0 ? void 0 : props.name)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          as: "h2",
          css: TitleOpenProps,
          onClick: handleExpand,
          id: "retrair-ao-vivo",
          children: "CLIQUE PARA RETRAIR"
        })]
      })]
    })]
  });
};

/* harmony default export */ var components_VideoLive = (VideoLive);
// EXTERNAL MODULE: ./node_modules/lodash/chunk.js
var chunk = __webpack_require__(8400);
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);
;// CONCATENATED MODULE: ./components/Wrappers/ColumnistSideBoxWidget.index.tsx





var ColumnistSideBoxWidgetWrapper = function ColumnistSideBoxWidgetWrapper(_ref) {
  var data = _ref.data;
  var groupItems = chunk_default()(data, 3);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%'
      },
      controlDots: {
        mt: '$2',
        mb: '$0'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    children: map_default()(groupItems, function (items, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['column', 'left', 'top'],
          width: 'auto'
        },
        children: map_default()(items, function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
            css: {
              align: ['row', 'center', 'top'],
              width: 'auto'
            },
            children: item
          }, key);
        })
      }, key);
    })
  });
};

/* harmony default export */ var ColumnistSideBoxWidget_index = (ColumnistSideBoxWidgetWrapper);
// EXTERNAL MODULE: ./providers/ArticleScroll/index.tsx + 1 modules
var ArticleScroll = __webpack_require__(6880);
;// CONCATENATED MODULE: ./components/Wrappers/ContinuousReadingWrapper.index.tsx


function ContinuousReadingWrapper_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ContinuousReadingWrapper_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ContinuousReadingWrapper_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContinuousReadingWrapper_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var ARTICLE_VIEWING = 'article:viewing';

var ContinuousReadingWidgetWrapper = function ContinuousReadingWidgetWrapper(props) {
  var itemsData = props.itemsData,
      renderItem = props.renderItem,
      slots = props.slots;
  var articleState = (0,react.useContext)(Article.ArticleContext);
  var articleScrollState = (0,react.useContext)(ArticleScroll.ArticleScrollContext);
  var filterContext = (0,react.useContext)(Filter.FilterContext);
  var items = [];

  if (filterContext.sideBoxFilter === '1') {
    items = articleState.articles.map(function (i, key) {
      var selectedScroll = articleScrollState.state[i.id];

      var ScrollableLink = function ScrollableLink(props) {
        function handleClick(e) {
          e.preventDefault();
          window.scrollTo(0, window.scrollY + 1 + selectedScroll.top * -1);
        }

        return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: props.href,
          onClick: handleClick,
          title: props.title,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
            as: "p",
            css: {
              color: 'black',
              fontSize: '$widget5',
              fontWeight: '$widget5',
              lineHeight: '$widget5'
            },
            children: props.title
          })
        });
      };

      if (selectedScroll !== null && selectedScroll !== void 0 && selectedScroll.viewing) {
        if (window) {
          window.dispatchEvent(new CustomEvent(ARTICLE_VIEWING, {
            detail: {
              article: i,
              viewing: selectedScroll.viewing,
              viewed: selectedScroll.viewed,
              progress: selectedScroll.progress
            }
          }));
        }
      }

      return renderItem({
        item: ContinuousReadingWrapper_index_objectSpread(ContinuousReadingWrapper_index_objectSpread({}, i), {}, {
          customProps: {
            customLink: ScrollableLink,
            'data-selected': selectedScroll === null || selectedScroll === void 0 ? void 0 : selectedScroll.viewing,
            'data-viewed': selectedScroll === null || selectedScroll === void 0 ? void 0 : selectedScroll.viewed,
            style: {
              backgroundImage: "linear-gradient(90deg, hsl(0deg 0% 91%) ".concat(selectedScroll === null || selectedScroll === void 0 ? void 0 : selectedScroll.progress, "%, hsl(0deg 0% 100%) ").concat(selectedScroll === null || selectedScroll === void 0 ? void 0 : selectedScroll.progress, "%)")
            }
          }
        }),
        position: key
      });
    });
  } else if (filterContext.sideBoxFilter === '2') {
    var mostReadItems = [];
    slots.forEach(function (i) {
      var item = itemsData.find(function (d) {
        return d.id === i.replace('contentid/', 'policy:');
      });
      item && mostReadItems.push(item);
    });
    items = mostReadItems.map(function (i, key) {
      return renderItem({
        item: i,
        position: key
      });
    });
  }

  return items;
};

/* harmony default export */ var ContinuousReadingWrapper_index = (ContinuousReadingWidgetWrapper);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js + 2 modules
var embla_carousel_react_esm = __webpack_require__(9382);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Wrappers/RadioWidgetWrapper.index.tsx



function RadioWidgetWrapper_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RadioWidgetWrapper_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RadioWidgetWrapper_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RadioWidgetWrapper_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable @next/next/no-img-element */









var RadioWidgetWrapper = function RadioWidgetWrapper(_ref) {
  var _radios$selectedRadio, _radios$selectedRadio2, _radios$selectedRadio3;

  var data = _ref.data;

  var _useState = (0,react.useState)([]),
      radios = _useState[0],
      setRadios = _useState[1];

  var _useState2 = (0,react.useState)(0),
      selectedRadioIndex = _useState2[0],
      setSelectedRadioIndex = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isPlaying = _useState3[0],
      setIsPlaying = _useState3[1];

  var _useState4 = (0,react.useState)(0.5),
      volume = _useState4[0],
      setVolume = _useState4[1];

  var _useEmblaCarousel = (0,embla_carousel_react_esm/* default */.Z)({
    axis: "y",
    loop: true,
    dragFree: false
  }),
      _useEmblaCarousel2 = (0,slicedToArray/* default */.Z)(_useEmblaCarousel, 2),
      emblaRef = _useEmblaCarousel2[0],
      emblaApi = _useEmblaCarousel2[1];

  var onSelect = (0,react.useCallback)(function () {
    if (!emblaApi) return;
    setSelectedRadioIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);
  var scrollTo = (0,react.useCallback)(function (index) {
    emblaApi && emblaApi.scrollTo(index);
  }, [emblaApi]);
  (0,react.useEffect)(function () {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
    return function () {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onSelect);
    };
  }, [emblaApi, onSelect]);
  (0,react.useEffect)(function () {
    if (data && data.length > 0) {
      var simplified = data.map(function (item) {
        var _firstChild$props$ima, _firstChild$props$ima2;

        var firstChild = item.props.children[0];
        return {
          caption: (_firstChild$props$ima = firstChild.props.image) === null || _firstChild$props$ima === void 0 ? void 0 : _firstChild$props$ima.caption,
          radioThumbnail: (_firstChild$props$ima2 = firstChild.props.image) === null || _firstChild$props$ima2 === void 0 ? void 0 : _firstChild$props$ima2.url,
          title: firstChild.props.title,
          subtitle: firstChild.props.subtitle
        };
      });
      setRadios(simplified);
    }
  }, [data]);
  var scrollPrev = (0,react.useCallback)(function () {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);
  var scrollNext = (0,react.useCallback)(function () {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  var togglePlay = function togglePlay() {
    setIsPlaying(!isPlaying);
  };

  var volumeSliderRef = (0,react.useRef)(null);

  var handleMouseDown = function handleMouseDown(event) {
    var updateVolume = function updateVolume(clientY) {
      if (volumeSliderRef.current) {
        var rect = volumeSliderRef.current.getBoundingClientRect();
        var newVolume = Math.max(0, Math.min(1, 1 - (clientY - rect.top) / rect.height));
        setVolume(Number(newVolume.toFixed(2)));
      }
    };

    updateVolume(event.clientY);

    var handleMouseMove = function handleMouseMove(e) {
      return updateVolume(e.clientY);
    };

    var handleMouseUp = function handleMouseUp() {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  var containerStyle = {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    padding: "0 4%",
    alignItems: "center"
  };
  var volumeContainerStyle = {
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "12px"
  };
  var volumeSliderContainerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "16px"
  };
  var volumeSliderStyle = {
    height: "60px",
    width: "2px",
    backgroundColor: "#e5e7eb",
    borderRadius: "9999px",
    cursor: "pointer",
    position: "relative"
  };
  var volumeFillStyle = {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#646464",
    borderRadius: "9999px",
    height: "".concat(volume * 100, "%")
  };
  var volumeHandleStyle = {
    position: "absolute",
    width: "12px",
    height: "12px",
    backgroundColor: "#646464",
    borderRadius: "50%",
    left: "-5px",
    maxHeight: 100,
    bottom: "calc(".concat(volume * 100, "% - 8px)"),
    cursor: "grab"
  };
  var carouselContainerStyle = {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  };
  var carouselStyle = {
    position: "relative",
    minWidth: "90px",
    height: "130px",
    overflow: "hidden"
  };
  var carouselSlideStyle = {
    flex: "0 0 70%",
    minHeight: "0",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.5rem",
    fontWeight: "bold",
    transition: "opacity 0.3s ease",
    cursor: "pointer"
  };
  var radioTextContainerStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: 90,
    justifyContent: "space-between",
    paddingTop: 6,
    paddingLeft: 4,
    paddingBottom: 6
  };
  var radioTitleStyle = {
    fontFamily: "sans-serif",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 130
  };
  var radioSubtitleStyle = {
    fontFamily: "sans-serif",
    fontSize: "12px",
    fontWeight: "lighter",
    color: "#646464"
  };
  var radioPlayerContainerStyle = {
    display: "flex",
    width: "80%",
    justifyContent: "space-between"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: containerStyle,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: carouselStyle,
      ref: emblaRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: carouselContainerStyle,
        children: radios.map(function (radio, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: RadioWidgetWrapper_index_objectSpread(RadioWidgetWrapper_index_objectSpread({}, carouselSlideStyle), {}, {
              opacity: index === selectedRadioIndex ? 1 : 0.3
            }),
            onClick: function onClick() {
              return scrollTo(index);
            },
            role: "button",
            "aria-label": "Go to slide ".concat(index + 1),
            tabIndex: 0,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              alt: "radio",
              style: {
                backgroundColor: index === selectedRadioIndex ? "#e0e0e0" : "none",
                borderRadius: "8px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                margin: "-100px 0",
                transform: "scale(".concat(index === selectedRadioIndex ? 1 : 0.9, ")"),
                transition: "all 0.3s ease"
              },
              width: 90,
              height: 90,
              src: radio.radioThumbnail
            })
          }, index);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: radioTextContainerStyle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          marginLeft: 10
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          style: radioTitleStyle,
          children: (_radios$selectedRadio = radios[selectedRadioIndex]) === null || _radios$selectedRadio === void 0 ? void 0 : _radios$selectedRadio.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          style: radioSubtitleStyle,
          children: (_radios$selectedRadio2 = radios[selectedRadioIndex]) === null || _radios$selectedRadio2 === void 0 ? void 0 : _radios$selectedRadio2.subtitle
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: radioPlayerContainerStyle,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
          id: "radio-prev",
          icon: {
            alt: "rádio anterior",
            height: "12px",
            src: "/assets/opopular/icons/IcRadioPlayerPrevious.svg",
            width: "12px"
          },
          onClick: scrollPrev
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
          id: "radio-play",
          icon: {
            alt: "play rádio",
            height: "28px",
            width: "28px",
            src: isPlaying ? "/assets/opopular/icons/IcRadioPlayerPause.svg" : "/assets/opopular/icons/IcRadioPlayerPlay.svg"
          },
          onClick: togglePlay
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
          id: "radio-next",
          icon: {
            alt: "próxima rádio",
            height: "12px",
            src: "/assets/opopular/icons/IcRadioPlayerNext.svg",
            width: "12px"
          },
          onClick: scrollNext
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: volumeContainerStyle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: volumeSliderContainerStyle,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          ref: volumeSliderRef,
          style: volumeSliderStyle,
          onMouseDown: handleMouseDown,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: volumeFillStyle
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: volumeHandleStyle
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          marginTop: 4
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          height: 15,
          width: 15,
          src: "/assets/opopular/icons/IcRadioVolMin.svg",
          alt: "\xEDcone de volume"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        display: "none"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, {
        url: (_radios$selectedRadio3 = radios[selectedRadioIndex]) === null || _radios$selectedRadio3 === void 0 ? void 0 : _radios$selectedRadio3.caption,
        playing: isPlaying,
        controls: false,
        volume: volume
      })
    })]
  });
};

/* harmony default export */ var RadioWidgetWrapper_index = (RadioWidgetWrapper);
;// CONCATENATED MODULE: ./components/Wrappers/JogosWidgetWrapper.index.tsx


/* eslint-disable @next/next/no-img-element */






var JogosWidgetWrapper = function JogosWidgetWrapper(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)([]),
      games = _useState[0],
      setGames = _useState[1];

  var _useEmblaCarousel = (0,embla_carousel_react_esm/* default */.Z)({
    loop: false
  }),
      _useEmblaCarousel2 = (0,slicedToArray/* default */.Z)(_useEmblaCarousel, 2),
      emblaRef = _useEmblaCarousel2[0],
      emblaApi = _useEmblaCarousel2[1];

  var gameCardStyle = {
    minWidth: "100%",
    padding: "16px",
    background: "#f9f9f9",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
  };
  var gameTitleStyle = {
    fontFamily: 'Roboto Slab, sans-serif',
    fontSize: 16,
    textTransform: "uppercase",
    fontWeight: "bold",
    overflow: "hidden",
    maxWidth: "100%",
    textAlign: "center",
    marginTop: 8,
    marginBottom: 16
  };
  var gameDetailsStyle = {
    fontFamily: 'Roboto Slab, sans-serif',
    fontSize: 12,
    fontWeight: "bold",
    overflow: "hidden",
    maxWidth: "100%",
    textAlign: "center",
    marginTop: 8,
    marginBottom: 16
  };
  var gameVersusStyle = {
    fontFamily: 'sans-serif',
    fontSize: 28,
    color: "#777"
  };
  var gameBottonLeftStyle = {
    position: "absolute",
    left: 0,
    top: "50%",
    transform: "translateY(-50%)",
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "50%",
    width: 40,
    height: 40,
    cursor: "pointer",
    zIndex: 2
  };
  var gameBottonRightStyle = {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "50%",
    width: 40,
    height: 40,
    cursor: "pointer",
    zIndex: 2
  };
  (0,react.useEffect)(function () {
    if (data && data.length > 0) {
      var parsedGames = data.map(function (item) {
        var _child$props$contentD;

        var child = item.props.children[0];
        var icons = ((_child$props$contentD = child.props.contentData) === null || _child$props$contentD === void 0 ? void 0 : _child$props$contentD.map(function (c) {
          return c.url.replace("jpg", "png");
        })) || [];
        return {
          name: child.props.name,
          slotTemplateCode: child.props.slotTemplateCode,
          icons: icons
        };
      });
      setGames(parsedGames);
    }
  }, [data]);
  var scrollPrev = (0,react.useCallback)(function () {
    return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev();
  }, [emblaApi]);
  var scrollNext = (0,react.useCallback)(function () {
    return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext();
  }, [emblaApi]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    as: "div",
    css: {
      position: "relative",
      padding: "20px",
      overflow: "hidden"
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: scrollPrev,
      style: gameBottonLeftStyle,
      children: "\u25C0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: scrollNext,
      style: gameBottonRightStyle,
      children: "\u25B6"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: emblaRef,
      style: {
        overflow: "hidden"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          display: "flex",
          gap: 16
        },
        children: games.map(function (game, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            style: gameCardStyle,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              style: gameTitleStyle,
              children: game.name
            }), game.icons.length >= 2 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              style: {
                display: "flex",
                alignItems: "center",
                gap: 16
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: game.icons[0],
                alt: "Time A",
                height: 80
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                style: gameVersusStyle,
                children: "X"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: game.icons[1],
                alt: "Time B",
                height: 80
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: gameDetailsStyle,
              children: game.slotTemplateCode
            })]
          }, index);
        })
      })
    })]
  });
};

/* harmony default export */ var JogosWidgetWrapper_index = (JogosWidgetWrapper);
;// CONCATENATED MODULE: ./components/Wrappers/GenericWidgetWrapper.index.tsx








var GenericWidgetWrapper = function GenericWidgetWrapper(_ref) {
  var data = _ref.data;
  var link = get_default()(data[0], 'props.children[0].props.image.byline', '');
  var title = get_default()(data[0], 'props.children[0].props.title', '');
  var subject = get_default()(data[0], 'props.children[0].props.subject', '');
  var colorArray = get_default()(data[0], 'props.children[0].props.image.caption', '').split(", ");
  var imageUrl = get_default()(data[0], 'props.children[0].props.image.url', '');
  var image = get_default()(data[0], 'props.children[0].props.image', '');
  var imageAlt = get_default()(data[0], 'props.children[0].props.image.caption', '');
  var imgSrc = (0,useImageProxy/* useImageProxy */.n)("".concat(imageUrl, "f=3x2&w=2048"), true);

  var isSameDomain = function isSameDomain(url) {
    try {
      var linkUrl = new URL(url);
      var windowUrl = new URL(window.location.href);
      return linkUrl.hostname === windowUrl.hostname;
    } catch (error) {
      return false; // Em caso de erro na análise da URL, assumir que não é o mesmo domínio
    }
  };

  var linkTarget = isSameDomain(link) ? '_self' : '_blank';
  var titleProps = {
    fontFamily: '$primary',
    fontSize: '26px',
    fontWeight: 700,
    lineHeight: '28px',
    color: colorArray[1],
    mt: '$2',
    mb: '$3',
    '@lg': {
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: 0.2
    },
    textAlign: 'left'
  };
  var subjectProps = {
    fontFamily: '$primary',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '24px',
    color: colorArray[1],
    mt: '$2',
    mb: '$3',
    '@lg': {
      fontSize: '18px',
      lineHeight: '22px',
      letterSpacing: 0.2
    },
    textAlign: 'left'
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      align: ['column', 'center', 'middle'],
      width: '100%',
      background: colorArray[0],
      borderRadius: '5px',
      padding: '$2',
      mt: '$1',
      mb: '$1'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        align: ['column', 'left', 'middle'],
        width: '100%'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
        css: subjectProps,
        children: subject
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Link */.rU, {
      bypass: false,
      component: (link_default()),
      componentProps: {
        href: link,
        target: linkTarget,
        legacyBehavior: true
      },
      href: link,
      target: linkTarget,
      css: {
        fontSize: 0,
        width: '100%'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        alt: imageAlt,
        src: imgSrc,
        width: '100%'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['column', 'left', 'middle'],
          width: '100%'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          css: titleProps,
          children: title
        })
      })]
    })]
  });
};

/* harmony default export */ var GenericWidgetWrapper_index = (GenericWidgetWrapper);
;// CONCATENATED MODULE: ./components/Wrappers/TemplateSideBarLeftWrapper.tsx



 // import ClassiRecomend from "../ClassiRecomend";





var TemplateSideBarLeftPageWrapper = function TemplateSideBarLeftPageWrapper(props) {
  var items = props.items,
      policyId = props.policyId,
      renderItem = props.renderItem;
  var filterDataContext = (0,react.useContext)(FilterData.FilterDataContext);
  var slotPolicyId = policyId.length > 0 ? policyId[0].replace("contentid/", "") : "";
  var slotData = filterDataContext.collections[slotPolicyId];
  var slotItemsFromProvider = (slotData === null || slotData === void 0 ? void 0 : slotData.data) || [];
  var itemsToRender = [].concat((0,toConsumableArray/* default */.Z)(items), (0,toConsumableArray/* default */.Z)(slotItemsFromProvider));
  var itemsToRenderLength = itemsToRender.length ? itemsToRender.length - 1 : 0;
  var isLessThanTreeItems = itemsToRenderLength <= 2;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [// FIXME rm classi
    itemsToRenderLength === 0 && null // && <ClassiRecomend />
    , itemsToRender === null || itemsToRender === void 0 ? void 0 : itemsToRender.map(function (i, key) {
      if (isLessThanTreeItems && itemsToRenderLength === key || !isLessThanTreeItems && key === 2) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
            type: "search",
            componentReference: "top",
            data: i
          }), renderItem({
            item: i,
            position: key
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
            type: "search",
            componentReference: "bottom",
            data: i
          })]
        });
      } else {
        return renderItem({
          item: i,
          position: key
        });
      }
    })]
  });
};

/* harmony default export */ var TemplateSideBarLeftWrapper = (TemplateSideBarLeftPageWrapper);
;// CONCATENATED MODULE: ./components/Wrappers/SlotAutoFilterAwareWrapper.index.tsx






var SlotAutoFilterAwareWrapper = function SlotAutoFilterAwareWrapper(props) {
  var items = props.items,
      policyId = props.policyId,
      renderItem = props.renderItem;
  var filterDataContext = (0,react.useContext)(FilterData.FilterDataContext);
  var slotPolicyId = policyId.length > 0 ? policyId[0].replace('contentid/', '') : '';
  var slotData = filterDataContext.collections[slotPolicyId];
  var slotItemsFromProvider = (slotData === null || slotData === void 0 ? void 0 : slotData.data) || [];
  var itemsToRender = [].concat((0,toConsumableArray/* default */.Z)(items), (0,toConsumableArray/* default */.Z)(slotItemsFromProvider));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: itemsToRender.map(function (i, key) {
      return renderItem({
        item: i,
        position: key
      });
    })
  });
};

/* harmony default export */ var SlotAutoFilterAwareWrapper_index = (SlotAutoFilterAwareWrapper);
;// CONCATENATED MODULE: ./components/Wrappers/StoriesSideBoxWidgetWrapper.tsx



var StoriesSideBoxWidgetWrapper = function StoriesSideBoxWidgetWrapper(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel.carousel-slider': {
          align: ['column', 'center', 'middle'],
          overflow: 'inherit',
          width: 'calc(100% - $8)'
        },
        '.carousel.carousel-slider .slider-wrapper': {
          overflow: 'inherit',
          width: '220px'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    showIndicators: false,
    children: data
  });
};

/* harmony default export */ var Wrappers_StoriesSideBoxWidgetWrapper = (StoriesSideBoxWidgetWrapper);
// EXTERNAL MODULE: ./providers/Slots/index.tsx
var Slots = __webpack_require__(3633);
;// CONCATENATED MODULE: ./components/Base/Base.Blocks.tsx


function Base_Blocks_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Base_Blocks_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Base_Blocks_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_Blocks_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var PageBlockComponent = function PageBlockComponent(dataProps) {
  var _templates$, _templates$2, _templates$2$css;

  var assetsState = (0,react.useContext)(Assets.AssetsContext);
  var slotsState = (0,react.useContext)(Slots.SlotsContext);
  var slotLayouts = get_default()(assetsState, 'assets.slotLayouts');
  var templates = get_default()(assetsState, 'assets.templates');

  if (!dataProps || !(dataProps !== null && dataProps !== void 0 && dataProps.isOnline)) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var data = extractTemplateFromBlock(dataProps);
  var wrappers = {};
  var itemsData = get_default()(data, 'items', []);
  var slotAutoLeftElements = get_default()(data, 'slotAutoLeftElements', []);
  var slotAutoCenterElements = get_default()(data, 'slotAutoCenterElements', []);
  var slotAutoRightElements = get_default()(data, 'slotAutoRightElements', []);
  var isSideBoxTabFixed = false;
  var slotLeftComponent = get_default()(data, 'slotLeftComponent', '');

  if (slotLeftComponent === 'ArticleReadMoreList') {
    if (window.innerWidth < 768) {
      return null;
    }

    wrappers['columnCenter'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items, renderItem) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ContinuousReadingWrapper_index, {
            items: items,
            renderItem: renderItem,
            itemsData: itemsData,
            slots: slotAutoCenterElements
          });
        }
      }
    };
  }

  if ((data === null || data === void 0 ? void 0 : data.slotTemplate) === 'TemplateSideBoxJogos') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(JogosWidgetWrapper_index, {
            data: items
          });
        }
      }
    };
  }

  if ((data === null || data === void 0 ? void 0 : data.slotTemplate) === 'TemplateSideBoxRadio') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(RadioWidgetWrapper_index, {
            data: items
          });
        }
      }
    };
  }

  if ((data === null || data === void 0 ? void 0 : data.slotTemplate) === 'TemplateSideBoxGeneric') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(GenericWidgetWrapper_index, {
            data: items
          });
        }
      }
    };
  }

  if ((data === null || data === void 0 ? void 0 : data.slotTemplate) === 'TemplateSideBoxColumnist') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ColumnistSideBoxWidget_index, {
            data: items
          });
        }
      }
    };
  }

  if ((data === null || data === void 0 ? void 0 : data.slotTemplate) === 'TemplateSideBoxStories') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrappers_StoriesSideBoxWidgetWrapper, {
            data: items
          });
        }
      }
    };
  }

  if ((data === null || data === void 0 ? void 0 : data.slotTemplate) === 'TemplateVideoLive') {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(VideoLiveWrap, Base_Blocks_objectSpread({}, data));
        }
      }
    };
  }

  if (data !== null && data !== void 0 && data.slotLeftReadMoreEnabled) {
    wrappers['columnLeft'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items, renderItem) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SlotAutoFilterAwareWrapper_index, {
            policyId: data === null || data === void 0 ? void 0 : data.slotManualTopLeft,
            items: items,
            renderItem: renderItem
          });
        }
      }
    };
  }

  if (data !== null && data !== void 0 && data.slotCenterReadMoreEnabled) {
    wrappers['columnCenter'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items, renderItem) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SlotAutoFilterAwareWrapper_index, {
            policyId: data === null || data === void 0 ? void 0 : data.slotManualTopCenter,
            items: items,
            renderItem: renderItem
          });
        }
      }
    };
  }

  if (data !== null && data !== void 0 && data.slotRightReadMoreEnabled) {
    wrappers['columnRight'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items, renderItem) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SlotAutoFilterAwareWrapper_index, {
            policyId: data === null || data === void 0 ? void 0 : data.slotManualTopRight,
            items: items,
            renderItem: renderItem
          });
        }
      }
    };
  }

  var sideBoxTabsList = slotsState.sideBoxTabsList;
  var sideBoxLeft = find_default()(sideBoxTabsList, {
    name: 'slotLeft'
  });
  var sideBoxCenter = find_default()(sideBoxTabsList, {
    name: 'slotCenter'
  });
  var sideBoxRight = find_default()(sideBoxTabsList, {
    name: 'slotRight'
  });
  var isLeftHidden = get_default()(sideBoxLeft, 'hidden', true);
  var cssLeftHidden = isSideBoxTabFixed && isLeftHidden ? {
    '.Left': {
      display: 'none'
    }
  } : {};
  var isCenterHidden = get_default()(sideBoxCenter, 'hidden', true);
  var cssCenterHidden = isSideBoxTabFixed && isCenterHidden ? {
    '.Center': {
      display: 'none'
    }
  } : {};
  var isRightHidden = get_default()(sideBoxRight, 'hidden', true);
  var cssRightHidden = isSideBoxTabFixed && isRightHidden ? {
    '.Right': {
      display: 'none'
    }
  } : {};
  var slotArray = [slotAutoLeftElements, slotAutoCenterElements, slotAutoRightElements, get_default()(data, 'slotManualTopLeft', []), get_default()(data, 'slotManualTopCenter', []), get_default()(data, 'slotManualTopRight', []), get_default()(data, 'slotManualBottomLeft', []), get_default()(data, 'slotManualBottomCenter', []), get_default()(data, 'slotManualBottomRight', []), get_default()(data, 'slotManualExtra', []), get_default()(data, 'slotManualExtraTop', [])];
  var slotData = [];
  map_default()(slotArray, function (slot) {
    var columnData = [];
    map_default()(slot, function (item) {
      var idToSearch = "".concat(item).replace('contentid/', 'policy:');
      var resultObject = find_default()(itemsData, {
        id: idToSearch
      });

      if (resultObject) {
        columnData.push(resultObject);
      }
    });
    slotData.push(columnData);
  });

  if (data.slotTemplate === 'Template100') {
    if (slotData[0].length == 1) {
      var _slotData$0$;

      var customProps = Base_Blocks_objectSpread({
        local: 'Super Manchete',
        teaserType: 'especial'
      }, (_slotData$0$ = slotData[0][0]) === null || _slotData$0$ === void 0 ? void 0 : _slotData$0$.customProps);

      slotData[0][0].customProps = customProps;
    }
  } else if (data.slotTemplate === 'Template5050100') {
    if (slotData[0].length === 1) {
      var _slotData$0$2;

      var _customProps = Base_Blocks_objectSpread({
        local: 'Manchete',
        teaserType: 'especial'
      }, (_slotData$0$2 = slotData[0][0]) === null || _slotData$0$2 === void 0 ? void 0 : _slotData$0$2.customProps);

      slotData[0][0].customProps = _customProps;
    }

    slotData[1].forEach(function (slot) {
      var _slotData$0$3;

      var customProps = Base_Blocks_objectSpread({
        local: 'Principal',
        teaserType: 'normal'
      }, (_slotData$0$3 = slotData[0][0]) === null || _slotData$0$3 === void 0 ? void 0 : _slotData$0$3.customProps);

      slot.customProps = customProps;
    });
  }

  var ComponentWrapped = function ComponentWrapped(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ComponentSwitch, {
      data: props,
      pageBlockId: data.id
    });
  };

  var slotTemplate = get_default()(data, 'slotTemplate');
  var slotLeftTeaserColor = get_default()(data, 'slotLeftTeaserColor');
  var slotLeftTeaserValue = get_default()(data, 'slotLeftTeaserValue');
  var slotCenterTeaserColor = get_default()(data, 'slotCenterTeaserColor');
  var slotCenterTeaserValue = get_default()(data, 'slotCenterTeaserValue');
  var slotRightTeaserColor = get_default()(data, 'slotRightTeaserColor');
  var slotRightTeaserValue = get_default()(data, 'slotRightTeaserValue');

  if (slotTemplate === 'TemplateSidebarLeft') {
    wrappers['columnCenter'] = {
      slotMiddle: {
        enabled: true,
        component: function component(items, renderItem) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(TemplateSideBarLeftWrapper, {
            policyId: data === null || data === void 0 ? void 0 : data.slotManualTopCenter,
            items: items,
            renderItem: renderItem
          });
        }
      }
    };
  }

  var slotLayoutsStyled = Base_Blocks_objectSpread({}, slotLayouts);

  var templatesStyled = Base_Blocks_objectSpread(Base_Blocks_objectSpread({}, templates), {}, (0,defineProperty/* default */.Z)({}, "".concat(slotTemplate), Base_Blocks_objectSpread(Base_Blocks_objectSpread({}, templates === null || templates === void 0 ? void 0 : templates["".concat(slotTemplate)]), {}, {
    css: Base_Blocks_objectSpread(Base_Blocks_objectSpread({}, templates === null || templates === void 0 ? void 0 : (_templates$ = templates["".concat(slotTemplate)]) === null || _templates$ === void 0 ? void 0 : _templates$.css), {}, {
      container: Base_Blocks_objectSpread(Base_Blocks_objectSpread(Base_Blocks_objectSpread(Base_Blocks_objectSpread({}, templates === null || templates === void 0 ? void 0 : (_templates$2 = templates["".concat(slotTemplate)]) === null || _templates$2 === void 0 ? void 0 : (_templates$2$css = _templates$2.css) === null || _templates$2$css === void 0 ? void 0 : _templates$2$css.container), {}, {
        '.Left .TeaserNumber': {
          backgroundColor: "$".concat(slotLeftTeaserColor)
        },
        '.Left .TeaserSubjectText': {
          color: "$".concat(slotLeftTeaserColor),
          textTransform: 'uppercase'
        },
        '.Left p.TeaserTitleText:before': {
          color: "$".concat(slotLeftTeaserColor)
        },
        '.Center .TeaserNumber': {
          backgroundColor: "$".concat(slotCenterTeaserColor)
        },
        '.Center .TeaserSubjectText': {
          color: "$".concat(slotCenterTeaserColor),
          textTransform: 'uppercase'
        },
        '.Center p.TeaserTitleText:before': {
          color: "$".concat(slotCenterTeaserColor)
        },
        '.Right .TeaserNumber': {
          backgroundColor: "$".concat(slotRightTeaserColor)
        },
        '.Right .TeaserSubjectText': {
          color: "$".concat(slotRightTeaserColor),
          textTransform: 'uppercase'
        },
        '.Right p.TeaserTitleText:before': {
          color: "$".concat(slotRightTeaserColor)
        }
      }, cssLeftHidden), cssCenterHidden), cssRightHidden)
    })
  })));

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
      type: "block",
      componentReference: "top",
      data: data
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* PageBlock */.ib, Base_Blocks_objectSpread(Base_Blocks_objectSpread({}, data), {}, {
      itemComponent: ComponentWrapped,
      slotLeftLayout: slotLeftTeaserValue,
      slotCenterLayout: slotCenterTeaserValue,
      slotRightLayout: slotRightTeaserValue,
      slotLeftColor: slotLeftTeaserColor,
      slotCenterColor: slotCenterTeaserColor,
      slotRightColor: slotRightTeaserColor,
      slotAutoLeftElements: get_default()(slotData, '[0]'),
      slotAutoCenterElements: get_default()(slotData, '[1]'),
      slotAutoRightElements: get_default()(slotData, '[2]'),
      slotManualTopLeft: get_default()(slotData, '[3]'),
      slotManualTopCenter: get_default()(slotData, '[4]'),
      slotManualTopRight: get_default()(slotData, '[5]'),
      slotManualBottomLeft: get_default()(slotData, '[6]'),
      slotManualBottomCenter: get_default()(slotData, '[7]'),
      slotManualBottomRight: get_default()(slotData, '[8]'),
      slotManualExtra: get_default()(slotData, '[9]'),
      slotManualExtraTop: get_default()(slotData, '[10]'),
      slotLayouts: slotLayoutsStyled,
      templates: templatesStyled,
      templateBgColor: get_default()(data, 'slotTemplateColor'),
      wrappers: wrappers
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
      type: "block",
      componentReference: "bottom",
      data: data
    })]
  });
};
/* harmony default export */ var Base_Blocks = (PageBlockComponent);
// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__(928);
var last_default = /*#__PURE__*/__webpack_require__.n(last);
;// CONCATENATED MODULE: ./components/AuthorProfile/index.tsx










function providerAuthorProfileProps(props) {
  var contents = get_default()(props, 'contentData', []);
  var description = get_default()(props, 'slotTemplateCode');
  var title = get_default()(props, 'title');
  var imageId = first_default()(props.slotImageMobileElements);
  var image = imageId && find_default()(contents, {
    id: "policy:".concat(last_default()(imageId.split('/')))
  });
  return {
    description: description,
    title: title,
    image: image
  };
}

var AuthorProfile_AuthorImage = prensa/* PrensaEngine.styled */.u7.styled('img', {
  borderRadius: '50%',
  ml: '0px',
  height: '100px',
  width: '100px',
  mt: '-70px',
  '@lg': {
    mt: '0px',
    ml: '-70px',
    height: '140px',
    width: '140px'
  }
});

var AuthorProfile = function AuthorProfile(props) {
  var _props$customProps, _props$customProps2, _props$customProps2$c;

  var className = (_props$customProps = props.customProps) === null || _props$customProps === void 0 ? void 0 : _props$customProps.className;
  var baseClassName = "AuthorProfile ".concat((props === null || props === void 0 ? void 0 : props.className) || '', " ").concat(className);
  var isDesktop = props === null || props === void 0 ? void 0 : (_props$customProps2 = props.customProps) === null || _props$customProps2 === void 0 ? void 0 : (_props$customProps2$c = _props$customProps2.className) === null || _props$customProps2$c === void 0 ? void 0 : _props$customProps2$c.includes('desktop');
  if (isDesktop) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});

  var _providerAuthorProfil = providerAuthorProfileProps(props),
      description = _providerAuthorProfil.description,
      image = _providerAuthorProfil.image,
      title = _providerAuthorProfil.title;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    className: baseClassName,
    css: {
      backgroundColor: '#f4f4f4',
      align: ['column', 'center', 'middle'],
      px: '$0',
      py: '$4',
      mb: '$6',
      mx: '$3',
      mt: '70px',
      textAlign: 'center',
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['row', 'left', 'middle'],
        px: '$0',
        py: '$4',
        ml: '70px',
        mt: '0px',
        mr: '0px',
        textAlign: 'left',
        width: 'calc(100% - 70px)'
      }
    },
    children: [image && image.url && /*#__PURE__*/(0,jsx_runtime.jsx)(AuthorProfile_AuthorImage, {
      alt: image.caption,
      src: image.url
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      className: baseClassName,
      css: {
        align: ['column', 'center', 'middle'],
        px: '$3',
        textAlign: 'center',
        width: '100%',
        '@lg': {
          align: ['column', 'left', 'middle'],
          px: '$6',
          textAlign: 'left'
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
        css: {
          color: '#4C362B',
          fontFamily: '$primary',
          fontSize: '16px',
          lineHeight: '20px',
          fontWeight: 700,
          letterSpacing: '0.2px',
          my: '$3',
          '@lg': {
            fontSize: '25px',
            lineHeight: '30px',
            mt: '$0'
          }
        },
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
        css: {
          color: '#000000',
          fontFamily: '$primary',
          fontSize: '14px',
          lineHeight: '19px',
          fontWeight: 400,
          letterSpacing: '0.2px',
          my: '$0',
          '@lg': {
            fontSize: '18px',
            lineHeight: '23px'
          }
        },
        children: description
      })]
    })]
  });
};

/* harmony default export */ var components_AuthorProfile = (AuthorProfile);
;// CONCATENATED MODULE: ./components/Scripts/Code.tsx



var Code_EmbedCode = prensa/* PrensaEngine.styled */.u7.styled('div', {
  width: '100%',
  marginBottom: '$12'
});

var ScriptCode = function ScriptCode(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Code_EmbedCode, {
    dangerouslySetInnerHTML: {
      __html: props.slotTemplateCode
    }
  });
};

/* harmony default export */ var Code = (ScriptCode);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
;// CONCATENATED MODULE: ./components/Buttons/DivisorTabsButton.tsx


var _excluded = ["children", "pageBlockId", "slotTemplateId", "numberValue"];

function DivisorTabsButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DivisorTabsButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DivisorTabsButton_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DivisorTabsButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var DivisorTabsButton = function DivisorTabsButton(_ref) {
  var children = _ref.children,
      pageBlockId = _ref.pageBlockId,
      slotTemplateId = _ref.slotTemplateId,
      numberValue = _ref.numberValue,
      otherProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useContext = (0,react.useContext)(Filter.FilterContext),
      sideBoxFilter = _useContext.sideBoxFilter,
      updateSideBoxFilter = _useContext.updateSideBoxFilter;

  var selected = sideBoxFilter === numberValue;
  var styles = {
    button: {
      border: '1px solid #E6E6E6',
      borderTopLeftRadius: '$alternative',
      borderTopRightRadius: '$alternative',
      minHeight: selected ? '59px' : '49px',
      padding: '0px',
      width: '50%'
    },
    label: {
      color: selected ? '$basicBlack' : '#A6A6A6',
      fontFamily: '$primary',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '26px'
    }
  };

  var handleClick = function handleClick() {
    updateSideBoxFilter(numberValue || '1');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Button */.zx, DivisorTabsButton_objectSpread(DivisorTabsButton_objectSpread({
    css: styles,
    onClick: handleClick,
    variant: "ghost",
    labelSpacing: 0
  }, otherProps), {}, {
    children: children
  }));
};

/* harmony default export */ var Buttons_DivisorTabsButton = (DivisorTabsButton);
;// CONCATENATED MODULE: ./hooks/useGCJAnalytics.ts
//TODO: [AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
// quando confirmado a migração, remover refletir remoção do script nos trechos de código que utilizam ele,
// por enquanto só desabilitar.
var WIDGET_TYPES = {
  WHATSAPP: 'Whatsapp',
  CLASSI: 'Classi',
  EDICAO_DIGITAL: 'Edição Digital'
};
var sendAnalytics = function sendAnalytics(event, data) {
  var userEmail = '';
  var copyObj = {};
  Object.assign(copyObj, data);
  cleanPageviewData(copyObj); // Caso seja o filtro de uma busca, ele deve remover alguns dados

  if (event == 'filtrar') {
    cleanPaginacao(copyObj);
    cleanData(copyObj);
  }

  var jsonAnalytics = {
    categoria: 'acao',
    tipo: event,
    dados: copyObj,
    email: userEmail ? userEmail : '',
    url: data.url,
    referrer: data.referrer
  };

  if (window.AnalyticsGJC) {
    window.AnalyticsGJC.filaAnalyticsGJC.push(['enviarEvento', jsonAnalytics]);
  }
};
var enviarPageView = function enviarPageView(data) {
  var jsonPageView = {};

  if (data) {
    jsonPageView = {
      url: data.url,
      contentId: data.contentId,
      referrer: data.referrer || ''
    };
  }

  window.AnalyticsGJC.filaAnalyticsGJC.push(['enviarPageView', jsonPageView]);
};
var enviarClickCarregarMais = function enviarClickCarregarMais(descContentId, carregamento) {
  sendAnalytics('click_carregar_mais', {
    descContentId: descContentId,
    carregamento: carregamento
  });
};
var enviarClickWidget = function enviarClickWidget(widget) {
  sendAnalytics('click_widget', {
    widget: widget
  });
};
var enviarViewWidget = function enviarViewWidget(widget) {
  sendAnalytics('visualizacao_widget', {
    widget: widget
  });
};
var enviarClickItem = function enviarClickItem(itemName, local) {
  sendAnalytics('click_item', {
    itemName: itemName,
    local: local
  });
};
var enviarCardViewAnuncio = function enviarCardViewAnuncio(idAnuncio) {
  sendAnalytics('impressao_do_card_anuncio ', {
    idAnuncio: idAnuncio
  });
};
var enviarScroll = function enviarScroll(porcentagem, contentId) {
  var jsonAnalytics = {
    categoria: 'scroll',
    dados: {
      porcentagem: porcentagem
    },
    contentId: contentId,
    email: '',
    url: '',
    referrer: ''
  };

  if (window.AnalyticsGJC) {
    window.AnalyticsGJC.filaAnalyticsGJC.push(['enviarEvento', jsonAnalytics]);
  }
};
var enviarViewTeaser = function enviarViewTeaser(local, tipoTeaser, pagina) {
  sendAnalytics('visualizacao_teaser', {
    local: local,
    tipoTeaser: tipoTeaser,
    pagina: pagina
  });
};
var enviarClickTeaser = function enviarClickTeaser(local, tipoTeaser, pagina) {
  sendAnalytics('click_teaser', {
    local: local,
    tipoTeaser: tipoTeaser,
    pagina: pagina
  });
};

function cleanPaginacao(obj) {
  delete obj.pagina;
  delete obj.paginado;
  delete obj.qtdRegistros;
}

function cleanPageviewData(obj) {
  delete obj.url;
  delete obj.referrer;
}

function cleanData(obj) {
  for (var propName in obj) {
    if (typeof obj[propName] === 'object') {
      obj[propName] = cleanData(obj[propName]);
    }
  }

  return obj;
}

var initAnalytics = function initAnalytics(siteId, contentId, userEmail) {
  if (false) {}

  (function (window) {
    (function (w, d, s, e, t) {
      w.AnalyticsGJC = w.AnalyticsGJC || {};
      w.AnalyticsGJC.filaAnalyticsGJC = w.AnalyticsGJC.filaAnalyticsGJC || []; // @ts-ignore

      e = d.createElement(s); // @ts-ignore

      e.type = 'text/java' + s; // @ts-ignore

      e.async = 'async'; // @ts-ignore

      e.src = 'https://s3-sa-east-1.amazonaws.com/analytics-gjc/analytics-gjc-min.js'; // @ts-ignore

      t = d.getElementsByTagName(s)[0]; // @ts-ignore

      t.parentNode.insertBefore(e, t);
    })(window, document, 'script');

    window.AnalyticsGJC.filaAnalyticsGJC.push(['definirContentId', contentId]);
    window.AnalyticsGJC.filaAnalyticsGJC.push(['definirSiteId', siteId]);
    userEmail && window.AnalyticsGJC.filaAnalyticsGJC.push(['definirUserEmail', userEmail]);
  })(window);
};
;// CONCATENATED MODULE: ./hooks/useOnScreen.ts


function useOnScreen(ref) {
  var _useState = (0,react.useState)(false),
      isIntersecting = _useState[0],
      setIntersecting = _useState[1];

  var observer = (0,react.useMemo)(function () {
    return new IntersectionObserver(function (_ref) {
      var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
          entry = _ref2[0];

      return setIntersecting(entry.isIntersecting);
    });
  }, [ref]);
  (0,react.useEffect)(function () {
    if (ref.current !== null) {
      observer.observe(ref.current);
    }

    return function () {
      return observer.disconnect();
    };
  }, []);
  return isIntersecting;
}
;// CONCATENATED MODULE: ./components/EditionFeatured/index.tsx










var dataProps = {
  headTitle1: 'Edição Digital'
};

var EditionFeatured = function EditionFeatured(props) {
  var _props$customProps, _props$customProps2, _props$customProps2$c, _props$contentData, _props$contentData$;

  var className = (_props$customProps = props.customProps) === null || _props$customProps === void 0 ? void 0 : _props$customProps.className;
  var baseClassName = "EditionFeatured ".concat((props === null || props === void 0 ? void 0 : props.className) || '', " ").concat(className);
  var isDesktop = props === null || props === void 0 ? void 0 : (_props$customProps2 = props.customProps) === null || _props$customProps2 === void 0 ? void 0 : (_props$customProps2$c = _props$customProps2.className) === null || _props$customProps2$c === void 0 ? void 0 : _props$customProps2$c.includes('desktop');
  var iconVersaoDigitalProps = (0,useIcon/* useIcon */.b)('IcVersaoDigitalCinzaClaro');
  var editionImagePath = (0,useImageProxy/* useImageProxy */.n)(props === null || props === void 0 ? void 0 : (_props$contentData = props.contentData) === null || _props$contentData === void 0 ? void 0 : (_props$contentData$ = _props$contentData[0]) === null || _props$contentData$ === void 0 ? void 0 : _props$contentData$.url, true);
  var editionLink = props === null || props === void 0 ? void 0 : props.slotTemplateCode;
  var ref = (0,react.useRef)(null);
  var isVisible = useOnScreen(ref);
  (0,react.useEffect)(function () {
    if (isVisible) {
      props.handleSendViewEvent(WIDGET_TYPES.EDICAO_DIGITAL);
    }
  }, [isVisible]);
  if (isDesktop) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    ref: ref,
    className: baseClassName,
    css: {
      align: ['column', 'center', 'middle'],
      mb: '$8',
      width: '100%'
    },
    onClick: function onClick() {
      return props.handleSendClickEvent(WIDGET_TYPES.EDICAO_DIGITAL);
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      className: baseClassName,
      css: {
        align: ['column', 'center', 'top'],
        backgroundColor: '#f4f4f4',
        width: '100%'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Typography */.ZT, {
        as: "h2",
        css: {
          align: ['row', 'center', 'middle'],
          color: '#4d4d4d',
          fontSize: '22px',
          fontWeight: 600,
          lineHeight: '24px',
          fontFamily: '$primary',
          mt: '$4',
          mb: '$2',
          pl: '$0',
          width: '100%',
          img: {
            width: '32px'
          },
          span: {
            ml: '$1'
          }
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
          icon: iconVersaoDigitalProps
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: dataProps.headTitle1
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['column', 'center', 'middle'],
          borderTop: '1px solid black',
          width: 'calc(100% - $12)',
          img: {
            mt: '$4',
            mb: '$4',
            width: '168px'
          }
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: editionLink,
          rel: "noreferrer",
          target: "_blank",
          title: "Clique para abrir a Edi\xE7\xE3o Digital",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: editionImagePath,
            alt: "Edi\xE7\xE3o do dia"
          })
        })
      })]
    })
  });
};

/* harmony default export */ var components_EditionFeatured = (EditionFeatured);
;// CONCATENATED MODULE: ./components/Editais/utils.ts


function utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var utils_convertLocaleDate = function convertLocaleDate(timestamp, showWeekDay) {
  var date = new Date(timestamp);

  var options = utils_objectSpread({
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }, showWeekDay && {
    weekday: 'long'
  });

  var dateString = date.toLocaleDateString('pt-BR', options);

  if (showWeekDay) {
    return dateString.replace(/^\w/, function (c) {
      return c.toUpperCase();
    });
  }

  return dateString.replace(/(\d{4})(\s+\d{2}:\d{2})/, '$1');
};
var convertLocaleDateWithoutTime = function convertLocaleDateWithoutTime(timestamp, showWeekDay) {
  var date = new Date(timestamp);

  var options = utils_objectSpread({
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }, showWeekDay && {
    weekday: 'long'
  });

  var dateString = date.toLocaleDateString('pt-BR', options);

  if (showWeekDay) {
    return dateString.replace(/^\w/, function (c) {
      return c.toUpperCase();
    });
  }

  return dateString.replace(/(\d{4})(\s+\d{2}:\d{2})/, '$1');
};
;// CONCATENATED MODULE: ./components/Editais/Editais.index.tsx


function Editais_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Editais_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Editais_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Editais_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var ImageHtml = prensa/* PrensaEngine.styled */.u7.styled('img', {
  border: '1px solid #e6e6e6',
  ml: '0px',
  mt: '0px',
  height: '200px',
  width: '200px'
});
var containerProps = {
  align: ['column', 'left', 'top'],
  width: '100%'
};
var containerTopProps = {
  align: ['column', 'left', 'top'],
  mt: '$4',
  mb: '$8',
  width: '100%',
  '@lg': {
    align: ['row', 'between', 'top']
  }
};
var containerImageProps = {
  align: ['column', 'left', 'top'],
  mb: '$8',
  height: '200px',
  width: '200px',
  '@lg': {
    mb: '$0'
  }
};
var containerHeaderProps = {
  align: ['column', 'left', 'top'],
  width: '100%',
  '@lg': {
    width: 'calc(100% - 220px)'
  }
};
var containerIframeProps = {
  align: ['column', 'left', 'top'],
  mb: '$8',
  width: '100%',
  iframe: {
    height: '100vh',
    maxHeight: '800px',
    width: '100%'
  }
};
var typographyTitleProps = {
  fontFamily: '$primary',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '19px',
  p: '$0',
  m: '$0',
  mb: '$2'
};
var typographyHeadlineProps = {
  fontFamily: '$primary',
  fontSize: '26px',
  fontWeight: 500,
  lineHeight: '30px',
  letterSpacing: '0.2px',
  p: '$0',
  m: '$0',
  mb: '$1'
};
var typographyTextProps = {
  fontFamily: '$primary',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '23px',
  p: '$0',
  m: '$0',
  mb: '$2'
};
var shareSection = {
  content: [{
    id: 'facebookShare',
    alt: 'Compartilhar no Facebook',
    icon: 'IcBotaoFacebookPreto',
    href: 'https://www.facebook.com/sharer/sharer.php?u='
  }, {
    id: 'twitterShare',
    alt: 'Compartilhar no Twitter',
    icon: 'IcBotaoTwitterPreto',
    href: 'https://twitter.com/intent/tweet?text='
  }, {
    id: 'whatsappShare',
    alt: 'Compartilhar no WhatsApp',
    icon: 'IcBotaoWhatsAppPreto',
    href: 'https://api.whatsapp.com/send?text='
  }]
};

var EditaisComponent = function EditaisComponent(props) {
  var shareSectionIcons = (0,useIcon/* useIcon */.b)(shareSection.content.map(function (i) {
    return i.icon;
  }));
  var shareSectionData = shareSectionIcons.map(function (i) {
    return Editais_index_objectSpread(Editais_index_objectSpread({}, i), {}, {
      config: shareSection.content.find(function (s) {
        return s.icon === i.name;
      })
    });
  });

  var _useContext = (0,react.useContext)(Article.ArticleContext),
      articles = _useContext.articles;

  var contentData = get_default()(articles, '[0]', {});
  if (!(contentData !== null && contentData !== void 0 && contentData.id)) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  var articleContentData = get_default()(contentData, 'contentData', []);
  var articleFileIt = 'com.atex.plugins.file.FileContentDataBean';
  var articleImageIt = 'com.atex.standard.image.ImageContentDataBean';
  var articlePdfObject = find_default()(articleContentData, {
    type: articleFileIt
  });
  var articleImgObject = find_default()(articleContentData, {
    type: articleImageIt
  });
  var articleImgFilePath = get_default()(articleImgObject, 'url', false);
  var articlePdfFilePath = get_default()(articlePdfObject, 'filePath', false);
  var articlePdfVersion = get_default()(articlePdfObject, 'version', false);
  var articleFinalUrl = articlePdfFilePath && articlePdfVersion ? "/filedelivery/contentid/".concat(articlePdfVersion, "/").concat(articlePdfFilePath) : false;
  var articleCompany = get_default()(contentData, 'categorization.company', []);
  var articleSector = get_default()(contentData, 'categorization.sector', []);
  var articleType = get_default()(contentData, 'categorization.type', []);
  var publishingTime = get_default()(contentData, 'publishingTime', false);
  var publishedDate = convertLocaleDateWithoutTime(publishingTime, false);
  console.log("contentData", articleCompany);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: containerProps,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: containerTopProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: containerHeaderProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          css: typographyTitleProps,
          as: "h2",
          children: "Empresa:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          css: typographyHeadlineProps,
          as: "h1",
          children: articleCompany[0]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          css: typographyTextProps,
          as: "p",
          children: publishedDate
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          css: typographyTitleProps,
          as: "h2",
          children: "Setor:"
        }), map_default()(articleSector, function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
            css: typographyTextProps,
            as: "h2",
            children: item
          }, key);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          css: typographyTitleProps,
          as: "h2",
          children: "Tipo:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          css: typographyTextProps,
          as: "h2",
          children: articleType[0]
        })]
      })
    }), articleFinalUrl && /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: containerIframeProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
        src: articleFinalUrl
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleShareSectionContainer, {
        children: shareSectionData.map(function (i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
            href: "".concat(i.config.href).concat(location.href),
            icon: {
              src: i.url
            },
            linkProps: {
              target: '_blank',
              title: i.config.alt,
              rel: 'noreferrer'
            },
            css: {
              button: {
                mr: '$2'
              }
            }
          }, i.name);
        })
      })]
    })]
  });
};

/* harmony default export */ var Editais_index = (EditaisComponent);
;// CONCATENATED MODULE: ./components/Buttons/CallToActionButton.index.tsx


var CallToActionButton_index_excluded = ["css", "children", "id"];

function CallToActionButton_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CallToActionButton_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CallToActionButton_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CallToActionButton_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CallToActionButton = function CallToActionButton(_ref) {
  var css = _ref.css,
      children = _ref.children,
      id = _ref.id,
      otherProps = (0,objectWithoutProperties/* default */.Z)(_ref, CallToActionButton_index_excluded);

  var styles = {
    button: CallToActionButton_index_objectSpread({
      border: '1px solid #e6e6e6',
      backgroundColor: '$primary800',
      borderColor: '$primary800',
      borderRadius: '$alternative',
      height: '42px',
      '&:active': {
        backgroundColor: '$primary900',
        borderColor: '$primary900'
      },
      '&:disabled': {
        backgroundColor: '#A7A7A7',
        borderColor: '#A7A7A7'
      }
    }, css === null || css === void 0 ? void 0 : css.button),
    label: CallToActionButton_index_objectSpread({
      color: '$basicWhite',
      fontFamily: '$primary',
      fontSize: '$caption3',
      fontWeight: '$caption3',
      lineHeight: '$caption3'
    }, css === null || css === void 0 ? void 0 : css.label)
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Button */.zx, CallToActionButton_index_objectSpread(CallToActionButton_index_objectSpread({
    variant: "filled",
    css: styles,
    id: id
  }, otherProps), {}, {
    children: children
  }));
};

/* harmony default export */ var CallToActionButton_index = (CallToActionButton);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/esm/index.js + 27 modules
var esm = __webpack_require__(9175);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/Calendar.css
var Calendar = __webpack_require__(9318);
;// CONCATENATED MODULE: ./components/DatePicker/DatePicker.index.tsx


var DatePicker_index_excluded = ["css"];

function DatePicker_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DatePicker_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DatePicker_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DatePicker_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var DatePicker_index_Label = prensa/* PrensaEngine.styled */.u7.styled('label', {});
var StyledCalendar = prensa/* PrensaEngine.styled */.u7.styled(esm/* default */.ZP, {
  border: '1px solid rgb(230, 230, 230)',
  borderRadius: '12px',
  fontFamily: '$primary',
  // <- aqui é uma variável do theme
  padding: '12px',
  backgroundColor: '#fff',
  marginTop: '$4',
  '& .react-calendar__navigation__label': {
    width: '100%',
    textTransform: 'capitalize'
  },
  '& .react-calendar__tile--active': {
    backgroundColor: '$primaryMain',
    // <- variável do seu theme
    color: '#fff'
  },
  '& .react-calendar__tile--now': {
    backgroundColor: '$backgroundMain',
    color: '#000'
  },
  '& .react-calendar__tile:hover': {
    backgroundColor: '$primaryMain',
    color: '#fff'
  },
  '& .react-calendar__tile': {
    borderRadius: '8px'
  },
  '& .react-calendar__month-view__days__day--weekend': {
    color: '#000'
  },
  '& .react-calendar__month-view__days__day--neighboringMonth': {
    color: '#757575'
  } // Outras customizações...

});

var DatePicker = function DatePicker(_ref) {
  var css = _ref.css,
      otherProps = (0,objectWithoutProperties/* default */.Z)(_ref, DatePicker_index_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: css === null || css === void 0 ? void 0 : css.container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DatePicker_index_Label, {
      css: DatePicker_index_objectSpread({
        fontFamily: '$primary',
        fontSize: '16px',
        fontWeight: '500',
        ml: '$3'
      }, css === null || css === void 0 ? void 0 : css.label),
      children: "Por data:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        maxWidth: '280px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCalendar, {
        onChange: function onChange(value) {
          if (value instanceof Date) {
            var _otherProps$onChange;

            (_otherProps$onChange = otherProps.onChange) === null || _otherProps$onChange === void 0 ? void 0 : _otherProps$onChange.call(otherProps, value);
          }
        },
        value: otherProps.selectedDate || new Date(Date.now())
      })
    })]
  });
};

/* harmony default export */ var DatePicker_index = (DatePicker);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(6864);
;// CONCATENATED MODULE: ./components/Input/InputEdital.index.tsx



function InputEdital_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InputEdital_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InputEdital_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InputEdital_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var InputEdital = function InputEdital(_ref) {
  var otherProps = (0,esm_extends/* default */.Z)({}, _ref);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      align: ['column', 'left', 'top']
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styles/* Label */._, {
      css: {
        fontFamily: '$primary',
        fontSize: '16px',
        fontWeight: '500',
        ml: '$3',
        mb: '$1'
      },
      children: "CNPJ"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input_styles/* Input */.I, InputEdital_index_objectSpread({
      maxLength: 18,
      css: {
        borderColor: '#BFBFBF',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '$unset',
        color: '#4D4D4D',
        fontFamily: '$primary',
        fontSize: '16px',
        px: '$3',
        height: '40px',
        mb: '$4',
        width: '100%'
      }
    }, otherProps))]
  });
};

/* harmony default export */ var InputEdital_index = (InputEdital);
;// CONCATENATED MODULE: ./components/Select/Select.index.tsx


function Select_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Select_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Select_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Select_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SelectStyled = prensa/* PrensaEngine.styled */.u7.styled('select', {});
var SelectOption = prensa/* PrensaEngine.styled */.u7.styled('option', {});
var Select_index_Label = prensa/* PrensaEngine.styled */.u7.styled('label', {});

var Select = function Select(_ref) {
  var css = _ref.css,
      disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: Select_index_objectSpread({
      align: ['column', 'left', 'top']
    }, css === null || css === void 0 ? void 0 : css.container),
    children: [label && /*#__PURE__*/(0,jsx_runtime.jsx)(Select_index_Label, {
      htmlFor: id,
      css: Select_index_objectSpread({
        fontFamily: '$primary',
        fontSize: '16px',
        fontWeight: '500',
        ml: '$3',
        mb: '$1'
      }, css === null || css === void 0 ? void 0 : css.label),
      children: label
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectStyled, {
      disabled: disabled,
      css: Select_index_objectSpread({
        backgroundImage: 'url(assets/opopular/icons/IcAbrirPreto.svg)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'calc(100% - 12px)',
        backgroundSize: '13px',
        borderColor: '#BFBFBF',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '$unset',
        color: '#4D4D4D',
        fontFamily: '$primary',
        fontSize: '16px',
        px: '$3',
        height: '40px',
        width: '100%',
        '&:hover': {
          cursor: 'pointer'
        },
        '&:after': {
          display: 'none'
        },
        'appearance': 'none',
        'mozAppearance': 'none',
        'webkitAppearance': 'none'
      }, css === null || css === void 0 ? void 0 : css.select),
      id: id,
      onChange: onChange,
      value: value,
      children: options.map(function (i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectOption, {
          "data-selected": i.selected,
          css: css === null || css === void 0 ? void 0 : css.selectOption,
          children: i.title
        }, i.id);
      })
    })]
  });
};

/* harmony default export */ var Select_index = (Select);
// EXTERNAL MODULE: ./node_modules/lodash/each.js
var each = __webpack_require__(6073);
var each_default = /*#__PURE__*/__webpack_require__.n(each);
;// CONCATENATED MODULE: ./components/Editais/Editais.Filters.tsx


function Editais_Filters_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Editais_Filters_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Editais_Filters_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Editais_Filters_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */













var Editais_Filters_containerProps = {
  align: ['column', 'left', 'top'],
  mb: '$4',
  mr: '$0',
  width: '100%'
};
var selectProps = {
  container: {
    mb: '$4'
  }
};

var prepareTagFilters = function prepareTagFilters(categorization, _ref) {
  var selectedCompany = _ref.selectedCompany,
      selectedSector = _ref.selectedSector;
  var companies = get_default()(categorization, 'company', []);
  var docTypes = get_default()(categorization, 'type', []);
  var sectors = get_default()(categorization, 'sector', []);
  companies.sort(function (a, b) {
    return a.localeCompare(b);
  });
  sectors.sort(function (a, b) {
    return a.localeCompare(b);
  });
  docTypes.sort(function (a, b) {
    return a.localeCompare(b);
  });
  var companiesData = [{
    id: -1,
    title: 'Nenhum',
    selected: true
  }];
  each_default()(companies, function (item, key) {
    return companiesData.push({
      id: key,
      title: item,
      selected: item == (selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.title)
    });
  });
  var sectorsData = [{
    id: -1,
    title: 'Nenhum',
    selected: true
  }];
  each_default()(sectors, function (item, key) {
    return sectorsData.push({
      id: key,
      title: item,
      selected: item == (selectedSector === null || selectedSector === void 0 ? void 0 : selectedSector.title)
    });
  });
  var docTypesData = [{
    id: -1,
    title: 'Nenhum',
    selected: true
  }];
  each_default()(docTypes, function (item, key) {
    return docTypesData.push({
      id: key,
      title: item,
      selected: item == (selectedSector === null || selectedSector === void 0 ? void 0 : selectedSector.title)
    });
  });
  return {
    companies: companies,
    companiesData: companiesData,
    docTypes: docTypes,
    docTypesData: docTypesData,
    sectors: sectors,
    sectorsData: sectorsData
  };
};

var EditaisFilters = function EditaisFilters(props) {
  var filterContext = (0,react.useContext)(Filter.FilterContext);
  var filterDataContext = (0,react.useContext)(FilterData.FilterDataContext);
  var tagFilters = prepareTagFilters(props.categorization, {
    selectedCompany: {},
    selectedSector: {}
  });

  var _useState = (0,react.useState)(null),
      date = _useState[0],
      setDate = _useState[1];

  var _useState2 = (0,react.useState)(tagFilters.companiesData),
      companiesList = _useState2[0],
      setCompaniesList = _useState2[1];

  var _useState3 = (0,react.useState)(tagFilters.docTypesData),
      docTypesList = _useState3[0],
      setdocTypesList = _useState3[1];

  var _useState4 = (0,react.useState)(tagFilters.sectorsData),
      sectorsList = _useState4[0],
      setSectorsList = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      cnpjFilter = _useState5[0],
      setCNPJFilter = _useState5[1];

  var clientSlug = "cbngo";
  var slotPolicyId = props === null || props === void 0 ? void 0 : props.slotTemplateCode;
  var slotFilters = filterContext.filters[slotPolicyId];
  var isFiltersDisabled = filterDataContext.loading;

  var handleCompanyFilter = function handleCompanyFilter(value) {
    var newState = companiesList.map(function (i) {
      return Editais_Filters_objectSpread(Editais_Filters_objectSpread({}, i), {}, {
        selected: i.title === value ? true : false
      });
    });
    setCompaniesList(newState);
  };

  var handleSectorFilter = function handleSectorFilter(value) {
    var newState = sectorsList.map(function (i) {
      return Editais_Filters_objectSpread(Editais_Filters_objectSpread({}, i), {}, {
        selected: i.title === value ? true : false
      });
    });
    setSectorsList(newState);
  };

  var handleDocTypeFilter = function handleDocTypeFilter(value) {
    var newState = docTypesList.map(function (i) {
      return Editais_Filters_objectSpread(Editais_Filters_objectSpread({}, i), {}, {
        selected: i.title === value ? true : false
      });
    });
    setdocTypesList(newState);
  };

  var handleNumberFilter = function handleNumberFilter(value) {
    setCNPJFilter(fromStringToCNPJ(value));
  };

  var handleDate = function handleDate(e) {
    setDate(e);
  };

  var fromStringToCNPJ = function fromStringToCNPJ(value) {
    var x = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
    x = !x[2] ? x[1] : x[1] + '.' + x[2] + (x[3] ? '.' + x[3] : '') + (x[4] ? '/' + x[4] : '') + (x[5] ? '-' + x[5] : '');
    return x;
  };

  var fromCNPJToString = function fromCNPJToString(value) {
    return value.replace(/[^\d]/g, '');
  };

  var handleFilter = function handleFilter() {
    var companiesSelected = companiesList.find(function (i) {
      return i.selected;
    });
    var docTypesSelected = docTypesList.find(function (i) {
      return i.selected;
    });
    var sectorsSelected = sectorsList.find(function (i) {
      return i.selected;
    });
    var categorizationParams = [];
    var dateParams = {};

    if (companiesSelected.id !== -1) {
      categorizationParams.push("tag_ojc.dimension.Editais.Empresa:".concat(companiesSelected.title));
    }

    if (docTypesSelected.id !== -1) {
      categorizationParams.push("tag_ojc.dimension.Editais.Tipo:".concat(docTypesSelected.title));
    }

    if (sectorsSelected.id !== -1) {
      categorizationParams.push("tag_ojc.dimension.Editais.Setor:".concat(sectorsSelected.title));
    }

    if (cnpjFilter !== '') {
      categorizationParams.push("tag_ojc.dimension.Editais.CNPJ:".concat(fromCNPJToString(cnpjFilter)));
    }

    if (date !== null) {
      dateParams['dateStart'] = new Date(new Date(date).setHours(0, 0, 0)).toISOString();
      dateParams['dateEnd'] = new Date(new Date(date).setHours(23, 59, 59)).toISOString();
    }

    filterDataContext.loadSearchEngineData(Editais_Filters_objectSpread(Editais_Filters_objectSpread({}, dateParams), {}, {
      policyId: slotPolicyId,
      categorization: categorizationParams,
      pageRows: slotFilters.pageRows,
      pageStart: 0
    }), {
      isSearchEngine: true
    });
  };

  var handleClearState = function handleClearState() {
    var newCompaniesState = companiesList.map(function (i) {
      return Editais_Filters_objectSpread(Editais_Filters_objectSpread({}, i), {}, {
        selected: i.id === -1 ? true : false
      });
    });
    var newSectorsState = sectorsList.map(function (i) {
      return Editais_Filters_objectSpread(Editais_Filters_objectSpread({}, i), {}, {
        selected: i.id === -1 ? true : false
      });
    });
    var newDocTypeState = docTypesList.map(function (i) {
      return Editais_Filters_objectSpread(Editais_Filters_objectSpread({}, i), {}, {
        selected: i.id === -1 ? true : false
      });
    });
    var newCNPJState = '';
    var newDateState = null;
    setCompaniesList(newCompaniesState);
    setSectorsList(newSectorsState);
    setdocTypesList(newDocTypeState);
    setCNPJFilter(newCNPJState);
    setDate(newDateState);
    filterContext.updateFilter(slotPolicyId, {
      pageStart: 0
    });
    filterDataContext.loadSearchEngineData({
      policyId: slotPolicyId,
      pageRows: slotFilters.pageRows,
      pageStart: 0
    }, {
      isSearchEngine: true
    });
  };

  var selectedCompanyOption = companiesList.find(function (i) {
    return i.selected;
  });
  var selectedSectorsOption = sectorsList.find(function (i) {
    return i.selected;
  });
  var selectedDocTypeOption = docTypesList.find(function (i) {
    return i.selected;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: Editais_Filters_objectSpread({}, Editais_Filters_containerProps),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: {
        mb: '$4',
        width: '100%'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Select_index, {
        id: "Empresa",
        label: "Empresa",
        onChange: function onChange(_ref2) {
          var target = _ref2.target;
          return handleCompanyFilter(target === null || target === void 0 ? void 0 : target.value);
        },
        options: companiesList,
        value: selectedCompanyOption.title,
        disabled: isFiltersDisabled,
        css: selectProps
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Select_index, {
        id: "Setor",
        label: "Setor",
        onChange: function onChange(_ref3) {
          var target = _ref3.target;
          return handleSectorFilter(target === null || target === void 0 ? void 0 : target.value);
        },
        options: sectorsList,
        value: selectedSectorsOption.title,
        disabled: isFiltersDisabled,
        css: selectProps
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Select_index, {
        id: "Tipo",
        label: "Tipo",
        onChange: function onChange(_ref4) {
          var target = _ref4.target;
          return handleDocTypeFilter(target === null || target === void 0 ? void 0 : target.value);
        },
        options: docTypesList,
        value: selectedDocTypeOption.title,
        disabled: isFiltersDisabled,
        css: selectProps
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InputEdital_index, {
        id: "CNPJ",
        onChange: function onChange(_ref5) {
          var target = _ref5.target;
          return handleNumberFilter(target === null || target === void 0 ? void 0 : target.value);
        },
        placeholder: "00.000.000/0000-00",
        type: "string",
        value: cnpjFilter,
        disabled: isFiltersDisabled
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DatePicker_index, {
        selectedDate: date || new Date(Date.now()),
        onChange: handleDate
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CallToActionButton_index, {
      disabled: isFiltersDisabled,
      onClick: handleFilter,
      css: {
        button: {
          mb: '$4',
          width: '100%',
          backgroundColor: clientSlug == 'daqui' ? '$secondaryMain' : '$primary800'
        }
      },
      children: "Filtrar"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CallToActionOutlinedButton_index/* default */.Z, {
      disabled: isFiltersDisabled,
      onClick: handleClearState,
      css: {
        button: {
          height: '42px',
          width: '100%',
          '&:disabled': {
            borderColor: 'rgb(167, 167, 167)',
            backgroundColor: '$basicWhite'
          }
        },
        label: {
          color: isFiltersDisabled ? 'rgb(167, 167, 167)' : clientSlug == 'daqui' ? '$secondaryMain' : '$primaryMain'
        }
      },
      children: "Limpar Filtros"
    })]
  });
};

/* harmony default export */ var Editais_Filters = (EditaisFilters);
;// CONCATENATED MODULE: ./components/Editais/Editais.Teaser.tsx







var Editais_Teaser_containerProps = {
  align: ['column', 'left', 'top'],
  mt: '$2',
  mb: '$6',
  width: '100%'
};
var Editais_Teaser_typographyHeadlineProps = {
  fontFamily: '$primary',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '19px',
  p: '$0',
  m: '$0',
  mb: '$1'
};

var EditaisTeaser = function EditaisTeaser(props) {
  var _props$customProps, _props$customProps$cl;

  var isDesktop = props === null || props === void 0 ? void 0 : (_props$customProps = props.customProps) === null || _props$customProps === void 0 ? void 0 : (_props$customProps$cl = _props$customProps.className) === null || _props$customProps$cl === void 0 ? void 0 : _props$customProps$cl.includes('desktop');
  if (isDesktop) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  var articleId = (0,lodash.get)(props, 'id', '').replace('policy:', '');
  var articleCompany = (0,lodash.get)(props, 'title', (0,lodash.get)(props, 'name', ''));
  var articleHref = "item-".concat(articleId);
  var articleLinkPath = (0,lodash.get)(window, 'location.pathname', '/');
  var publishingTime = (0,lodash.get)(props, 'publishingTime', false);
  var publishedDate = convertLocaleDateWithoutTime(publishingTime, false);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: Editais_Teaser_containerProps,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Link */.rU, {
      component: props.customLink,
      componentProps: props.customLinkProps,
      href: "".concat(articleLinkPath, "/").concat(articleHref),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Typography */.ZT, {
        css: Editais_Teaser_typographyHeadlineProps,
        as: "p",
        children: [publishedDate, " | ", articleCompany]
      })
    })
  });
};

/* harmony default export */ var Editais_Teaser = (EditaisTeaser);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var lib_esm = __webpack_require__(4853);
;// CONCATENATED MODULE: ./components/FaleConosco/select.options.ts
var selectionOption = [{
  value: 'Atendimento ao assinante',
  label: "Atendimento ao assinante"
}, {
  value: 'Comunicar erros',
  label: "Comunicar erros"
}, {
  value: 'Quero anunciar no impresso',
  label: "Quero anunciar no impresso"
}, {
  value: 'Quero anunciar no site',
  label: "Quero anunciar no site"
}, {
  value: 'Classificados',
  label: "Classificados"
}, {
  value: 'Sugestão de pauta',
  label: "Sugestão de pauta"
}, {
  value: 'Fale com a redação',
  label: "Fale com a redação"
}, {
  value: 'Trabalhe conosco',
  label: "Trabalhe conosco"
}, {
  value: 'Política de privacidade',
  label: "Política de privacidade"
}, {
  value: 'Outros',
  label: "Outros"
}];
;// CONCATENATED MODULE: ./components/FaleConosco/Inputs.tsx




function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function Inputs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Inputs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Inputs_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Inputs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var InputArea = function InputArea(_ref) {
  var onChange = _ref.onChange,
      onKeyPress = _ref.onKeyPress,
      css = _ref.css;

  var _useState = (0,react.useState)(''),
      recaptchaToken = _useState[0],
      setRecaptchaToken = _useState[1];

  var _useState2 = (0,react.useState)(''),
      formattedFone = _useState2[0],
      setFormattedFone = _useState2[1];

  var _useState3 = (0,react.useState)('Outros'),
      selectedOption = _useState3[0],
      setSelectedOption = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      name = _useState4[0],
      setName = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      email = _useState5[0],
      setEmail = _useState5[1];

  var _useState6 = (0,react.useState)(''),
      message = _useState6[0],
      setMessage = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      loading = _useState7[0],
      setLoading = _useState7[1];

  var _useState8 = (0,react.useState)({
    name: name,
    email: email,
    message: message
  }),
      input = _useState8[0],
      setInput = _useState8[1];

  var handleInputChange = function handleInputChange(fieldName, value) {
    setInput(function (prevState) {
      return Inputs_objectSpread(Inputs_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, fieldName, value));
    });
  };

  var selectChange = function selectChange(event) {
    var value = event.target.value;
    setSelectedOption(value);
  };

  var formatPhone = function formatPhone(fone) {
    var numbers = fone.replace(/\D/g, '');

    if (numbers.length <= 2) {
      return numbers;
    }

    if (numbers.length === 10) {
      if (numbers[2] !== '9') {
        numbers = numbers.slice(0, 2) + '9' + numbers.slice(2);
      }

      return "(".concat(numbers.slice(0, 2), ") ").concat(numbers.slice(2, 6), "-").concat(numbers.slice(6, 10));
    } else if (numbers.length === 11) {
      return "(".concat(numbers.slice(0, 2), ") ").concat(numbers.slice(2, 7), "-").concat(numbers.slice(7, 11));
    }

    return numbers;
  }; // ...


  var handleSelect = function handleSelect() {
    switch (selectedOption) {
      case 'Atendimento ao assinante':
        return 'atendimento-ao-assinante@opopular.com.br';

      case 'Comunicar erros':
        return 'comunicar-erros@opopular.com.br';

      case 'Quero anunciar no impresso':
        return 'quero-anunciar@opopular.com.br';

      case 'Quero Anunciar no site':
        return 'gerenciadigital@gjccorp.com.br';
      // FIXME rm classi

      case 'Classificados':
        return ['classificados@opopular.com.br', 'classitel@ojc.com.br', 'opecdigital@gjccorp.com.br'];

      case 'Sugestão de pauta':
        return 'sugestao-de-pauta@opopular.com.br';

      case 'Fale com a redação':
        return 'fale-com-a-redacao@opopular.com.br';

      case 'Trabalhe conosco':
        return 'trabalhe-conosco@opopular.com.br';

      case 'Política de privacidade':
        return 'dpo@gjccorp.com.br';

      case 'Outros':
        return 'outros@opopular.com.br';

      default:
        return 'outros@popular.com.br';
    }
  };

  var clearStates = function clearStates() {
    setEmail('');
    setMessage('');
    setName('');
    setFormattedFone('');
    setInput({
      name: '',
      email: '',
      message: ''
    });
    setSelectedOption('Outros');
  };

  var handleChangeFone = function handleChangeFone(e) {
    var fone = e.target.value;
    var formattedFone = formatPhone(fone);
    setFormattedFone(formattedFone);
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      var missingFields, _iterator, _step, field, storeId, queryParams, sendMailUrl, response;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              missingFields = [];

              if (!input.name) {
                missingFields.push("nome");
              }

              if (!input.email) {
                missingFields.push("email");
              }

              if (!selectedOption) {
                missingFields.push("assunto");
              }

              if (!input.message) {
                missingFields.push("mensagem");
              }

              if (!formattedFone) {
                missingFields.push("telefone");
              }

              if (!recaptchaToken) {
                missingFields.push("recaptcha");
              }

              if (!(missingFields.length > 0)) {
                _context.next = 12;
                break;
              }

              _iterator = _createForOfIteratorHelper(missingFields);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  field = _step.value;
                  react_toastify_esm/* toast.info */.Am.info("O campo ".concat(field, " \xE9 obrigat\xF3rio"));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              return _context.abrupt("return");

            case 12:
              if (!(input.email && input.name && input.message && recaptchaToken)) {
                _context.next = 35;
                break;
              }

              _context.prev = 13;
              setLoading(true);
              storeId = getStoreId();
              queryParams = query_string/* default.stringify */.Z.stringify({
                from: input.email,
                text: "\n            Assunto: ".concat(selectedOption, "\n            Nome: ").concat(input.name, ",\n            E-mail: ").concat(input.email, ",\n            Telefone/Celular: ").concat(formattedFone, ",\n            Mensagem: ").concat(input.message, ",\n          "),
                subject: selectedOption,
                to: handleSelect(),
                contactName: input.name,
                customPhone: formattedFone,
                storeId: storeId
              });
              sendMailUrl = "/service-sendmail/api/send-mail?".concat(queryParams);
              _context.next = 20;
              return fetch(sendMailUrl);

            case 20:
              response = _context.sent;

              if (response.ok) {
                _context.next = 23;
                break;
              }

              throw new Error('Algo deu errado, por favor, tente novamente');

            case 23:
              _context.next = 25;
              return response.json();

            case 25:
              react_toastify_esm/* toast.success */.Am.success('Email enviado com sucesso!');
              clearStates();
              _context.next = 32;
              break;

            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](13);
              console.error(_context.t0);

            case 32:
              _context.prev = 32;
              setLoading(false);
              return _context.finish(32);

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[13, 29, 32, 35]]);
    }));

    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleRecaptcha = function handleRecaptcha(token) {
    setRecaptchaToken(token);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      align: ['column', 'left', 'middle'],
      width: '100%',
      '@lg': {
        maxWidth: '904px'
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styles/* Input */.I, {
      onChange: function onChange(e) {
        return handleInputChange('name', e.target.value);
      },
      name: "name",
      onKeyPress: onKeyPress,
      placeholder: "Nome",
      required: true,
      type: "text",
      value: input.name,
      css: Inputs_objectSpread({
        borderColor: '#E6E6E6',
        borderRadius: '$default',
        borderStyle: 'solid',
        borderWidth: '1px',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'calc(100% - 16px)',
        backgroundPositionY: '50%',
        color: '#4D4D4D',
        fontFamily: '$primary',
        fontSize: '16px',
        fontWeight: '$headline6',
        lineHeight: '$headline6',
        height: '45px',
        px: '$4',
        pr: '$13',
        mb: '$4',
        width: '100%'
      }, css === null || css === void 0 ? void 0 : css.input)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: {
        align: ['column', 'center', 'middle'],
        width: '100%',
        '@lg': {
          maxWidth: '904px',
          align: ['row', 'left', 'middle']
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styles/* Input */.I, {
        onChange: function onChange(e) {
          return handleInputChange('email', e.target.value);
        },
        name: "email",
        onKeyPress: onKeyPress,
        placeholder: "E-mail",
        type: "text",
        value: input.email,
        css: Inputs_objectSpread({
          borderColor: '#E6E6E6',
          borderRadius: '$default',
          borderStyle: 'solid',
          borderWidth: '1px',
          backgroundRepeat: 'no-repeat',
          backgroundPositionX: 'calc(100% - 16px)',
          backgroundPositionY: '50%',
          color: '#4D4D4D',
          fontFamily: '$primary',
          fontSize: '16px',
          fontWeight: '$headline6',
          lineHeight: '$headline6',
          height: '45px',
          px: '$4',
          mb: '$4',
          width: '100%',
          '@lg': {
            display: 'flex',
            mr: '$4',
            width: 'calc(301px - 16px)'
          }
        }, css === null || css === void 0 ? void 0 : css.input)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input_styles/* Input */.I, {
        onChange: handleChangeFone,
        onKeyPress: onKeyPress,
        placeholder: "Telefone",
        value: formattedFone,
        type: "text",
        css: Inputs_objectSpread({
          borderColor: '#E6E6E6',
          borderRadius: '$default',
          borderStyle: 'solid',
          borderWidth: '1px',
          backgroundRepeat: 'no-repeat',
          backgroundPositionX: 'calc(100% - 16px)',
          backgroundPositionY: '50%',
          color: '#4D4D4D',
          fontFamily: '$primary',
          fontSize: '16px',
          fontWeight: '$headline6',
          lineHeight: '$headline6',
          height: '45px',
          width: '100%',
          mb: '$4',
          px: '$4',
          '@lg': {
            mr: '$4',
            width: 'calc(301px - 16px)'
          }
        }, css === null || css === void 0 ? void 0 : css.input)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['row', 'left', 'middle'],
          mb: '$4',
          width: '100%',
          '@lg': {
            width: '301px'
          },
          'select': {
            background: 'white',
            border: '1px solid #E6E6E6',
            borderRadius: '3px',
            color: '#4D4D4D',
            fontFamily: '$primary',
            fontSize: '16px',
            height: '48px',
            paddingLeft: '4px',
            width: '100%',
            '@lg': {
              width: '301px'
            }
          }
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("select", {
          onChange: selectChange,
          children: selectionOption.map(function (item, key) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
              value: item.value,
              selected: true,
              children: item.label
            }, key);
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
      onChange: function onChange(e) {
        return handleInputChange('message', e.target.value);
      },
      name: "message" // onKeyPress={onKeyPress}
      ,
      placeholder: "Mensagem",
      value: input.message,
      className: "textarea__assine",
      style: {
        borderColor: '#E6E6E6',
        borderRadius: '4px',
        borderStyle: 'solid',
        borderWidth: '1px',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'calc(100% - 16px)',
        backgroundPositionY: '50%',
        color: '#4D4D4D',
        fontSize: '16px',
        fontWeight: '$headline6',
        lineHeight: '$headline6',
        height: '109px',
        marginTop: 16,
        marginBottom: 16,
        width: '100%',
        padding: 16,
        resize: 'none',
        paddingTop: '10px',
        paddingBottom: '90px',
        fontFamily: 'Fira Sans Condensed'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: {
        align: ['column', 'center', 'middle'],
        gap: '$4',
        width: '100%',
        '@lg': {
          align: ['row', 'right', 'middle'],
          maxWidth: '904px'
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          marginRight: '$35'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib_esm/* default */.Z, {
          sitekey: "6LeB6tokAAAAAMt6LRItLaFnoeHBPR1h5zSw25Cr" || 0,
          onChange: handleRecaptcha,
          style: {
            width: 190
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Button */.zx, {
        onClick: handleSubmit,
        id: "enviar-contato",
        variant: "outlined",
        css: {
          button: {
            background: '#164194',
            borderRadius: '10px',
            height: '40px',
            paddingLeft: '$9',
            paddingRight: '$9',
            marginBottom: '$0',
            width: '120px'
          },
          label: {
            color: 'white',
            fontFamily: '$primary',
            fontSize: '14px',
            fontWeight: '600',
            textTransform: 'capitalize'
          }
        },
        children: loading ? 'CARREGANDO...' : "Enviar"
      })]
    })]
  });
};

/* harmony default export */ var Inputs = (InputArea);
;// CONCATENATED MODULE: ./components/FaleConosco/DropDown.styled.tsx



var ContainerHeader = function ContainerHeader(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    onClick: onClick,
    css: {
      align: ['row', 'between', 'middle'],
      borderBottom: '1px solid #E6E6E6',
      cursor: 'pointer',
      mt: '$4',
      mb: '$3',
      width: '100%'
    },
    children: children
  });
};
var DropDownText = function DropDownText(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    css: {
      color: '#4D4D4D',
      fontFamily: '$primary',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '16.8px'
    },
    children: children
  });
};
var DropDownTitle = function DropDownTitle(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    css: {
      color: '#000',
      fontFamily: '$primary',
      fontSize: '16px',
      lineHeight: '19.2px',
      fontWeight: 400
    },
    children: children
  });
};
;// CONCATENATED MODULE: ./components/FaleConosco/DropDownItem.tsx











var GroupTocantins = function GroupTocantins(_ref) {
  var children = _ref.children,
      title = _ref.title;

  var formatEmails = function formatEmails(emails) {
    if (!emails) return null;
    return emails.split(';').map(function (email, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [email.trim(), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
      }, index);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: {
      my: '$5',
      width: '100%'
    },
    children: (0,lodash.map)(children, function (data, key) {
      switch (title) {
        case 'Publicidade Legal':
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: formatEmails(data === null || data === void 0 ? void 0 : data.pub_legal)
            })
          }, key);

        case 'Sugestão de pauta':
          return /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
            children: data === null || data === void 0 ? void 0 : data.sugestao_pauta
          });

        case 'Fale com a redação':
          return /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
            children: data === null || data === void 0 ? void 0 : data.fale_redacao
          });

        case 'Trabalhe conosco':
          return /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
            children: data === null || data === void 0 ? void 0 : data.trabalhe_conosco
          });

        case 'Politica de Privacidade':
          return /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
            children: data === null || data === void 0 ? void 0 : data.politica_privacidade
          });

        case 'Atendimento ao anunciante':
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.atendimento_anunciante
            })
          }, key);

        default:
          return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
      }
    })
  });
};

var GroupOPopular = function GroupOPopular(_ref2) {
  var children = _ref2.children,
      title = _ref2.title;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: {
      my: '$5',
      width: '100%'
    },
    children: (0,lodash.map)(children, function (data, key) {
      switch (title) {
        // FIXME rm classi
        case 'Anuncie no Classi':
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.anuncie_telefone
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.anuncie_email
            })]
          }, key);

        case 'Vendas de assinatura':
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.vendas_telefone
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.vendas_horario
            })]
          }, key);

        case 'Atendimento ao assinante':
          return /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
            children: data === null || data === void 0 ? void 0 : data.assinante_telefone
          }, key);

        case 'Atendimento ao anunciante':
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.anunciante_telefone
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.anunciante_email
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.anunciante_horario
            })]
          }, key);

        case 'Atendimento Classificados, Editais e Anúncios':
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.classificados_telefone
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.classificados_email
            })]
          }, key);

        case 'Sucursal São Paulo':
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.sucursal_sp_celular
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.sucursal_sp_email
            })]
          }, key);

        case 'Sucursal Distrito Federal':
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.sucursal_df_celular
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.sucursal_df_email
            })]
          }, key);

        case 'Política de Privacidade':
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.politica_telefone
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropDownText, {
              children: data === null || data === void 0 ? void 0 : data.politica_email
            })]
          }, key);
      }
    })
  });
};

var DropDownItem = function DropDownItem(_ref3) {
  var children = _ref3.children,
      title = _ref3.title;

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var iconUp = (0,useIcon/* useIcon */.b)('IcArrowUp');
  var iconDown = (0,useIcon/* useIcon */.b)('IcArrowDown');
  var slugValue = (0,lodash.get)(children, 'contatos.slug', '');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ContainerHeader, {
      onClick: function onClick() {
        return setOpen(!open);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DropDownTitle, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        onClick: function onClick() {
          return setOpen(!open);
        },
        icon: open ? iconUp : iconDown
      })]
    }), open && (slugValue === 'tocantins' ? /*#__PURE__*/(0,jsx_runtime.jsx)(GroupTocantins, {
      title: title,
      children: children
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(GroupOPopular, {
      title: title,
      children: children
    }))]
  });
};

/* harmony default export */ var FaleConosco_DropDownItem = (DropDownItem);
;// CONCATENATED MODULE: ./components/FaleConosco/DropDown.tsx







var DropDownArea = function DropDownArea(props) {
  var slugValue = (0,lodash.get)(props, "strings.contatos.slug", '');

  if (slugValue === 'tocantins') {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: {
        align: ['column', 'left', 'middle'],
        width: '100%',
        '@lg': {
          maxWidth: '904px'
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
        title: "Publicidade Legal",
        children: props.strings
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
        title: "Sugest\xE3o de pauta",
        children: props.strings
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
        title: "Fale com a reda\xE7\xE3o",
        children: props.strings
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
        title: "Trabalhe conosco",
        children: props.strings
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
        title: "Politica de Privacidade",
        children: props.strings
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
        title: "Atendimento ao anunciante",
        children: props.strings
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      align: ['column', 'left', 'middle'],
      width: '100%',
      '@lg': {
        maxWidth: '904px'
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
      title: "Anuncie no Classi",
      children: props.strings
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
      title: "Vendas de assinatura",
      children: props.strings
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
      title: "Atendimento ao assinante",
      children: props.strings
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
      title: "Atendimento ao anunciante",
      children: props.strings
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
      title: "Atendimento Classificados, Editais e An\xFAncios",
      children: props.strings
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
      title: "Sucursal S\xE3o Paulo",
      children: props.strings
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
      title: "Sucursal Distrito Federal",
      children: props.strings
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FaleConosco_DropDownItem, {
      title: "Pol\xEDtica de Privacidade",
      children: props.strings
    })]
  });
};

/* harmony default export */ var DropDown = (DropDownArea);
;// CONCATENATED MODULE: ./components/FaleConosco/index.tsx







var FaleConosco = function FaleConosco(props) {
  var getTextStrings = function getTextStrings() {
    var objectFromTemplate = {};

    try {
      objectFromTemplate = JSON.parse(props === null || props === void 0 ? void 0 : props.slotTemplateCode);
    } catch (e) {
      objectFromTemplate = {
        strings: {}
      };
    }

    return objectFromTemplate;
  };

  var strings = getTextStrings();

  var shouldRenderDropDown = function shouldRenderDropDown() {
    if (!strings || typeof strings !== 'object') return false;
    var keys = Object.keys(strings);
    if (keys.length === 0) return false;

    if (keys.length === 1 && keys[0] === 'strings' && Object.keys(strings.strings || {}).length === 0) {
      return false;
    }

    return true;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      align: ['column', 'left', 'middle'],
      px: '$4',
      mb: '$4',
      width: '100%',
      '@lg': {
        maxWidth: '904px'
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: "h1",
      css: {
        color: '#000',
        fontFamily: '$primary',
        fontSize: '18px',
        lineHeight: '21.6px',
        fontWeight: 500,
        mb: '$5',
        mt: '$10'
      },
      children: "Fale conosco"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      css: {
        color: '#000',
        fontFamily: '$primary',
        fontSize: '16px',
        lineHeight: '21.6px',
        fontWeight: 400,
        mb: '$4'
      },
      children: "Utilize este formul\xE1rio para enviar-nos coment\xE1rios, sugest\xF5es ou cr\xEDticas."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Inputs, {}), shouldRenderDropDown() && /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown, {
      strings: strings
    })]
  });
};

/* harmony default export */ var components_FaleConosco = (FaleConosco);
;// CONCATENATED MODULE: ./components/Expediente/PrivacyPolicy.index.tsx
// @ts-nocheck



var MainDiv = prensa/* PrensaEngine.styled */.u7.styled('div', {
  align: ['column', 'left', 'top'],
  fontFamily: '$primary',
  my: '$22',
  maxWidth: '940px',
  width: '100%'
});
var Heading1 = prensa/* PrensaEngine.styled */.u7.styled('h1', {
  fontSize: '30px',
  fontWeight: 700,
  lineHeight: '36px',
  mt: '$0',
  mb: '$4'
});
var Heading2 = prensa/* PrensaEngine.styled */.u7.styled('h2', {
  fontSize: '25px',
  fontWeight: 700,
  lineHeight: '30px',
  mt: '$8',
  mb: '$4'
});
var Heading3 = prensa/* PrensaEngine.styled */.u7.styled('h3', {
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: '22px',
  my: '$4'
});
var Paragraph = prensa/* PrensaEngine.styled */.u7.styled('p', {
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '24px',
  mt: '$0',
  mb: '$4'
});

var PagePolicy = function PagePolicy() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading1, {
      children: "Pol\xEDtica de Privacidade do Grupo Jaime C\xE2mara"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Esta Política de Privacidade foi atualizada em 10/03/2023.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'O Grupo Jaime Câmara* é formado por diversos veículos de comunicação, sediados nos Estados de Goiás e Tocantins, atuando em diversos segmentos como rádio, televisão, jornal e plataformas digitais, com milhares de telespectadores, ouvintes e consumidores, estando profundamente comprometido com a proteção e privacidade de seus Dados Pessoais.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Como principal e maior Grupo de comunicação nestes Estados, a privacidade e proteção de Dados são de extrema importância e esta declaração de Privacidade detalha as políticas do Grupo Jaime Câmara com relação ao manuseio de informações de identificação pessoal ("Informação Pessoal") enviadas ou de alguma forma coletadas pelos websites, aplicativos móveis e /ou autorizações para o uso de conteúdo ou direito de imagem, coletivamente designados como "Serviços")'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Assim quando acessar, interagir e ou utilizar algum dos produtos disponibilizados pelo Grupo Jaime Câmara, os Dados serão coletados, utilizados, compartilhados e armazenados de acordo com os termos desta Política de Privacidade.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Informações pessoais que coletamos:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Informações pessoais são informações que podem ser usadas para identificar um indivíduo (“Informações Pessoais” ou “Dados Pessoais”). Coletamos Informações Pessoais sempre que os Serviços são utilizados '
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'As Informações Pessoais coletadas incluem informações fornecidas diretamente por indivíduos ou parceiros para o enriquecimento e validação das informações.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'A coleta de Informações Pessoais aqui descritas é necessária para o uso dos serviços. Essas informações incluem, mas não está limitada a:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Informações do indivíduo, como nome, sexo, data nascimento, RG, CPF, telefone, login e senha para cesso nos produtos digitais).'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Informação de contato (como endereço de e-mail, número de telefone, região de residência).'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Informações sobre pedidos e pagamentos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Caso você seja assinante, além dos Dados de cadastro, coletamos seus Dados de cobrança, conforme fornecidos por você no momento da assinatura'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Coletamos outras informações, como:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Endereço IP e informações sobre o dispositivo usado para acessar os Serviços.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Como e quais serviços são usados.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Informações fornecidas a nós por meios como mídias sociais ou quando você entrar em contato conosco através do nosso site'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Dados de Navegação nos produtos digitais: quando você acessa nossos Sites e Aplicativos coletamos Dados da sua navegação: sua geolocalização; seu endereço de IP; informações do dispositivo de acesso (como identificador da unidade, identificador de publicidade, nome e tipo de sistema operacional); informação de conexão; tipo do seu navegador e as páginas e conteúdos que você acessou;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Coletamos seus Dados quando você interage com nossos produtos (digitais, rádios, tv ou jornais) e canais de atendimento por: nossas redes sociais, WhatsApp, pesquisas, formulários, e-mails, chat, call center newsletters, comentários, votações, promoções, eventos, sorteios, concursos culturais e entrevistas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Também coletamos ou compilamos outras informações sobre você (como informações de grupos demográficos) que não o identificam. Podemos usar ou compartilhar qualquer outra informação com terceiros para qualquer finalidade legal.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- O Grupo Jaime Câmara não tem intenção em tratar Dados Sensíveis¹, podendo eventualmente, ocorrer o processamento de tais Dados dependendo das informações que você fornecer voluntariamente.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Uso de Cookies'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'O Grupo Jaime Câmara utiliza certas ferramentas para coletar informações sobre os usuários que navegam em nosso site ou aplicativos. Essas ferramentas usam cookies que são pequenos arquivos de texto armazenados no disco rígido do computador de um usuário ou em seu telefone celular. Os cookies são usados, entre outras coisas, para melhorar o desempenho do site/APP, fornecer opções de visualização personalizadas, compilar relatórios estatísticos sobre a atividade do site/APP, para redução de fraudes ou para fins de segurança. Também usamos cookies para reconhecer clientes ou visitantes anteriores do nosso site ou para preencher previamente os formulários do site.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Essas informações podem ser divulgadas a terceiros para fornecer qualquer uma das atividades mencionadas acima em nome do Grupo Jaime Câmara'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Para saber mais sobre cookies, incluindo instruções específicas do navegador sobre como restringir ou bloquear cookies, acesse http://www.allaboutcookies.org'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Lembre-se, porém, que sem cookies, os usuários podem não conseguir tirar o máximo proveito de todos os recursos do nosso site ou aplicativos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Como usamos as Informações Pessoais e outras informações'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'O uso e a divulgação de Informações Pessoais variam de acordo com o relacionamento de uma parte com o Grupo Jaime Câmara, em geral sendo utilizadas para fornecer serviços a você, nos comunicar com você, prover sua segurança e proteger direitos, personalizar sua experiência, aprimorar e desenvolver novos produtos e serviços, cumprir nossas obrigações regulatórias,  entre outras.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'O Grupo Jaime Câmara usa principalmente essas informações para fornecer os Serviços e recursos relacionados e para:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Facilitar o processamento de transações de pagamento'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Responder a solicitações e consultas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Fornecer serviços de suporte de envio de informações administrativas, como alterações em nossos termos, condições e políticas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Administrar promoções ou campanhas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Facilitar a funcionalidade de compartilhamento social.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Analisar e monitorar o uso dos serviços e fazer melhorias.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Ajudar a proteger os Serviços, evitar fraudes e reforçar nossas políticas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Ajudar a personalizar nossos serviços.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Comunicar sobre outros serviços do Grupo Jaime Câmara ou de nossos afiliados ou de terceiros.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Para fazer contato, diretamente ou através de um fornecedor terceirizado, para preencher uma pesquisa ou questionário.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Compilar informações para uso de forma agregada e não identificada'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Realizar análise e pesquisa de Dados, auditar, desenvolver novos produtos, identificar tendências de uso, determinar a eficácia de nossas campanhas promocionais e operar e expandir nossas atividades de negócios.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Realizar outras atividades com consentimento.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Caso você tenha qualquer dúvida sobre como os seus Dados Pessoais estão sendo coletados e utilizados, recomendamos que você entre em contato conosco pelo e-mail protecaodedados@tvanhanguera.com.br'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Como tratamos Dados de menores'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Sabemos o quanto é importante a privacidade e proteção dos Dados de menores.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'O Grupo Jaime Câmara não realiza a coleta e o tratamento de Dados Pessoais de crianças sem o devido consentimento fornecido por um dos pais ou responsável legal.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Quais empresas do Grupo Jaime Câmara são as controladoras dos seus Dados'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'As empresas do Grupo Jaime Câmara² são as controladoras de seus Dados e compartilham infraestrutura e sistemas que são integrados.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Como compartilhamos informações pessoais'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'O Grupo Jaime Câmara poderá operar em conjunto com outras empresas em diversas atividades, inclusive para hospedagem de Dados, analytics e medição de audiência, sendo assim reservado direito de compartilhar suas informações com as empresas parceiras. Será adotado, sempre que possível, mecanismos de anonimização desses Dados, visando preservar ao máximo a sua privacidade e a integridade de seus Dados Pessoais.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Compartilharemos apenas Informações Pessoais, conforme descrito nesta política. Especificamente, podemos compartilhar informações pessoais:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Conforme necessário para executar os Serviços e concluir transações de pagamento,com Instituições Financeiras, Provedores de Meios de Pagamento, Integradores de Meios de Pagamento e Empresas de Cartões de Crédito, parceiros de análises de Dados e crédito;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Com empresas e fornecedores que nos ajudam a operar nossos negócios, fornecendo serviços como hospedagem de sites, rastreamento de fraudes, análise de dados, tecnologia da informação e fornecimento de infraestrutura relacionada, atendimento ao cliente, entrega de e-mail, auditoria e outros serviços similares.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Com terceiros patrocinadores e anunciantes de promoções ou concursos em que o consentimento foi dado.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Podemos compartilhar seus Dados com parceiros, com empresas de marketing, com utilização de sistemas de análises de Dados, mailing, notificações, com o intuito de  direcionar conteúdo e anúncios de acordo com seus interesses através de Dados comportamentais e Dados sobre o uso dos produtos (analytics), assim havendo o compartilhamento entre o Grupo Jaime Câmara e empresas parceiras.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Com autoridades governamentais, com a finalidade de cumprir determinações legais, judiciais e administrativas, como responder a intimações ou outros pedidos de órgãos públicos e governamentais, incluindo leis e outras obrigações legais fora do país de residência de uma parte.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Para proteger nossos direitos, operações ou propriedade, ou os de nossos usuários.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Investigar, impedir ou tomar medidas relacionadas a atividades ilegais em potencial ou suspeitas, fraudes, ameaças à segurança pessoal de qualquer pessoa ou violações dos termos e condições do Serviço.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Com outras empresas que controlam, são controladas ou estão sob controle comum do Grupo Jaime Câmara, que oferecem suporte ao fornecimento de Serviços de transação ou relacionamento com uma parte. Isso inclui todas empresas controladas pelo Grupo.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Com um comprador de toda ou uma unidade Grupo (ou a maioria dos ativos da Grupo Jaime Câmara), uma fusão, aquisição ou reorganização interna.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '- Com quaisquer terceiros, desde que com consentimento.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Observe que qualquer informação publicada em áreas públicas, como em nossas páginas de mídia social, pode ser vista por outros visitantes.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Transferência internacional da Dados.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Os usuários podem optar por não nos fornecer informações pessoais quando você usa nosso (s) site (s) ou aplicativo (s) móvel. No entanto, se a solicitação de informações não for identificada como opcional e o usuário optar por não fornecer as informações pessoais necessárias, o usuário poderá não conseguir usar os recursos do site ou aplicativo móvel.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Os usuários podem optar por não receber e-mails promocionais seguindo o link de cancelamento de inscrição nessas mensagens de e-mail.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Os usuários podem optar por não receber mensagens de texto SMS das empresas do Grupo Jaime Câmara respondendo STOP a qualquer mensagem.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Os usuários podem configurar seu navegador para rejeitar cookies ou para notificá-lo quando um cookie é definido. No entanto, se você rejeitar cookies, os Serviços podem não funcionar corretamente.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Direitos do Titular'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'De acordo com a legislação, segue relação de direitos que o titular dos Dados poderá requisitar:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'I - confirmação da existência de tratamento;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'II - acesso aos Dados;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'III - correção de Dados incompletos, inexatos ou desatualizados;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'IV - anonimização, bloqueio ou eliminação de Dados desnecessários, excessivos ou tratados em desconformidade com o disposto nesta Lei;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'V - portabilidade dos Dados a outro fornecedor de serviço ou produto, mediante requisição expressa, de acordo com a regulamentação da autoridade nacional, observados os segredos comercial e industrial;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'VI - eliminação dos Dados pessoais tratados com o consentimento do titular, exceto nas hipóteses previstas na LGPD;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'VII - informação das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de Dados;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'VIII - informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'IX - revogação do consentimento, nos termos da LGPD;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Acessando ou editando informações pessoais'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'O Grupo Jaime Câmara pode ser contatado no endereço de e-mail na parte inferior desta política para solicitar acesso ou atualizarmos ou corrigir as Informações Pessoais coletadas por nossos Serviços. Observe que, de acordo com as leis atuais, a O Grupo Jaime Câmara pode reter informações pessoais para fins de auditoria, para solucionar problemas, ajudar com investigações, aplicar nossas políticas ou cumprir com os requisitos legais. Observe que não somos responsáveis ​​por permitir a revisão ou a atualização ou exclusão de informações pessoais fornecidas a terceiros, incluindo qualquer aplicativo móvel, plataforma de mídia social ou provedor de serviços sem fio. '
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Terceiros e serviços vinculados'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'O Grupo Jaime Câmara não é responsável pelas políticas e práticas de coleta, uso e divulgação (incluindo as práticas de segurança de Dados) de outras organizações, incluindo quaisquer Informações Pessoais divulgadas a outras organizações por meio ou em conexão com os Serviços.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'A inclusão de um link no site ou aplicativo do Grupo Jaime Câmara não implica o endosso do site ou serviço vinculado pelo Grupo Jaime Câmara '
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Alterações nesta Política de Privacidade'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Podemos alterar esta política de privacidade a qualquer momento, publicando uma política de privacidade atualizada.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Período de retenção'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Reteremos as Informações Pessoais somente pelo período necessário para cumprir os objetivos descritos nesta política, a menos que um período de retenção mais longo seja exigido ou permitido pela lei ou regulamento aplicável.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Para determinar o período de retenção adequado para os Dados Pessoais, consideramos a quantidade, a natureza e a sensibilidade de tais Dados, o risco potencial de danos decorrentes do uso não autorizado ou da divulgação de seus Dados Pessoais, a finalidade do processamento e se podemos alcançar tais propósitos por outros meios, e os requisitos legais aplicáveis.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Como protegemos seus Dados?'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Utilizamos providências técnicas, administrativas e organizacionais para proteger seus Dados Pessoais contra perda, uso não autorizado ou outros abusos. Os Dados são armazenados em um ambiente operacional seguro que não é acessível ao público. Além disso possuímos regras de boas práticas e de governança de Dados, buscando afastar qualquer tipo de ilicitude, quando do tratamento de Dados Pessoais, mitigando as possibilidades de uso indevido, interferência, perda, acesso não autorizado ou até a divulgação de informações armazenadas. '
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Assim procuramos disponibilizar as melhores práticas de segurança da informação, com o desenvolvimento de sistemas confiáveis de identificação eletrônica e autenticação dos titulares dos Dados, para evitar acessos não autorizados. Buscamos verificar a precisão a autorização de pessoas que tenham ou solicitem acesso à base de Dados e sistemas do Grupo Jaime Câmara; registro de todas as etapas de processamento dos Dados dentro dos sistemas, adoção de procedimentos preventivos contra incidentes de segurança da informação, além de encriptação e anonimização Dados Pessoais sempre que possível.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Como entrar em contato com o Grupo Jaime Câmara sobre suas dúvidas e questões de privacidade'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Se você tiver dúvidas ou comentários sobre nossas práticas de privacidade ou se desejar que o Grupo Jaime Câmara corrija suas informações armazenadas em seus sistemas, envie sua solicitação por e-mail para:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'protecaodedados@gjccorp.com.br'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Assunto: Política de Privacidade'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading3, {
      children: 'Alterações'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: 'Esta Política de Privacidade pode passar por alterações, assim recomendamos a visita periódica nesta página para o devido conhecimento de eventuais alterações '
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '¹ Art. 5, inciso II da Lei 13.709/18 (LGPD): Art. 5º Para os fins desta Lei, considera-se: II - dado pessoal sensível: dado pessoal sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural; Em resumo, dados sensíveis são dados sobre temas mais delicados, que podem sujeitar seu titular a práticas discriminatórias. '
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: '² O Grupo Jaime Câmara é composto por diversas empresas, e dentre elas estão: Televisão Anhanguera S.A, TV Tocantins Ltda, Televisão Riviera Ltda, SPC - Sistema Paranaíba De Comunicações Ltda, Televisão Pirapitinga Ltda, TV Luziânia Ltda, Televisão Planalto Central Ltda, Televisão Rio Formoso Ltda, Centro Norte De Comunicação Ltda, Televisão Anhanguera De Araguaína Ltda, Rádio Anhanguera S.A, Rádio Araguaia Ltda, Rádio Executiva Ltda, Rádio Som de Gurupi Ltda, Rádio Padre Luso Ltda, Rádio Som Juventude Ltda, J. Câmara & Irmãos S.A, Anhanguera Comercio e Serviços Ltda, Empreendimentos Imobiliários Rio Vermelho Ltda, Instituto Jaime Câmara Ltda,.'
    })]
  });
};

/* harmony default export */ var PrivacyPolicy_index = (PagePolicy);
// EXTERNAL MODULE: ./components/ClickableAsset/ClickableAsset.index.tsx
var ClickableAsset_index = __webpack_require__(6454);
;// CONCATENATED MODULE: ./components/Footer/Footer.index.tsx


function Footer_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Footer_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Footer_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Footer_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var FooterComponent = function FooterComponent() {
  var assetsContext = (0,react.useContext)(Assets.AssetsContext);
  var _assetsContext$assets = assetsContext.assets.footer,
      css = _assetsContext$assets.css,
      data = _assetsContext$assets.data;
  var icons = (0,useIcon/* useIcon */.b)(data.socialNetworks.map(function (i) {
    return i.icon;
  }));
  var textStyle = {
    color: '$basicWhite',
    fontFamily: '$primary',
    fontSize: '$paragraphPaywall',
    fontWeight: '$paragraphPaywall',
    lineHeight: '$paragraphPaywall'
  };
  (0,react.useEffect)(function () {
    var _tp$experience;

    var tp = window.tp || [];
    tp === null || tp === void 0 ? void 0 : (_tp$experience = tp.experience) === null || _tp$experience === void 0 ? void 0 : _tp$experience.execute();
  });

  var SlotMiddle = function SlotMiddle() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: {
        align: ['column', 'center', 'middle'],
        width: '100%',
        '@xl': {
          align: ['row', 'between', 'middle'],
          maxWidth: '1280px'
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: {
          align: ['column', 'center', 'middle'],
          '@xl': {
            align: ['row', 'left', 'middle']
          }
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          as: "span",
          css: Footer_index_objectSpread(Footer_index_objectSpread({}, textStyle), {}, {
            mb: '$4',
            '@xl': {
              mb: '$0'
            }
          }),
          children: data.leftText
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
          css: {
            align: ['row', 'left', 'middle'],
            mx: '$2',
            'a': {
              m: '$1'
            }
          },
          children: data.socialNetworks.map(function (i, k) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ClickableAsset_index/* default */.Z, {
              alt: i.title,
              src: icons[k].url,
              href: i.href,
              target: i.target,
              height: "",
              width: ""
            }, i.id);
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['column', 'center', 'middle'],
          'a': {
            m: '$4'
          },
          '@xl': {
            align: ['row', 'left', 'middle']
          }
        },
        children: data.navMenu.map(function (i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: i.href,
            target: i.target,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
              as: "span",
              css: textStyle,
              children: i.title
            })
          }, i.id);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
        as: "span",
        css: Footer_index_objectSpread(Footer_index_objectSpread({}, textStyle), {}, {
          display: 'none',
          '@xl': {
            display: 'flex'
          }
        }),
        children: data.rightText
      })]
    });
  };

  var SlotBottom = function SlotBottom() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      as: "span",
      css: Footer_index_objectSpread(Footer_index_objectSpread({}, textStyle), {}, {
        display: 'flex',
        '@xl': {
          display: 'none'
        }
      }),
      children: data.rightText
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Footer */.$_, {
    slotMiddle: SlotMiddle,
    slotBottom: SlotBottom,
    css: css
  });
};

/* harmony default export */ var Footer_index = (FooterComponent);
;// CONCATENATED MODULE: ./components/Scripts/PianoOffer.tsx








var ScriptPiano = function ScriptPiano(props) {
  var _useKeycloak = (0,ssr_lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var handleLogin = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return keycloak === null || keycloak === void 0 ? void 0 : keycloak.login({
                redirectUri: "".concat(window.location.href)
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error("Error during login:", _context.t0);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function handleLogin() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    var _tp$experience;

    var tp = window.tp || [];
    tp.push(["setUseTinypassAccounts", false]);
    tp.push(["setUsePianoIdUserProvider", false]);
    tp.push(["setUsePianoIdLiteUserProvider", true]);
    tp.push(["addHandler", "loginRequired", function (params) {
      if (keycloak) {
        tp.push(["setExternalJWT", (0,ecryption/* decrypt */.p)(keycloak === null || keycloak === void 0 ? void 0 : keycloak.token)]);
        tp.offer.startCheckout(params);
      } else {
        handleLogin();
      }
    }]);
    (_tp$experience = tp.experience) === null || _tp$experience === void 0 ? void 0 : _tp$experience.execute();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "assine-offers",
      style: {
        width: "100%"
      }
    })
  });
};

/* harmony default export */ var PianoOffer = (ScriptPiano);
;// CONCATENATED MODULE: ./components/Scripts/PianoPerfil.tsx








var PianoPerfil = function PianoPerfil(props) {
  var _useKeycloak = (0,ssr_lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var handleLogin = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return keycloak === null || keycloak === void 0 ? void 0 : keycloak.login({
                redirectUri: "".concat(window.location.href)
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error('Error during login:', _context.t0);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function handleLogin() {
      return _ref.apply(this, arguments);
    };
  }();

  function initPiano() {
    var tp = window.tp || [];
    tp.push(["init", function () {
      tp.experience.execute();
    }]);
    tp.push(["setUseTinypassAccounts", false]);
    tp.push(["setUsePianoIdUserProvider", false]);
    tp.push(["setUsePianoIdLiteUserProvider", true]);
    tp.push(["addHandler", "loginRequired", function (params) {
      handleLogin();
    }]);
  }

  function showUserPianoInfo() {
    var _tp$experience;

    var tp = window.tp || [];

    if (keycloak) {
      var _tp$pianoId;

      (_tp$pianoId = tp.pianoId) === null || _tp$pianoId === void 0 ? void 0 : _tp$pianoId.loginByToken((0,ecryption/* decrypt */.p)(keycloak.token));
    } else {
      handleLogin();
    }

    tp.push(["init", function () {
      tp.myaccount.show({
        displayMode: "inline",
        containerSelector: "#my-account"
      });
    }]);
    (_tp$experience = tp.experience) === null || _tp$experience === void 0 ? void 0 : _tp$experience.execute();
  }

  (0,react.useEffect)(function () {
    initPiano();
    showUserPianoInfo();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "my-account",
      style: {
        width: "100%",
        maxWidth: "1280px"
      }
    })
  });
};

/* harmony default export */ var Scripts_PianoPerfil = (PianoPerfil);
;// CONCATENATED MODULE: ./components/SearchMore/SearchMore.index.tsx
/* eslint-disable react-hooks/exhaustive-deps */
 // import { enviarClickCarregarMais } from 'hooks/useGCJAnalytics'








var SearchMoreBox = function SearchMoreBox(props) {
  var clientSlug = "cbngo";
  var filterContext = (0,react.useContext)(Filter.FilterContext);
  var filterDataContext = (0,react.useContext)(FilterData.FilterDataContext);
  var isLoading = filterDataContext.loading;
  var isDisabled = isLoading || filterDataContext.totalItems <= filterContext.filters.pageStart;
  var templatePolicyId = props === null || props === void 0 ? void 0 : props.slotTemplateCode;
  var templateFilters = filterContext.filters[templatePolicyId] || {};
  var templateData = filterDataContext.collections[templatePolicyId] || {};
  var templateTotalItems = templateData.totalItems || 0;
  var templatePageStart = templateFilters.pageStart || 0;
  var templatePageRows = templateFilters.pageRows || 1;
  var paginationLimit = templatePageStart + templatePageRows >= templateTotalItems;

  var handleMore = function handleMore() {
    var urlParams = new URLSearchParams(window.location.search);
    var searchPageMatcher = new RegExp('\\/pesquisa');
    var tagPageMatcher = new RegExp('\\/tag');
    var urlIsSearchPage = searchPageMatcher.test(window.location.href);
    var urlIsTagPage = tagPageMatcher.test(window.location.href);
    var searchTag = urlIsTagPage && urlParams.get('tag') || '';
    var searchText = urlIsSearchPage && urlParams.get('term') || ''; //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // if(!window.AnalyticsGJC.loadMoreCurrentPage) {
    //   window.AnalyticsGJC.loadMoreCurrentPage = 0;
    // }

    var contentId = (0,lodash.get)(props, 'id', '').replace('policy:', ''); //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // enviarClickCarregarMais(contentId, ++window.AnalyticsGJC.loadMoreCurrentPage);

    filterContext.updateFilter(templatePolicyId, {
      departments: templateFilters.departments,
      pageRows: templateFilters.pageRows,
      pageStart: templatePageStart + templatePageRows
    });
    filterDataContext.loadSearchEngineData({
      dateStart: templateFilters.date ? new Date(new Date(templateFilters.date).setHours(0, 0, 0)).toISOString() : null,
      dateEnd: templateFilters.date ? new Date(new Date(templateFilters.date).setHours(23, 59, 59)).toISOString() : null,
      departments: templateFilters.departments,
      policyId: templatePolicyId,
      pageRows: templateFilters.pageRows,
      pageStart: templatePageStart + templatePageRows,
      searchTag: searchTag,
      searchText: searchText
    }, {
      isPaginated: true
    });
  };

  if (!templatePolicyId || paginationLimit === true) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(CallToActionOutlinedButton_index/* default */.Z, {
    onClick: handleMore,
    id: "carregar-mais-noticias",
    disabled: isDisabled,
    css: {
      button: {
        mb: '$4',
        width: '100%',
        '&:disabled': {
          borderColor: 'rgb(167, 167, 167)',
          backgroundColor: '$basicWhite'
        }
      },
      label: {
        color: isDisabled ? 'rgb(167, 167, 167)' : clientSlug == 'daqui' ? '$secondaryMain' : '$primaryMain'
      }
    },
    children: isLoading ? 'CARREGANDO MAIS NOTÍCIAS...' : 'CARREGAR MAIS NOTÍCIAS'
  });
};

/* harmony default export */ var SearchMore_index = (SearchMoreBox);
;// CONCATENATED MODULE: ./components/SearchFilter/Search.Filter.tsx



function Search_Filter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Search_Filter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Search_Filter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Search_Filter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/rules-of-hooks */

















var actionButtonsStyle = {
  button: {
    height: '42px',
    width: '100%'
  }
};
var Search_Filter_containerProps = {
  align: ['column', 'left', 'top'],
  mb: '$4',
  p: '$3',
  width: '100%'
};
var containerDatePickerProps = {
  borderBottom: '1px solid #e6e6e6',
  mb: '$5',
  width: '100%'
};
var containerDepartmentFilterProps = {
  borderStyle: 'solid',
  borderWidth: '1px',
  borderRadius: '$alternative',
  borderColor: '#e6e6e6',
  minWidth: '278px',
  mb: '$4',
  width: '100%',
  ' > :first-child': {
    borderTop: 'none'
  }
};
var datePickerCssProps = {
  picker: {
    container: {
      width: '280px',
      my: '$4',
      mb: '$1'
    }
  },
  label: {
    fontFamily: '$primary',
    fontSize: '18px',
    lineHeight: '21px',
    fontWeight: '400',
    ml: '$0'
  }
};
var itemDepartmentFilterProps = {
  align: ['row', 'between', 'middle'],
  borderTop: '1px solid #e6e6e6',
  width: '100%'
};
var typographyDepartmentItemProps = {
  align: ['row', 'left', 'middle'],
  fontFamily: '$primary',
  fontSize: '18px',
  fontWeight: 500,
  lineHeight: '25px',
  letterSpacing: '0.4px',
  pl: '$3',
  py: '$2',
  m: '$0'
};
var Search_Filter_typographyHeadlineProps = {
  fontFamily: '$primary',
  fontSize: '18px',
  fontWeight: 600,
  lineHeight: '20px',
  p: '$0',
  pb: '$3',
  m: '$0'
};
var typographyLabelProps = {
  fontFamily: '$primary',
  fontSize: '18px',
  lineHeight: '21px',
  fontWeight: '400'
};
var Search_Filter_InputBox = prensa/* PrensaEngine.styled */.u7.styled('input', {
  borderColor: '#BFBFBF',
  borderRadius: '$default',
  cursor: 'pointer',
  height: '20px',
  mr: '$4',
  width: '20px'
});

var SearchFilters = function SearchFilters(props) {
  var router = (0,next_router.useRouter)();
  var filterDataContext = (0,react.useContext)(FilterData.FilterDataContext);
  var filterContext = (0,react.useContext)(Filter.FilterContext);
  var slotPolicyId = props === null || props === void 0 ? void 0 : props.slotTemplateCode;
  var slotFilters = filterContext.filters[slotPolicyId] || {};
  var slotMenuItem = first_default()(get_default()(props, 'slotAutoLeftElements', [])) || '';
  var slotMenuItemId = slotMenuItem ? slotMenuItem.replace('contentid/', 'policy:') : '';
  var departmentList = find_default()(get_default()(props, 'contentData', []), {
    id: slotMenuItemId
  });
  var isFiltersDisabled = filterDataContext.loading;
  var urlParams = new URLSearchParams(window.location.search);
  var searchTag = urlParams.get('tag') || '';
  var searchText = slotFilters.term !== '' ? slotFilters.term : urlParams.get('term') || '';
  var clientSlug = "cbngo";

  var handleDate = function handleDate(e) {
    filterContext.updateFilter(slotPolicyId, {
      date: e
    });
  };

  var handleDepartmentFilter = function handleDepartmentFilter(e) {
    var _slotFilters$departme;

    var _e$target = e.target,
        isChecked = _e$target.checked,
        id = _e$target.id;
    var oldState = (_slotFilters$departme = slotFilters.departments) !== null && _slotFilters$departme !== void 0 ? _slotFilters$departme : [];
    var newState = isChecked ? [].concat((0,toConsumableArray/* default */.Z)(oldState), [id]) : oldState.filter(function (deptId) {
      return deptId !== id;
    });
    filterContext.updateFilter(slotPolicyId, {
      departments: newState
    });
  };

  var handleFilter = function handleFilter() {
    filterContext.updateFilter(slotPolicyId, {
      pageStart: 0
    });
    filterDataContext.loadSearchEngineData({
      dateStart: slotFilters.date ? new Date(new Date(slotFilters.date).setHours(0, 0, 0)).toISOString() : null,
      dateEnd: slotFilters.date ? new Date(new Date(slotFilters.date).setHours(23, 59, 59)).toISOString() : null,
      departments: slotFilters.departments,
      policyId: slotPolicyId,
      pageRows: slotFilters.pageRows,
      pageStart: 0,
      searchTag: searchTag,
      searchText: searchText
    }, {
      isSearchEngine: true
    });
  };

  var handleClearState = function handleClearState() {
    var currentUrlPath = router.asPath;
    var termRegex = new RegExp('\\?term=');
    var urlHasParams = termRegex.test(currentUrlPath);
    var url = urlHasParams === false ? currentUrlPath : "".concat(currentUrlPath.split(termRegex)[0]);
    router.push(url);
  };

  var parseIconName = function parseIconName(icon) {
    var itemName = icon.replace('Cidades', 'Cidade').replace('Política', 'Politica').replace('Opinião', 'Opiniao');
    return (0,useIcon/* useIcon */.b)("Ic".concat(itemName));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: Search_Filter_containerProps,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
      type: "block",
      componentReference: "top",
      data: {
        name: 'Search Filter'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: containerDatePickerProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
        css: Search_Filter_typographyHeadlineProps,
        as: "h2",
        children: "FILTRO DE RESULTADOS"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DatePicker_index, {
      css: datePickerCssProps,
      onChange: handleDate,
      selectedDate: slotFilters.date || new Date(Date.now())
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      css: typographyLabelProps,
      as: "h2",
      children: "Por Editoria:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: containerDepartmentFilterProps,
      children: map_default()(get_default()(departmentList, 'contentData', []), function (item) {
        var _slotFilters$departme2;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
          css: itemDepartmentFilterProps,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Typography */.ZT, {
            css: typographyDepartmentItemProps,
            as: "p",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
              icon: parseIconName(item.name),
              css: {
                button: {
                  mr: '$2'
                }
              }
            }), item.name]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Search_Filter_InputBox, {
            checked: (_slotFilters$departme2 = slotFilters.departments) !== null && _slotFilters$departme2 !== void 0 && _slotFilters$departme2.find(function (i) {
              return i === item.id;
            }) ? true : false,
            disabled: isFiltersDisabled,
            id: item.id,
            onChange: handleDepartmentFilter,
            type: "checkbox"
          })]
        }, item.id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CallToActionButton_index, {
      id: "buscar-avancado-botao",
      disabled: isFiltersDisabled,
      onClick: handleFilter,
      css: {
        button: Search_Filter_objectSpread(Search_Filter_objectSpread({}, actionButtonsStyle.button), {}, {
          backgroundColor: clientSlug == 'daqui' ? '$secondaryMain' : '$primary800'
        })
      },
      children: "Buscar"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        mb: '$4'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CallToActionOutlinedButton_index/* default */.Z, {
      onClick: handleClearState,
      disabled: isFiltersDisabled,
      css: {
        button: Search_Filter_objectSpread(Search_Filter_objectSpread({}, actionButtonsStyle.button), {}, {
          borderColor: '#E6E6E6',
          '&:disabled': {
            borderColor: 'rgb(167, 167, 167)',
            backgroundColor: '$basicWhite'
          }
        }),
        label: {
          color: isFiltersDisabled ? 'rgb(167, 167, 167)' : clientSlug == 'daqui' ? '$secondaryMain' : '$primaryMain'
        }
      },
      children: "Limpar Filtros"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
      type: "block",
      componentReference: "bottom",
      data: {
        name: 'Search Filter'
      }
    })]
  });
};

/* harmony default export */ var Search_Filter = (SearchFilters);
// EXTERNAL MODULE: ./components/SearchInput/SearchInput.index.tsx + 1 modules
var SearchInput_index = __webpack_require__(4634);
;// CONCATENATED MODULE: ./components/SearchInput/SearchInputBox.index.tsx


function SearchInputBox_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchInputBox_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchInputBox_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchInputBox_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var SearchInputBox = function SearchInputBox(_ref) {
  var css = _ref.css,
      _ref$hasItemsIndicato = _ref.hasItemsIndicator,
      hasItemsIndicator = _ref$hasItemsIndicato === void 0 ? true : _ref$hasItemsIndicato,
      id = _ref.id,
      buttonId = _ref.buttonId,
      slotTemplateCode = _ref.slotTemplateCode;
  var urlParams = new URLSearchParams(window.location.search);
  var termParam = urlParams.get('term') || '';
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(termParam),
      term = _useState[0],
      setTerm = _useState[1];

  var filterContext = (0,react.useContext)(Filter.FilterContext);
  var filterDataContext = (0,react.useContext)(FilterData.FilterDataContext);
  var templateData = filterDataContext.collections[slotTemplateCode];
  var templateTotalItems = (templateData === null || templateData === void 0 ? void 0 : templateData.totalItems) || 0;

  var handleChange = function handleChange(event) {
    setTerm(event.target.value);
    filterContext.updateFilter(slotTemplateCode, {
      term: event.target.value
    });
  };

  var handleSearch = function handleSearch() {
    var url = "/pesquisa?term=".concat(term);
    router.push(url);
  };

  var styles = {
    container: {
      m: '$0',
      mb: '$6',
      width: '100%'
    },
    input: {
      ml: '$3',
      width: 'calc(100% - $6)',
      '@lg': {
        m: '$0',
        width: '100%'
      }
    },
    icon: {
      button: {
        right: '$6',
        '@lg': {
          right: '$3'
        }
      }
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      width: '100%'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SearchInput_index/* default */.Z, {
      id: id,
      buttonId: buttonId,
      onChange: handleChange,
      onSearch: handleSearch,
      value: term,
      css: SearchInputBox_index_objectSpread(SearchInputBox_index_objectSpread({}, styles), css)
    }), hasItemsIndicator && /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Typography */.ZT, {
      as: "p",
      css: {
        fontSize: '22px',
        mb: '$8'
      },
      variant: "sectionTitle-default",
      children: ["Foram encontrados ", templateTotalItems, " resultados:"]
    })]
  });
};

/* harmony default export */ var SearchInputBox_index = (SearchInputBox);
;// CONCATENATED MODULE: ./components/Expediente/styles.tsx

var styles_Heading1 = prensa/* PrensaEngine.styled */.u7.styled('h1', {
  align: ['column', 'center', 'top'],
  display: 'flex',
  fontSize: '22px',
  fontWeight: 500,
  lineHeight: '28px',
  mt: '$0',
  width: '100%'
});
var styles_Heading2 = prensa/* PrensaEngine.styled */.u7.styled('h2', {
  alignItems: 'center',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '12px',
  mt: '$1',
  mb: '$3'
});
var styles_Heading3 = prensa/* PrensaEngine.styled */.u7.styled('h3', {
  alignItems: 'center',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '12px',
  mt: '$1',
  mb: '$1'
});
var Heading4 = prensa/* PrensaEngine.styled */.u7.styled('h4', {
  alignItems: 'center',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  mt: '$0',
  mb: '$0'
});
var Heading5 = prensa/* PrensaEngine.styled */.u7.styled('h5', {
  alignItems: 'center',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '15px',
  mt: '$0',
  mb: '$0'
});
var styles_MainDiv = prensa/* PrensaEngine.styled */.u7.styled('div', {
  align: ['column', 'center', 'top'],
  fontFamily: '$primary',
  width: '100%',
  my: '$15',
  '@lg': {
    my: '$10' // maxWidth: '940px'

  }
});
var topBlockProps = {
  align: ['column', 'center', 'top'],
  '@lg': {
    align: ['row', 'center', 'top'],
    width: '100%'
  }
};
var middleBlockProps = {
  align: ['column', 'center', 'top'],
  '@lg': {
    align: ['row', 'center', 'top'],
    mb: '$4',
    width: '80%'
  }
};
var bottomBlockProps = {
  align: ['column', 'center', 'top'],
  mb: '$18',
  width: '80%'
};
var itemTopProps = {
  align: ['column', 'center', 'top'],
  mb: '$6',
  '@lg': {
    mr: '$9'
  }
};
var itemMiddleProps = {
  align: ['column', 'center', 'top'],
  mb: '$6',
  minWidth: '250px !important',
  '@lg': {
    mr: '$8'
  }
};
var itemBottomProps = {
  align: ['column', 'center', 'top'],
  minWidth: '250px',
  mb: '$6',
  '@lg': {
    mb: '$8',
    mr: '$8'
  }
};
var logoProps = {
  align: ['column', 'center', 'top'],
  mb: '$10',
  mt: '$14'
};
var logo2Props = {
  align: ['column', 'center', 'top'],
  mb: '$10',
  mt: '$14'
};
;// CONCATENATED MODULE: ./components/Expediente/cbn/Team.index.tsx
// @ts-nocheck





var CbnPageTeam = function CbnPageTeam() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading1, {
      children: "Expediente"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logoProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/cbn/logos/LogoCBNDesktop.svg",
        alt: "Logo cbn Goi\xE2nia",
        height: "102px",
        width: "182px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: topBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Coordena\xE7\xE3o de Jornalismo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Luiz Geraldo"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Chefia de Reportagem"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Aldenne Lopes"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Apresenta\xE7\xE3o CBN Goi\xE2nia"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Rayfran Cardoso"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Luiz Geraldo"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Apresenta\xE7\xE3o Tarde CBN"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Nath\xE1lia Lima"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jos\xE9 Bonfim"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Produ\xE7\xE3o CBN Goi\xE2nia"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Andressa Vasconcelos"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Produ\xE7\xE3o Tarde CBN"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Joyce Vilela"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Bonny Fonseca Fonseca"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Site CBN Goi\xE2nia"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jo\xE3o Paulo Alexandre"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Bonny Fonseca Fonseca"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Reportagem"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "La\xEDs Ara\xFAjo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jos\xE9 Bonfim"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Daniela Versiane"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Alex Maia"
        })]
      })]
    })]
  });
};

/* harmony default export */ var Team_index = (CbnPageTeam);
;// CONCATENATED MODULE: ./components/Expediente/cbngo/Team.index.tsx
// @ts-nocheck





var CbngoPageTeam = function CbngoPageTeam() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading1, {
      children: "Expediente"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logoProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/opopular/logos/LogoGrupoJaimeCamara.svg",
        alt: "Logo Grupo Jaime C\xE2mara",
        height: "32px",
        width: "110px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: topBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "FUNDADOR:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jaime C\xE2mara (1909 - 1989)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "VICE-PRESIDENTE DE NEG\xD3CIOS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Ronaldo Borges Ferrante"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "PRESIDENTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jaime C\xE2mara J\xFAnior"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "CEO:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Breno Machado"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "DIR. JUR\xCDDICO/ REL. INSTITUCIONAIS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Guliver Augusto Le\xE3o"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logoProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/cbngo/logos/LogoCBNDesktop.svg",
        alt: "Logo cbngo Goi\xE2nia",
        height: "102px",
        width: "182px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: topBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Coordena\xE7\xE3o de Jornalismo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Luiz Geraldo"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Gerente de Conte\xFAdo Digital"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Elis\xE2ngela Nascimento"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Apresenta\xE7\xE3o CBN Goi\xE2nia"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Luiz Geraldo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Daniela Versiane"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Apresenta\xE7\xE3o Tarde CBN"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Nath\xE1lia Lima"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jos\xE9 Bonfim"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Produ\xE7\xE3o"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Andressa Vasconcelos"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Laylla Alves"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Ma\xEDsa Martins"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "D\xE9borah Marques"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Gracielly Oliveira"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Editores Digital"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Paula Resende"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Reportagem"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Sabrina Vilela"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Eliara Salla"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Anna Clelma"
        })]
      })]
    })]
  });
};

/* harmony default export */ var cbngo_Team_index = (CbngoPageTeam);
;// CONCATENATED MODULE: ./components/Expediente/cbnto/Team.index.tsx
// @ts-nocheck





var CbntoPageTeam = function CbntoPageTeam() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading1, {
      children: "Expediente"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logoProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/cbnto/logos/LogoCBNDesktop.svg",
        alt: "Logo cbn Tocantins",
        height: "102px",
        width: "182px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: topBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Coordena\xE7\xE3o de Jornalismo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Luiz Geraldo"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Chefia de Reportagem"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Aldenne Lopes"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Apresenta\xE7\xE3o cbn Goi\xE2nia"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Rayfran Cardoso"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Luiz Geraldo"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Apresenta\xE7\xE3o Tarde cbn"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Nath\xE1lia Lima"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jos\xE9 Bonfim"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Produ\xE7\xE3o cbn Goi\xE2nia"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Andressa Vasconcelos"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Produ\xE7\xE3o Tarde cbn"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Joyce Vilela"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Bonny Fonseca Fonseca"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Site cbn Goi\xE2nia"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jo\xE3o Paulo Alexandre"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Bonny Fonseca Fonseca"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "Reportagem"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "La\xEDs Ara\xFAjo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jos\xE9 Bonfim"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Daniela Versiane"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Alex Maia"
        })]
      })]
    })]
  });
};

/* harmony default export */ var cbnto_Team_index = (CbntoPageTeam);
;// CONCATENATED MODULE: ./components/Expediente/tocantins/Team.index.tsx
// @ts-nocheck





var TocantinsPageTeam = function TocantinsPageTeam() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading1, {
      children: "Expediente"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logoProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/opopular/logos/LogoGrupoJaimeCamara.svg",
        alt: "Logo Grupo Jaime C\xE2mara",
        height: "32px",
        width: "110px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: topBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "FUNDADOR:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jaime C\xE2mara (1909 - 1989)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "PRESIDENTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jaime C\xE2mara J\xFAnior"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "CEO:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Breno Machado"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "VICE-PRESIDENTE DE NEG\xD3CIOS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Ronaldo Borges Ferrante"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "DIR. JUR\xCDDICO/ REL. INSTITUCIONAIS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Guliver Augusto Le\xE3o"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "DIRETOR-GERAL DO GJC NO TOCANTINS"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Paulo Ricardo Caragelasco"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logoProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/tocantins/logos/LogoTocantinsMobile.svg",
        alt: "Logo Jornal do Tocantins",
        height: "20px",
        width: "153px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "FUNDADORES:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Jaime C\xE2mara (1909 - 1989)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Joaquim C\xE2mara Filho (1899 - 1955)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Rebou\xE7as C\xE2mara (1898 - 1973)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "DIRETOR SUPERINTENDENTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Tasso Jos\xE9 C\xE2mara"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "GERENTE DE CONTE\xDADO DIGITAL:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Elis\xE2ngela Nascimento"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "EDITORA-CHEFE"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Vilma Nascimento"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: bottomBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemBottomProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "PUBLICIDADE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "(63) 3215-9519"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemBottomProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "CENTRAL DE COMERCIALIZA\xC7\xC3O:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Telefone: (62) 3250-1215"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Fax: (62) 3250-1260"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemBottomProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "SUCURSAL S\xC3O PAULO:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Telefone/fax: (11) 3774-8100"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemBottomProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "SUCURSAL BRAS\xCDLIA"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Telefone: (61) 3321-0501"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemBottomProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "REPRESENTANTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Rio de Janeiro: (21) 2524-5644"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Belo Horizonte: (31) 2535-2711 / 8865-7363"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Vit\xF3ria: (27) 2124-9739 / 99762-4151"
        })]
      })]
    })]
  });
};

/* harmony default export */ var tocantins_Team_index = (TocantinsPageTeam);
;// CONCATENATED MODULE: ./components/Expediente/opopular/Team.index.tsx
// @ts-nocheck





var PopularPageTeam = function PopularPageTeam() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading1, {
      children: "Expediente"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logoProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/opopular/logos/LogoGrupoJaimeCamara.svg",
        alt: "Logo Grupo Jaime C\xE2mara",
        height: "32px",
        width: "110px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: topBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "FUNDADOR:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jaime C\xE2mara (1909 - 1989)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "VICE-PRESIDENTE DE NEG\xD3CIOS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Ronaldo Borges Ferrante"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "PRESIDENTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jaime C\xE2mara J\xFAnior"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "CEO:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Breno Machado"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "DIR. JUR\xCDDICO/ REL. INSTITUCIONAIS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Guliver Augusto Le\xE3o"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logo2Props,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/opopular/logos/LogoOPopularDesktop.svg",
        alt: "Logo O Popular",
        height: "26px",
        width: "155px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "FUNDADORES:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Jaime C\xE2mara (1909 - 1989)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Joaquim C\xE2mara Filho (1899 - 1955)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Rebou\xE7as C\xE2mara (1898 - 1973)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "DIRETOR SUPERINTENDENTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Tasso Jos\xE9 C\xE2mara"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "EDITORES EXECUTIVOS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Silvana Bittencourt"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "GERENTE DE CONTE\xDADO DIGITAL:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Elis\xE2ngela Nascimento"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "EDITORES ONLINE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Iv\xE2nia Cavalcanti"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Pedro Nunes"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "REPRESENTANTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Rio de Janeiro: 21 2524 5644"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Belo Horizonte: 31 2535 2711 / 8865 7363"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Vit\xF3ria: 27 2124 9739 / 99762 4151"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "CENTRAL DE COMERCIALIZA\xC7\xC3O:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Rua Thomas Edson - Quadra 7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "n\xBA 500 - Setor Serrinha"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Tel.: 62 3250 1215 | Fax: 62 3250 1260"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "SUCURSAL S\xC3O PAULO:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Rua \xC1lvaro Anes - n\xBA 56, Conjunto 72"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Bairro Pinheiros, S\xE3o Paulo - SP"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Tel./fax: 11 3775-8100"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "SUCURSAL BRAS\xCDLIA:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "SBS, Edif\xEDcio OK - Office Tower"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "7\xBA andar, Salas 712/715"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Tel.: 61 3321 0501"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: bottomBlockProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemBottomProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "PUBLICIDADE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "(62) 3250-1453"
        })]
      })
    })]
  });
};

/* harmony default export */ var opopular_Team_index = (PopularPageTeam);
;// CONCATENATED MODULE: ./components/Expediente/daqui/Team.index.tsx
// @ts-nocheck





var Team_index_PopularPageTeam = function PopularPageTeam() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading1, {
      children: "Expediente"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logoProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/opopular/logos/LogoGrupoJaimeCamara.svg",
        alt: "Logo Grupo Jaime C\xE2mara",
        height: "32px",
        width: "110px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: topBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "FUNDADOR:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jaime C\xE2mara (1909 - 1989)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "VICE-PRESIDENTE DE NEG\xD3CIOS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Ronaldo Borges Ferrante"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "PRESIDENTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jaime C\xE2mara J\xFAnior"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "CEO:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Breno Machado"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "DIR. JUR\xCDDICO/ REL. INSTITUCIONAIS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Guliver Augusto Le\xE3o"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logo2Props,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/daqui/logos/LogoDaquiDesktop.svg",
        alt: "Logo Jornal Daqui",
        height: "67px",
        width: "118px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "FUNDADORES:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Jaime C\xE2mara (1909 - 1989)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Joaquim C\xE2mara Filho (1899 - 1955)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Rebou\xE7as C\xE2mara (1898 - 1973)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "DIRETOR SUPERINTENDENTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Tasso Jos\xE9 C\xE2mara"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "EDITORES EXECUTIVOS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Luciano Martins"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "GERENTE DE CONTE\xDADO DIGITAL:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Elis\xE2ngela Nascimento"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "EDITORES ONLINE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Iv\xE2nia Cavalcanti"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Pedro Nunes"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "REPRESENTANTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Rio de Janeiro: 21 2524 5644"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Belo Horizonte: 31 2535 2711 / 8865 7363"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Vit\xF3ria: 27 2124 9739 / 99762 4151"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "CENTRAL DE COMERCIALIZA\xC7\xC3O:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Rua Thomas Edson - Quadra 7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "n\xBA 500 - Setor Serrinha"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Tel.: 62 3250 1215 | Fax: 62 3250 1260"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "SUCURSAL S\xC3O PAULO:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Rua \xC1lvaro Anes - n\xBA 56, Conjunto 72"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Bairro Pinheiros, S\xE3o Paulo - SP"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Tel./fax: 11 3775-8100"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "SUCURSAL BRAS\xCDLIA:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "SBS, Edif\xEDcio OK - Office Tower"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "7\xBA andar, Salas 712/715"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Tel.: 61 3321 0501"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: bottomBlockProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemBottomProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "PUBLICIDADE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "(62) 3250-1453"
        })]
      })
    })]
  });
};

/* harmony default export */ var daqui_Team_index = (Team_index_PopularPageTeam);
;// CONCATENATED MODULE: ./components/Expediente/Team.index.tsx











var PageTeam = function PageTeam(_ref) {
  var site = _ref.site;

  if (site === 'cbn') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Team_index, {});
  }

  if (site === 'cbngo') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Team_index, {});
  }

  if (site === 'cbnto') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(cbnto_Team_index, {});
  }

  if (site === 'daqui') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(daqui_Team_index, {});
  }

  if (site === 'tocantins') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(tocantins_Team_index, {});
  }

  if (site === 'opopular') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(opopular_Team_index, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading1, {
      children: "Expediente"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logoProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/opopular/logos/LogoGrupoJaimeCamara.svg",
        alt: "Logo Grupo Jaime C\xE2mara",
        height: "32px",
        width: "110px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: topBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "FUNDADOR:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jaime C\xE2mara (1909 - 1989)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "VICE-PRESIDENTE DE NEG\xD3CIOS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Ronaldo Borges Ferrante"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "PRESIDENTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Jaime C\xE2mara J\xFAnior"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "CEO:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Breno Machado"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemTopProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "DIR. JUR\xCDDICO/ REL. INSTITUCIONAIS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading3, {
          children: "Guliver Augusto Le\xE3o"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: logo2Props,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/opopular/logos/LogoOPopularDesktop.svg",
        alt: "Logo O Popular",
        height: "26px",
        width: "155px"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "FUNDADORES:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Jaime C\xE2mara (1909 - 1989)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Joaquim C\xE2mara Filho (1899 - 1955)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Rebou\xE7as C\xE2mara (1898 - 1973)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "DIRETOR SUPERINTENDENTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Tasso Jos\xE9 C\xE2mara"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "EDITORES EXECUTIVOS:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Silvana Bittencourt"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "GERENTE DE CONTE\xDADO DIGITAL:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Elis\xE2ngela Nascimento"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "EDITORES ONLINE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Iv\xE2nia Cavalcanti"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Pedro Nunes"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "REPRESENTANTE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Rio de Janeiro: 21 2524 5644"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Belo Horizonte: 31 2535 2711 / 8865 7363"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "Vit\xF3ria: 27 2124 9739 / 99762 4151"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: middleBlockProps,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "CENTRAL DE COMERCIALIZA\xC7\xC3O:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Rua Thomas Edson - Quadra 7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "n\xBA 500 - Setor Serrinha"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Tel.: 62 3250 1215 | Fax: 62 3250 1260"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "SUCURSAL S\xC3O PAULO:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Rua \xC1lvaro Anes - n\xBA 56, Conjunto 72"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Bairro Pinheiros, S\xE3o Paulo - SP"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Tel./fax: 11 3775-8100"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemMiddleProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "SUCURSAL BRAS\xCDLIA:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "SBS, Edif\xEDcio OK - Office Tower"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "7\xBA andar, Salas 712/715"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading5, {
          children: "Tel.: 61 3321 0501"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: bottomBlockProps,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: itemBottomProps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(styles_Heading2, {
          children: "PUBLICIDADE:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading4, {
          children: "(62) 3250-1453"
        })]
      })
    })]
  });
};

/* harmony default export */ var Expediente_Team_index = (PageTeam);
;// CONCATENATED MODULE: ./components/Expediente/tocantins/Terms.index.tsx
// @ts-nocheck



var Terms_index_MainDiv = prensa/* PrensaEngine.styled */.u7.styled('div', {
  align: ['column', 'left', 'top'],
  fontFamily: '$primary',
  my: '$22',
  maxWidth: '1280px'
});
var Terms_index_Heading1 = prensa/* PrensaEngine.styled */.u7.styled('h1', {
  fontSize: '30px',
  fontWeight: 700,
  lineHeight: '36px',
  mt: '$0',
  mb: '$4'
});
var Terms_index_Heading2 = prensa/* PrensaEngine.styled */.u7.styled('h2', {
  fontSize: '25px',
  fontWeight: 700,
  lineHeight: '30px',
  mt: '$8',
  mb: '$4'
});
var Terms_index_Heading3 = prensa/* PrensaEngine.styled */.u7.styled('h3', {
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: '22px',
  my: '$4'
});
var Terms_index_Paragraph = prensa/* PrensaEngine.styled */.u7.styled('p', {
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '24px',
  mt: '$0',
  mb: '$4'
});

var PageTermsTocantins = function PageTermsTocantins() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Terms_index_MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading1, {
      children: "Termos e Condi\xE7\xF5es de Uso do Site do Jornal do Tocantins"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: "1. INTRODU\xC7\xC3O"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'O Site do Jornal do Tocantins (Jornal do Tocantins) consiste em um portal de conteúdos jornalísticos de titularidade do Grupo Jaime Câmara, sediada na Av. NS02, QD. 102 norte, Conj: 2 Lt: 9/10, Palmas, TO, devidamente inscrita no CNPJ sob o nº 1.536.754/0003-95.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'O presente Termo de Uso (“Termos de Uso”) regula a utilização e acesso ao site  https://jornaldotocantins.com.br/ de propriedade do Grupo Jaime Câmera e aos serviços de assinatura digital do produto denominado Jornal do Tocantins. Neste Termos de Uso, o usuário que utilizar e acessar os Produtos Digitais, terá acesso as informações e regras gerais sobre a utilização dos Produtos Digitais e funcionalidades decorrentes.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'Constituem os “Conteúdos do Jornal do Tocantins” todo e qualquer conteúdo, aplicativo, ferramenta, disponibilizados sem cessão definitiva (licenciamento) pelo O Popular, para utilização por qualquer pessoa que acessar tais conteúdo.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'A aceitação deste Termo de Uso deverá ser feita no momento do Cadastro, juntamente com a Política de Privacidade, acessível por meio deste link https://jornaldotocantins.com.br/politica-de-privacidade. Se você interessado, não concordar com as disposições constantes ao longo do texto, não deverá finalizar o Cadastro e usufruir o conteúdo completo fornecido pelo Jornal do Tocantins. Esses Termos têm como objetivo estabelecer direitos e obrigações, tanto do O Popular como dos Usuários. Se o Usuário discordar ou não consentir com alguma disposição destes Termos de Uso, recomendamos que não conclua o Cadastro e não mais acesse o Portal de O Popular.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'Ao utilizar-se dos sites e aplicativos, de qualquer maneira, o USUÁRIO aceita e concorda com todos os Termos e Condições de Uso aqui expostos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: '2. CADASTRO DO USUÁRIO, SENHA E SEGURANÇA:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '2.1 - Para navegar por algumas áreas dos site do Jornal do Tocantins, e/ou usar alguns dos nossos serviços ou, ainda, para ter direito a um maior consumo gratuito de reportagens, pode ser necessário identificar-se por meio de cadastro, onde poderão ser solicitados dados pessoais, e aceitar o armazenamento de cookies, que são pequenos arquivos instalados por sites nos computadores quando o navegador de internet é usado. Esses arquivos permitem identificar se um mesmo aparelho já fez uma visita anterior ao site, se o usuário tem ou não cadastro ou se é assinante, através de dados fornecidos pelos próprios usuários em cadastro prévio, por livre e espontânea vontade.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '2.2 - O usuário poderá não aceitar os cookies ao navegar pelos sites e aplicativos de Jornal do Tocantins. Nesse caso, Jornal do Tocantins não garante o correto funcionamento dos sites, aplicativos e demais serviços prestados.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '2.3 - Usuário, neste Termos de Uso, concorda em: i) fornecer informações verdadeiras, exatas, atuais e completas sobre si mesmo quando do registro no cadastro específico para acesso aos Conteúdos no site de Jornal do Tocantins; ii) conservar e manter seus dados pessoais atualizados, de modo que suas informações permaneçam constantemente verdadeiras e completas'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '2.4 - O USUÁRIO, ao realizar o seu cadastro, deverá informar seu endereço eletrônico próprio, que será utilizado para a sua identificação no site de Jornal do Tocantins e, ainda para que possa receber todas as notificações e mensagens referente ao seu cadastro. O USUÁRIO deve criar a sua senha de acesso, sendo completamente responsável pela segurança e confidencialidade de sua senha e, ainda, qualquer ação que ocorra no campo de seu cadastro. O USUÁRIO poderá alterar a sua senha a qualquer tempo. O endereço eletrônico informado pelo USUÁRIO, bem como a senha  por ele criada serão usados como meio de sua identificação e autorização de acesso ao site de Jornal do Tocantins.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '2.5 - O cadastro deve ser realizado por maiores de 18 (dezoito) anos. Os USUÁRIOS menores de 18 (dezoito) anos devem ser representados pelos pais ou responsáveis legais. O mesmo se aplica para aqueles considerados incapazes, nos termos dos artigos 3º e 4º do Código Civil de 2002. O responsável legal será responsável por aceitar este Termos de Uso, se responsabilizando, portanto, pelos feitos do menor do Portal de Jornal do Tocantins.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '2.7 - O envio dos e-mails pode ser feito por meio dos servidores de empresa contratada pelo Jornal do Tocantins. Essa empresa não armazenará e tampouco usará, de nenhuma forma e sob nenhuma hipótese, os dados do cadastro dos usuários para qualquer outro fim que não o envio das mensagens, de acordo com autorização e preferências registrada no momento do cadastro.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '2.8 - A autorização dada pelo usuário para as atividades acima descritas poderá ser revogada, a qualquer momento, através do email faleconosco@jornaldotocantins.com.br, bem como poderá ser atualizada qualquer informação pessoal que tenha sido fornecida ao Jornal do Tocantins. Caso receba alguma promoção identificada como sendo do Jornal do Tocantins e tenha dúvidas sobre sua veracidade, o usuário poderá consultar o Jornal do Tocantins na página http://www.jornaldotocantins.com.br/fale-conosco'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '2.9 - O USUÁRIO se compromete a notificar imediatamente Jornal do Tocantins sobre qualquer uso não autorizado de seu e-mail eletrônico e senha ou qualquer quebra de segurança de seu conhecimento através do endereço eletrônico http://www.jornaldotocantins.com.br/cmlink/o-popular/fale-conosco, ou pelo telefone (63) 3215-9540.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: '3. CONTEÚDOS DISPONIBILIZADOS NOS SITES DO Jornal do Tocantins'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.1 - O USUÁRIO não assinante poderá acessar de forma gratuita número limitado de conteúdo disponibilizado no site do Jornal do Tocantins. Após atingir o número limite de acesso mensal, para continuar tendo acesso ao conteúdo do Jornal do Tocantins, o Usuário deverá efetuar o cadastro, inserindo as informações necessárias. O cadastro não confere acesso ilimitado e irrestrito a todo o conteúdo veiculado no site de Jornal do Tocantins, mas apenas dá direito ao usuário de acessar um número maior de reportagens.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.2 - O USUÁRIO assinante do Jornal do Tocantins possui acesso ilimitado a todo o conteúdo disponibilizado, o qual encontra-se protegido por direitos autorais ou outros direitos de propriedade intelectual. É vedada a reprodução total ou parcial, de qualquer conteúdo veiculado no site, aplicativos e ferramentas de propriedade de Jornal do Tocantins, incluindo, mas não se limitando, fotografias, charges, vídeos, podcasts, reportagens ou qualquer outro material jornalístico disponibilizado, em qualquer meio de comunicação, sem autorização por escrito.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.3 - O conteúdo do site de Jornal do Tocantins não poderá ser utilizado para fins que não sejam exclusivamente não comerciais, ficando o usuário integralmente responsável por qualquer dano ou prejuízo causado em decorrência da sua utilização para fins diversos daqueles aqui especificados. Neste caso, o Jornal do Tocantins poderá, a seu exclusivo critério, suspender o acesso do usuário por tempo indeterminado.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.4 - O USUÁRIO não poderá utilizar o site e aplicativos do Jornal do Tocantins para divulgação de produtos e serviços, ou qualquer atividade com fins lucrativos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.5 - O USUÁRIO assinante poderá fazer comentários nas reportagens veiculadas, ficando desde já estabelecido, que será integralmente responsável pelo seu teor, bem como por todas as opiniões, dados e informações neles contidos, respondendo o USUÁRIO no âmbito civil e criminal, perante qualquer pessoa física e/ou jurídica que se sinta prejudicada ou ofendida em decorrência de tais comentários, uma vez que não é possível o monitoramento prévio, por parte do Jornal do Tocantins, dos comentários que serão inseridos em seus sites. O USUÁRIO responderá de forma exclusiva e independente perante aquele que se sentir prejudicado pelos comentários, e assegurando a exclusão do Jornal do Tocantins de qualquer responsabilidade ou ação judicial pelas opiniões constantes nos comentários.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.6 -  O Jornal do Tocantins não se responsabiliza pelo conteúdo acima, item 3.5 supra, quando o mesmo for publicado por um menor de idade, momento no qual a responsabilidade será de um dos genitores ou representante legal que consentiu com a participação do menor nas Plataformas e aceitou os presentes Termos e Condições de Uso.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.7 - O Jornal do Tocantins não se responsabiliza por realizar armazenagem e backups de comentários inseridos, disponibilizados ou gerados por USUÁRIOS no Portal.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.8 -  Os USUÁRIOS se comprometem a não postar quaisquer comentários que constituam violação a direito de terceiros, bem como infrinjam direitos de propriedade intelectual. Jornal do Tocantins não se responsabiliza por tais atos. '
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.9 - O USUÁRIO declara ter ciência e concordar que os comentários poderão ser reproduzidos e/ou explorados juntamente com matérias jornalísticas que o Jornal do Tocantins julgar pertinentes, em qualquer outra ferramenta/produto de titularidade de Jornal do Tocantins a seu exclusivo critério.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.10 - O Jornal do Tocantins se exime de toda e qualquer responsabilidade perante o USUÁRIO e terceiros, decorrentes dos comentários inseridos pelos USUÁRIOS, tendo em vista a impossibilidade técnica de se efetuar monitoramento preventivo de todos os comentários inseridos por Usuários e terceiros em seu Portal.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.11  - O material jornalístico produzido pelo Jornal do Tocantins é protegido por lei. As regras têm como objetivo proteger o investimento feito pelo Jornal do Tocantins na qualidade constante de seu jornalismo.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.12 - O Jornal do Tocantins somente excluirá comentários feitos em reportagens em seus sites mediante requerimento judicial e/ou da Administração Pública.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.13 - O USUÁRIO declara ter ciência e concordar que os comentários poderão ser reproduzidos e/ou explorados juntamente com matérias jornalísticas que o Jornal do Tocantins julgar pertinentes, a seu exclusivo critério.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.9 - Esta política vale apenas para os sites, ferramentas e aplicativos pertencentes ao site do Jornal do Tocantins.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '3.10 - O Jornal do Tocantins não é responsável por sites fora de seu domínio, não possuindo qualquer controle sobre privacidade, conteúdo, confidencialidade ou consequências de sua utilização.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: '4. PUBLICIDADE'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '4.1 – O Jornal do Tocantins não se responsabiliza pelo conteúdo, condições comerciais e cumprimento de qualquer oferta, publicidade ou anúncio veiculado nos seus sites. Assim sendo, qualquer dano ou prejuízo causado a terceiros em decorrência de tais ofertas ou anúncios, serão de responsabilidade exclusiva de seus respectivos anunciantes.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: '5. PRIVACIDADE'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '5.1 - O Jornal do Tocantins usará todos os meios necessários para proteger a confidencialidade, a integridade e a disponibilidade dos dados pessoais dos usuários. As informações serão incorporadas ao banco de dados do GJC e ficarão armazenadas na sede do GJC, restritas apenas aos seus funcionários e pessoas autorizadas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '5.2 - Os dados do usuário nunca serão transferidos pelo  Jornal do Tocantins a terceiros, que não sejam parceiros ou empresas contratadas para as finalidades previstas neste documento, sem que o usuário tenha previamente autorizado, exceto em casos de decisão judicial. Também nunca serão usados para qualquer outro fim além do motivo de sua coleta. Caso sejam indevidamente utilizados, os responsáveis estão sujeitos a sanções judiciais e administrativas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '5.3 - As informações coletadas dos usuários poderão ser utilizadas para as seguintes finalidades:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'I. Informar sobre conteúdo publicado pelo Jornal do Tocantins e novos produtos da empresa;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'II. Manter atualizados os dados de usuários para contato por telefone, correio eletrônico e mala direta;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'III. Analisar estatísticas gerais de uso do site, sem nenhuma identificação individual dos usuários, visando melhorar a experiência de navegação, através de registros de informações sobre quais páginas foram acessadas, qual é seu navegador, seu IP, seu sistema operacional, entre outros;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'IV. Realizar campanhas de comunicação e marketing de relacionamento;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'V.  Divulgar ofertas especiais de parceiros.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '5.4. O Jornal do Tocantins tem o compromisso em melhorar continuamente os controles de atualização, gerenciamento, exportação e exclusão dos dados pessoais dos usuários, evoluindo seus sistemas em conformidade com os regulamentos de proteção de dados vigentes que possam atingir seu universo de leitores. O Jornal do Tocantins se compromete a pormenorizar de forma técnica, caso haja interesse, como ocorre o processamento de dados na empresa.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: '6. PRAZO'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '6.1 - O presente Termo permanecerá vigente por prazo indeterminado, sendo resguardado ao Jornal do Tocantins o direito de modificar ou cancelar qualquer conteúdo disponibilizado nos seus sites e, a qualquer momento, sem aviso prévio.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: '7. VIGÊNCIA E CANCELAMENTO'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '7.1 O presente instrumento vigorará por prazo indeterminado, observadas as regras previstas nessa cláusula para cancelamento do Plano contratado, de acordo com a modalidade de pagamento escolhida pelo USUÁRIO.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '7.2 - O USUÁRIO poderá a qualquer momento solicitar o cancelamento dos Recursos através do Serviço ao Assinante do Jornal do Tocantins ou através dos telefones constantes na página https://jornaldotocantins.com.br/fale-conosco, observadas as condições estabelecidas nesse documento. O Jornal do Tocantins poderá rescindir o presente documento de contratação dos Recursos a qualquer momento mediante comunicação prévia, no prazo de 20 (vinte) dias, por escrito, enviada ao USUÁRIO.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '7.3 - No cancelamento o USUÁRIO se compromete a saldar e liquidar eventuais débitos e pendências existentes e vincendas relativos a Recursos já disponibilizados, podendo usufruir destes Recursos até o final do período adimplido.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: '8. PREÇOS, PLANOS E OFERTAS'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '8.1 - Pelos Recursos contratados o USUÁRIO pagará os valores constantes na Oferta ou informados no ato da contratação, de acordo com a forma e modalidade de pagamento escolhida.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '8.2 - Os recursos contratados em cada plano podem sofrer variação de acordo com as demandas e necessidades de mercado, cabendo ao Jornal do Tocantins manter o equilíbrio do benefício contratado no ato da compra.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '8.3 - Pedidos pagos com cartão de crédito estão sujeitos à aprovação da administradora do cartão. A entrega dos Recursos é considerada a partir da checagem dos dados cadastrais e da confirmação do pagamento, de acordo com prazo da administradora do cartão.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '8.4 - Pedidos pagos com boleto bancário serão considerados válidos a partir da confirmação do pagamento do boleto pelo banco.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '8.5 - Conforme a forma de pagamento escolhida, o USUÁRIO declara expressamente concordar que o Jornal do Tocantins efetue débitos em seu cartão de crédito ou conta corrente na periodicidade de pagamento escolhida pelo USUÁRIO. Caso o USUÁRIO possua mais de uma forma de pagamento cadastrada e não seja possível realizar o débito na forma de pagamento preferencial indicada pelo USUÁRIO, o Jornal do Tocantins se reserva ao direito de realizar o débito em qualquer das outras formas de pagamento cadastrados pelo USUÁRIO.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '8.6 - O USUÁRIO se declara ciente de que, possuindo o banco emissor tal funcionalidade, o cartão de débito ou crédito vencido ou expirado será automaticamente renovado, dando continuidade à cobrança dos recursos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '8.7 - No caso de impossibilidade do débito dos valores na modalidade de cartão de crédito ou débito em conta corrente, o Jornal do Tocantins reserva-se o direito de emitir contra o USUÁRIO um boleto para cobrança dos valores devidos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '8.9 - Os planos e preço podem ser alterados, a qualquer tempo, de acordo com as condições comerciais da empresa.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: '9. INDISPONIBILIDADE DO SITE'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: 'O Jornal do Tocantins não terá qualquer responsabilidade na hipótese de indisponibilidade dos sites causada por caso fortuito ou força maior, alheias ao seu controle e que fujam da sua esfera de responsabilidade.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: '10. DISPOSIÇÕES GERAIS'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '10.1 - Caso qualquer das disposições do presente Termo venha a ser considerada nula, inválida ou inexequível, tal decisão não afetará a validade das disposições remanescentes, que continuarão a vigorar e a produzir efeitos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '10.2 - O Jornal do Tocantins poderá atualizar o presente Termo a qualquer momento. Caso haja mudança em algum item deste compromisso, todos os leitores cadastrados poderão ser avisados, e o novo texto será publicado nesta página.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '10.3 - Independentemente de notificação, o usuário deverá acessar esta página com frequência para garantir que esteja de acordo com eventuais mudanças realizadas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '10.4 - O presente Termo é regido pela legislação brasileira, sendo eleito o foro da Comarca da Capital do Estado de Goiás para dirimir qualquer controvérsia.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Heading3, {
      children: '11. CONTATO'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index_Paragraph, {
      children: '10.1 - Em caso de dúvidas ou solicitações acerca de uso dos dados pessoais ou sobre a Política de Privacidade de Jornal do Tocantins, o USUÁRIO pode entrar em contato através do formulário disponível em: https://jornaldotocantins.com.br/fale-conosco.'
    })]
  });
};

/* harmony default export */ var Terms_index = (PageTermsTocantins);
;// CONCATENATED MODULE: ./components/Expediente/cbngo/Terms.index.tsx
// @ts-nocheck



var cbngo_Terms_index_MainDiv = prensa/* PrensaEngine.styled */.u7.styled('div', {
  align: ['column', 'left', 'top'],
  fontFamily: '$primary',
  my: '$22',
  maxWidth: '1280px'
});
var cbngo_Terms_index_Heading1 = prensa/* PrensaEngine.styled */.u7.styled('h1', {
  fontSize: '30px',
  fontWeight: 700,
  lineHeight: '36px',
  mt: '$0',
  mb: '$4'
});
var cbngo_Terms_index_Heading2 = prensa/* PrensaEngine.styled */.u7.styled('h2', {
  fontSize: '25px',
  fontWeight: 700,
  lineHeight: '30px',
  mt: '$8',
  mb: '$4'
});
var cbngo_Terms_index_Heading3 = prensa/* PrensaEngine.styled */.u7.styled('h3', {
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: '22px',
  my: '$4'
});
var cbngo_Terms_index_Paragraph = prensa/* PrensaEngine.styled */.u7.styled('p', {
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '24px',
  mt: '$0',
  mb: '$4'
});

var PageTermsCbngo = function PageTermsCbngo() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(cbngo_Terms_index_MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading1, {
      children: "Termos e Condi\xE7\xF5es de Uso do Site da R\xE1dio CBN Goi\xE2nia"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: "1. INTRODU\xC7\xC3O"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'O Site da Rádio CBN Goiânia (Rádio CBN Goiânia) consiste em um portal de conteúdos jornalísticos de titularidade do Grupo Jaime Câmara, sediada na Av. NS02, QD. 102 norte, Conj: 2 Lt: 9/10, Palmas, TO, devidamente inscrita no CNPJ sob o nº 01.536.754/0001-2 ("GJC")'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'O presente Termo de Uso (“Termos de Uso”) regula a utilização e acesso ao site  https://cbngoiania.com.br/ de propriedade do Grupo Jaime Câmera e aos serviços de assinatura digital do produto denominada Rádio CBN Goiânia. Neste Termos de Uso, o usuário que utilizar e acessar os Produtos Digitais, terá acesso as informações e regras gerais sobre a utilização dos Produtos Digitais e funcionalidades decorrentes.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'Constituem os “Conteúdos da Rádio CBN Goiânia” todo e qualquer conteúdo, aplicativo, ferramenta, disponibilizados sem cessão definitiva (licenciamento) pelo O Popular, para utilização por qualquer pessoa que acessar tais conteúdo.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'A aceitação deste Termo de Uso deverá ser feita no momento do Cadastro, juntamente com a Política de Privacidade, acessível por meio deste link https://cbngoiania.com.br/politica-de-privacidade. Se você interessado, não concordar com as disposições constantes ao longo do texto, não deverá finalizar o Cadastro e usufruir o conteúdo completo fornecido pela Rádio CBN Goiânia. Esses Termos têm como objetivo estabelecer direitos e obrigações, tanto do O Popular como dos Usuários. Se o Usuário discordar ou não consentir com alguma disposição destes Termos de Uso, recomendamos que não conclua o Cadastro e não mais acesse o Portal de O Popular.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'Ao utilizar-se dos sites e aplicativos, de qualquer maneira, o USUÁRIO aceita e concorda com todos os Termos e Condições de Uso aqui expostos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: '2. CADASTRO DO USUÁRIO, SENHA E SEGURANÇA:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '2.1 - Para navegar por algumas áreas dos site da Rádio CBN Goiânia, e/ou usar alguns dos nossos serviços ou, ainda, para ter direito a um maior consumo gratuito de reportagens, pode ser necessário identificar-se por meio de cadastro, onde poderão ser solicitados dados pessoais, e aceitar o armazenamento de cookies, que são pequenos arquivos instalados por sites nos computadores quando o navegador de internet é usado. Esses arquivos permitem identificar se um mesmo aparelho já fez uma visita anterior ao site, se o usuário tem ou não cadastro ou se é assinante, através de dados fornecidos pelos próprios usuários em cadastro prévio, por livre e espontânea vontade.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '2.2 - O usuário poderá não aceitar os cookies ao navegar pelos sites e aplicativos de Rádio CBN Goiânia. Nesse caso, Rádio CBN Goiânia não garante o correto funcionamento dos sites, aplicativos e demais serviços prestados.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '2.3 - Usuário, neste Termos de Uso, concorda em: i) fornecer informações verdadeiras, exatas, atuais e completas sobre si mesmo quando do registro no cadastro específico para acesso aos Conteúdos no site de Rádio CBN Goiânia; ii) conservar e manter seus dados pessoais atualizados, de modo que suas informações permaneçam constantemente verdadeiras e completas'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '2.4 - O USUÁRIO, ao realizar o seu cadastro, deverá informar seu endereço eletrônico próprio, que será utilizado para a sua identificação no site de Rádio CBN Goiânia e, ainda para que possa receber todas as notificações e mensagens referente ao seu cadastro. O USUÁRIO deve criar a sua senha de acesso, sendo completamente responsável pela segurança e confidencialidade de sua senha e, ainda, qualquer ação que ocorra no campo de seu cadastro. O USUÁRIO poderá alterar a sua senha a qualquer tempo. O endereço eletrônico informado pelo USUÁRIO, bem como a senha  por ele criada serão usados como meio de sua identificação e autorização de acesso ao site de Rádio CBN Goiânia.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '2.5 - O cadastro deve ser realizado por maiores de 18 (dezoito) anos. Os USUÁRIOS menores de 18 (dezoito) anos devem ser representados pelos pais ou responsáveis legais. O mesmo se aplica para aqueles considerados incapazes, nos termos dos artigos 3º e 4º do Código Civil de 2002. O responsável legal será responsável por aceitar este Termos de Uso, se responsabilizando, portanto, pelos feitos do menor do Portal de Rádio CBN Goiânia.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '2.7 - O envio dos e-mails pode ser feito por meio dos servidores de empresa contratada pela Rádio CBN Goiânia. Essa empresa não armazenará e tampouco usará, de nenhuma forma e sob nenhuma hipótese, os dados do cadastro dos usuários para qualquer outro fim que não o envio das mensagens, de acordo com autorização e preferências registrada no momento do cadastro.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '2.8 - A autorização dada pelo usuário para as atividades acima descritas poderá ser revogada, a qualquer momento, através do email faleconosco@cbngoiania.com.br, bem como poderá ser atualizada qualquer informação pessoal que tenha sido fornecida aa Rádio CBN Goiânia. Caso receba alguma promoção identificada como sendo da Rádio CBN Goiânia e tenha dúvidas sobre sua veracidade, o usuário poderá consultar a Rádio CBN Goiânia na página http://www.cbngoiania.com.br/fale-conosco'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '2.9 - O USUÁRIO se compromete a notificar imediatamente Rádio CBN Goiânia sobre qualquer uso não autorizado de seu e-mail eletrônico e senha ou qualquer quebra de segurança de seu conhecimento através do endereço eletrônico http://www.cbngoiania.com.br/cmlink/o-popular/fale-conosco, ou pelo telefone (63) 3215-9540.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: '3. CONTEÚDOS DISPONIBILIZADOS NOS SITES Da Rádio CBN Goiânia'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.1 - O USUÁRIO não assinante poderá acessar de forma gratuita número limitado de conteúdo disponibilizado no site da Rádio CBN Goiânia. Após atingir o número limite de acesso mensal, para continuar tendo acesso ao conteúdo da Rádio CBN Goiânia, o Usuário deverá efetuar o cadastro, inserindo as informações necessárias. O cadastro não confere acesso ilimitado e irrestrito a todo o conteúdo veiculado no site de Rádio CBN Goiânia, mas apenas dá direito ao usuário de acessar um número maior de reportagens.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.2 - O USUÁRIO assinante da Rádio CBN Goiânia possui acesso ilimitado a todo o conteúdo disponibilizado, o qual encontra-se protegido por direitos autorais ou outros direitos de propriedade intelectual. É vedada a reprodução total ou parcial, de qualquer conteúdo veiculado no site, aplicativos e ferramentas de propriedade de Rádio CBN Goiânia, incluindo, mas não se limitando, fotografias, charges, vídeos, podcasts, reportagens ou qualquer outro material jornalístico disponibilizado, em qualquer meio de comunicação, sem autorização por escrito.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.3 - O conteúdo do site de Rádio CBN Goiânia não poderá ser utilizado para fins que não sejam exclusivamente não comerciais, ficando o usuário integralmente responsável por qualquer dano ou prejuízo causado em decorrência da sua utilização para fins diversos daqueles aqui especificados. Neste caso, a Rádio CBN Goiânia poderá, a seu exclusivo critério, suspender o acesso do usuário por tempo indeterminado.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.4 - O USUÁRIO não poderá utilizar o site e aplicativos da Rádio CBN Goiânia para divulgação de produtos e serviços, ou qualquer atividade com fins lucrativos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.5 - O USUÁRIO assinante poderá fazer comentários nas reportagens veiculadas, ficando desde já estabelecido, que será integralmente responsável pelo seu teor, bem como por todas as opiniões, dados e informações neles contidos, respondendo o USUÁRIO no âmbito civil e criminal, perante qualquer pessoa física e/ou jurídica que se sinta prejudicada ou ofendida em decorrência de tais comentários, uma vez que não é possível o monitoramento prévio, por parte da Rádio CBN Goiânia, dos comentários que serão inseridos em seus sites. O USUÁRIO responderá de forma exclusiva e independente perante aquele que se sentir prejudicado pelos comentários, e assegurando a exclusão da Rádio CBN Goiânia de qualquer responsabilidade ou ação judicial pelas opiniões constantes nos comentários.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.6 -  a Rádio CBN Goiânia não se responsabiliza pelo conteúdo acima, item 3.5 supra, quando o mesmo for publicado por um menor de idade, momento no qual a responsabilidade será de um dos genitores ou representante legal que consentiu com a participação do menor nas Plataformas e aceitou os presentes Termos e Condições de Uso.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.7 - a Rádio CBN Goiânia não se responsabiliza por realizar armazenagem e backups de comentários inseridos, disponibilizados ou gerados por USUÁRIOS no Portal.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.8 -  Os USUÁRIOS se comprometem a não postar quaisquer comentários que constituam violação a direito de terceiros, bem como infrinjam direitos de propriedade intelectual. Rádio CBN Goiânia não se responsabiliza por tais atos. '
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.9 - O USUÁRIO declara ter ciência e concordar que os comentários poderão ser reproduzidos e/ou explorados juntamente com matérias jornalísticas que a Rádio CBN Goiânia julgar pertinentes, em qualquer outra ferramenta/produto de titularidade de Rádio CBN Goiânia a seu exclusivo critério.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.10 - a Rádio CBN Goiânia se exime de toda e qualquer responsabilidade perante o USUÁRIO e terceiros, decorrentes dos comentários inseridos pelos USUÁRIOS, tendo em vista a impossibilidade técnica de se efetuar monitoramento preventivo de todos os comentários inseridos por Usuários e terceiros em seu Portal.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.11  - O material jornalístico produzido pela Rádio CBN Goiânia é protegido por lei. As regras têm como objetivo proteger o investimento feito pela Rádio CBN Goiânia na qualidade constante de seu jornalismo.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.12 - a Rádio CBN Goiânia somente excluirá comentários feitos em reportagens em seus sites mediante requerimento judicial e/ou da Administração Pública.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.13 - O USUÁRIO declara ter ciência e concordar que os comentários poderão ser reproduzidos e/ou explorados juntamente com matérias jornalísticas que a Rádio CBN Goiânia julgar pertinentes, a seu exclusivo critério.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.9 - Esta política vale apenas para os sites, ferramentas e aplicativos pertencentes ao site da Rádio CBN Goiânia.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '3.10 - a Rádio CBN Goiânia não é responsável por sites fora de seu domínio, não possuindo qualquer controle sobre privacidade, conteúdo, confidencialidade ou consequências de sua utilização.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: '4. PUBLICIDADE'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '4.1 – a Rádio CBN Goiânia não se responsabiliza pelo conteúdo, condições comerciais e cumprimento de qualquer oferta, publicidade ou anúncio veiculado nos seus sites. Assim sendo, qualquer dano ou prejuízo causado a terceiros em decorrência de tais ofertas ou anúncios, serão de responsabilidade exclusiva de seus respectivos anunciantes.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: '5. PRIVACIDADE'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '5.1 - a Rádio CBN Goiânia usará todos os meios necessários para proteger a confidencialidade, a integridade e a disponibilidade dos dados pessoais dos usuários. As informações serão incorporadas ao banco de dados do GJC e ficarão armazenadas na sede do GJC, restritas apenas aos seus funcionários e pessoas autorizadas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '5.2 - Os dados do usuário nunca serão transferidos pelo  Rádio CBN Goiânia a terceiros, que não sejam parceiros ou empresas contratadas para as finalidades previstas neste documento, sem que o usuário tenha previamente autorizado, exceto em casos de decisão judicial. Também nunca serão usados para qualquer outro fim além do motivo de sua coleta. Caso sejam indevidamente utilizados, os responsáveis estão sujeitos a sanções judiciais e administrativas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '5.3 - As informações coletadas dos usuários poderão ser utilizadas para as seguintes finalidades:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'I. Informar sobre conteúdo publicado pela Rádio CBN Goiânia e novos produtos da empresa;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'II. Manter atualizados os dados de usuários para contato por telefone, correio eletrônico e mala direta;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'III. Analisar estatísticas gerais de uso do site, sem nenhuma identificação individual dos usuários, visando melhorar a experiência de navegação, através de registros de informações sobre quais páginas foram acessadas, qual é seu navegador, seu IP, seu sistema operacional, entre outros;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'IV. Realizar campanhas de comunicação e marketing de relacionamento;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'V.  Divulgar ofertas especiais de parceiros.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '5.4. a Rádio CBN Goiânia tem o compromisso em melhorar continuamente os controles de atualização, gerenciamento, exportação e exclusão dos dados pessoais dos usuários, evoluindo seus sistemas em conformidade com os regulamentos de proteção de dados vigentes que possam atingir seu universo de leitores. a Rádio CBN Goiânia se compromete a pormenorizar de forma técnica, caso haja interesse, como ocorre o processamento de dados na empresa.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: '6. PRAZO'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '6.1 - O presente Termo permanecerá vigente por prazo indeterminado, sendo resguardado aa Rádio CBN Goiânia o direito de modificar ou cancelar qualquer conteúdo disponibilizado nos seus sites e, a qualquer momento, sem aviso prévio.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: '7. VIGÊNCIA E CANCELAMENTO'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '7.1 O presente instrumento vigorará por prazo indeterminado, observadas as regras previstas nessa cláusula para cancelamento do Plano contratado, de acordo com a modalidade de pagamento escolhida pelo USUÁRIO.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '7.2 - O USUÁRIO poderá a qualquer momento solicitar o cancelamento dos Recursos através do Serviço ao Assinante da Rádio CBN Goiânia ou através dos telefones constantes na página https://cbngoiania.com.br/fale-conosco, observadas as condições estabelecidas nesse documento. a Rádio CBN Goiânia poderá rescindir o presente documento de contratação dos Recursos a qualquer momento mediante comunicação prévia, no prazo de 20 (vinte) dias, por escrito, enviada ao USUÁRIO.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '7.3 - No cancelamento o USUÁRIO se compromete a saldar e liquidar eventuais débitos e pendências existentes e vincendas relativos a Recursos já disponibilizados, podendo usufruir destes Recursos até o final do período adimplido.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: '8. PREÇOS, PLANOS E OFERTAS'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '8.1 - Pelos Recursos contratados o USUÁRIO pagará os valores constantes na Oferta ou informados no ato da contratação, de acordo com a forma e modalidade de pagamento escolhida.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '8.2 - Os recursos contratados em cada plano podem sofrer variação de acordo com as demandas e necessidades de mercado, cabendo aa Rádio CBN Goiânia manter o equilíbrio do benefício contratado no ato da compra.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '8.3 - Pedidos pagos com cartão de crédito estão sujeitos à aprovação da administradora do cartão. A entrega dos Recursos é considerada a partir da checagem dos dados cadastrais e da confirmação do pagamento, de acordo com prazo da administradora do cartão.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '8.4 - Pedidos pagos com boleto bancário serão considerados válidos a partir da confirmação do pagamento do boleto pelo banco.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '8.5 - Conforme a forma de pagamento escolhida, o USUÁRIO declara expressamente concordar que a Rádio CBN Goiânia efetue débitos em seu cartão de crédito ou conta corrente na periodicidade de pagamento escolhida pelo USUÁRIO. Caso o USUÁRIO possua mais de uma forma de pagamento cadastrada e não seja possível realizar o débito na forma de pagamento preferencial indicada pelo USUÁRIO, a Rádio CBN Goiânia se reserva ao direito de realizar o débito em qualquer das outras formas de pagamento cadastrados pelo USUÁRIO.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '8.6 - O USUÁRIO se declara ciente de que, possuindo o banco emissor tal funcionalidade, o cartão de débito ou crédito vencido ou expirado será automaticamente renovado, dando continuidade à cobrança dos recursos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '8.7 - No caso de impossibilidade do débito dos valores na modalidade de cartão de crédito ou débito em conta corrente, a Rádio CBN Goiânia reserva-se o direito de emitir contra o USUÁRIO um boleto para cobrança dos valores devidos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '8.9 - Os planos e preço podem ser alterados, a qualquer tempo, de acordo com as condições comerciais da empresa.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: '9. INDISPONIBILIDADE DO SITE'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: 'a Rádio CBN Goiânia não terá qualquer responsabilidade na hipótese de indisponibilidade dos sites causada por caso fortuito ou força maior, alheias ao seu controle e que fujam da sua esfera de responsabilidade.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: '10. DISPOSIÇÕES GERAIS'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '10.1 - Caso qualquer das disposições do presente Termo venha a ser considerada nula, inválida ou inexequível, tal decisão não afetará a validade das disposições remanescentes, que continuarão a vigorar e a produzir efeitos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '10.2 - a Rádio CBN Goiânia poderá atualizar o presente Termo a qualquer momento. Caso haja mudança em algum item deste compromisso, todos os leitores cadastrados poderão ser avisados, e o novo texto será publicado nesta página.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '10.3 - Independentemente de notificação, o usuário deverá acessar esta página com frequência para garantir que esteja de acordo com eventuais mudanças realizadas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '10.4 - O presente Termo é regido pela legislação brasileira, sendo eleito o foro da Comarca da Capital do Estado de Goiás para dirimir qualquer controvérsia.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Heading3, {
      children: '11. CONTATO'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index_Paragraph, {
      children: '10.1 - Em caso de dúvidas ou solicitações acerca de uso dos dados pessoais ou sobre a Política de Privacidade de Rádio CBN Goiânia, o USUÁRIO pode entrar em contato através do formulário disponível em: https://cbngoiania.com.br/fale-conosco.'
    })]
  });
};

/* harmony default export */ var cbngo_Terms_index = (PageTermsCbngo);
;// CONCATENATED MODULE: ./components/Expediente/Terms.index.tsx
// @ts-nocheck





var Expediente_Terms_index_MainDiv = prensa/* PrensaEngine.styled */.u7.styled('div', {
  align: ['column', 'left', 'top'],
  fontFamily: '$primary',
  my: '$22',
  maxWidth: '940px',
  width: '100%'
});
var Expediente_Terms_index_Heading1 = prensa/* PrensaEngine.styled */.u7.styled('h1', {
  fontSize: '30px',
  fontWeight: 700,
  lineHeight: '36px',
  mt: '$0',
  mb: '$4'
});
var Expediente_Terms_index_Heading2 = prensa/* PrensaEngine.styled */.u7.styled('h2', {
  fontSize: '25px',
  fontWeight: 700,
  lineHeight: '30px',
  mt: '$8',
  mb: '$4'
});
var Expediente_Terms_index_Heading3 = prensa/* PrensaEngine.styled */.u7.styled('h3', {
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: '22px',
  my: '$4'
});
var Expediente_Terms_index_Paragraph = prensa/* PrensaEngine.styled */.u7.styled('p', {
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '24px',
  mt: '$0',
  mb: '$4'
});

var PageTerms = function PageTerms(_ref) {
  var site = _ref.site;

  if (site === 'tocantins') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Terms_index, {});
  } else if (site === 'cbngo') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(cbngo_Terms_index, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Expediente_Terms_index_MainDiv, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading1, {
      children: "Termos e Condi\xE7\xF5es de Uso do Site do Jornal O Popular"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: "1. INTRODU\xC7\xC3O"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'O Site do Jornal O Popular (O Popular) consiste em um portal de conteúdos jornalísticos de titularidade do Grupo Jaime Câmara, sediada na Rua Thomas Edison, nº 400, Setor Serrinha, Goiânia GO, devidamente inscrita no CNPJ sob o nº 01.536.754/0001-2 ("GJC").'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'O presente Termo de Uso (“Termos de Uso”) regula a utilização e acesso ao site https://opopular.com.br/ de propriedade do Grupo Jaime Câmera e aos serviços de assinatura digital do produto denominado Jornal O Popular. Neste Termos de Uso, o usuário que utilizar e acessar os Produtos Digitais, terá acesso as informações e regras gerais sobre a utilização dos Produtos Digitais e funcionalidades decorrentes.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'Constituem os “Conteúdos do Jornal O Popular” todo e qualquer conteúdo, aplicativo, ferramenta, disponibilizados sem cessão definitiva (licenciamento) pelo O Popular, para utilização por qualquer pessoa que acessar tais conteúdo.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'A aceitação deste Termo de Uso deverá ser feita no momento do Cadastro, juntamente com a Política de Privacidade, acessível por meio deste link https://opopular.com.br/politica-de-privacidade. Se você interessado, não concordar com as disposições constantes ao longo do texto, não deverá finalizar o Cadastro e usufruir o conteúdo completo fornecido pelo Jornal O Popular. Esses Termos têm como objetivo estabelecer direitos e obrigações, tanto do O Popular como dos Usuários. Se o Usuário discordar ou não consentir com alguma disposição destes Termos de Uso, recomendamos que não conclua o Cadastro e não mais acesse o Portal de O Popular.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'Ao utilizar-se dos sites e aplicativos, de qualquer maneira, o USUÁRIO aceita e concorda com todos os Termos e Condições de Uso aqui expostos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: '2. CADASTRO DO USUÁRIO, SENHA E SEGURANÇA:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '2.1 - Para navegar por algumas áreas dos site do Jornal O Popular, e/ou usar alguns dos nossos serviços ou, ainda, para ter direito a um maior consumo gratuito de reportagens, pode ser necessário identificar-se por meio de cadastro, onde poderão ser solicitados dados pessoais, e aceitar o armazenamento de cookies, que são pequenos arquivos instalados por sites nos computadores quando o navegador de internet é usado. Esses arquivos permitem identificar se um mesmo aparelho já fez uma visita anterior ao site, se o usuário tem ou não cadastro ou se é assinante, através de dados fornecidos pelos próprios usuários em cadastro prévio, por livre e espontânea vontade.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '2.2 - O usuário poderá não aceitar os cookies ao navegar pelos sites e aplicativos de O Popular. Nesse caso, O Popular não garante o correto funcionamento dos sites, aplicativos e demais serviços prestados.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '2.3 - Usuário, neste Termos de Uso, concorda em: i) fornecer informações verdadeiras, exatas, atuais e completas sobre si mesmo quando do registro no cadastro específico para acesso aos Conteúdos no site de O Popular; ii) conservar e manter seus dados pessoais atualizados, de modo que suas informações permaneçam constantemente verdadeiras e completas'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '2.4 - O USUÁRIO, ao realizar o seu cadastro, deverá informar seu endereço eletrônico próprio, que será utilizado para a sua identificação no site de O Popular e, ainda para que possa receber todas as notificações e mensagens referente ao seu cadastro. O USUÁRIO deve criar a sua senha de acesso, sendo completamente responsável pela segurança e confidencialidade de sua senha e, ainda, qualquer ação que ocorra no campo de seu cadastro. O USUÁRIO poderá alterar a sua senha a qualquer tempo. O endereço eletrônico informado pelo USUÁRIO, bem como a senha  por ele criada serão usados como meio de sua identificação e autorização de acesso ao site de O Popular.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '2.5 - O cadastro deve ser realizado por maiores de 18 (dezoito) anos. Os USUÁRIOS menores de 18 (dezoito) anos devem ser representados pelos pais ou responsáveis legais. O mesmo se aplica para aqueles considerados incapazes, nos termos dos artigos 3º e 4º do Código Civil de 2002. O responsável legal será responsável por aceitar este Termos de Uso, se responsabilizando, portanto, pelos feitos do menor do Portal de O Popular.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '2.7 - O envio dos e-mails pode ser feito por meio dos servidores de empresa contratada pelo O Popular. Essa empresa não armazenará e tampouco usará, de nenhuma forma e sob nenhuma hipótese, os dados do cadastro dos usuários para qualquer outro fim que não o envio das mensagens, de acordo com autorização e preferências registrada no momento do cadastro.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '2.8 - A autorização dada pelo usuário para as atividades acima descritas poderá ser revogada, a qualquer momento, através do email faleconosco@opopular.com.br, bem como poderá ser atualizada qualquer informação pessoal que tenha sido fornecida ao O Popular. Caso receba alguma promoção identificada como sendo do Jornal O Popular e tenha dúvidas sobre sua veracidade, o usuário poderá consultar o Jornal O Popular na página http://www.opopular.com.br/fale-conosco'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '2.9 - O USUÁRIO se compromete a notificar imediatamente O Popular sobre qualquer uso não autorizado de seu e-mail eletrônico e senha ou qualquer quebra de segurança de seu conhecimento através do endereço eletrônico http://www.opopular.com.br/cmlink/o-popular/fale-conosco, ou pelo telefone (62) 3250-1220.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: '3. CONTEÚDOS DISPONIBILIZADOS NOS SITES DO JORNAL O POPULAR'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.1 - O USUÁRIO não assinante poderá acessar de forma gratuita número limitado de conteúdo disponibilizado no site do Jornal O Popular. Após atingir o número limite de acesso mensal, para continuar tendo acesso ao conteúdo do Jornal O Popular, o Usuário deverá efetuar o cadastro, inserindo as informações necessárias. O cadastro não confere acesso ilimitado e irrestrito a todo o conteúdo veiculado no site de O Popular, mas apenas dá direito ao usuário de acessar um número maior de reportagens.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.2 - O USUÁRIO assinante do Jornal O Popular possui acesso ilimitado a todo o conteúdo disponibilizado, o qual encontra-se protegido por direitos autorais ou outros direitos de propriedade intelectual. É vedada a reprodução total ou parcial, de qualquer conteúdo veiculado no site, aplicativos e ferramentas de propriedade de Jornal O Popular, incluindo, mas não se limitando, fotografias, charges, vídeos, podcasts, reportagens ou qualquer outro material jornalístico disponibilizado, em qualquer meio de comunicação, sem autorização por escrito.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.3 - O conteúdo do site de O Popular não poderá ser utilizado para fins que não sejam exclusivamente não comerciais, ficando o usuário integralmente responsável por qualquer dano ou prejuízo causado em decorrência da sua utilização para fins diversos daqueles aqui especificados. Neste caso, o Jornal O Popular poderá, a seu exclusivo critério, suspender o acesso do usuário por tempo indeterminado.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.4 - O USUÁRIO não poderá utilizar o site e aplicativos do O Popular para divulgação de produtos e serviços, ou qualquer atividade com fins lucrativos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.5 - O USUÁRIO assinante poderá fazer comentários nas reportagens veiculadas, ficando desde já estabelecido, que será integralmente responsável pelo seu teor, bem como por todas as opiniões, dados e informações neles contidos, respondendo o USUÁRIO no âmbito civil e criminal, perante qualquer pessoa física e/ou jurídica que se sinta prejudicada ou ofendida em decorrência de tais comentários, uma vez que não é possível o monitoramento prévio, por parte do Jornal O Popular, dos comentários que serão inseridos em seus sites. O USUÁRIO responderá de forma exclusiva e independente perante aquele que se sentir prejudicado pelos comentários, e assegurando a exclusão do Jornal O Popular de qualquer responsabilidade ou ação judicial pelas opiniões constantes nos comentários.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.6 -  O Jornal O Popular não se responsabiliza pelo conteúdo acima, item 3.5 supra, quando o mesmo for publicado por um menor de idade, momento no qual a responsabilidade será de um dos genitores ou representante legal que consentiu com a participação do menor nas Plataformas e aceitou os presentes Termos e Condições de Uso.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.7 - O Jornal O Popular não se responsabiliza por realizar armazenagem e backups de comentários inseridos, disponibilizados ou gerados por USUÁRIOS no Portal.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.8 -  Os USUÁRIOS se comprometem a não postar quaisquer comentários que constituam violação a direito de terceiros, bem como infrinjam direitos de propriedade intelectual. O Popular não se responsabiliza por tais atos. '
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.9 - O USUÁRIO declara ter ciência e concordar que os comentários poderão ser reproduzidos e/ou explorados juntamente com matérias jornalísticas que o Jornal O Popular julgar pertinentes, em qualquer outra ferramenta/produto de titularidade de O Popular a seu exclusivo critério.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.10 - O Jornal O Popular se exime de toda e qualquer responsabilidade perante o USUÁRIO e terceiros, decorrentes dos comentários inseridos pelos USUÁRIOS, tendo em vista a impossibilidade técnica de se efetuar monitoramento preventivo de todos os comentários inseridos por Usuários e terceiros em seu Portal.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.11  - O material jornalístico produzido pelo Jornal O Popular é protegido por lei. As regras têm como objetivo proteger o investimento feito pelo Jornal O Popular na qualidade constante de seu jornalismo.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.12 - O Jornal O Popular somente excluirá comentários feitos em reportagens em seus sites mediante requerimento judicial e/ou da Administração Pública.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.13 - O USUÁRIO declara ter ciência e concordar que os comentários poderão ser reproduzidos e/ou explorados juntamente com matérias jornalísticas que o Jornal O Popular julgar pertinentes, a seu exclusivo critério.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.9 - Esta política vale apenas para os sites, ferramentas e aplicativos pertencentes ao site do Jornal O Popular.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '3.10 - O Jornal O Popular não é responsável por sites fora de seu domínio, não possuindo qualquer controle sobre privacidade, conteúdo, confidencialidade ou consequências de sua utilização.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: '4. PUBLICIDADE'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '4.1 – O Jornal O Popular não se responsabiliza pelo conteúdo, condições comerciais e cumprimento de qualquer oferta, publicidade ou anúncio veiculado nos seus sites. Assim sendo, qualquer dano ou prejuízo causado a terceiros em decorrência de tais ofertas ou anúncios, serão de responsabilidade exclusiva de seus respectivos anunciantes.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: '5. PRIVACIDADE'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '5.1 - O Jornal O Popular usará todos os meios necessários para proteger a confidencialidade, a integridade e a disponibilidade dos dados pessoais dos usuários. As informações serão incorporadas ao banco de dados do GJC e ficarão armazenadas na sede do GJC, restritas apenas aos seus funcionários e pessoas autorizadas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '5.2 - Os dados do usuário nunca serão transferidos pelo  Jornal O Popular a terceiros, que não sejam parceiros ou empresas contratadas para as finalidades previstas neste documento, sem que o usuário tenha previamente autorizado, exceto em casos de decisão judicial. Também nunca serão usados para qualquer outro fim além do motivo de sua coleta. Caso sejam indevidamente utilizados, os responsáveis estão sujeitos a sanções judiciais e administrativas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '5.3 - As informações coletadas dos usuários poderão ser utilizadas para as seguintes finalidades:'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'I. Informar sobre conteúdo publicado pelo Jornal O Popular e novos produtos da empresa;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'II. Manter atualizados os dados de usuários para contato por telefone, correio eletrônico e mala direta;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'III. Analisar estatísticas gerais de uso do site, sem nenhuma identificação individual dos usuários, visando melhorar a experiência de navegação, através de registros de informações sobre quais páginas foram acessadas, qual é seu navegador, seu IP, seu sistema operacional, entre outros;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'IV. Realizar campanhas de comunicação e marketing de relacionamento;'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'V.  Divulgar ofertas especiais de parceiros.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '5.4. O Jornal O Popular tem o compromisso em melhorar continuamente os controles de atualização, gerenciamento, exportação e exclusão dos dados pessoais dos usuários, evoluindo seus sistemas em conformidade com os regulamentos de proteção de dados vigentes que possam atingir seu universo de leitores. O Jornal O Popular se compromete a pormenorizar de forma técnica, caso haja interesse, como ocorre o processamento de dados na empresa.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: '6. PRAZO'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '6.1 - O presente Termo permanecerá vigente por prazo indeterminado, sendo resguardado ao Jornal O Popular o direito de modificar ou cancelar qualquer conteúdo disponibilizado nos seus sites e, a qualquer momento, sem aviso prévio.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: '7. VIGÊNCIA E CANCELAMENTO'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '7.1 O presente instrumento vigorará por prazo indeterminado, observadas as regras previstas nessa cláusula para cancelamento do Plano contratado, de acordo com a modalidade de pagamento escolhida pelo USUÁRIO.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '7.2 - O USUÁRIO poderá a qualquer momento solicitar o cancelamento dos Recursos através do Serviço ao Assinante do Jornal O Popular ou através dos telefones constantes na página https://opopular.com.br/fale-conosco, observadas as condições estabelecidas nesse documento. O Jornal O Popular poderá rescindir o presente documento de contratação dos Recursos a qualquer momento mediante comunicação prévia, no prazo de 20 (vinte) dias, por escrito, enviada ao USUÁRIO.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '7.3 - No cancelamento o USUÁRIO se compromete a saldar e liquidar eventuais débitos e pendências existentes e vincendas relativos a Recursos já disponibilizados, podendo usufruir destes Recursos até o final do período adimplido.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: '8. PREÇOS, PLANOS E OFERTAS'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '8.1 - Pelos Recursos contratados o USUÁRIO pagará os valores constantes na Oferta ou informados no ato da contratação, de acordo com a forma e modalidade de pagamento escolhida.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '8.2 - Os recursos contratados em cada plano podem sofrer variação de acordo com as demandas e necessidades de mercado, cabendo ao Jornal O Popular manter o equilíbrio do benefício contratado no ato da compra.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '8.3 - Pedidos pagos com cartão de crédito estão sujeitos à aprovação da administradora do cartão. A entrega dos Recursos é considerada a partir da checagem dos dados cadastrais e da confirmação do pagamento, de acordo com prazo da administradora do cartão.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '8.4 - Pedidos pagos com boleto bancário serão considerados válidos a partir da confirmação do pagamento do boleto pelo banco.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '8.5 - Conforme a forma de pagamento escolhida, o USUÁRIO declara expressamente concordar que o Jornal O Popular efetue débitos em seu cartão de crédito ou conta corrente na periodicidade de pagamento escolhida pelo USUÁRIO. Caso o USUÁRIO possua mais de uma forma de pagamento cadastrada e não seja possível realizar o débito na forma de pagamento preferencial indicada pelo USUÁRIO, o Jornal O Popular se reserva ao direito de realizar o débito em qualquer das outras formas de pagamento cadastrados pelo USUÁRIO.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '8.6 - O USUÁRIO se declara ciente de que, possuindo o banco emissor tal funcionalidade, o cartão de débito ou crédito vencido ou expirado será automaticamente renovado, dando continuidade à cobrança dos recursos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '8.7 - No caso de impossibilidade do débito dos valores na modalidade de cartão de crédito ou débito em conta corrente, o Jornal O Popular reserva-se o direito de emitir contra o USUÁRIO um boleto para cobrança dos valores devidos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '8.9 - Os planos e preço podem ser alterados, a qualquer tempo, de acordo com as condições comerciais da empresa.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: '9. INDISPONIBILIDADE DO SITE'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: 'O Jornal O Popular não terá qualquer responsabilidade na hipótese de indisponibilidade dos sites causada por caso fortuito ou força maior, alheias ao seu controle e que fujam da sua esfera de responsabilidade.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: '10. DISPOSIÇÕES GERAIS'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '10.1 - Caso qualquer das disposições do presente Termo venha a ser considerada nula, inválida ou inexequível, tal decisão não afetará a validade das disposições remanescentes, que continuarão a vigorar e a produzir efeitos.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '10.2 - O Jornal O Popular poderá atualizar o presente Termo a qualquer momento. Caso haja mudança em algum item deste compromisso, todos os leitores cadastrados poderão ser avisados, e o novo texto será publicado nesta página.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '10.3 - Independentemente de notificação, o usuário deverá acessar esta página com frequência para garantir que esteja de acordo com eventuais mudanças realizadas.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '10.4 - O presente Termo é regido pela legislação brasileira, sendo eleito o foro da Comarca da Capital do Estado de Goiás para dirimir qualquer controvérsia.'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Heading3, {
      children: '11. CONTATO'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index_Paragraph, {
      children: '10.1 - Em caso de dúvidas ou solicitações acerca de uso dos dados pessoais ou sobre a Política de Privacidade de O Popular, o USUÁRIO pode entrar em contato através do formulário disponível em: https://opopular.com.br/fale-conosco.'
    })]
  });
};

/* harmony default export */ var Expediente_Terms_index = (PageTerms);
;// CONCATENATED MODULE: ./components/WhatsAppBanner/index.tsx







var WhatsAppBanner = function WhatsAppBanner(props) {
  var _props$customProps, _props$customProps2, _props$customProps2$c;

  var slug = "cbngo" || 0;
  var className = (_props$customProps = props.customProps) === null || _props$customProps === void 0 ? void 0 : _props$customProps.className;
  var baseClassName = "WhatsAppBanner ".concat((props === null || props === void 0 ? void 0 : props.className) || '', " ").concat(className);
  var isDesktop = props === null || props === void 0 ? void 0 : (_props$customProps2 = props.customProps) === null || _props$customProps2 === void 0 ? void 0 : (_props$customProps2$c = _props$customProps2.className) === null || _props$customProps2$c === void 0 ? void 0 : _props$customProps2$c.includes('desktop');
  var ref = (0,react.useRef)(null);
  var isVisible = useOnScreen(ref);
  (0,react.useEffect)(function () {
    if (isVisible) {
      props.handleSendViewEvent(WIDGET_TYPES.WHATSAPP);
    }
  }, [isVisible]);
  if (isDesktop) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    id: "whatsapp-pop",
    href: "https://api.whatsapp.com/send?phone=".concat(props.telNumber),
    onClick: function onClick() {
      return props.handleSendClickEvent(WIDGET_TYPES.WHATSAPP);
    },
    rel: "noreferrer",
    target: "_blank",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      ref: ref,
      className: baseClassName,
      css: {
        align: ['row', 'center', 'middle'],
        'img': {
          width: 'calc(100% - $4)'
        },
        mb: '$6'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/".concat(slug, "/banners/BannerWhatsApp.svg"),
        alt: "WhatsApp"
      })
    })
  });
};

/* harmony default export */ var components_WhatsAppBanner = (WhatsAppBanner);
;// CONCATENATED MODULE: ./components/StoriesPop/StoriesPopComponent.index.tsx





var StoriesPopComponent = function StoriesPopComponent() {
  (0,react.useEffect)(function () {
    var msfb = document.querySelector("#msfb");

    if (msfb) {
      msfb.innerHTML = "\n        <div id=\"mss6\" class=\"mpsa\">\n          <div class=\"msmd\">\n            <p class=\"msps\"></p>\n            <span>\n              <p class=\"msst\"></p>\n              <p class=\"msso\"></p>\n            </span>\n          </div>\n          <div class=\"msmd\">\n            <p class=\"msps\"></p>\n            <span>\n              <p class=\"msst\"></p>\n              <p class=\"msso\"></p>\n            </span>\n          </div>\n          <div class=\"msmd\">\n            <p class=\"msps\"></p>\n            <span>\n              <p class=\"msst\"></p>\n              <p class=\"msso\"></p>\n            </span>\n          </div>\n          <div class=\"msmd\">\n            <p class=\"msps\"></p>\n            <span>\n              <p class=\"msst\"></p>\n              <p class=\"msso\"></p>\n            </span>\n          </div>\n          <div class=\"msmd\">\n            <p class=\"msps\"></p>\n            <span>\n              <p class=\"msst\"></p>\n              <p class=\"msso\"></p>\n            </span>\n          </div>\n        </div>\n      ";
    } // Carrega os scripts de forma síncrona para garantir a execução correta


    var ampStoryScript = document.createElement('script');
    ampStoryScript.src = 'https://cdn.ampproject.org/amp-story-player-v0.js';

    ampStoryScript.onload = function () {
      var makeStoriesScript = document.createElement('script');
      makeStoriesScript.src = 'https://js.makestories.io/player/StoryPlayer.js';

      makeStoriesScript.onload = function () {
        // Inicializa o player após o carregamento do script
        if (window.msPlayer) {
          window.msPlayer({
            root: "#ms-story-player55ba295e7186",
            widgetId: "0a60ff20-b1cf-400c-9a9a-55ba295e7186",
            openButtonText: "Abrir"
          });
        }
      };

      document.body.appendChild(makeStoriesScript);
    };

    document.body.appendChild(ampStoryScript); // Cleanup dos scripts ao desmontar o componente

    return function () {
      document.body.removeChild(ampStoryScript);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      align: ['column', 'left', 'top'],
      width: 'auto',
      border: '1px solid #E3F1FC',
      borderRadius: '5px',
      padding: '0 $2',
      mb: '$4'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      css: {
        color: '#000',
        fontFamily: '$primary',
        fontSize: '18px',
        lineHeight: '25px',
        fontWeight: 500,
        ml: '$1',
        mb: '0px'
      },
      children: "Stories"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        id: "ms-story-player55ba295e7186",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("style", {
          children: "\n          #mss6 * {\n            box-sizing: border-box;\n            margin: 0;\n          }\n          .mpsa {\n            scroll-behavior: smooth;\n            width: 100%;\n            height: 100%;\n            padding: 15px 0;\n          }\n          #mss6 {\n            margin: 0 auto;\n            padding: 0 10px;\n            max-width: 650px;\n          }\n          .mpsa::-webkit-scrollbar {\n            height: 0;\n            width: 0;\n          }\n          @keyframes shimmer {\n            0% {\n              left: -100px;\n            }\n            100% {\n              left: 100px;\n            }\n          }\n          #mss6 .msmd {\n            width: 100%;\n            display: flex;\n            margin: 0 auto 20px;\n            padding: 15px;\n            border: 1px solid #194392;\n            border-radius: 5px;\n            max-width: 700px;\n            background: #fff;\n            color: #194392;\n          }\n          #mss6 .msso,\n          #mss6 .msst {\n            width: 25%;\n            padding: 0 20px;\n            margin-right: auto;\n            height: 20px;\n            position: relative;\n            overflow: hidden;\n            background: #e6e6e6;\n            border-radius: 5px;\n          }\n          #mss6 .msso {\n            height: 35px;\n            width: 20%;\n            margin-top: 10px;\n          }\n          #mss6 span {\n            flex: 1;\n            text-align: left;\n          }\n          #mss6 .msps {\n            min-height: 120px;\n            width: 100px;\n            min-width: 100px;\n            height: 100%;\n            border-radius: 4px;\n            object-fit: cover;\n            margin-right: 15px;\n            position: relative;\n            overflow: hidden;\n            background: #e6e6e6;\n          }\n          #mss6 .msps::after,\n          #mss6 .msso::after,\n          #mss6 .msst::after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            height: 100px;\n            width: 100px;\n            background: linear-gradient(to right, #e6e6e6, rgba(255, 255, 255, 0.5), #e6e6e6);\n            overflow: hidden;\n            animation: shimmer 1.5s ease infinite;\n          }\n        "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          id: "msfb"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        href: "https://cdn.ampproject.org/amp-story-player-v0.css",
        rel: "stylesheet",
        type: "text/css"
      })]
    })]
  });
};

/* harmony default export */ var StoriesPopComponent_index = (StoriesPopComponent);
;// CONCATENATED MODULE: ./components/Base/Base.Component.tsx


function Base_Component_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Base_Component_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Base_Component_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_Component_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // import ClassiComponent, { ClassiComponentProps } from "components/ClassiComBr";


























var BaseComponent = function BaseComponent(props) {
  var _props$customProps;

  var className = (_props$customProps = props.customProps) === null || _props$customProps === void 0 ? void 0 : _props$customProps.className;
  var baseClassName = "BaseComponent ".concat((props === null || props === void 0 ? void 0 : props.className) || "", " ").concat(className);

  if ((props === null || props === void 0 ? void 0 : props.slotTemplateCode) === "CbnPageTeam") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Team_index, {
      site: "cbn"
    });
  }

  if ((props === null || props === void 0 ? void 0 : props.slotTemplateCode) === "CbngoPageTeam") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Team_index, {
      site: "cbngo"
    });
  }

  if ((props === null || props === void 0 ? void 0 : props.slotTemplateCode) === "CbntoPageTeam") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Team_index, {
      site: "cbnto"
    });
  }

  if ((props === null || props === void 0 ? void 0 : props.slotTemplateCode) === "DaquiPageTeam") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Team_index, {
      site: "daqui"
    });
  }

  if ((props === null || props === void 0 ? void 0 : props.slotTemplateCode) === "PopularPageTeam") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Team_index, {
      site: "opopular"
    });
  }

  if ((props === null || props === void 0 ? void 0 : props.slotTemplateCode) === "TocantinsPageTeam") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Team_index, {
      site: "tocantins"
    });
  }

  if ((props === null || props === void 0 ? void 0 : props.slotTemplateCode) === "TempPagePrivacy") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(PrivacyPolicy_index, {});
  }

  if ((props === null || props === void 0 ? void 0 : props.slotTemplateCode) === "PageTermsTocantins") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index, {
      site: "tocantins"
    });
  }

  if ((props === null || props === void 0 ? void 0 : props.slotTemplateCode) === "PageTermsCbngo") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index, {
      site: "cbngo"
    });
  }

  if ((props === null || props === void 0 ? void 0 : props.slotTemplateCode) === "TemPageTerms") {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Expediente_Terms_index, {
      site: ""
    });
  }

  if (props.className === "TeaserEditais") {
    if ((props === null || props === void 0 ? void 0 : props.slotTemplate) !== "SearchLoadMore") {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Editais_Teaser, Base_Component_objectSpread(Base_Component_objectSpread({}, props), {}, {
        customLink: (link_default()),
        customLinkProps: {
          legacyBehavior: true
        }
      }));
    }
  }

  var handleSendClickEvent = function handleSendClickEvent(type) {//[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // enviarClickWidget(type);
  };

  var handleSendViewEvent = function handleSendViewEvent(type) {//[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // enviarViewWidget(type);
  };

  switch (props.slotTemplate) {
    case "AuthorMiniBio":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_AuthorProfile, Base_Component_objectSpread({}, props));

    case "popMakeStories":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StoriesPopComponent_index, {});
    // FIXME rm classi
    // case "ClassiComBr":
    // const classiProps: ClassiComponentProps = {
    //   handleSendClickEvent,
    //   handleSendViewEvent,
    //   ...props
    // }
    // return <ClassiComponent {...classiProps} />;

    case "DivisorTabs":
      var divisorProps = {
        children: props.name,
        pageBlockId: props.pageBlockId,
        numberValue: props.numberValue,
        slotTemplateId: props.slotTemplateCode
      };
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_DivisorTabsButton, Base_Component_objectSpread({}, divisorProps));

    case "DivisorSimples":
      var simpleTitleProps = {
        isExpanded: false,
        isReadMore: false,
        titleColor: props.slotColor || "",
        titleIcon: props.slotTemplateIcon,
        titleLabel: props.title || ""
      };
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionTitle, Base_Component_objectSpread({}, simpleTitleProps));

    case "DivisorVerMais":
      var sectionTitleReadMoreProps = {
        titleLink: props === null || props === void 0 ? void 0 : props.link,
        isExpanded: true,
        isReadMore: true,
        titleIcon: props.slotTemplateIcon,
        titleLabel: props.title || ""
      };
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionTitle, Base_Component_objectSpread({}, sectionTitleReadMoreProps));

    case "DivisorVejaMais":
      var sectionTitleSeeMoreProps = {
        titleLink: props === null || props === void 0 ? void 0 : props.link,
        isExpanded: false,
        isSeeMore: true,
        titleIcon: props.slotTemplateIcon,
        titleLabel: props.title || ""
      };
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionTitle, Base_Component_objectSpread({}, sectionTitleSeeMoreProps));

    case "DivisorVideos":
      var sectionTitleVideoProps = {
        isExpanded: true,
        isReadMore: true,
        isVideoBox: true,
        titleIcon: props.slotTemplateIcon,
        titleLabel: props.title || ""
      };
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionTitle, Base_Component_objectSpread({}, sectionTitleVideoProps));

    case "DivisorComLinha":
      var urlParams = new URLSearchParams(window.location.search);
      var searchTag = urlParams.get('tag') || '';
      var divisorTitle = searchTag ? "".concat(props.title, " ").concat(searchTag) : props.title || '';
      var sectionTitleProps = {
        isExpanded: true,
        isReadMore: false,
        titleIcon: props.slotTemplateIcon,
        titleLabel: divisorTitle
      };
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionTitle, Base_Component_objectSpread({}, sectionTitleProps));

    case "EditaisFilter":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Editais_Filters, Base_Component_objectSpread({}, props));

    case "EditaisHeader":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Editais_index, Base_Component_objectSpread({}, props));

    case "EditionFeatured":
      var editionProps = Base_Component_objectSpread({
        handleSendClickEvent: handleSendClickEvent,
        handleSendViewEvent: handleSendViewEvent
      }, props);

      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_EditionFeatured, Base_Component_objectSpread({}, editionProps));

    case "FaleConosco":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_FaleConosco, Base_Component_objectSpread({}, props));

    case "Footer":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_index, {});

    case "SearchFilter":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Search_Filter, Base_Component_objectSpread({}, props));

    case "SearchInput":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchInputBox_index, Base_Component_objectSpread(Base_Component_objectSpread({}, props), {}, {
        buttonId: "buscar-avancado-lupa"
      }));

    case "SearchLoadMore":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchMore_index, Base_Component_objectSpread({}, props));

    case "ScriptCode":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Code, Base_Component_objectSpread({}, props));

    case "ScriptPiano":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(PianoOffer, Base_Component_objectSpread({}, props));

    case "ScriptPianoPerfil":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Scripts_PianoPerfil, Base_Component_objectSpread({}, props));

    case "VideoLive":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_VideoLive, Base_Component_objectSpread({}, props));

    case "WhatsApp":
      var whatsappBannerProps = {
        handleSendClickEvent: handleSendClickEvent,
        handleSendViewEvent: handleSendViewEvent,
        telNumber: (props === null || props === void 0 ? void 0 : props.slotTemplateCode) || '5562999952795'
      };
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_WhatsAppBanner, Base_Component_objectSpread({}, whatsappBannerProps));
    // FIXME rm classi
    // case "ClassiSearch":
    // return <ClassiSearch />;

    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }
};

/* harmony default export */ var Base_Component = (BaseComponent);
;// CONCATENATED MODULE: ./components/Assets/CloseIcon.tsx


var CloseIcon = function CloseIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
    })
  });
};
;// CONCATENATED MODULE: ./components/SideMenu/SectionHeader/SideMenuSectionHeader.tsx









var SideMenuSectionHeader = function SideMenuSectionHeader(_ref) {
  var _variantConfig$logo, _assetsContext$assets, _serverSideContext$si, _serverSideContext$si2, _variantConfig$css, _variantConfig$css2, _variantConfig$css3, _variantConfig$css4, _variantConfig$logo2, _variantConfig$logo3;

  var config = _ref.config,
      onClose = _ref.onClose,
      onLogin = _ref.onLogin,
      onLogout = _ref.onLogout,
      variant = _ref.variant;
  var serverSideContext = (0,react.useContext)(ServerSideProps.ServerSidePropsContext);
  var variantConfig = config.variants[variant];
  var advertiseSection = config.advertiseSection;
  var logoName = (variantConfig === null || variantConfig === void 0 ? void 0 : (_variantConfig$logo = variantConfig.logo) === null || _variantConfig$logo === void 0 ? void 0 : _variantConfig$logo.name) || "";
  var assetsContext = (0,react.useContext)(Assets.AssetsContext);
  var banners = assetsContext === null || assetsContext === void 0 ? void 0 : (_assetsContext$assets = assetsContext.assets) === null || _assetsContext$assets === void 0 ? void 0 : _assetsContext$assets.banners;
  var banner = banners.find(function (i) {
    return i.name === logoName;
  });
  var sessionData = (0,react.useContext)(Session.SessionDataContext);
  var isPaywall = serverSideContext === null || serverSideContext === void 0 ? void 0 : (_serverSideContext$si = serverSideContext.site) === null || _serverSideContext$si === void 0 ? void 0 : (_serverSideContext$si2 = _serverSideContext$si.pageConfig) === null || _serverSideContext$si2 === void 0 ? void 0 : _serverSideContext$si2.featureRadioSelectPaywall;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      css: variantConfig === null || variantConfig === void 0 ? void 0 : (_variantConfig$css = variantConfig.css) === null || _variantConfig$css === void 0 ? void 0 : _variantConfig$css.container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: variantConfig === null || variantConfig === void 0 ? void 0 : (_variantConfig$css2 = variantConfig.css) === null || _variantConfig$css2 === void 0 ? void 0 : _variantConfig$css2.iconContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* IconButton */.hU, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(CloseIcon, {}),
          color: variantConfig === null || variantConfig === void 0 ? void 0 : (_variantConfig$css3 = variantConfig.css) === null || _variantConfig$css3 === void 0 ? void 0 : _variantConfig$css3.iconColor,
          onClick: onClose,
          size: "md",
          variant: "ghost",
          css: variantConfig === null || variantConfig === void 0 ? void 0 : (_variantConfig$css4 = variantConfig.css) === null || _variantConfig$css4 === void 0 ? void 0 : _variantConfig$css4.icon
        })
      }), banner && /*#__PURE__*/(0,jsx_runtime.jsx)(ClickableAsset_index/* default */.Z, {
        alt: banner.name,
        src: banner.url,
        href: variantConfig === null || variantConfig === void 0 ? void 0 : (_variantConfig$logo2 = variantConfig.logo) === null || _variantConfig$logo2 === void 0 ? void 0 : _variantConfig$logo2.href,
        id: (_variantConfig$logo3 = variantConfig.logo) === null || _variantConfig$logo3 === void 0 ? void 0 : _variantConfig$logo3.id,
        height: banner.height,
        width: banner.width,
        css: {
          container: variantConfig === null || variantConfig === void 0 ? void 0 : variantConfig.css.logo
        },
        target: "blank"
      })]
    })
  });
};
;// CONCATENATED MODULE: ./components/Buttons/LoginButton.index.tsx


function LoginButton_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LoginButton_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LoginButton_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LoginButton_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var LoginButton = function LoginButton(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Button */.zx, LoginButton_index_objectSpread(LoginButton_index_objectSpread({}, props), {}, {
    variant: "outlined",
    css: {
      button: {
        borderRadius: '$rounded',
        height: '40px',
        paddingLeft: '$9',
        paddingRight: '$9'
      },
      label: {
        color: '$basicBlack',
        fontFamily: '$primary',
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'uppercase'
      }
    },
    children: "Entrar"
  }));
};
;// CONCATENATED MODULE: ./components/Buttons/SideMenuServiceButton.index.tsx


function SideMenuServiceButton_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SideMenuServiceButton_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SideMenuServiceButton_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SideMenuServiceButton_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var SideMenuServiceButton = function SideMenuServiceButton(_ref) {
  var href = _ref.href,
      variant = _ref.variant,
      target = _ref.target;

  var renderIcon = function renderIcon() {
    switch (variant) {
      case 'WhatsApp':
        return 'IcWhatsAppCinza';

      case 'JornalDigital':
      case 'tocantins':
        return 'IcVersaoDigitalCinza';

      default:
        return '';
    }
  };

  var renderName = function renderName() {
    switch (variant) {
      case 'WhatsApp':
        return 'WhatsApp';

      case 'JornalDigital':
        return 'Jornal Digital';

      case 'tocantins':
        return 'Acervo';

      default:
        return '';
    }
  };

  var icon = renderIcon();
  var name = renderName();
  var styles = {
    button: {
      borderRadius: '$alternative',
      backgroundColor: '#EAEAEA',
      height: '52px',
      width: '52px'
    }
  };
  var onClickProps = href ? {
    onClick: function onClick() {
      return target === '_blank' ? window.open(href, "_blank") : window.location.assign(href);
    }
  } : {};
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, SideMenuServiceButton_index_objectSpread(SideMenuServiceButton_index_objectSpread({
    css: {
      align: ['column', 'center', 'middle'],
      m: '$2'
    }
  }, onClickProps), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* IconButton */.hU, {
      variant: "ghost",
      css: styles,
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, SideMenuServiceButton_index_objectSpread({}, (0,useIcon/* useIcon */.b)(icon)))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
      css: {
        color: '#525252',
        fontFamily: '$primary',
        fontSize: '10px',
        fontWeight: 400
      },
      children: name
    })]
  }));
};
;// CONCATENATED MODULE: ./components/Buttons/index.ts


;// CONCATENATED MODULE: ./components/SideMenu/SideMenuSectionTitle/SideMenuSectionTitle.tsx


function SideMenuSectionTitle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SideMenuSectionTitle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SideMenuSectionTitle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SideMenuSectionTitle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var SideMenuSectionTitle = function SideMenuSectionTitle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, SideMenuSectionTitle_objectSpread(SideMenuSectionTitle_objectSpread({
    as: "p",
    css: {
      color: props.color,
      fontFamily: '$primary',
      fontSize: '$retrancaHamburger',
      fontWeight: '$retrancaHamburger',
      lineHeight: '$retrancaHamburger',
      m: '0px',
      pl: '$8',
      pt: '$3',
      pb: '$3',
      textAlign: 'left',
      width: '100%'
    }
  }, props), {}, {
    children: props.children
  }));
};
SideMenuSectionTitle.defaultProps = {
  color: '$primaryMain'
};
;// CONCATENATED MODULE: ./components/DotsBackground/DotsBackground.index.tsx


function DotsBackground_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DotsBackground_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DotsBackground_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DotsBackground_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var DotsBackground = function DotsBackground(_ref) {
  var css = _ref.css,
      children = _ref.children,
      height = _ref.height;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: DotsBackground_index_objectSpread(DotsBackground_index_objectSpread({}, css), {}, {
      background: 'transparent',
      backgroundImage: 'radial-gradient(#E6E6E6 0.5px, transparent 0px)',
      backgroundSize: '3px 3px',
      backgroundPosition: '0 0, 3px 3px',
      height: height,
      width: '100%'
    }),
    children: children
  });
};
DotsBackground.defaultProps = {
  height: '100%'
};
// EXTERNAL MODULE: ./components/Buttons/GhostButton.index.tsx
var GhostButton_index = __webpack_require__(7679);
;// CONCATENATED MODULE: ./components/SideMenu/SubscriberInfo/SubscriberInfo.index.tsx









var SubscriberInfo = function SubscriberInfo(_ref) {
  var type = _ref.type,
      amountLeft = _ref.amountLeft,
      onLogin = _ref.onLogin,
      onLogout = _ref.onLogout;
  var sessionData = (0,react.useContext)(Session.SessionDataContext);

  var renderAnonymous = function renderAnonymous() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        height: "77px",
        width: "100%"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DotsBackground, {
        css: {
          align: ["column", "center", "middle"],
          height: "100%"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoginButton, {
          onClick: onLogin,
          children: "Entrar"
        })
      })
    });
  };

  var renderGuestSubscriber = function renderGuestSubscriber() {
    var _sessionData$emailUsu;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DotsBackground, {
        height: "13px"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        css: {
          align: ["row", "between", "middle"],
          borderColor: "#E6E6E6",
          borderBottomWidth: "1px",
          borderBottomStyle: "solid",
          mx: "$3",
          pt: "$4",
          pb: "$5"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
          css: {
            align: ["row", "center", "middle"]
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
            as: "span",
            css: {
              fontFamily: "$primary",
              fontSize: "$caption3",
              fontWeight: "$caption3",
              lineBreak: "anywhere",
              lineHeight: "$caption3",
              ml: "$2",
              mr: "$2"
            },
            children: "Ol\xE1, ".concat((sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$emailUsu = sessionData.emailUsuario) === null || _sessionData$emailUsu === void 0 ? void 0 : _sessionData$emailUsu.split("@")[0]) || "Convidado")
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(GhostButton_index/* default */.Z, {
          css: {
            button: {
              cursor: "pointer",
              height: "fit-content",
              padding: "0px" // mr: '$6'

            },
            label: {
              color: "$primaryMain",
              fontFamily: "$primary",
              fontSize: "$caption3",
              fontWeight: "$caption4",
              lineHeight: "$caption3"
            }
          },
          onClick: onLogout,
          children: "Sair"
        })]
      })]
    });
  };

  var renderSubscriber = function renderSubscriber() {
    var _sessionData$emailUsu2;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DotsBackground, {
          height: "13px"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
          css: {
            align: ["row", "between", "middle"],
            borderColor: "#E6E6E6",
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
            mx: "$7",
            py: "$4"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
            as: "span",
            css: {
              fontFamily: "$primary",
              fontSize: "$caption3",
              fontWeight: "$caption3",
              lineHeight: "$caption3",
              ml: "$2"
            },
            children: "Ol\xE1, ".concat((sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$emailUsu2 = sessionData.emailUsuario) === null || _sessionData$emailUsu2 === void 0 ? void 0 : _sessionData$emailUsu2.split("@")[0]) || "Convidado")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
            as: "span",
            onClick: onLogout,
            css: {
              cursor: "pointer",
              color: "$primaryMain",
              fontFamily: "$primary",
              fontSize: "$caption4",
              fontWeight: "$caption4",
              lineHeight: "$caption4",
              mr: "$6"
            },
            children: "Sair"
          })]
        })]
      })
    });
  };

  switch (type) {
    case "anonymous":
      return renderAnonymous();

    case "DEGUSTADOR":
      return renderGuestSubscriber();

    case "advertiser_subscriber":
    case "club_subscriber":
    case "ASSINANTE":
      return renderSubscriber();
  }
};
;// CONCATENATED MODULE: ./components/SideMenu/SectionContent/SideMenuSectionContent.tsx


function SideMenuSectionContent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SideMenuSectionContent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SideMenuSectionContent_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SideMenuSectionContent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var HandleLink = function HandleLink(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), SideMenuSectionContent_objectSpread({
    legacyBehavior: true
  }, props));
};

var SubItemGroup = prensa/* PrensaEngine.styled */.u7.styled('ul', {
  p: '$0',
  m: '$0',
  'list-style-type': 'none'
});
var SubItem = prensa/* PrensaEngine.styled */.u7.styled('li', {
  align: ['row', 'left', 'middle'],
  height: 'fit-content',
  py: '$2'
});

var SubItems = function SubItems(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SubItemGroup, {
    children: data.map(function (i, k) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SubItem, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
          as: "span",
          css: {
            fontFamily: '$primary',
            fontSize: '$caption5',
            fontWeight: '$caption5',
            color: '$basicBlack',
            my: '$0'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: i.path,
            children: i.name
          })
        })
      }, "".concat(i.id, "-").concat(k));
    })
  });
};

var SideMenuSectionContent = function SideMenuSectionContent(_ref2) {
  var _assetsContext$assets, _serverSideContext$si, _serverSideContext$si2, _sessionData$inscrica, _sessionData$inscrica2, _sessionData$emailUsu;

  var config = _ref2.config,
      navItems = _ref2.navItems,
      onClose = _ref2.onClose,
      onLogin = _ref2.onLogin,
      onLogout = _ref2.onLogout,
      variant = _ref2.variant;
  var enabled = config.enabled,
      searchInput = config.searchInput,
      serviceButtons = config.serviceButtons,
      navigationAccordions = config.navigationAccordions,
      advertiseSection = config.advertiseSection;
  var site = "cbngo";
  var collapseIcon = (0,useIcon/* useIcon */.b)('IcSetaFechar');
  var expandIcon = (0,useIcon/* useIcon */.b)('IcSetaAbrir');
  var assetsContext = (0,react.useContext)(Assets.AssetsContext);
  var sessionData = (0,react.useContext)(Session.SessionDataContext);
  var banners = assetsContext === null || assetsContext === void 0 ? void 0 : (_assetsContext$assets = assetsContext.assets) === null || _assetsContext$assets === void 0 ? void 0 : _assetsContext$assets.banners;
  var bannerAnuncie = banners.find(function (i) {
    return i.name === 'BannerAssineAgora';
  });
  var serverSideContext = react.useContext(ServerSideProps.ServerSidePropsContext);
  var shouldRenderAcervo = (0,lodash.get)(serverSideContext, 'siteSlug', '');

  if (!enabled) {
    return null;
  }

  var isPaywall = serverSideContext === null || serverSideContext === void 0 ? void 0 : (_serverSideContext$si = serverSideContext.site) === null || _serverSideContext$si === void 0 ? void 0 : (_serverSideContext$si2 = _serverSideContext$si.pageConfig) === null || _serverSideContext$si2 === void 0 ? void 0 : _serverSideContext$si2.featureRadioSelectPaywall;
  var navigationAccordionItemCSS = navigationAccordions.css || {};
  var navigationAccordionItems = navItems ? navItems.map(function (i, k) {
    var _navigationAccordionI, _navigationAccordionI2, _navigationAccordionI3;

    // Verifica se o título é "Publicidades" para aplicar um estilo personalizado
    var idPubSection = i.name === 'Publicidade';
    var pubTitleStyles = {
      title: {
        color: site == 'daqui' ? '$secondaryMain' : '$primaryMain',
        fontFamily: '$primary',
        fontSize: '$retrancaHamburger',
        fontWeight: '$retrancaHamburger',
        lineHeight: '$retrancaHamburger',
        m: '0px',
        pt: '$3',
        pl: '$8',
        pr: '$18',
        height: 'max-content',
        minHeight: '40px',
        cursor: 'default'
      }
    };

    if (idPubSection) {
      // Retorna apenas um texto, sem link ou drop-down
      return {
        id: "".concat(i.path, "-").concat(k),
        title: i.name,
        children: null,
        // Não haverá filhos
        css: {
          accordionTitle: SideMenuSectionContent_objectSpread(SideMenuSectionContent_objectSpread({}, pubTitleStyles), {}, {
            iconButton: {
              display: 'none'
            }
          })
        }
      };
    }

    return {
      id: "".concat(i.path, "-").concat(k),
      title: i.name,
      href: i.path,
      iconExpandedState: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, SideMenuSectionContent_objectSpread({}, collapseIcon)),
      iconNotExpandedState: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, SideMenuSectionContent_objectSpread({}, expandIcon)),
      customLink: HandleLink,
      children: i.subItems ? /*#__PURE__*/(0,jsx_runtime.jsx)(SubItems, {
        data: i.subItems
      }) : undefined,
      css: SideMenuSectionContent_objectSpread(SideMenuSectionContent_objectSpread({}, navigationAccordionItemCSS === null || navigationAccordionItemCSS === void 0 ? void 0 : navigationAccordionItemCSS.accordionItemGroup), {}, {
        accordionTitle: SideMenuSectionContent_objectSpread(SideMenuSectionContent_objectSpread({}, navigationAccordionItemCSS === null || navigationAccordionItemCSS === void 0 ? void 0 : (_navigationAccordionI = navigationAccordionItemCSS.accordionItemGroup) === null || _navigationAccordionI === void 0 ? void 0 : _navigationAccordionI.accordionTitle), {}, {
          iconButton: SideMenuSectionContent_objectSpread(SideMenuSectionContent_objectSpread({}, navigationAccordionItemCSS === null || navigationAccordionItemCSS === void 0 ? void 0 : (_navigationAccordionI2 = navigationAccordionItemCSS.accordionItemGroup) === null || _navigationAccordionI2 === void 0 ? void 0 : (_navigationAccordionI3 = _navigationAccordionI2.accordionTitle) === null || _navigationAccordionI3 === void 0 ? void 0 : _navigationAccordionI3.iconButton), {}, {
            display: i.subItems ? 'unset' : 'none'
          })
        })
      })
    };
  }) : [];

  if (shouldRenderAcervo === "tocantins") {
    var _navigationAccordionI4, _navigationAccordionI5, _navigationAccordionI6;

    navigationAccordionItems.push({
      id: 'acervo',
      title: 'Acervo',
      href: 'https://www.jornaldotocantins.com.br/digital/',
      iconExpandedState: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, SideMenuSectionContent_objectSpread({}, collapseIcon)),
      iconNotExpandedState: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, SideMenuSectionContent_objectSpread({}, expandIcon)),
      customLink: HandleLink,
      children: undefined,
      css: SideMenuSectionContent_objectSpread(SideMenuSectionContent_objectSpread({}, navigationAccordionItemCSS === null || navigationAccordionItemCSS === void 0 ? void 0 : navigationAccordionItemCSS.accordionItemGroup), {}, {
        accordionTitle: SideMenuSectionContent_objectSpread(SideMenuSectionContent_objectSpread({}, navigationAccordionItemCSS === null || navigationAccordionItemCSS === void 0 ? void 0 : (_navigationAccordionI4 = navigationAccordionItemCSS.accordionItemGroup) === null || _navigationAccordionI4 === void 0 ? void 0 : _navigationAccordionI4.accordionTitle), {}, {
          iconButton: SideMenuSectionContent_objectSpread(SideMenuSectionContent_objectSpread({}, navigationAccordionItemCSS === null || navigationAccordionItemCSS === void 0 ? void 0 : (_navigationAccordionI5 = navigationAccordionItemCSS.accordionItemGroup) === null || _navigationAccordionI5 === void 0 ? void 0 : (_navigationAccordionI6 = _navigationAccordionI5.accordionTitle) === null || _navigationAccordionI6 === void 0 ? void 0 : _navigationAccordionI6.iconButton), {}, {
            display: 'none'
          })
        })
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      width: '100%'
    },
    children: [searchInput.enabled && /*#__PURE__*/(0,jsx_runtime.jsx)(SearchInputBox_index, {
      buttonId: "busca-menu",
      hasItemsIndicator: false,
      css: {
        container: {
          mt: '$6',
          mb: '$4'
        },
        input: {
          ml: '$3',
          width: 'calc(100% - $6)'
        },
        icon: {
          button: {
            mr: '$0'
          }
        }
      }
    }), serviceButtons.enabled && /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        align: ['row', 'center', 'middle'],
        mb: '$2'
      },
      children: serviceButtons.items.map(function (i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SideMenuServiceButton, {
          href: i.href,
          variant: site === 'tocantins' && i.variant === 'JornalDigital' ? site : i.variant,
          target: i.target
        }, i.id);
      })
    }), advertiseSection.enabled && !(sessionData !== null && sessionData !== void 0 && sessionData.emailUsuario) && /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        align: ['row', 'center', 'middle'],
        backgroundColor: advertiseSection.color,
        height: '100px',
        width: '100%'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClickableAsset_index/* default */.Z, {
        id: "assine-agora",
        alt: "Assine",
        href: advertiseSection.href,
        src: bannerAnuncie.url,
        height: bannerAnuncie.height,
        width: bannerAnuncie.width,
        target: "blank"
      })
    }), isPaywall !== "DESATIVADO" && /*#__PURE__*/(0,jsx_runtime.jsx)(SubscriberInfo, {
      amountLeft: sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$inscrica = sessionData.inscricaoDegustador) === null || _sessionData$inscrica === void 0 ? void 0 : (_sessionData$inscrica2 = _sessionData$inscrica.creditosDegustadorList[0]) === null || _sessionData$inscrica2 === void 0 ? void 0 : _sessionData$inscrica2.quantidade,
      type: sessionData !== null && sessionData !== void 0 && sessionData.id ? "ASSINANTE" : variant,
      onLogin: onLogin,
      onLogout: onLogout,
      username: (sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$emailUsu = sessionData.emailUsuario) === null || _sessionData$emailUsu === void 0 ? void 0 : _sessionData$emailUsu.split("@")[0]) || ""
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SideMenuSectionTitle, {
      color: navigationAccordions.sectionTitleColor,
      children: "Editorias"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Accordion */.UQ, {
      accordionTitleAs: "p",
      items: navigationAccordionItems,
      size: "fullWidth",
      css: {
        accordionGroup: {
          border: 'unset'
        }
      }
    }), navigationAccordions.items.map(function (i) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SideMenuSectionTitle, {
          color: navigationAccordions.sectionTitleColor,
          children: i.title
        }), i.items.map(function (itemMenu, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
            css: {
              align: ['row', 'left', 'middle'],
              width: 'auto',
              paddingLeft: '$8',
              paddingRight: '$18',
              paddingTop: '$2',
              paddingBottom: '$2',
              fontFamily: '$primary',
              fontSize: '$caption5',
              fontWeight: '$caption5',
              color: '$basicBlack'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: itemMenu.href || '',
              target: "blank",
              children: itemMenu.title
            }, key)
          }, key);
        })]
      }, i.id);
    })]
  });
};
;// CONCATENATED MODULE: ./components/SideMenu/SectionFooter/SideMenuSectionFooter.tsx


function SideMenuSectionFooter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SideMenuSectionFooter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SideMenuSectionFooter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SideMenuSectionFooter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var SideMenuSectionFooter = function SideMenuSectionFooter(_ref) {
  var _assetsContext$assets;

  var config = _ref.config;
  var enabled = config.enabled,
      advertiseSection = config.advertiseSection,
      socialmediasSection = config.socialmediasSection;
  var assetsContext = (0,react.useContext)(Assets.AssetsContext);
  var banners = assetsContext === null || assetsContext === void 0 ? void 0 : (_assetsContext$assets = assetsContext.assets) === null || _assetsContext$assets === void 0 ? void 0 : _assetsContext$assets.banners;
  var bannerAnuncie = banners.find(function (i) {
    return i.name === 'BannerAnuncie';
  });
  var icons = (0,useIcon/* useIcon */.b)(socialmediasSection.content.map(function (i) {
    return i.icon;
  }));

  if (!enabled) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: {
      align: ['column', 'center', 'top'],
      pt: '$10',
      height: '100%'
    },
    children: socialmediasSection.enabled && /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        align: ['row', 'center', 'middle'],
        backgroundColor: socialmediasSection.color,
        height: '100px',
        width: '100%'
      },
      children: socialmediasSection.content.map(function (i, k) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Link */.rU, {
          href: i.href,
          target: "_blank",
          css: SideMenuSectionFooter_objectSpread({
            height: '33px',
            m: '$1'
          }, i.css),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, {
            alt: icons[k].name,
            src: icons[k].url,
            height: icons[k].height,
            width: icons[k].width
          })
        }, i.id);
      })
    })
  });
};
;// CONCATENATED MODULE: ./components/SideMenu/SideMenu.index.tsx






var SideMenuLeft = function SideMenuLeft(_ref) {
  var assets = _ref.assets,
      close = _ref.close,
      open = _ref.open,
      navItems = _ref.navItems,
      onLogin = _ref.onLogin,
      onLogout = _ref.onLogout,
      variant = _ref.variant;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* SideMenu */.fv, {
    open: open,
    close: close,
    sections: {
      header: /*#__PURE__*/(0,jsx_runtime.jsx)(SideMenuSectionHeader, {
        config: assets.menus.sideMenuLeft.sectionHeader,
        onClose: close,
        onLogin: onLogin,
        onLogout: onLogout,
        variant: variant
      }),
      content: /*#__PURE__*/(0,jsx_runtime.jsx)(SideMenuSectionContent, {
        config: assets.menus.sideMenuLeft.sectionContent,
        navItems: navItems,
        onClose: close,
        onLogin: onLogin,
        onLogout: onLogout,
        variant: variant
      }),
      footer: /*#__PURE__*/(0,jsx_runtime.jsx)(SideMenuSectionFooter, {
        config: assets.menus.sideMenuLeft.sectionFooter
      })
    },
    css: {
      header: {
        width: '100%'
      },
      content: {
        align: ['column', 'center', 'top'],
        width: '100%'
      },
      footer: {
        alignSelf: 'baseline',
        width: '100%'
      },
      drawer: {
        content: {
          align: ['column', 'center', 'between'],
          height: '100vh',
          width: '320px',
          zIndex: 9999
        },
        spacer: {
          align: ['column', 'center', 'top'],
          height: '100vh',
          width: '100%'
        }
      }
    }
  });
};
// EXTERNAL MODULE: ./providers/DrawersProvider/index.tsx
var DrawersProvider = __webpack_require__(3928);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(2286);
;// CONCATENATED MODULE: ./components/Base/Base.SideMenu.tsx













var RenderSideMenu = function RenderSideMenu() {
  var _pagesContext$navigat;

  var pagesContext = (0,react.useContext)(Pages.PagesContext);
  var cookies = (0,dist.parseCookies)();
  var sessionData = JSON.parse(cookies.sessionData || "{}");

  var _useKeycloak = (0,ssr_lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var _useContext = (0,react.useContext)(Assets.AssetsContext),
      assets = _useContext.assets;

  var _useContext2 = (0,react.useContext)(DrawersProvider.DrawersContext),
      handleSideMenuLeft = _useContext2.handleSideMenuLeft,
      sideMenuLeftState = _useContext2.sideMenuLeftState;

  var sideMenuItems = (pagesContext === null || pagesContext === void 0 ? void 0 : (_pagesContext$navigat = pagesContext.navigation) === null || _pagesContext$navigat === void 0 ? void 0 : _pagesContext$navigat.menuSide) || [];
  var routerRedirectUrl = window.location.href;

  var handleClose = function handleClose() {
    handleSideMenuLeft({
      open: !sideMenuLeftState.open
    });
  };

  function keycloakSessionLogOut(_x) {
    return _keycloakSessionLogOut.apply(this, arguments);
  }

  function _keycloakSessionLogOut() {
    _keycloakSessionLogOut = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(id) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return axios_default()["delete"]("/paywall/delete-sessao/".concat(id));

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _keycloakSessionLogOut.apply(this, arguments);
  }

  var handleLogin = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return keycloak === null || keycloak === void 0 ? void 0 : keycloak.login({
                redirectUri: "".concat(window.location.href)
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error("Error during login:", _context.t0);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function handleLogin() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SideMenuLeft, {
    assets: assets,
    close: handleClose,
    open: sideMenuLeftState.open,
    onLogin: handleLogin,
    onLogout: function onLogout() {
      if ((sessionData === null || sessionData === void 0 ? void 0 : sessionData.id) == undefined) {
        keycloak === null || keycloak === void 0 ? void 0 : keycloak.logout();
      } else {
        keycloakSessionLogOut(sessionData.id).then(function (res) {
          if (res.status == 200) {
            keycloak === null || keycloak === void 0 ? void 0 : keycloak.logout();
            (0,utils/* removeSessionDataCookie */.pR)();
          } else {
            console.log("Erro ao fazer login");
          }
        });
      }
    },
    navItems: sideMenuItems,
    variant: sessionData !== null && sessionData !== void 0 && sessionData.id ? "ASSINANTE" : "anonymous"
  });
};

/* harmony default export */ var Base_SideMenu = (RenderSideMenu);
// EXTERNAL MODULE: ./node_modules/react-image/umd/index.js
var umd = __webpack_require__(3324);
;// CONCATENATED MODULE: ./components/Base/Base.Teaser.tsx


var Base_Teaser_excluded = ["customLink", "customLinkProps", "local", "teaserType", "page"];

function Base_Teaser_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Base_Teaser_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Base_Teaser_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_Teaser_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











// import { enviarClickTeaser, enviarViewTeaser } from 'hooks/useGCJAnalytics'
var Base_Teaser_convertLocaleDate = function convertLocaleDate(timestamp) {
  var date = new Date(timestamp);
  var options = {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };
  var dateString = date.toLocaleDateString('pt-BR', options);
  return dateString.replace(/(\d{4})(\s+\d{2}:\d{2})/, '$1 |$2');
};

var extractWidthFromImage = function extractWidthFromImage(teaserProps) {
  var imageWidth = get_default()(teaserProps, 'css[".TeaserImageContainer"].maxWidth', false);
  var imageWidthRegex = imageWidth ? imageWidth.match(/(\d+)/) : false;
  var imageWidthParsed = imageWidthRegex && imageWidthRegex.length > 0 ? imageWidthRegex[1] : false;
  var imageWidthFormatted = imageWidthParsed ? "&w=".concat(Number(imageWidthParsed) * 2) : false;
  return imageWidthFormatted;
};

var TeaserImageWrap = function TeaserImageWrap(teaserProps) {
  var TeaserImageWrapComponent = function TeaserImageWrapComponent(props) {
    var imageWidthFormatted = extractWidthFromImage(teaserProps);
    var imageSrcUrl = (0,useImageProxy/* useImageProxy */.n)("".concat(props === null || props === void 0 ? void 0 : props.url).concat(imageWidthFormatted || ''), true);

    if (!(props !== null && props !== void 0 && props.url) || imageSrcUrl === '') {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Link */.rU, {
      bypass: false,
      href: teaserProps.path,
      css: {
        fontSize: 0,
        width: '100%'
      },
      onClick: function onClick(event) {
        event.preventDefault();
        window.location.href = teaserProps.path;
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(umd.Img, {
        alt: teaserProps.title,
        src: imageSrcUrl,
        unloader: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
        loading: 'lazy'
      })
    });
  };

  TeaserImageWrapComponent.displayName = 'TeaserImageWrap';
  return TeaserImageWrapComponent;
};

var RenderTeaser = function RenderTeaser(props) {
  var _props$customProps = props === null || props === void 0 ? void 0 : props.customProps,
      customLink = _props$customProps.customLink,
      customLinkProps = _props$customProps.customLinkProps,
      local = _props$customProps.local,
      teaserType = _props$customProps.teaserType,
      page = _props$customProps.page,
      otherCustomProps = (0,objectWithoutProperties/* default */.Z)(_props$customProps, Base_Teaser_excluded);

  var ref = (0,react.useRef)(null); // const isVisible = useOnScreen(ref);
  //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
  // quando confirmado a migração, remover.
  // useEffect(() => {
  //   if(isVisible) {
  //     const pagina = page === undefined ? 0 : page;
  //     enviarViewTeaser(local, teaserType, pagina)
  //   }
  // }, [isVisible])

  var handleClickTeaser = function handleClickTeaser() {//[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // const pagina = page === undefined ? 0 : page;
    // enviarClickTeaser(local, teaserType, pagina);
  };

  var subtitle = props === null || props === void 0 ? void 0 : props.subtitle;

  if ((props === null || props === void 0 ? void 0 : props.subtitleVariant) === 'subtitle-datetime' && props.publishingTime) {
    subtitle = Base_Teaser_convertLocaleDate(props === null || props === void 0 ? void 0 : props.publishingTime);
  }

  var subject = props === null || props === void 0 ? void 0 : props.subject;

  if ((props === null || props === void 0 ? void 0 : props.subject) === '') {
    subject = first_default()(get_default()(props, 'tags.tags', []));
  }

  var slotColor = (props === null || props === void 0 ? void 0 : props.color) || (props === null || props === void 0 ? void 0 : props.slotColor);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Teaser */.lu, Base_Teaser_objectSpread(Base_Teaser_objectSpread({}, props), {}, {
    customLink: customLink || (link_default()),
    customLinkProps: customLinkProps || {
      legacyBehavior: true
    },
    customProps: Base_Teaser_objectSpread({
      onClick: handleClickTeaser,
      ref: ref
    }, otherCustomProps),
    subtitle: subtitle,
    subject: subject,
    subjectColor: slotColor,
    wrapImage: TeaserImageWrap(props)
  }));
};

/* harmony default export */ var Base_Teaser = (RenderTeaser);
;// CONCATENATED MODULE: ./components/Topbar/Items/TopbarItems.styled.tsx


function TopbarItems_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TopbarItems_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TopbarItems_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TopbarItems_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var TopbarItemContainer = function TopbarItemContainer(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    as: "nav",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      as: "ul",
      css: {
        align: ['row', 'center', 'middle'],
        my: '$0',
        px: '$0',
        'list-style-type': 'none'
      },
      children: props.children
    })
  });
};
var TopbarItemLabel = function TopbarItemLabel(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Typography */.ZT, {
    as: "span",
    variant: "menuTag-default",
    css: TopbarItems_styled_objectSpread({
      fontFamily: '$tertiary'
    }, props.css),
    children: props.children
  });
};
;// CONCATENATED MODULE: ./components/Topbar/Items/TopbarItems.index.tsx


function TopbarItems_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TopbarItems_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TopbarItems_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TopbarItems_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // import { enviarClickItem } from 'hooks/useGCJAnalytics'







var TopbarItem = function TopbarItem(props) {
  var _props$css, _props$css2;

  var li_css = TopbarItems_index_objectSpread({}, (_props$css = props.css) === null || _props$css === void 0 ? void 0 : _props$css.li);

  var handleSendClickEvent = function handleSendClickEvent(itemName, local) {//[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
    // quando confirmado a migração, remover.
    // enviarClickItem(itemName, local);
  };

  if (props.color && props.selected === props.pathSegment) {
    li_css = TopbarItems_index_objectSpread(TopbarItems_index_objectSpread({}, li_css), {}, {
      '> a': {
        borderBottomColor: "$".concat(props.color),
        '&:hover': {
          borderBottomColor: "$".concat(props.color)
        }
      }
    });
  } else {
    li_css = TopbarItems_index_objectSpread(TopbarItems_index_objectSpread({}, li_css), {}, {
      'a:hover': {
        borderBottomColor: "$".concat(props.color)
      }
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    as: "li",
    css: li_css,
    onClick: function onClick() {
      return handleSendClickEvent(props.name, 'minicapa');
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: props.path,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TopbarItemLabel, {
        path: props.path,
        variant: "menuTag-desktop",
        css: (_props$css2 = props.css) === null || _props$css2 === void 0 ? void 0 : _props$css2.label,
        children: props.name
      })
    })
  });
};

var TopbarItems = function TopbarItems(props) {
  var _props$css3;

  var router = (0,next_router.useRouter)();
  var slug = router.asPath.split('/');
  var pageDataSlug = slug[1];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TopbarItemContainer, {
    css: (_props$css3 = props.css) === null || _props$css3 === void 0 ? void 0 : _props$css3.container,
    hideInMobile: props.hideInMobile,
    children: map_default()(props.items, function (item, key) {
      var _props$css4;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(TopbarItem, TopbarItems_index_objectSpread({
        css: (_props$css4 = props.css) === null || _props$css4 === void 0 ? void 0 : _props$css4.item,
        selected: pageDataSlug
      }, item), key);
    })
  });
};

/* harmony default export */ var TopbarItems_index = (TopbarItems);
;// CONCATENATED MODULE: ./components/Topbar/Desktop/TopbarDesktop.index.tsx


function TopbarDesktop_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TopbarDesktop_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TopbarDesktop_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TopbarDesktop_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var TopbarDesktop = function TopbarDesktop(props) {
  var _props$css2;

  var RenderTopbarItems = function RenderTopbarItems() {
    var _props$css;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(TopbarItems_index, {
      css: props === null || props === void 0 ? void 0 : (_props$css = props.css) === null || _props$css === void 0 ? void 0 : _props$css.topbarItems,
      hideInMobile: false,
      items: props.menuTopItems
    });
  };

  var RenderTopbarLogo = function RenderTopbarLogo() {
    var serverSideContext = (0,react.useContext)(ServerSideProps.ServerSidePropsContext);
    var selectedLogo = props.logos.find(function (i) {
      return i.name === props.mainLogo;
    }) || {};
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ClickableAsset_index/* default */.Z, {
      alt: "Ir para a Home | Atualizar a p\xE1gina",
      src: selectedLogo.url,
      hasH1: serverSideContext.pageType.type === 'home' || serverSideContext.pageType.type === 'department' ? true : false,
      href: "/",
      height: selectedLogo.height,
      id: "pop-logo",
      width: selectedLogo.width
    });
  };

  var SlotTopLeft = props.slotTopLeft || null;
  var SlotTopCenter = props.slotTopCenter || null;
  var SlotTopRight = props.slotTopRight || null;
  var SlotMiddleLeft = props.slotMiddleLeft || null;

  var SlotMiddleCenter = props.slotMiddleCenter || /*#__PURE__*/(0,jsx_runtime.jsx)(RenderTopbarLogo, {});

  var SlotMiddleRight = props.slotMiddleRight || null;
  var SlotBottomLeft = props.slotBottomLeft || null;

  var SlotBottomCenter = /*#__PURE__*/(0,jsx_runtime.jsx)(RenderTopbarItems, {});

  var SlotBottomRight = props.slotBottomRight || null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Topbar */.ZA, {
    css: TopbarDesktop_index_objectSpread(TopbarDesktop_index_objectSpread({}, props === null || props === void 0 ? void 0 : props.css), {}, {
      cssContainer: TopbarDesktop_index_objectSpread(TopbarDesktop_index_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$css2 = props.css) === null || _props$css2 === void 0 ? void 0 : _props$css2.cssContainer), {}, {
        display: 'none',
        '@lg': {
          display: 'flex'
        }
      })
    }),
    slotTopLeft: SlotTopLeft,
    slotTopCenter: SlotTopCenter,
    slotTopRight: SlotTopRight,
    slotMiddleLeft: SlotMiddleLeft,
    slotMiddleCenter: SlotMiddleCenter,
    slotMiddleRight: SlotMiddleRight,
    slotBottomLeft: SlotBottomLeft,
    slotBottomCenter: SlotBottomCenter,
    slotBottomRight: SlotBottomRight
  });
};

/* harmony default export */ var TopbarDesktop_index = (TopbarDesktop);
;// CONCATENATED MODULE: ./components/Topbar/Mobile/TopbarMobile.index.tsx


function TopbarMobile_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TopbarMobile_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TopbarMobile_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TopbarMobile_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var TopbarMobile = function TopbarMobile(props) {
  var _props$css2;

  var RenderTopbarItems = function RenderTopbarItems() {
    var _props$css;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(TopbarItems_index, {
      css: props === null || props === void 0 ? void 0 : (_props$css = props.css) === null || _props$css === void 0 ? void 0 : _props$css.topbarItems,
      hideInMobile: false,
      items: props === null || props === void 0 ? void 0 : props.menuTopItems
    });
  };

  var RenderTopbarLogo = function RenderTopbarLogo() {
    var selectedLogo = props.logos.find(function (i) {
      return i.name === props.mainLogo;
    }) || {};
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ClickableAsset_index/* default */.Z, {
      alt: "Ir para a Home | Atualizar a p\xE1gina",
      src: selectedLogo.url,
      hasH1: true,
      href: "/",
      height: selectedLogo.height,
      id: "pop-logo",
      width: selectedLogo.width
    });
  };

  var SlotTopLeft = props.slotTopLeft || null;
  var SlotTopCenter = props.slotTopCenter || null;
  var SlotTopRight = props.slotTopRight || null;
  var SlotMiddleLeft = props.slotMiddleLeft || null;
  var SlotMiddleRight = props.slotMiddleRight || null;
  var SlotBottomLeft = props.slotBottomLeft || null;

  var SlotBottomCenter = /*#__PURE__*/(0,jsx_runtime.jsx)(RenderTopbarItems, {});

  var SlotBottomRight = props.slotBottomRight || null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Topbar */.ZA, {
    css: TopbarMobile_index_objectSpread(TopbarMobile_index_objectSpread({}, props === null || props === void 0 ? void 0 : props.css), {}, {
      cssContainer: TopbarMobile_index_objectSpread(TopbarMobile_index_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$css2 = props.css) === null || _props$css2 === void 0 ? void 0 : _props$css2.cssContainer), {}, {
        '@lg': {
          display: 'none'
        }
      })
    }),
    slotTopLeft: SlotTopLeft,
    slotTopCenter: SlotTopCenter,
    slotTopRight: SlotTopRight,
    slotMiddleLeft: SlotMiddleLeft,
    slotMiddleCenter: RenderTopbarLogo,
    slotMiddleRight: SlotMiddleRight,
    slotBottomLeft: SlotBottomLeft,
    slotBottomCenter: SlotBottomCenter,
    slotBottomRight: SlotBottomRight
  });
};

/* harmony default export */ var TopbarMobile_index = (TopbarMobile);
;// CONCATENATED MODULE: ./components/Topbar/Topbar.index.tsx


function Topbar_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Topbar_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Topbar_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Topbar_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var lastKnowScrollPosition = 0;
var FIXED_POSITION_OFFSET_DESKTOP = 190;
var FIXED_POSITION_OFFSET_MOBILE = 60;
var delayFixedPosition = false;
var delayFixedPositionTimeoutId;
var lastScrollTop = 0;
var scrollDirection = null;
var isTopbarFixed = false;
var isTopbarVisible = true;
var SCREEN_WIDTH_DESKTOP = 1016;
var DELAY_MS_TO_FIXED_TOPBAR = 100;
var enabledHeader = false;
var UP = 'UP';
var DOWN = 'DOWN';

var handleScrollEvent = function handleScrollEvent(event) {
  var initialScrollPosition = window.scrollY || document.documentElement.scrollTop;
  lastKnowScrollPosition = initialScrollPosition - lastKnowScrollPosition;
  lastKnowScrollPosition = lastKnowScrollPosition <= 0 ? 0 : lastKnowScrollPosition;
  var scrollOffset = lastScrollTop - initialScrollPosition;
  scrollDirection = scrollOffset < 0 ? DOWN : scrollOffset > 0 ? UP : null;
  lastScrollTop = initialScrollPosition <= 0 ? 0 : initialScrollPosition;
  var screenOffset = screen.width < SCREEN_WIDTH_DESKTOP ? FIXED_POSITION_OFFSET_MOBILE : FIXED_POSITION_OFFSET_DESKTOP; // Menor scroll possível, garantindo que o topbar não fique fixo

  if (!lastScrollTop) {
    delayFixedPosition = false;
    isTopbarFixed = false;
    isTopbarVisible = true;
  }

  if (!delayFixedPosition) {
    delayFixedPosition = true;

    if (lastKnowScrollPosition > screenOffset && !isTopbarFixed) {
      isTopbarFixed = true;
    }

    if (lastKnowScrollPosition <= screenOffset) {
      isTopbarFixed = false;
      isTopbarVisible = true;
    }

    if (delayFixedPositionTimeoutId) clearTimeout(delayFixedPositionTimeoutId);
    delayFixedPositionTimeoutId = setTimeout(function () {
      if (typeof delayFixedPosition !== 'undefined') delayFixedPosition = false;
    }, DELAY_MS_TO_FIXED_TOPBAR);
  } //#end delayFixedPosition


  if (initialScrollPosition > lastKnowScrollPosition && isTopbarFixed) {
    isTopbarVisible = false;
  }

  if (scrollDirection === UP && !isTopbarVisible && isTopbarFixed) {
    isTopbarVisible = true;
  }

  event === null || event === void 0 ? void 0 : event.preventDefault();
  var topbarHeader = document.getElementById('topbar-header');
  var topbarWrapper = document.getElementById('topbar-wrapper');

  if (!isTopbarFixed) {
    topbarHeader === null || topbarHeader === void 0 ? void 0 : topbarHeader.classList.remove('topbar-fixed');
    topbarWrapper === null || topbarWrapper === void 0 ? void 0 : topbarWrapper.classList.remove('topbar-fixed');
  } else {
    topbarHeader === null || topbarHeader === void 0 ? void 0 : topbarHeader.classList.add('topbar-fixed');
    topbarWrapper === null || topbarWrapper === void 0 ? void 0 : topbarWrapper.classList.add('topbar-fixed');
  }

  if (!isTopbarVisible) {
    topbarWrapper === null || topbarWrapper === void 0 ? void 0 : topbarWrapper.classList.add('topbar-hidden');
    topbarWrapper === null || topbarWrapper === void 0 ? void 0 : topbarWrapper.classList.remove('topbar-visible');
  } else {
    topbarWrapper === null || topbarWrapper === void 0 ? void 0 : topbarWrapper.classList.add('topbar-visible');
    topbarWrapper === null || topbarWrapper === void 0 ? void 0 : topbarWrapper.classList.remove('topbar-hidden');
  }
};

var Topbar = function Topbar(_ref) {
  var topbarDesktop = _ref.topbarDesktop,
      topbarMobile = _ref.topbarMobile;
  (0,react.useEffect)(function () {
    if (!enabledHeader) {
      enabledHeader = true;
      document.addEventListener('scroll', function (event) {
        handleScrollEvent(event);
      });
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "topbar-header",
      className: "topbar topbar-fixed",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        id: "topbar-wrapper",
        className: "pivot topbar-visible",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TopbarMobile_index, Topbar_index_objectSpread({}, topbarMobile)), /*#__PURE__*/(0,jsx_runtime.jsx)(TopbarDesktop_index, Topbar_index_objectSpread({}, topbarDesktop))]
      })
    })
  });
};

/* harmony default export */ var Topbar_index = (Topbar);
;// CONCATENATED MODULE: ./components/Base/Base.Topbar.tsx


function Base_Topbar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Base_Topbar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Base_Topbar_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_Topbar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var useTopbarData = function useTopbarData() {
  var assetsState = (0,react.useContext)(Assets.AssetsContext);
  var pagesState = (0,react.useContext)(Pages.PagesContext);
  var logos = (0,lodash.get)(assetsState, 'assets.logos', []);
  var banners = (0,lodash.get)(assetsState, 'assets.banners', []);
  var topbarProps = (0,lodash.get)(assetsState, 'assets.topbar');
  var mobileProps = (0,lodash.get)(topbarProps, 'topbarMobile', {});
  var desktopProps = (0,lodash.get)(topbarProps, 'topbarDesktop', {});
  var menuTopItems = (0,lodash.get)(pagesState, 'navigation.menuTop', []);
  return {
    topbarMobile: Base_Topbar_objectSpread(Base_Topbar_objectSpread({}, mobileProps), {}, {
      menuTopItems: menuTopItems,
      logos: logos,
      banners: banners
    }),
    topbarDesktop: Base_Topbar_objectSpread(Base_Topbar_objectSpread({}, desktopProps), {}, {
      menuTopItems: menuTopItems,
      logos: logos,
      banners: banners
    })
  };
};

var RenderTopbar = function RenderTopbar() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Topbar_index, Base_Topbar_objectSpread({}, useTopbarData()));
};

/* harmony default export */ var Base_Topbar = (RenderTopbar);
;// CONCATENATED MODULE: ./components/Base/Base.index.tsx


function Base_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Base_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Base_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






 // import AdsComponent from "../Ads/Ads.index";












var ComponentSwitch = function ComponentSwitch(_ref) {
  var _data$customProps, _data$customProps$cla;

  var data = _ref.data,
      pageBlockId = _ref.pageBlockId;
  var isDesktop = data === null || data === void 0 ? void 0 : (_data$customProps = data.customProps) === null || _data$customProps === void 0 ? void 0 : (_data$customProps$cla = _data$customProps.className) === null || _data$customProps$cla === void 0 ? void 0 : _data$customProps$cla.includes("desktop");
  var isDeviceDesktop = window.innerWidth > 980;

  switch (data === null || data === void 0 ? void 0 : data.type) {
    // AdsComponent desativado em pro da implementação nova de Ads.Slot.{SITE}
    // case "com.atex.standard.component.AdsBean":
    //   return <AdsComponent {...data} isDesktop={isDesktop} />;
    case "com.atex.standard.pageblock.PageblockArticleBean":
      if (isDesktop) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Base_Article, Base_index_objectSpread({}, data));

    case "com.atex.standard.pageblock.PageblockBean":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Base_Blocks, Base_index_objectSpread(Base_index_objectSpread({}, data), {}, {
        isDesktop: isDesktop
      }));

    case "com.atex.standard.component.FilterBean":
      if (isDesktop) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchEngine_index, Base_index_objectSpread(Base_index_objectSpread({}, data), {}, {
        pageBlockId: pageBlockId
      }));

    case "br.com.atex.templates.articleVideo.it":
    case "br.com.atex.templates.pageblockComponent.it":
    case "com.atex.standard.component.ComponentBean":
      if (isDesktop) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Base_Component, Base_index_objectSpread(Base_index_objectSpread({}, data), {}, {
        isDesktop: isDesktop,
        pageBlockId: pageBlockId
      }));

    case "com.atex.standard.article.ArticleBean":
    case "com.atex.plugins.teaser.TeaserBean":
      if (isDesktop && isDeviceDesktop) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Base_Teaser, Base_index_objectSpread(Base_index_objectSpread({}, data), {}, {
          isDesktop: isDesktop
        }));
      } else if (!isDesktop && !isDeviceDesktop) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Base_Teaser, Base_index_objectSpread(Base_index_objectSpread({}, data), {}, {
          isDesktop: isDesktop
        }));
      }

      break;

    case "com.atex.standard.pageblock.PageblockButtonBean":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionMore, Base_index_objectSpread(Base_index_objectSpread({}, data), {}, {
        isDesktop: isDesktop
      }));

    case "com.atex.standard.pageblock.PageblockTitleBean":
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionTitle, Base_index_objectSpread(Base_index_objectSpread({}, data), {}, {
        isDesktop: isDesktop
      }));

    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {});
  }
};

var BaseStructure = function BaseStructure(_ref2) {
  var children = _ref2.children;
  var sessionData = (0,react.useContext)(Session.SessionDataContext);

  var _useKeycloak = (0,ssr_lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      width: "100%"
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Base_Topbar, {}), children, /*#__PURE__*/(0,jsx_runtime.jsx)(Base_SideMenu, {})]
  });
};

/* harmony default export */ var Base_index = (BaseStructure);

/***/ }),

/***/ 1190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ AutoRefreshContext; },
/* harmony export */   "p": function() { return /* binding */ AutoRefreshProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);


var AutoRefreshContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
var AutoRefreshProvider = function AutoRefreshProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      isAutoRefreshEnabled = _useState[0],
      setIsAutoRefreshEnabled = _useState[1];

  var enableAutoRefresh = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return setIsAutoRefreshEnabled(true);
  }, []);
  var disableAutoRefresh = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return setIsAutoRefreshEnabled(false);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var timeoutId = null;

    var scheduleRefresh = function scheduleRefresh() {
      if (isAutoRefreshEnabled) {
        timeoutId = setTimeout(function () {
          window.location.reload();
          scheduleRefresh(); // Re-schedule after refresh
        }, 15 * 60 * 1000);
      }
    };

    scheduleRefresh();
    return function () {
      if (timeoutId) clearInterval(timeoutId);
    };
  }, [isAutoRefreshEnabled]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AutoRefreshContext.Provider, {
    value: {
      isAutoRefreshEnabled: isAutoRefreshEnabled,
      enableAutoRefresh: enableAutoRefresh,
      disableAutoRefresh: disableAutoRefresh
    },
    children: children
  });
};

/***/ }),

/***/ 3633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SlotsContext": function() { return /* binding */ SlotsContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* eslint-disable react-hooks/exhaustive-deps */


var SlotsContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});

var SlotsProvider = function SlotsProvider(_ref) {
  var children = _ref.children,
      disableLoadPage = _ref.disableLoadPage,
      _ref$initSlotPageData = _ref.initSlotPageData,
      initSlotPageData = _ref$initSlotPageData === void 0 ? [] : _ref$initSlotPageData;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initSlotPageData),
      slotsPageData = _useState[0],
      setSlotsPageData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([{
    id: '',
    name: 'slotLeft',
    hidden: false
  }]),
      sideBoxTabsList = _useState2[0],
      setSideBoxTabsList = _useState2[1];

  var handleSideBoxTabs = function handleSideBoxTabs(props) {};

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SlotsContext.Provider, {
    value: {
      slotsPageData: slotsPageData,
      sideBoxTabsList: sideBoxTabsList,
      handleSideBoxTabs: handleSideBoxTabs
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (SlotsProvider);

/***/ })

}]);